import { Aggregate, Aggregate as Aggregate$1, CollectionViewGroup, CollectionViewGroup as CollectionViewGroup$1, Control, DataType, DataType as DataType$1, Event as Event$1, Globalize, GroupDescription, NotifyCollectionChangedAction, NotifyCollectionChangedAction as NotifyCollectionChangedAction$1, NotifyCollectionChangedEventArgs, ObservableArray, ObservableArray as ObservableArray$1, PropertyGroupDescription, PropertyGroupDescription as PropertyGroupDescription$1, SortDescription, SortDescription as SortDescription$1, culture, setLicenseKey } from "@mescius/wijmo";
import { CellRange, CellType, FlexGrid as DatagridInstance, GroupRow, MergeManager, Row } from "@mescius/wijmo.grid";
import { Fragment, Suspense, Teleport, Transition, camelize, computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createSlots, createTextVNode, createVNode, defineComponent, getCurrentInstance, guardReactiveProps, h, inject, isMemoSame, isRef, mergeDefaults, mergeModels, mergeProps, nextTick, normalizeClass, normalizeProps, normalizeStyle, onBeforeUnmount, onBeforeUpdate, onMounted, onScopeDispose, onUnmounted, onUpdated, openBlock, provide, reactive, readonly, ref, render, renderList, renderSlot, resolveComponent, resolveDirective, resolveDynamicComponent, shallowReactive, shallowRef, toDisplayString, toRaw, toRef, unref, useId, useModel, useSlots, useTemplateRef, vModelCheckbox, vModelText, vShow, watch, watchEffect, withCtx, withDirectives, withModifiers } from "vue";
import { CharacterCasing, ConsoleLogger, ResourceManager, WhiteSpaceHandling, addDays, addToDate, createGuid, endOf, getPropertyByPath, getSimplifiedDateFormat, isDeepEqual, parseSimplifiedDate, setPropertyByPath, setTimeOfDay, startOf, stringFormat, supportsTouch, toCamelCase, toPascalCase, twoDigitYearMax } from "@neos/shared";
import { onClickOutside, reactiveComputed, refDebounced, useCurrentElement, useElementBounding, useElementSize, useEventListener, useFocus, useFocusWithin, useIntersectionObserver, useIntervalFn, useSpeechRecognition, useVModel, useWindowFocus, useWindowSize } from "@vueuse/core";
import { Markdown } from "@comark/vue";
import highlightPlugin from "@comark/vue/plugins/highlight";
import mermaidPlugin, { Mermaid } from "@comark/vue/plugins/mermaid";
import securityPlugin from "@comark/vue/plugins/security";
import bash from "@shikijs/langs/bash";
import csharp from "@shikijs/langs/csharp";
import css from "@shikijs/langs/css";
import html from "@shikijs/langs/html";
import json from "@shikijs/langs/json";
import markdown from "@shikijs/langs/markdown";
import powershell from "@shikijs/langs/powershell";
import shell from "@shikijs/langs/shell";
import sql from "@shikijs/langs/sql";
import typescript from "@shikijs/langs/typescript";
import vue from "@shikijs/langs/vue";
import xml from "@shikijs/langs/xml";
import yaml from "@shikijs/langs/yaml";
import yml from "@shikijs/langs/yml";
import minDark from "@shikijs/themes/min-dark";
import minLight from "@shikijs/themes/min-light";
import { textContent } from "@comark/vue/utils";
import frontmatterPlugin from "@comark/vue/plugins/frontmatter";
import { CalendarCell, CalendarCellTrigger, CalendarGrid, CalendarGridBody, CalendarGridHead, CalendarGridRow, CalendarHeadCell, CalendarNext, CalendarPrev, CalendarRoot, CollapsibleContent, CollapsibleRoot, CollapsibleTrigger, ColorAreaArea, ColorAreaRoot, ColorAreaThumb, ColorFieldInput, ColorFieldRoot, ColorSliderRoot, ColorSliderThumb, ColorSliderTrack, ColorSwatch, DialogContent, DialogPortal, DialogRoot, DialogTitle, DropdownMenuContent, DropdownMenuItem, DropdownMenuPortal, DropdownMenuRoot, DropdownMenuSeparator, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, MonthPickerCell, MonthPickerCellTrigger, MonthPickerGrid, MonthPickerGridBody, MonthPickerGridRow, MonthPickerNext, MonthPickerPrev, MonthPickerRoot, MonthRangePickerCell, MonthRangePickerCellTrigger, MonthRangePickerGrid, MonthRangePickerGridBody, MonthRangePickerGridRow, MonthRangePickerNext, MonthRangePickerPrev, MonthRangePickerRoot, PopoverAnchor, PopoverArrow, PopoverContent, PopoverPortal, PopoverRoot, PopoverTrigger, Presence, RangeCalendarCell, RangeCalendarCellTrigger, RangeCalendarGrid, RangeCalendarGridBody, RangeCalendarGridHead, RangeCalendarGridRow, RangeCalendarHeadCell, RangeCalendarNext, RangeCalendarPrev, RangeCalendarRoot, Separator, SplitterGroup, SplitterPanel, SplitterResizeHandle, TimeFieldInput, TimeFieldRoot, ToastClose, ToastDescription, ToastProvider, ToastRoot, ToastTitle, ToastViewport, ToggleGroupItem, ToggleGroupRoot, TooltipContent, TooltipPortal, TooltipProvider, TooltipRoot, TooltipTrigger, YearPickerCell, YearPickerCellTrigger, YearPickerGrid, YearPickerGridBody, YearPickerGridRow, YearPickerNext, YearPickerPrev, YearPickerRoot, YearRangePickerCell, YearRangePickerCellTrigger, YearRangePickerGrid, YearRangePickerGridBody, YearRangePickerGridRow, YearRangePickerNext, YearRangePickerPrev, YearRangePickerRoot, colorToHex, convertToHsb, convertToRgb, isValidColor, parseColor } from "reka-ui";
import { CalendarDate, Time, endOfMonth, endOfYear, getLocalTimeZone, startOfMonth, startOfYear, today } from "@internationalized/date";
import annotationPlugin from "chartjs-plugin-annotation";
import { WjFlexGrid, WjFlexGridCellTemplate, WjFlexGridCellTemplateDefinition, WjFlexGridColumn } from "@mescius/wijmo.vue2.grid";
import { WjFlexGridDetail } from "@mescius/wijmo.vue2.grid.detail";
import { DetailRow } from "@mescius/wijmo.grid.detail";
import { saveAs } from "file-saver";
import { WjGroupPanel } from "@mescius/wijmo.vue2.grid.grouppanel";
import { useFocusTrap } from "@vueuse/integrations/useFocusTrap";
import DOMPurify from "dompurify";
import Lottie from "lottie-web/build/player/lottie_light";
import { VList } from "virtua/vue";
// src/composables/useComponentAutomationProperties.ts
var automationMode = false;
function isAutomationMode() {
	return automationMode;
}
function setAutomationMode(value = true) {
	automationMode = value;
}
/**
* Set __neosComponent DOM variable if the application is started in automation mode (url parameters contains automation=true)
*/
function useComponentAutomationProperties(element, name) {
	if (!automationMode) return;
	name ??= getComponentName();
	if (!name) return;
	const resolvedElement = element ?? useCurrentElement();
	const instance = getCurrentInstance();
	function applyToCurrentElement() {
		const el = resolvedElement.value && getComponentElement(resolvedElement.value);
		if (el && !isNamedByAncestor(el, instance)) {
			el.__neosComponent = name;
			elementNamers.set(el, instance);
		}
	}
	watch(resolvedElement, applyToCurrentElement);
	onUpdated(applyToCurrentElement);
}
var elementNamers = /* @__PURE__ */ new WeakMap();
function isNamedByAncestor(element, instance) {
	const namer = elementNamers.get(element);
	for (let ancestor = instance?.parent; ancestor; ancestor = ancestor.parent) if (ancestor === namer) return true;
	return false;
}
function getComponentName() {
	const instance = getCurrentInstance();
	if (!instance) return;
	return instance.type.name ?? instance.type.__name;
}
function getComponentElement(element) {
	return element instanceof HTMLElement ? element : element.$el;
}
// src/composables/useImages.ts
function provideImages(images) {
	provide("images", images);
	return images;
}
function useImages() {
	return inject("images", {});
}
// src/composables/useThemeManager.ts
function provideThemeManager(themeManager) {
	provide("themeManager", themeManager);
	return themeManager;
}
function useThemeManager(throwError = true) {
	const themeManager = inject("themeManager", void 0);
	if (!themeManager && throwError) throw new Error("ThemeManager not provided");
	return themeManager;
}
// src/components/Image/standardImages.ts
var countryImages = {
	flagAD: {
		class: "i-twemoji-flag-andorra",
		colored: true
	},
	flagAE: {
		class: "i-twemoji-flag-united-arab-emirates",
		colored: true
	},
	flagAF: {
		class: "i-twemoji-flag-afghanistan",
		colored: true
	},
	flagAI: {
		class: "i-twemoji-flag-anguilla",
		colored: true
	},
	flagAL: {
		class: "i-twemoji-flag-albania",
		colored: true
	},
	flagAM: {
		class: "i-twemoji-flag-armenia",
		colored: true
	},
	flagAO: {
		class: "i-twemoji-flag-angola",
		colored: true
	},
	flagAR: {
		class: "i-twemoji-flag-argentina",
		colored: true
	},
	flagAS: {
		class: "i-twemoji-flag-american-samoa",
		colored: true
	},
	flagAT: {
		class: "i-twemoji-flag-austria",
		colored: true
	},
	flagAU: {
		class: "i-twemoji-flag-australia",
		colored: true
	},
	flagAW: {
		class: "i-twemoji-flag-aruba",
		colored: true
	},
	flagAZ: {
		class: "i-twemoji-flag-azerbaijan",
		colored: true
	},
	flagBB: {
		class: "i-twemoji-flag-barbados",
		colored: true
	},
	flagBD: {
		class: "i-twemoji-flag-bangladesh",
		colored: true
	},
	flagBE: {
		class: "i-twemoji-flag-belgium",
		colored: true
	},
	flagBF: {
		class: "i-twemoji-flag-burkina-faso",
		colored: true
	},
	flagBG: {
		class: "i-twemoji-flag-bulgaria",
		colored: true
	},
	flagBH: {
		class: "i-twemoji-flag-bahrain",
		colored: true
	},
	flagBI: {
		class: "i-twemoji-flag-burundi",
		colored: true
	},
	flagBJ: {
		class: "i-twemoji-flag-benin",
		colored: true
	},
	flagBM: {
		class: "i-twemoji-flag-bermuda",
		colored: true
	},
	flagBN: {
		class: "i-twemoji-flag-brunei",
		colored: true
	},
	flagBO: {
		class: "i-twemoji-flag-bolivia",
		colored: true
	},
	flagBR: {
		class: "i-twemoji-flag-brazil",
		colored: true
	},
	flagBS: {
		class: "i-twemoji-flag-bahamas",
		colored: true
	},
	flagBT: {
		class: "i-twemoji-flag-bhutan",
		colored: true
	},
	flagBW: {
		class: "i-twemoji-flag-botswana",
		colored: true
	},
	flagBY: {
		class: "i-twemoji-flag-belarus",
		colored: true
	},
	flagBZ: {
		class: "i-twemoji-flag-belize",
		colored: true
	},
	flagCA: {
		class: "i-twemoji-flag-canada",
		colored: true
	},
	flagCF: {
		class: "i-twemoji-flag-central-african-republic",
		colored: true
	},
	flagCH: {
		class: "i-twemoji-flag-switzerland",
		colored: true
	},
	flagCK: {
		class: "i-twemoji-flag-cook-islands",
		colored: true
	},
	flagCL: {
		class: "i-twemoji-flag-chile",
		colored: true
	},
	flagCM: {
		class: "i-twemoji-flag-cameroon",
		colored: true
	},
	flagCN: {
		class: "i-twemoji-flag-china",
		colored: true
	},
	flagCO: {
		class: "i-twemoji-flag-colombia",
		colored: true
	},
	flagCR: {
		class: "i-twemoji-flag-costa-rica",
		colored: true
	},
	flagCU: {
		class: "i-twemoji-flag-cuba",
		colored: true
	},
	flagCX: {
		class: "i-twemoji-flag-christmas-island",
		colored: true
	},
	flagCY: {
		class: "i-twemoji-flag-cyprus",
		colored: true
	},
	flagCZ: {
		class: "i-twemoji-flag-czechia",
		colored: true
	},
	flagDE: {
		class: "i-twemoji-flag-germany",
		colored: true
	},
	flagDJ: {
		class: "i-twemoji-flag-djibouti",
		colored: true
	},
	flagDK: {
		class: "i-twemoji-flag-denmark",
		colored: true
	},
	flagDM: {
		class: "i-twemoji-flag-dominica",
		colored: true
	},
	flagDO: {
		class: "i-twemoji-flag-dominican-republic",
		colored: true
	},
	flagDZ: {
		class: "i-twemoji-flag-algeria",
		colored: true
	},
	flagEC: {
		class: "i-twemoji-flag-ecuador",
		colored: true
	},
	flagEE: {
		class: "i-twemoji-flag-estonia",
		colored: true
	},
	flagEG: {
		class: "i-twemoji-flag-egypt",
		colored: true
	},
	flagER: {
		class: "i-twemoji-flag-eritrea",
		colored: true
	},
	flagES: {
		class: "i-twemoji-flag-spain",
		colored: true
	},
	flagET: {
		class: "i-twemoji-flag-ethiopia",
		colored: true
	},
	flagFI: {
		class: "i-twemoji-flag-finland",
		colored: true
	},
	flagFJ: {
		class: "i-twemoji-flag-fiji",
		colored: true
	},
	flagFK: {
		class: "i-twemoji-flag-falkland-islands",
		colored: true
	},
	flagFM: {
		class: "i-twemoji-flag-micronesia",
		colored: true
	},
	flagFO: {
		class: "i-twemoji-flag-faroe-islands",
		colored: true
	},
	flagFR: {
		class: "i-twemoji-flag-france",
		colored: true
	},
	flagGA: {
		class: "i-twemoji-flag-gabon",
		colored: true
	},
	flagGB: {
		class: "i-twemoji-flag-united-kingdom",
		colored: true
	},
	flagGD: {
		class: "i-twemoji-flag-grenada",
		colored: true
	},
	flagGE: {
		class: "i-twemoji-flag-georgia",
		colored: true
	},
	flagGF: {
		class: "i-twemoji-flag-french-guiana",
		colored: true
	},
	flagGG: {
		class: "i-twemoji-flag-guernsey",
		colored: true
	},
	flagGH: {
		class: "i-twemoji-flag-ghana",
		colored: true
	},
	flagGI: {
		class: "i-twemoji-flag-gibraltar",
		colored: true
	},
	flagGL: {
		class: "i-twemoji-flag-greenland",
		colored: true
	},
	flagGM: {
		class: "i-twemoji-flag-gambia",
		colored: true
	},
	flagGN: {
		class: "i-twemoji-flag-guinea",
		colored: true
	},
	flagGP: {
		class: "i-twemoji-flag-guadeloupe",
		colored: true
	},
	flagGQ: {
		class: "i-twemoji-flag-equatorial-guinea",
		colored: true
	},
	flagGR: {
		class: "i-twemoji-flag-greece",
		colored: true
	},
	flagGT: {
		class: "i-twemoji-flag-guatemala",
		colored: true
	},
	flagGU: {
		class: "i-twemoji-flag-guam",
		colored: true
	},
	flagGW: {
		class: "i-twemoji-flag-guinea-bissau",
		colored: true
	},
	flagGY: {
		class: "i-twemoji-flag-guyana",
		colored: true
	},
	flagHN: {
		class: "i-twemoji-flag-honduras",
		colored: true
	},
	flagHR: {
		class: "i-twemoji-flag-croatia",
		colored: true
	},
	flagHT: {
		class: "i-twemoji-flag-haiti",
		colored: true
	},
	flagHU: {
		class: "i-twemoji-flag-hungary",
		colored: true
	},
	flagID: {
		class: "i-twemoji-flag-indonesia",
		colored: true
	},
	flagIE: {
		class: "i-twemoji-flag-ireland",
		colored: true
	},
	flagIL: {
		class: "i-twemoji-flag-israel",
		colored: true
	},
	flagIM: {
		class: "i-twemoji-flag-isle-of-man",
		colored: true
	},
	flagIN: {
		class: "i-twemoji-flag-india",
		colored: true
	},
	flagIO: {
		class: "i-twemoji-flag-british-indian-ocean-territory",
		colored: true
	},
	flagIQ: {
		class: "i-twemoji-flag-iraq",
		colored: true
	},
	flagIR: {
		class: "i-twemoji-flag-iran",
		colored: true
	},
	flagIS: {
		class: "i-twemoji-flag-iceland",
		colored: true
	},
	flagIT: {
		class: "i-twemoji-flag-italy",
		colored: true
	},
	flagJE: {
		class: "i-twemoji-flag-jersey",
		colored: true
	},
	flagJM: {
		class: "i-twemoji-flag-jamaica",
		colored: true
	},
	flagJO: {
		class: "i-twemoji-flag-jordan",
		colored: true
	},
	flagJP: {
		class: "i-twemoji-flag-japan",
		colored: true
	},
	flagKE: {
		class: "i-twemoji-flag-kenya",
		colored: true
	},
	flagKG: {
		class: "i-twemoji-flag-kyrgyzstan",
		colored: true
	},
	flagKH: {
		class: "i-twemoji-flag-cambodia",
		colored: true
	},
	flagKI: {
		class: "i-twemoji-flag-kiribati",
		colored: true
	},
	flagKM: {
		class: "i-twemoji-flag-comoros",
		colored: true
	},
	flagKP: {
		class: "i-twemoji-flag-north-korea",
		colored: true
	},
	flagKW: {
		class: "i-twemoji-flag-kuwait",
		colored: true
	},
	flagKY: {
		class: "i-twemoji-flag-cayman-islands",
		colored: true
	},
	flagKZ: {
		class: "i-twemoji-flag-kazakhstan",
		colored: true
	},
	flagLA: {
		class: "i-twemoji-flag-laos",
		colored: true
	},
	flagLB: {
		class: "i-twemoji-flag-lebanon",
		colored: true
	},
	flagLI: {
		class: "i-twemoji-flag-liechtenstein",
		colored: true
	},
	flagLK: {
		class: "i-twemoji-flag-sri-lanka",
		colored: true
	},
	flagLR: {
		class: "i-twemoji-flag-liberia",
		colored: true
	},
	flagLS: {
		class: "i-twemoji-flag-lesotho",
		colored: true
	},
	flagLT: {
		class: "i-twemoji-flag-lithuania",
		colored: true
	},
	flagLU: {
		class: "i-twemoji-flag-luxembourg",
		colored: true
	},
	flagLV: {
		class: "i-twemoji-flag-latvia",
		colored: true
	},
	flagLY: {
		class: "i-twemoji-flag-libya",
		colored: true
	},
	flagMA: {
		class: "i-twemoji-flag-morocco",
		colored: true
	},
	flagMC: {
		class: "i-twemoji-flag-monaco",
		colored: true
	},
	flagMD: {
		class: "i-twemoji-flag-moldova",
		colored: true
	},
	flagME: {
		class: "i-twemoji-flag-montenegro",
		colored: true
	},
	flagMG: {
		class: "i-twemoji-flag-madagascar",
		colored: true
	},
	flagMH: {
		class: "i-twemoji-flag-marshall-islands",
		colored: true
	},
	flagMK: {
		class: "i-twemoji-flag-north-macedonia",
		colored: true
	},
	flagML: {
		class: "i-twemoji-flag-mali",
		colored: true
	},
	flagMN: {
		class: "i-twemoji-flag-mongolia",
		colored: true
	},
	flagMP: {
		class: "i-twemoji-flag-northern-mariana-islands",
		colored: true
	},
	flagMQ: {
		class: "i-twemoji-flag-martinique",
		colored: true
	},
	flagMR: {
		class: "i-twemoji-flag-mauritania",
		colored: true
	},
	flagMS: {
		class: "i-twemoji-flag-montserrat",
		colored: true
	},
	flagMT: {
		class: "i-twemoji-flag-malta",
		colored: true
	},
	flagMU: {
		class: "i-twemoji-flag-mauritius",
		colored: true
	},
	flagMV: {
		class: "i-twemoji-flag-maldives",
		colored: true
	},
	flagMW: {
		class: "i-twemoji-flag-malawi",
		colored: true
	},
	flagMX: {
		class: "i-twemoji-flag-mexico",
		colored: true
	},
	flagMY: {
		class: "i-twemoji-flag-malaysia",
		colored: true
	},
	flagMZ: {
		class: "i-twemoji-flag-mozambique",
		colored: true
	},
	flagNA: {
		class: "i-twemoji-flag-namibia",
		colored: true
	},
	flagNC: {
		class: "i-twemoji-flag-new-caledonia",
		colored: true
	},
	flagNE: {
		class: "i-twemoji-flag-niger",
		colored: true
	},
	flagNF: {
		class: "i-twemoji-flag-norfolk-island",
		colored: true
	},
	flagNG: {
		class: "i-twemoji-flag-nigeria",
		colored: true
	},
	flagNI: {
		class: "i-twemoji-flag-nicaragua",
		colored: true
	},
	flagNL: {
		class: "i-twemoji-flag-netherlands",
		colored: true
	},
	flagNO: {
		class: "i-twemoji-flag-norway",
		colored: true
	},
	flagNP: {
		class: "i-twemoji-flag-nepal",
		colored: true
	},
	flagNR: {
		class: "i-twemoji-flag-nauru",
		colored: true
	},
	flagNU: {
		class: "i-twemoji-flag-niue",
		colored: true
	},
	flagNZ: {
		class: "i-twemoji-flag-new-zealand",
		colored: true
	},
	flagOM: {
		class: "i-twemoji-flag-oman",
		colored: true
	},
	flagPA: {
		class: "i-twemoji-flag-panama",
		colored: true
	},
	flagPE: {
		class: "i-twemoji-flag-peru",
		colored: true
	},
	flagPF: {
		class: "i-twemoji-flag-french-polynesia",
		colored: true
	},
	flagPG: {
		class: "i-twemoji-flag-papua-new-guinea",
		colored: true
	},
	flagPH: {
		class: "i-twemoji-flag-philippines",
		colored: true
	},
	flagPK: {
		class: "i-twemoji-flag-pakistan",
		colored: true
	},
	flagPL: {
		class: "i-twemoji-flag-poland",
		colored: true
	},
	flagPN: {
		class: "i-twemoji-flag-pitcairn-islands",
		colored: true
	},
	flagPR: {
		class: "i-twemoji-flag-puerto-rico",
		colored: true
	},
	flagPT: {
		class: "i-twemoji-flag-portugal",
		colored: true
	},
	flagPW: {
		class: "i-twemoji-flag-palau",
		colored: true
	},
	flagPY: {
		class: "i-twemoji-flag-paraguay",
		colored: true
	},
	flagQA: {
		class: "i-twemoji-flag-qatar",
		colored: true
	},
	flagRO: {
		class: "i-twemoji-flag-romania",
		colored: true
	},
	flagRS: {
		class: "i-twemoji-flag-serbia",
		colored: true
	},
	flagRU: {
		class: "i-twemoji-flag-russia",
		colored: true
	},
	flagRW: {
		class: "i-twemoji-flag-rwanda",
		colored: true
	},
	flagSA: {
		class: "i-twemoji-flag-saudi-arabia",
		colored: true
	},
	flagSB: {
		class: "i-twemoji-flag-solomon-islands",
		colored: true
	},
	flagSC: {
		class: "i-twemoji-flag-seychelles",
		colored: true
	},
	flagSD: {
		class: "i-twemoji-flag-sudan",
		colored: true
	},
	flagSE: {
		class: "i-twemoji-flag-sweden",
		colored: true
	},
	flagSG: {
		class: "i-twemoji-flag-singapore",
		colored: true
	},
	flagSI: {
		class: "i-twemoji-flag-slovenia",
		colored: true
	},
	flagSK: {
		class: "i-twemoji-flag-slovakia",
		colored: true
	},
	flagSL: {
		class: "i-twemoji-flag-sierra-leone",
		colored: true
	},
	flagSM: {
		class: "i-twemoji-flag-san-marino",
		colored: true
	},
	flagSN: {
		class: "i-twemoji-flag-senegal",
		colored: true
	},
	flagSO: {
		class: "i-twemoji-flag-somalia",
		colored: true
	},
	flagSR: {
		class: "i-twemoji-flag-suriname",
		colored: true
	},
	flagSS: {
		class: "i-twemoji-flag-south-sudan",
		colored: true
	},
	flagSV: {
		class: "i-twemoji-flag-el-salvador",
		colored: true
	},
	flagSX: {
		class: "i-twemoji-flag-sint-maarten",
		colored: true
	},
	flagSY: {
		class: "i-twemoji-flag-syria",
		colored: true
	},
	flagSZ: {
		class: "i-twemoji-flag-eswatini",
		colored: true
	},
	flagTD: {
		class: "i-twemoji-flag-chad",
		colored: true
	},
	flagTG: {
		class: "i-twemoji-flag-togo",
		colored: true
	},
	flagTH: {
		class: "i-twemoji-flag-thailand",
		colored: true
	},
	flagTJ: {
		class: "i-twemoji-flag-tajikistan",
		colored: true
	},
	flagTK: {
		class: "i-twemoji-flag-tokelau",
		colored: true
	},
	flagTL: {
		class: "i-twemoji-flag-timor-leste",
		colored: true
	},
	flagTM: {
		class: "i-twemoji-flag-turkmenistan",
		colored: true
	},
	flagTN: {
		class: "i-twemoji-flag-tunisia",
		colored: true
	},
	flagTO: {
		class: "i-twemoji-flag-tonga",
		colored: true
	},
	flagTR: {
		class: "i-twemoji-flag-turkey",
		colored: true
	},
	flagTV: {
		class: "i-twemoji-flag-tuvalu",
		colored: true
	},
	flagTW: {
		class: "i-twemoji-flag-taiwan",
		colored: true
	},
	flagTZ: {
		class: "i-twemoji-flag-tanzania",
		colored: true
	},
	flagUA: {
		class: "i-twemoji-flag-ukraine",
		colored: true
	},
	flagUG: {
		class: "i-twemoji-flag-uganda",
		colored: true
	},
	flagUS: {
		class: "i-twemoji-flag-united-states",
		colored: true
	},
	flagUY: {
		class: "i-twemoji-flag-uruguay",
		colored: true
	},
	flagUZ: {
		class: "i-twemoji-flag-uzbekistan",
		colored: true
	},
	flagVA: {
		class: "i-twemoji-flag-vatican-city",
		colored: true
	},
	flagVE: {
		class: "i-twemoji-flag-venezuela",
		colored: true
	},
	flagVG: {
		class: "i-twemoji-flag-british-virgin-islands",
		colored: true
	},
	flagVN: {
		class: "i-twemoji-flag-vietnam",
		colored: true
	},
	flagVU: {
		class: "i-twemoji-flag-vanuatu",
		colored: true
	},
	flagWS: {
		class: "i-twemoji-flag-samoa",
		colored: true
	},
	flagXK: {
		class: "i-twemoji-flag-kosovo",
		colored: true
	},
	flagYE: {
		class: "i-twemoji-flag-yemen",
		colored: true
	},
	flagYT: {
		class: "i-twemoji-flag-mayotte",
		colored: true
	},
	flagZA: {
		class: "i-twemoji-flag-south-africa",
		colored: true
	},
	flagZM: {
		class: "i-twemoji-flag-zambia",
		colored: true
	},
	flagZW: {
		class: "i-twemoji-flag-zimbabwe",
		colored: true
	}
};
var dataTypeImages = {
	dataTypeAutoIncrementedInteger: {
		class: "i-mdi-counter",
		colored: false
	},
	dataTypeBoolean: {
		class: "i-mdi-checkbox-outline",
		colored: false
	},
	dataTypeColor: {
		class: "i-mdi-format-color-fill",
		colored: false
	},
	dataTypeDataType: {
		class: "i-mdi-format-list-bulleted",
		colored: false
	},
	dataTypeDate: {
		class: "i-mdi-calendar-outline",
		colored: false
	},
	dataTypeDateTime: {
		class: "i-mdi-calendar-clock-outline",
		colored: false
	},
	dataTypeDecimal: {
		class: "i-mdi-decimal",
		colored: false
	},
	dataTypeEnum: {
		class: "i-mdi-format-list-bulleted",
		colored: false
	},
	dataTypeFile: {
		class: "i-mdi-file-outline",
		colored: false
	},
	dataTypeGuid: {
		class: "i-mdi-identifier",
		colored: false
	},
	dataTypeImage: {
		class: "i-mdi-image-outline",
		colored: false
	},
	dataTypeInteger: {
		class: "i-mdi-numeric-0-box-outline",
		colored: false
	},
	dataTypeInvariantDateTime: {
		class: "i-mdi-calendar-clock-outline",
		colored: false
	},
	dataTypeLocalizableString: {
		class: "i-mdi-format-text",
		colored: false
	},
	dataTypeLong: {
		class: "i-mdi-numeric-0-box-outline",
		colored: false
	},
	dataTypeString: {
		class: "i-mdi-format-text",
		colored: false
	},
	dataTypeStringArray: {
		class: "i-mdi-code-brackets",
		colored: false
	}
};
var standardImages = {
	add: {
		class: "i-mdi-plus-thick",
		colored: false
	},
	addCondition: {
		class: "i-mdi-playlist-plus",
		colored: false
	},
	addGroup: {
		class: "i-mdi-format-list-group-plus",
		colored: false
	},
	arrowDown: {
		class: "i-mdi-arrow-down-thin",
		colored: false
	},
	arrowLeft: {
		class: "i-mdi-arrow-left",
		colored: false
	},
	arrowRight: {
		class: "i-mdi-arrow-right",
		colored: false
	},
	arrowUp: {
		class: "i-mdi-arrow-up-thin",
		colored: false
	},
	asterisk: {
		class: "i-mdi-asterisk",
		colored: false
	},
	between: {
		class: "i-mdi-format-horizontal-align-center",
		colored: false
	},
	bookmarkOutline: {
		class: "i-mdi-bookmark-outline",
		colored: false
	},
	bulb: {
		class: "i-mdi-lightbulb-outline",
		colored: false
	},
	calendar: {
		class: "i-mdi-calendar-outline",
		colored: false
	},
	calendarStart: {
		class: "i-mdi-calendar-start",
		colored: false
	},
	chevronDoubleDown: {
		class: "i-mdi-chevron-double-down",
		colored: false
	},
	chevronDoubleLeft: {
		class: "i-mdi-chevron-double-left",
		colored: false
	},
	chevronDoubleRight: {
		class: "i-mdi-chevron-double-right",
		colored: false
	},
	chevronDoubleUp: {
		class: "i-mdi-chevron-double-up",
		colored: false
	},
	chevronDown: {
		class: "i-mdi-chevron-down",
		colored: false
	},
	chevronLeft: {
		class: "i-mdi-chevron-left",
		colored: false
	},
	chevronRight: {
		class: "i-mdi-chevron-right",
		colored: false
	},
	chevronRightCircle: {
		class: "i-mdi-chevron-right-circle-outline",
		colored: false
	},
	chevronUp: {
		class: "i-mdi-chevron-up",
		colored: false
	},
	circle: {
		class: "i-mdi-checkbox-blank-circle",
		colored: false
	},
	clear: {
		class: "i-mdi-close-circle-outline",
		colored: false
	},
	clearFilter: {
		class: "i-mdi-filter-remove-outline",
		colored: false
	},
	clock: {
		class: "i-mdi-clock-outline",
		colored: false
	},
	clone: {
		class: "i-mdi-content-copy",
		colored: false
	},
	close: {
		class: "i-mdi-close",
		colored: false
	},
	closeTabs: {
		class: "i-mdi-tab-remove",
		colored: false
	},
	cog: {
		class: "i-mdi-cog",
		colored: false
	},
	collapse: {
		class: "i-mdi-arrow-collapse",
		colored: false
	},
	columnPicker: {
		class: "i-mdi-table-column-plus-before",
		colored: false
	},
	contains: {
		class: "i-mdi-format-letter-matches",
		colored: false
	},
	csharp: {
		class: "i-mdi-language-csharp",
		colored: false
	},
	csv: {
		class: "i-mdi-file-table-outline",
		colored: false
	},
	danger: {
		class: "i-mdi-alert-circle-outline",
		colored: false
	},
	datagridLoadData: {
		class: "i-neos-datagrid-load-data",
		colored: true
	},
	datagridNoData: {
		class: "i-neos-datagrid-no-data",
		colored: true
	},
	decrement: {
		class: "i-mdi-minus",
		colored: false
	},
	dotsHorizontal: {
		class: "i-mdi-dots-horizontal",
		colored: false
	},
	doubleChevronLeft: {
		class: "i-mdi-chevron-double-left",
		colored: false
	},
	doubleChevronRight: {
		class: "i-mdi-chevron-double-right",
		colored: false
	},
	download: {
		class: "i-mdi-download",
		colored: false
	},
	dragHorizontal: {
		class: "i-mdi-drag-horizontal",
		colored: false
	},
	dragVertical: {
		class: "i-mdi-drag-vertical",
		colored: false
	},
	edit: {
		class: "i-mdi-pencil",
		colored: false
	},
	endsWith: {
		class: "i-mdi-format-letter-ends-with",
		colored: false
	},
	equal: {
		class: "i-mdi-equal",
		colored: false
	},
	erase: {
		class: "i-mdi-eraser",
		colored: false
	},
	error: {
		class: "i-mdi-alert-circle-outline",
		colored: false
	},
	excel: {
		class: "i-mdi-microsoft-excel",
		colored: false
	},
	expand: {
		class: "i-mdi-arrow-expand",
		colored: false
	},
	export: {
		class: "i-mdi-download",
		colored: false
	},
	expression: {
		class: "i-mdi-function-variant",
		colored: false
	},
	eye: {
		class: "i-mdi-eye",
		colored: false
	},
	eyeOff: {
		class: "i-mdi-eye-off",
		colored: false
	},
	filter: {
		class: "i-mdi-filter",
		colored: false
	},
	filterCheckOutline: {
		class: "i-mdi-filter-check-outline",
		colored: false
	},
	filterOutline: {
		class: "i-mdi-filter-outline",
		colored: false
	},
	folder: {
		class: "i-mdi-folder",
		colored: false
	},
	fullscreen: {
		class: "i-mdi-fullscreen",
		colored: false
	},
	fullscreenExit: {
		class: "i-mdi-fullscreen-exit",
		colored: false
	},
	generateduitemplate: {
		class: "i-mdi-identifier",
		colored: false
	},
	greater: {
		class: "i-mdi-greater-than",
		colored: false
	},
	greaterOrEqual: {
		class: "i-mdi-greater-than-or-equal",
		colored: false
	},
	groupPanel: {
		class: "i-mdi-format-list-group",
		colored: false
	},
	homeGroup: {
		class: "i-mdi-home-group",
		colored: false
	},
	in: {
		class: "i-mdi-plus-circle-outline",
		colored: false
	},
	increment: {
		class: "i-mdi-plus",
		colored: false
	},
	info: {
		class: "i-mdi-information-outline",
		colored: false
	},
	isNotNull: {
		class: "i-mdi-alphabetical-variant",
		colored: false
	},
	isNull: {
		class: "i-mdi-alphabetical-variant-off",
		colored: false
	},
	less: {
		class: "i-mdi-less-than",
		colored: false
	},
	lessOrEqual: {
		class: "i-mdi-less-than-or-equal",
		colored: false
	},
	lock: {
		class: "i-mdi-lock-outline",
		colored: false
	},
	logout: {
		class: "i-mdi-logout",
		colored: false
	},
	menu: {
		class: "i-mdi-menu",
		colored: false
	},
	menuDown: {
		class: "i-mdi-menu-down",
		colored: false
	},
	microphone: {
		class: "i-mdi-microphone",
		colored: false
	},
	min: {
		class: "i-mdi-minus",
		colored: false
	},
	notEqual: {
		class: "i-mdi-not-equal-variant ",
		colored: false
	},
	notIn: {
		class: "i-mdi-minus-circle-outline",
		colored: false
	},
	open: {
		class: "i-mdi-open-in-new",
		colored: false
	},
	paperclip: {
		class: "i-mdi-paperclip",
		colored: false
	},
	pause: {
		class: "i-mdi-pause-circle-outline",
		colored: false
	},
	pdf: {
		class: "i-mdi-file-pdf-box",
		colored: false
	},
	pin: {
		class: "i-mdi-pin-outline",
		colored: false
	},
	pinned: {
		class: "i-mdi-pin-outline",
		colored: false
	},
	positive: {
		class: "i-mdi-check-circle-outline",
		colored: false
	},
	print: {
		class: "i-mdi-printer",
		colored: false
	},
	refresh: {
		class: "i-mdi-refresh",
		colored: false
	},
	remove: {
		class: "i-mdi-trash-can-outline",
		colored: false
	},
	removeColumn: {
		class: "i-mdi-table-column-remove",
		colored: false
	},
	reset: {
		class: "i-mdi-arrow-u-left-top",
		colored: false
	},
	restart: {
		class: "i-mdi-restart",
		colored: false
	},
	save: {
		class: "i-mdi-content-save-outline",
		colored: false
	},
	search: {
		class: "i-mdi-magnify",
		colored: false
	},
	send: {
		class: "i-mdi-send",
		colored: false
	},
	sparkles: {
		class: "i-neos-sparkles",
		colored: true
	},
	startsWith: {
		class: "i-mdi-format-letter-starts-with ",
		colored: false
	},
	swap: {
		class: "i-mdi-swap-vertical",
		colored: false
	},
	translate: {
		class: "i-mdi-translate",
		colored: false
	},
	tune: {
		class: "i-mdi-tune-variant",
		colored: false
	},
	typescript: {
		class: "i-mdi-language-typescript",
		colored: false
	},
	uicsharp: {
		class: "i-mdi-language-csharp",
		colored: false
	},
	uitemplate: {
		class: "i-mdi-xml",
		colored: false
	},
	unpin: {
		class: "i-mdi-pin-off-outline",
		colored: false
	},
	unsave: {
		class: "i-mdi-content-save-off-outline",
		colored: false
	},
	user: {
		class: "i-mdi-account",
		colored: false
	},
	validate: {
		class: "i-mdi-check",
		colored: false
	},
	warning: {
		class: "i-mdi-alert-outline",
		colored: false
	},
	...countryImages,
	...dataTypeImages
};
// src/components/Image/Image.ts?vue&type=script&src=true&lang.ts
var Image_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Image",
	props: {
		name: {
			type: String,
			default: void 0
		},
		size: {
			type: String,
			default: "medium"
		},
		fit: {
			type: String,
			default: "contain"
		}
	},
	setup(props) {
		const images = useImages();
		const themeManager = useThemeManager(false);
		const image = computed(() => {
			if (!props.name) return;
			const camelCaseName = toCamelCase(props.name);
			const customImage = images[camelCaseName];
			return typeof customImage === "object" ? customImage : standardImages[customImage ?? camelCaseName] ?? standardImages[camelCaseName];
		});
		const classes = computed(() => {
			if (!image.value) return;
			const fitClass = props.fit === "contain" ? [] : [`image-fit-${props.fit}`];
			if (image.value.path && image.value.colored) return [
				"image-bg",
				`image-${props.size}`,
				...fitClass
			];
			return [
				image.value.class ?? "image-mask",
				`image-${props.size}`,
				...fitClass
			];
		});
		const style = computed(() => {
			if (image.value?.darkVersionPath && themeManager?.currentTheme.colorScheme === "dark") return `--image-url: url('${image.value.darkVersionPath}')`;
			if (image.value?.path) return `--image-url: url('${image.value.path}')`;
		});
		useComponentAutomationProperties();
		return {
			classes,
			style
		};
	}
});
// \0plugin-vue:export-helper
var _plugin_vue_export_helper_default = (sfc, props) => {
	const target = sfc.__vccOpts || sfc;
	for (const [key, val] of props) target[key] = val;
	return target;
};
// src/components/Image/Image.vue
function _sfc_render$21(_ctx, _cache, $props, $setup, $data, $options) {
	return _ctx.classes ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: normalizeClass(["image", _ctx.classes]),
		style: normalizeStyle(_ctx.style)
	}, null, 6)) : createCommentVNode("", true);
}
var Image_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Image_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$21], ["__scopeId", "data-v-e4db28c2"]]);
// src/components/Avatar/Avatar.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$49 = {
	key: 0,
	class: "avatar-label"
};
// src/components/Avatar/Avatar.vue
var Avatar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Avatar",
	props: {
		label: { default: void 0 },
		icon: { default: void 0 },
		size: { default: "medium" },
		shape: { default: "circle" }
	},
	setup(__props) {
		const props = __props;
		const classes = computed(() => {
			const array = [`avatar-${props.size}`];
			if (props.shape === "square") array.push("avatar-square");
			return array;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["avatar", classes.value]) }, [__props.label ? (openBlock(), createElementBlock("span", _hoisted_1$49, toDisplayString(__props.label), 1)) : __props.icon ? (openBlock(), createBlock(Image_default, {
				key: 1,
				name: __props.icon,
				class: "avatar-icon",
				size: __props.size
			}, null, 8, ["name", "size"])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-9a1f8f29"]]);
// src/components/Badge/Badge.vue
var Badge_default = /* @__PURE__ */ defineComponent({
	__name: "Badge",
	props: {
		value: { default: void 0 },
		severity: { default: "none" },
		size: { default: "medium" }
	},
	setup(__props) {
		const props = __props;
		const classes = computed(() => {
			const classes = [];
			if (props.severity != "none") classes.push(`badge-${props.severity}`);
			if (props.size != "medium") classes.push(`badge-${props.size}`);
			if (props.value != null && String(props.value).length <= 2) classes.push("badge-circle");
			return classes;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("span", { class: normalizeClass(["badge", classes.value]) }, toDisplayString(__props.value), 3);
		};
	}
});
// src/composables/useGlobalResourceManager.ts
function provideGlobalResourceManager(globalResourceManager) {
	provide("globalResourceManager", globalResourceManager);
	return globalResourceManager;
}
function useGlobalResourceManager() {
	const globalResourceManager = inject("globalResourceManager");
	if (!globalResourceManager) throw new Error("GlobalResourceManager not provided");
	return {
		globalResourceManager,
		translate: (key, ...args) => stringFormat(globalResourceManager.get(key), ...args)
	};
}
// src/composables/useFocusableElement.ts
var focusableElementProps = {
	autofocus: {
		type: Boolean,
		default: void 0
	},
	focused: {
		type: Boolean,
		default: void 0
	}
};
var focusableElementEmits = ["update:focused"];
function useFocusableElement(element, props, emit, options = {}) {
	if (props.focused === void 0 && props.autofocus === void 0) return;
	const focused = options.focusWithin ? useWritableFocusWithin(element) : useFocus(element).focused;
	watch(element, (value) => {
		if (value) {
			const autofocus = props.focused || props.autofocus;
			if (autofocus) {
				const el = getComponentElement(value);
				el.setAttribute("autofocus", `${autofocus}`);
				el.focus();
			}
		}
	}, { immediate: true });
	watch(() => props.focused, (value) => {
		if (value !== void 0 && value !== focused.value) focused.value = value;
	});
	watch(focused, (value) => {
		if (value !== props.focused) emit("update:focused", value);
	});
}
/**
* Tracks whether the focus is on the element or one of its descendants.
* Moving the focus from the element to one of its children briefly removes it from the element,
* but both changes happen before the watchers run, so no transition is reported in between.
* Focusing gives the focus to the element itself, which is expected to forward it to a child,
* and blurring removes it from whichever descendant has it.
*/
function useWritableFocusWithin(element) {
	const { focused } = useFocusWithin(element);
	return computed({
		get: () => focused.value,
		set: (value) => {
			if (!element.value) return;
			if (value) getComponentElement(element.value).focus();
			else document.activeElement.blur();
		}
	});
}
// src/composables/useInput.ts
var inputProps = {
	label: {
		type: String,
		default: void 0
	},
	labelPosition: {
		type: String,
		default: void 0
	},
	required: {
		type: Boolean,
		default: false
	},
	readonly: {
		type: Boolean,
		default: false
	},
	disabled: {
		type: Boolean,
		default: false
	},
	messageText: {
		type: String,
		default: void 0
	},
	messageSeverity: {
		type: String,
		default: void 0
	},
	messagePosition: {
		type: String,
		default: void 0
	},
	documentation: {
		type: String,
		default: void 0
	},
	placeholder: {
		type: String,
		default: void 0
	},
	tabStop: {
		type: Boolean,
		default: true
	},
	inputDisplayMode: {
		type: String,
		default: "form"
	},
	aiSuggestion: {
		type: Object,
		default: void 0
	},
	...focusableElementProps
};
var inputEmits = [
	"update:modelValue",
	"aiApply",
	"aiCancel",
	...focusableElementEmits
];
function useInput(props, emit, focusOptions) {
	const input = ref(null);
	const id = createGuid();
	const hasErrorMessage = computed(() => props.messageText != void 0 && (props.messageSeverity === "error" || props.messageSeverity === void 0));
	const classes = computed(() => ({
		"neos-inline-input": props.labelPosition === "left" || props.labelPosition === "right",
		"neos-inline-right-input": props.labelPosition === "right",
		"neos-datagrid-input": props.inputDisplayMode === "datagrid",
		"neos-input-readonly": props.readonly,
		"neos-input-disabled": props.disabled,
		"neos-input-warning": props.messageSeverity === "warning" && props.messageText !== void 0,
		"neos-input-error": hasErrorMessage.value
	}));
	const isLabelVisible = computed(() => props.label != null && props.labelPosition !== "hidden");
	const isMessageVisible = computed(() => props.messageText != null && props.messagePosition !== "hidden");
	const tabIndex = computed(() => props.tabStop ? void 0 : -1);
	const messageId = `${id}-message`;
	const ariaAttributes = computed(() => ({
		"aria-invalid": hasErrorMessage.value || void 0,
		"aria-describedby": isMessageVisible.value ? messageId : void 0,
		"aria-required": props.required || void 0,
		"aria-label": isLabelVisible.value ? void 0 : props.label
	}));
	useComponentAutomationProperties();
	useFocusableElement(input, props, emit, focusOptions);
	return {
		input,
		id,
		classes,
		ariaAttributes,
		isLabelVisible,
		isMessageVisible,
		messageId,
		tabIndex
	};
}
function triggerChangeOnActiveInput() {
	const el = document.activeElement;
	if ((el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) && !el.closest(".neos-input-readonly") && !el.closest(".neos-input-disabled")) el.dispatchEvent(new Event("change", { bubbles: true }));
}
// src/composables/useInputInvalidValue.ts
function useInputInvalidValue(props, emit) {
	const internalInvalidValue = ref(null);
	return computed({
		get() {
			if (props.invalidValue !== void 0) return props.invalidValue;
			return internalInvalidValue.value;
		},
		set(value) {
			if (props.invalidValue !== void 0) {
				if (props.invalidValue !== value) emit("update:invalidValue", value);
			} else internalInvalidValue.value = value;
		}
	});
}
// src/composables/useLocalizator.ts
function provideLocalizator(localizator) {
	provide("localizator", localizator);
	return localizator;
}
function useLocalizator() {
	const localizator = inject("localizator");
	if (!localizator) throw new Error("Localizator not provided");
	return localizator;
}
// src/composables/useSelectableItemProperties.ts
function useSelectableItemProperties(props) {
	const localizator = useLocalizator();
	function getItemKey(item) {
		if (props.keyProperty) return getPropertyByPath(item, props.keyProperty);
		return item;
	}
	function getItemLabel(item) {
		let label;
		if (props.displayProperty) label = getPropertyByPath(item, props.displayProperty);
		else label = item;
		if (label == null) return "";
		if (typeof label !== "object" || label instanceof Date) return String(label);
		return localizator.translate(label) ?? "";
	}
	function isSameItem(leftItem, rightItem) {
		return props.keyProperty ? getItemKey(leftItem) === getItemKey(rightItem) : isDeepEqual(leftItem, rightItem);
	}
	return {
		getItemKey,
		getItemLabel,
		isSameItem
	};
}
// src/composables/useSelectProps.ts
function useSelectProps(props) {
	const disabledOrReadonly = computed(() => props.disabled || props.readonly);
	const keyProperty = computed(() => props.keyProperty ?? props.valueProperty);
	const displayProperty = computed(() => props.displayProperty ?? props.valueProperty);
	function getOptionValue(option) {
		if (props.valueProperty && option != null) return getPropertyByPath(option, props.valueProperty);
		return option;
	}
	return {
		disabledOrReadonly,
		keyProperty,
		displayProperty,
		getOptionValue
	};
}
// src/utils/contentProps.ts
/**
* The props of a component that applies the style directives of its usage to a content element rather
* than to its root (inputs, ActionButton, MenuButton).
*/
var contentProps = {
	/**
	* Classes of the content element.
	*/
	contentClass: {
		type: [
			String,
			Object,
			Array
		],
		default: void 0
	},
	/**
	* Inline style of the content element.
	*/
	contentStyle: {
		type: [
			String,
			Object,
			Array
		],
		default: void 0
	}
};
/**
* The contentStyle prop as a style object, to bind on the content element: unlike a style string, Vue
* patches only the properties of an object that changed.
*
* @param props - The props of the component.
*/
function useContentStyle(props) {
	return computed(() => normalizeStyle([props.contentStyle]));
}
// src/utils/tokens.ts
var pixelSizeExpression = /^\d+$/;
/**
* A `size` prop is either a token (a string) or a hardcoded pixel size (a number). A literal in a
* template reaches the component as a real number, but a value bound to a Field or Computed holding
* pixels arrives as a numeric string ("20"), which would otherwise be mistaken for a token and match
* no CSS class at all. Converts such a string back to a number.
*/
function normalizeSize(size) {
	return typeof size === "string" && pixelSizeExpression.test(size) ? Number(size) : size;
}
var SpaceValues = {
	none: "0px",
	extrasmall: "0.25rem",
	small: "0.5rem",
	medium: "0.875rem",
	large: "1.125rem",
	extralarge: "1.5rem"
};
var CornerRadiusValues = {
	...SpaceValues,
	full: "9999px"
};
var AlignValues = {
	start: "flex-start",
	left: "flex-start",
	center: "center",
	end: "flex-end",
	right: "flex-end",
	stretch: "stretch",
	"space-between": "space-between"
};
var VerticalAlignValues = {
	top: "flex-start",
	center: "center",
	bottom: "flex-end",
	stretch: "stretch"
};
var HorizontalLayoutVerticalAlignValues = {
	...VerticalAlignValues,
	baseline: "baseline"
};
var BreakpointValues = {
	small: 640,
	medium: 768,
	large: 1024,
	extralarge: 1280,
	extraextralarge: 1536
};
var WeightValues = {
	regular: "var(--text-weight-regular)",
	strong: "var(--text-weight-strong)",
	stronger: "var(--text-weight-stronger)"
};
var validationMessageSeverities = [
	"error",
	"warning",
	"information"
];
// src/composables/useText.ts
var textPropsDefaults = {
	size: "medium",
	weight: "regular"
};
var smallTextPropsDefaults = {
	size: "small",
	weight: "regular"
};
function useText(props) {
	return {
		classes: computed(() => {
			const value = [];
			const size = normalizeSize(props.size);
			if (typeof size === "string") value.push(`text-${size}`);
			if (props.weight !== "regular") value.push(`text-${props.weight}`);
			return value;
		}),
		styles: computed(() => {
			const value = {};
			const size = normalizeSize(props.size);
			if (typeof size === "number") value["font-size"] = `calc(${size}px * var(--neos-font-scale, 1))`;
			return value;
		})
	};
}
// src/components/Button/Button.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$48 = {
	key: 0,
	class: "button-loading-icon",
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	fill: "none",
	"aria-hidden": "true"
};
var _hoisted_2$23 = {
	key: 2,
	class: "button-label"
};
// src/components/Button/Button.vue
var Button_default = /* @__PURE__ */ defineComponent({
	__name: "Button",
	props: {
		...focusableElementProps,
		tooltip: {
			type: String,
			default: void 0
		},
		contentAlign: {
			type: String,
			default: "start"
		},
		type: {
			type: String,
			default: "button"
		},
		/**
		* When set, renders the button as a real anchor (`<a href="...">`) instead of a `<button>`,
		* with the exact same look, so a linked target has a single interactive element (no button
		* nested inside an anchor) and gets genuine browser link behavior (ctrl/middle-click, right-
		* click "open in new tab", status bar preview on hover).
		*/
		href: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "default"
		},
		size: {
			type: String,
			default: "medium"
		},
		disabled: {
			type: Boolean,
			default: false
		},
		direction: {
			type: String,
			default: "horizontal"
		},
		loading: {
			type: Boolean,
			default: false
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		label: {
			type: [String, Number],
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		badge: {
			type: [String, Number],
			default: void 0
		},
		badgeSeverity: {
			type: String,
			default: "none"
		},
		iconSize: {
			type: String,
			default: void 0
		},
		animated: {
			type: Boolean,
			default: false
		}
	},
	emits: [...focusableElementEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const themeManager = useThemeManager(false);
		const root = ref(null);
		const labelText = computed(() => toDisplayedText(props.label));
		const badgeText = computed(() => toDisplayedText(props.badge));
		const effectiveHref = computed(() => props.disabled || props.loading ? void 0 : props.href);
		const isAnimated = computed(() => props.animated && props.variant !== "link" && props.variant !== "unstyled" && !!themeManager?.currentTheme.animatedButtons);
		const classes = computed(() => [
			`button-${props.variant}`,
			`button-${props.size}`,
			`neos-${props.direction}-content`,
			{
				"button-icon-only": !!props.icon && !labelText.value && !badgeText.value,
				"button-loading": props.loading,
				"button-overlay-badge": !!badgeText.value && !labelText.value,
				"button-animated": isAnimated.value
			}
		]);
		const badgeClasses = computed(() => {
			const list = [];
			if (props.badgeSeverity !== "none") list.push(`button-badge-${props.badgeSeverity}`);
			if (badgeText.value?.length === 1) list.push("button-badge-circle");
			return list;
		});
		useComponentAutomationProperties(root);
		useFocusableElement(root, props, emit);
		function toDisplayedText(value) {
			return value?.toString() || void 0;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(resolveDynamicComponent(effectiveHref.value ? "a" : "button"), {
				ref_key: "root",
				ref: root,
				class: normalizeClass(["button", classes.value]),
				href: effectiveHref.value,
				type: effectiveHref.value ? void 0 : __props.type,
				disabled: effectiveHref.value ? void 0 : __props.disabled,
				"aria-label": __props.ariaLabel ?? __props.label,
				title: __props.tooltip,
				style: normalizeStyle({ justifyContent: __props.contentAlign }),
				onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"]))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, () => [
					__props.loading ? (openBlock(), createElementBlock("svg", _hoisted_1$48, [..._cache[1] || (_cache[1] = [createElementVNode("path", {
						d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
						fill: "currentColor"
					}, null, -1)])])) : __props.icon ? (openBlock(), createBlock(Image_default, {
						key: 1,
						name: __props.icon,
						size: __props.iconSize ?? __props.size
					}, null, 8, ["name", "size"])) : createCommentVNode("", true),
					labelText.value ? (openBlock(), createElementBlock("span", _hoisted_2$23, toDisplayString(labelText.value), 1)) : createCommentVNode("", true),
					badgeText.value ? (openBlock(), createElementBlock("span", {
						key: 3,
						class: normalizeClass(["button-badge", badgeClasses.value])
					}, toDisplayString(badgeText.value), 3)) : createCommentVNode("", true)
				])]),
				_: 3
			}, 40, [
				"class",
				"href",
				"type",
				"disabled",
				"aria-label",
				"title",
				"style"
			]);
		};
	}
});
// src/composables/useButtonContainerSpace.ts
function useButtonContainerSpace(themeManager, props) {
	return computed(() => {
		return (props?.animated ?? themeManager?.currentTheme.animatedButtons) === true ? "none" : void 0;
	});
}
// src/components/HorizontalLayout/HorizontalLayout.ts?vue&type=script&src=true&lang.ts
var HorizontalLayout_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "HorizontalLayout",
	props: {
		space: {
			type: String,
			default: "small"
		},
		align: {
			type: String,
			default: "left"
		},
		verticalAlign: {
			type: String,
			default: "stretch"
		},
		wrap: {
			type: Boolean,
			default: true
		},
		reverse: {
			type: Boolean,
			default: false
		},
		fullHeight: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const classes = computed(() => {
			const array = [];
			if (!props.wrap) array.push("horizontal-layout-nowrap");
			if (props.fullHeight) array.push("horizontal-layout-full-height");
			if (props.reverse) array.push("horizontal-layout-reverse");
			return array;
		});
		const style = computed(() => ({
			[`--horizontal-space`]: SpaceValues[props.space],
			[`--horizontal-align`]: AlignValues[props.align],
			[`--horizontal-vertical-align`]: HorizontalLayoutVerticalAlignValues[props.verticalAlign]
		}));
		useComponentAutomationProperties();
		return {
			classes,
			style
		};
	}
});
// src/components/HorizontalLayout/HorizontalLayout.vue
function _sfc_render$20(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["horizontal-layout", _ctx.classes]),
		style: normalizeStyle(_ctx.style)
	}, [renderSlot(_ctx.$slots, "default")], 6);
}
var HorizontalLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(HorizontalLayout_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$20]]);
// src/components/ButtonsLayout/ButtonsLayout.vue
var ButtonsLayout_default = /* @__PURE__ */ defineComponent({
	__name: "ButtonsLayout",
	setup(__props) {
		const themeManager = useThemeManager(false);
		const reverse = computed(() => themeManager?.currentTheme.buttonsLayoutReverseOrder === true);
		const align = computed(() => reverse.value ? "start" : "end");
		const buttonContainerSpace = useButtonContainerSpace(themeManager);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				space: unref(buttonContainerSpace),
				reverse: reverse.value,
				align: align.value
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"space",
				"reverse",
				"align"
			]);
		};
	}
});
// src/components/MarkdownViewer/ProsePre.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$47 = { class: "prose-pre" };
var _hoisted_2$22 = { class: "prose-pre-content" };
// src/components/MarkdownViewer/ProsePre.vue
var ProsePre_default = /* @__PURE__ */ defineComponent({
	__name: "ProsePre",
	props: { __node: {} },
	setup(__props) {
		const props = __props;
		async function copyCode() {
			if (props.__node) {
				const text = textContent(props.__node);
				await navigator.clipboard.writeText(text);
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$47, [createElementVNode("button", {
				type: "button",
				class: "copy-code-button",
				onClick: copyCode
			}, [..._cache[0] || (_cache[0] = [createElementVNode("div", { class: "image i-mdi-content-copy image-small" }, null, -1)])]), createElementVNode("div", _hoisted_2$22, [renderSlot(_ctx.$slots, "default")])]);
		};
	}
});
// src/components/MarkdownViewer/ProseTable.ts
/**
* Wraps the table rendered by the Markdown engine in a scroll container.
* The scroll lives on the wrapper so that the table keeps its native display and accessibility semantics.
* It is a render function because the header cells come from the Markdown content (slot), not from a template.
* The Markdown engine finds it by the ProseTable key it is registered under, not by the name of this function.
*/
var proseTable = (_props, { slots }) => h("div", { class: "prose-table" }, [h("table", slots.default?.())]);
// src/components/MarkdownViewer/TolerantFrontmatterPlugin.ts
/**
* Replaces the frontmatter plugin that Comark registers by default, as both have the same name.
* A text starting with --- that is not followed by a valid YAML header is rendered as Markdown
* instead of throwing, a thematic break being also written ---.
*/
function tolerantFrontmatterPlugin() {
	const plugin = frontmatterPlugin();
	return {
		...plugin,
		async pre(state) {
			try {
				await plugin.pre?.(state);
			} catch {}
		}
	};
}
// src/components/MarkdownViewer/MarkdownViewer.vue
var MarkdownViewer_default = /* @__PURE__ */ defineComponent({
	__name: "MarkdownViewer",
	props: {
		source: { default: void 0 },
		sanitize: {
			type: Boolean,
			default: false
		},
		highlightCode: {
			type: Boolean,
			default: false
		},
		copyCodeButton: {
			type: Boolean,
			default: false
		},
		mermaid: {
			type: Boolean,
			default: false
		},
		streaming: {
			type: Boolean,
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		const value = computed(() => props.source ?? "");
		const themeManager = useThemeManager(false);
		const isDarkTheme = ref(themeManager?.currentTheme.colorScheme === "dark");
		const handleThemeChanged = (theme) => {
			isDarkTheme.value = theme.colorScheme === "dark";
		};
		themeManager?.changedEvent.add(handleThemeChanged);
		onUnmounted(() => {
			themeManager?.changedEvent.remove(handleThemeChanged);
		});
		const plugins = computed(() => {
			const plugins = [tolerantFrontmatterPlugin()];
			if (props.highlightCode) plugins.push(highlightPlugin({
				registerDefaultLanguages: false,
				registerDefaultThemes: false,
				languages: [
					bash,
					csharp,
					css,
					html,
					json,
					markdown,
					powershell,
					shell,
					sql,
					typescript,
					vue,
					xml,
					yaml,
					yml
				],
				themes: {
					dark: minDark,
					light: minLight
				}
			}));
			if (props.mermaid) plugins.push(mermaidPlugin());
			if (props.sanitize) plugins.push(securityPlugin());
			return plugins;
		});
		const components = computed(() => {
			const components = { ProseTable: proseTable };
			if (props.highlightCode && props.copyCodeButton) components.ProsePre = ProsePre_default;
			if (props.mermaid) components.Mermaid = Mermaid;
			return components;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["markdown-viewer", { "markdown-viewer-dark": isDarkTheme.value }]) }, [(openBlock(), createBlock(Suspense, null, {
				default: withCtx(() => [createVNode(unref(Markdown), {
					value: value.value,
					streaming: __props.streaming,
					plugins: plugins.value,
					components: components.value
				}, null, 8, [
					"value",
					"streaming",
					"plugins",
					"components"
				])]),
				_: 1
			}))], 2);
		};
	}
});
// src/composables/useOverlay.ts
/**
* Manages the opening of an overlay (popover, menu...) displayed above the overlays already open.
* @param open - The opening state of the overlay.
* @param prepare - Called with the arguments of `show` before opening, to anchor the overlay.
*/
function useOverlay(open, prepare) {
	const portalKey = useOverlayPortalKey(open);
	function show(...args) {
		prepare(...args);
		open.value = true;
	}
	function hide() {
		open.value = false;
	}
	function toggle(...args) {
		if (open.value) hide();
		else show(...args);
	}
	return {
		portalKey,
		show,
		hide,
		toggle
	};
}
/**
* Gets the key of the portal teleporting an overlay to the body, changed on each opening.
* A portal stays where it was first teleported, whereas the overlays share the same z-index and are stacked by their
* order in the body: teleported again at the end of the body on each opening, the overlay is displayed above the
* overlays already open.
* The key is a string, unlike the numeric keys Vue gives to the `v-if` branches next to the portal.
* @param open - The opening state of the overlay.
*/
function useOverlayPortalKey(open) {
	const openingCount = shallowRef(0);
	watch(open, (isOpen) => {
		if (isOpen) openingCount.value++;
	});
	return computed(() => `overlay-portal-${openingCount.value}`);
}
// src/utils/dropdown.ts
/**
* Gets a value indicating whether there is an active dropdown.
* lookup-dropdown: Lookup
* select-dropdown: Select
* menu-content: DropdownMenu and ContextMenu, including their submenus
* input-color-dropdown: InputColor picker
*/
var selectors = ".lookup-dropdown, .select-dropdown, .dropdown-menu, .menu-content, .input-color-dropdown";
function isVisibleDropdown(element) {
	for (let current = element; current; current = current.parentElement) {
		if (current instanceof HTMLElement && (current.hidden || current.getAttribute("aria-hidden") === "true")) return false;
		const style = getComputedStyle(current);
		if (style.display === "none" || style.visibility === "hidden") return false;
	}
	return true;
}
function isDropdownActive() {
	return Array.from(document.body.querySelectorAll(selectors)).some((element) => isVisibleDropdown(element));
}
function isInDropdown(element) {
	const dropdowns = document.body.querySelectorAll(selectors);
	for (const dropdown of dropdowns) if (dropdown.contains(element)) return true;
	return false;
}
// src/utils/overlay.ts
/**
* Gets a value indicating whether an interaction reported as outside of an overlay happened in the
* given element, typically the element which opened the overlay.
*/
function isInteractionInside(event, element) {
	const eventTarget = event.detail.originalEvent.target;
	return element instanceof Element && eventTarget instanceof Node && element.contains(eventTarget);
}
/**
* Ignores a pointer interaction with an element that is closing, to listen to in the capture phase of the element
* carrying its data-state attribute. The element stays displayed during its closing animation: a click there, meant
* for what it covered, must neither act on its content nor reach the element underneath.
*/
function ignoreInteractionWhileClosing(event) {
	if (event.currentTarget instanceof HTMLElement && event.currentTarget.dataset.state === "closed") {
		event.preventDefault();
		event.stopPropagation();
	}
}
/** Creates a zero-sized element located at the given position of the viewport, to anchor an overlay. */
function createPointReference(x, y) {
	const rect = {
		x,
		y,
		top: y,
		right: x,
		bottom: y,
		left: x,
		width: 0,
		height: 0
	};
	return { getBoundingClientRect: () => rect };
}
// src/components/Popover/Popover.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$46 = { class: "popover-body" };
// src/components/Popover/Popover.vue
var Popover_default = /* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "Popover",
	props: /*@__PURE__*/ mergeModels({
		side: { default: "bottom" },
		align: { default: "start" },
		sideOffset: { default: 4 },
		collisionPadding: { default: 10 },
		showArrow: {
			type: Boolean,
			default: true
		},
		arrowSize: { default: 12 },
		preventHide: {
			type: Boolean,
			default: false
		},
		focus: {
			type: Boolean,
			default: true
		}
	}, {
		"open": {
			type: Boolean,
			default: false
		},
		"openModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels(["show", "hide"], ["update:open"]),
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const open = useModel(__props, "open");
		const triggerElement = shallowRef();
		const positionTarget = shallowRef();
		const { portalKey, show, hide, toggle } = useOverlay(open, (target, position) => {
			const element = resolveTarget(target);
			if (element) triggerElement.value = element;
			const anchor = position ?? element;
			if (anchor) positionTarget.value = anchor;
		});
		watch(open, (isOpen) => {
			if (isOpen) emit("show");
			else emit("hide");
		});
		onBeforeUnmount(() => {
			if (open.value) emit("hide");
		});
		function getArrowStyle(style) {
			const normalized = normalizeStyle([style]);
			const fill = normalized.background ?? normalized.backgroundColor;
			return fill ? { fill } : void 0;
		}
		function resolveTarget(target) {
			if (target instanceof Element) return target;
			const currentTarget = target?.currentTarget;
			return currentTarget instanceof Element ? currentTarget : void 0;
		}
		function onInteractOutside(event) {
			const eventTarget = event.detail.originalEvent.target;
			const isOnTrigger = isInteractionInside(event, triggerElement.value);
			const isOnDropdown = eventTarget instanceof Element && isInDropdown(eventTarget);
			if (props.preventHide || isOnTrigger || isOnDropdown) event.preventDefault();
		}
		function onFocusOutside(event) {
			event.preventDefault();
		}
		function onEscapeKeyDown(event) {
			if (props.preventHide) event.preventDefault();
		}
		function onOpenAutoFocus(event) {
			if (!props.focus) event.preventDefault();
		}
		__expose({
			show,
			hide,
			toggle
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PopoverRoot), {
				open: open.value,
				"onUpdate:open": _cache[0] || (_cache[0] = ($event) => open.value = $event)
			}, {
				default: withCtx(() => [
					_ctx.$slots.trigger ? (openBlock(), createBlock(unref(PopoverTrigger), {
						key: 0,
						"as-child": ""
					}, {
						default: withCtx(() => [renderSlot(_ctx.$slots, "trigger", { open: open.value })]),
						_: 3
					})) : createCommentVNode("", true),
					positionTarget.value ? (openBlock(), createBlock(unref(PopoverAnchor), {
						key: 1,
						reference: positionTarget.value,
						"as-child": ""
					}, null, 8, ["reference"])) : _ctx.$slots.anchor ? (openBlock(), createBlock(unref(PopoverAnchor), {
						key: 2,
						"as-child": ""
					}, {
						default: withCtx(() => [renderSlot(_ctx.$slots, "anchor")]),
						_: 3
					})) : createCommentVNode("", true),
					(openBlock(), createBlock(unref(PopoverPortal), { key: unref(portalKey) }, {
						default: withCtx(() => [createVNode(unref(PopoverContent), mergeProps({ class: "popover" }, _ctx.$attrs, {
							side: __props.side,
							align: __props.align,
							"side-offset": __props.sideOffset,
							"collision-padding": __props.collisionPadding,
							onInteractOutside,
							onFocusOutside,
							onEscapeKeyDown,
							onOpenAutoFocus,
							onPointerdownCapture: unref(ignoreInteractionWhileClosing),
							onClickCapture: unref(ignoreInteractionWhileClosing)
						}), {
							default: withCtx(() => [createElementVNode("div", _hoisted_1$46, [renderSlot(_ctx.$slots, "default", { close: unref(hide) })]), __props.showArrow ? (openBlock(), createBlock(unref(PopoverArrow), {
								key: 0,
								class: "popover-arrow",
								width: __props.arrowSize,
								height: __props.arrowSize / 2,
								style: normalizeStyle(getArrowStyle(_ctx.$attrs.style))
							}, null, 8, [
								"width",
								"height",
								"style"
							])) : createCommentVNode("", true)]),
							_: 3
						}, 16, [
							"side",
							"align",
							"side-offset",
							"collision-padding",
							"onPointerdownCapture",
							"onClickCapture"
						])]),
						_: 3
					}))
				]),
				_: 3
			}, 8, ["open"]);
		};
	}
});
// src/components/PopoverWithTarget/PopoverWithTarget.vue
var PopoverWithTarget_default = /* @__PURE__ */ defineComponent({
	__name: "PopoverWithTarget",
	props: {
		"target": { default: null },
		"targetModifiers": {}
	},
	emits: ["update:target"],
	setup(__props) {
		const target = useModel(__props, "target");
		const popoverElement = useTemplateRef("popover");
		watch([popoverElement, target], ([popover, currentTarget]) => {
			if (popover) {
				if (currentTarget) popover.show(currentTarget);
				else popover.hide();
			}
		}, { immediate: true });
		function handleHide() {
			target.value = null;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Popover_default, {
				ref: "popover",
				onHide: handleHide
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 512);
		};
	}
});
// src/composables/useTextMaxLines.ts
function useTextMaxLines(props) {
	return {
		classes: computed(() => props.maxLines ? ["text-with-webkit-box-for-ellipsis"] : []),
		styles: computed(() => props.maxLines ? { "-webkit-line-clamp": props.maxLines } : void 0)
	};
}
// src/components/Text/Text.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$45 = ["title"];
// src/components/Text/Text.vue
var Text_default = /* @__PURE__ */ defineComponent({
	__name: "Text",
	props: /*@__PURE__*/ mergeDefaults({
		size: {},
		weight: {},
		orientation: {},
		tooltip: {},
		maxLines: {}
	}, {
		...textPropsDefaults,
		orientation: "horizontal",
		tooltip: void 0,
		maxLines: void 0
	}),
	setup(__props) {
		const props = __props;
		useComponentAutomationProperties();
		const { classes: baseClasses, styles: baseStyles } = useText(props);
		const { classes: maxLinesClasses, styles: maxLinesStyles } = useTextMaxLines(props);
		const classes = computed(() => {
			const value = [...baseClasses.value, ...maxLinesClasses.value];
			if (props.orientation !== "horizontal") value.push(`text-orientation-${props.orientation}`);
			return value;
		});
		const styles = computed(() => ({
			...baseStyles.value,
			...maxLinesStyles.value
		}));
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("span", {
				class: normalizeClass(["text", classes.value]),
				title: __props.tooltip,
				style: normalizeStyle(styles.value)
			}, [renderSlot(_ctx.$slots, "default")], 14, _hoisted_1$45);
		};
	}
});
// src/components/VerticalLayout/VerticalLayout.ts?vue&type=script&src=true&lang.ts
var VerticalLayout_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "VerticalLayout",
	props: {
		space: {
			type: String,
			default: "small"
		},
		align: {
			type: String,
			default: "stretch"
		},
		verticalAlign: {
			type: String,
			default: void 0
		}
	},
	setup(props) {
		useComponentAutomationProperties();
		return { style: computed(() => ({
			[`--vertical-space`]: SpaceValues[props.space],
			[`--vertical-align`]: AlignValues[props.align],
			...props.verticalAlign && { justifyContent: VerticalAlignValues[props.verticalAlign] }
		})) };
	}
});
// src/components/VerticalLayout/VerticalLayout.vue
function _sfc_render$19(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: "vertical-layout",
		style: normalizeStyle(_ctx.style)
	}, [renderSlot(_ctx.$slots, "default")], 4);
}
var VerticalLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(VerticalLayout_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$19]]);
// src/components/AiSuggestionIndicator/AiSuggestionIndicator.vue
var AiSuggestionIndicator_default = /* @__PURE__ */ defineComponent({
	__name: "AiSuggestionIndicator",
	props: {
		suggestion: { default: void 0 },
		animated: {
			type: Boolean,
			default: true
		}
	},
	emits: ["apply", "cancel"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const popoverTarget = shallowRef(null);
		const popoverContent = shallowRef(null);
		const indicatorElement = shallowRef(null);
		let closeTimeout = null;
		let popoverElement = null;
		function cancelCloseTimeout() {
			if (closeTimeout) {
				clearTimeout(closeTimeout);
				closeTimeout = null;
			}
		}
		function isMouseOverElement(element) {
			return element?.matches(":hover") ?? false;
		}
		function scheduleClose() {
			cancelCloseTimeout();
			closeTimeout = setTimeout(() => {
				if (!isMouseOverElement(indicatorElement.value) && !isMouseOverElement(popoverElement)) popoverTarget.value = null;
			}, 200);
		}
		function handlePopoverMouseEnter() {
			cancelCloseTimeout();
		}
		function handlePopoverMouseLeave() {
			scheduleClose();
		}
		watch(popoverContent, (content) => {
			if (popoverElement) {
				popoverElement.removeEventListener("mouseenter", handlePopoverMouseEnter);
				popoverElement.removeEventListener("mouseleave", handlePopoverMouseLeave);
				popoverElement = null;
			}
			if (content) setTimeout(() => {
				popoverElement = content.$el?.closest(".popover");
				if (popoverElement) {
					popoverElement.addEventListener("mouseenter", handlePopoverMouseEnter);
					popoverElement.addEventListener("mouseleave", handlePopoverMouseLeave);
				}
			}, 0);
		});
		function handleIndicatorMouseEnter(event) {
			cancelCloseTimeout();
			if (popoverTarget.value) return;
			popoverTarget.value = event.currentTarget;
		}
		function handleIndicatorMouseLeave() {
			scheduleClose();
		}
		function handleCancel() {
			cancelCloseTimeout();
			popoverTarget.value = null;
			emit("cancel");
		}
		function handleApply() {
			cancelCloseTimeout();
			popoverTarget.value = null;
			emit("apply");
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [props.suggestion ? (openBlock(), createElementBlock("span", {
				key: 0,
				ref_key: "indicatorElement",
				ref: indicatorElement,
				class: normalizeClass(["ai-suggestion-indicator", { "is-animated": props.animated }]),
				onMouseenter: handleIndicatorMouseEnter,
				onMouseleave: handleIndicatorMouseLeave
			}, [createVNode(Image_default, {
				name: "ai",
				size: "extrasmall"
			})], 34)) : createCommentVNode("", true), props.suggestion ? (openBlock(), createBlock(PopoverWithTarget_default, {
				key: 1,
				target: popoverTarget.value,
				"onUpdate:target": _cache[0] || (_cache[0] = ($event) => popoverTarget.value = $event),
				focus: false
			}, {
				default: withCtx(() => [createVNode(VerticalLayout_default, {
					ref_key: "popoverContent",
					ref: popoverContent,
					space: "small",
					class: "ai-suggestion-popover"
				}, {
					default: withCtx(() => [
						createVNode(Text_default, null, {
							default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("AiSuggestion")), 1)]),
							_: 1
						}),
						props.suggestion?.text ? (openBlock(), createBlock(MarkdownViewer_default, {
							key: 0,
							class: "ai-suggestion-markdown",
							source: props.suggestion.text,
							sanitize: true
						}, null, 8, ["source"])) : createCommentVNode("", true),
						createVNode(HorizontalLayout_default, {
							align: "right",
							class: "ai-suggestion-actions"
						}, {
							default: withCtx(() => [createVNode(ButtonsLayout_default, null, {
								default: withCtx(() => [createVNode(Button_default, {
									variant: "default",
									size: "small",
									icon: "check",
									animated: "",
									label: unref(translate)("Apply"),
									onClick: handleApply
								}, null, 8, ["label"]), createVNode(Button_default, {
									variant: "default",
									size: "small",
									icon: "reset",
									animated: "",
									onClick: handleCancel
								})]),
								_: 1
							})]),
							_: 1
						})
					]),
					_: 1
				}, 512)]),
				_: 1
			}, 8, ["target"])) : createCommentVNode("", true)], 64);
		};
	}
});
// src/composables/useModal.ts
function useModal() {
	const isOpen = ref(false);
	function open() {
		isOpen.value = true;
	}
	function close() {
		isOpen.value = false;
	}
	return {
		isOpen,
		open,
		close
	};
}
// src/composables/useModalOpenState.ts
/**
* A monotonically increasing counter, bumped by every Modal instance whenever it mounts, unmounts,
* or toggles its own `isOpen` prop. Reading `.value` (even just to discard it) inside a Vue
* computed makes that computed a reactive dependent of "has some modal's open state changed
* anywhere in the document", without needing a MutationObserver or another way to reactively
* observe the raw DOM presence of `.modal` elements - see FramesManager.isModalOpen, the reason
* this exists: it refuses a navigation link while a modal is open, and needs that check to be a
* reactive dependency of the computed href, not just a one-off DOM query.
*/
var modalStateVersion = ref(0);
function bumpModalStateVersion() {
	modalStateVersion.value++;
}
// src/components/Modal/Modal.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$44 = ["data-state"];
var _hoisted_2$21 = { class: "modal-header neos-horizontal-content" };
var _hoisted_3$12 = {
	key: 0,
	class: "modal-header-actions"
};
var _hoisted_4$8 = ["aria-label"];
var _hoisted_5$7 = ["aria-label"];
var _hoisted_6$5 = { class: "modal-body neos-vertical-content" };
var _hoisted_7$5 = {
	key: 0,
	class: "modal-footer neos-horizontal-content"
};
// src/components/Modal/Modal.vue
var Modal_default = /* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "Modal",
	props: {
		isOpen: { type: Boolean },
		dismissOnClickOutside: {
			type: Boolean,
			default: false
		},
		size: { default: "auto" },
		dismissible: {
			type: Boolean,
			default: false
		},
		position: { default: "center" },
		maximizable: {
			type: Boolean,
			default: true
		},
		focus: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:isOpen", "close"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const isMaximized = ref(false);
		const portalKey = useOverlayPortalKey(() => props.isOpen);
		const mask = useTemplateRef("mask");
		let maskMouseDownTarget = null;
		let previouslyFocusedElement = null;
		const maskPositionClass = computed(() => props.position === "center" ? void 0 : `modal-mask-${props.position}`);
		function restoreFocus() {
			const activeElement = document.activeElement;
			if (activeElement === document.body || mask.value?.contains(activeElement) === true) previouslyFocusedElement?.focus();
			previouslyFocusedElement = null;
		}
		function close() {
			emit("update:isOpen", false);
			emit("close");
		}
		/**
		* Closes only on an Escape pressed inside the modal and not already handled by one of its components (a datagrid
		* cancelling an edition...), whereas Reka would close it on any Escape pressed in the page.
		*/
		function onEscapeKeyDown(event) {
			const isInside = event.target instanceof Node && mask.value?.contains(event.target) === true;
			const shouldClose = props.dismissible && isInside && !event.defaultPrevented;
			event.preventDefault();
			if (shouldClose) close();
		}
		function onMaskMouseDown(event) {
			maskMouseDownTarget = event.target;
		}
		function onMaskMouseUp(event) {
			const isClickOnMask = maskMouseDownTarget === event.currentTarget && event.target === event.currentTarget;
			if (props.dismissOnClickOutside && isClickOnMask) close();
			maskMouseDownTarget = null;
		}
		function onOpenAutoFocus(event) {
			if (!props.focus) event.preventDefault();
		}
		watch(() => props.isOpen, (isOpen) => {
			if (isOpen) previouslyFocusedElement = document.activeElement;
			else restoreFocus();
		}, { immediate: true });
		onMounted(bumpModalStateVersion);
		onUnmounted(bumpModalStateVersion);
		watch(() => props.isOpen, bumpModalStateVersion, { flush: "post" });
		onBeforeUnmount(restoreFocus);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DialogRoot), {
				open: __props.isOpen,
				modal: false
			}, {
				default: withCtx(() => [(openBlock(), createBlock(unref(DialogPortal), { key: unref(portalKey) }, {
					default: withCtx(() => [createVNode(unref(Presence), { present: __props.isOpen }, {
						default: withCtx(() => [createElementVNode("div", {
							ref_key: "mask",
							ref: mask,
							class: normalizeClass(["modal-mask", maskPositionClass.value]),
							"data-state": __props.isOpen ? "open" : "closed",
							onMousedown: onMaskMouseDown,
							onMouseup: onMaskMouseUp,
							onPointerdownCapture: _cache[3] || (_cache[3] = (...args) => unref(ignoreInteractionWhileClosing) && unref(ignoreInteractionWhileClosing)(...args)),
							onClickCapture: _cache[4] || (_cache[4] = (...args) => unref(ignoreInteractionWhileClosing) && unref(ignoreInteractionWhileClosing)(...args))
						}, [createVNode(unref(DialogContent), mergeProps(_ctx.$attrs, {
							"force-mount": "",
							class: ["modal", {
								"modal-full-size": __props.size === "full",
								"modal-maximized": isMaximized.value
							}],
							"aria-modal": "true",
							"aria-describedby": void 0,
							onEscapeKeyDown,
							onInteractOutside: _cache[1] || (_cache[1] = withModifiers(() => {}, ["prevent"])),
							onOpenAutoFocus,
							onCloseAutoFocus: _cache[2] || (_cache[2] = withModifiers(() => {}, ["prevent"]))
						}), {
							default: withCtx(() => [
								createElementVNode("div", _hoisted_2$21, [createVNode(unref(DialogTitle), {
									as: "div",
									class: "modal-title"
								}, {
									default: withCtx(() => [renderSlot(_ctx.$slots, "header")]),
									_: 3
								}), __props.maximizable || __props.dismissible ? (openBlock(), createElementBlock("div", _hoisted_3$12, [__props.maximizable ? (openBlock(), createElementBlock("button", {
									key: 0,
									type: "button",
									class: "modal-header-button modal-maximize-button",
									"aria-label": unref(translate)(isMaximized.value ? "ModalRestore" : "ModalMaximize"),
									onClick: _cache[0] || (_cache[0] = ($event) => isMaximized.value = !isMaximized.value)
								}, [createVNode(Image_default, {
									name: isMaximized.value ? "fullscreenExit" : "fullscreen",
									size: "extrasmall"
								}, null, 8, ["name"])], 8, _hoisted_4$8)) : createCommentVNode("", true), __props.dismissible ? (openBlock(), createElementBlock("button", {
									key: 1,
									type: "button",
									class: "modal-header-button modal-close-button",
									"aria-label": unref(translate)("Close"),
									onClick: close
								}, [createVNode(Image_default, {
									name: "close",
									size: "extrasmall"
								})], 8, _hoisted_5$7)) : createCommentVNode("", true)])) : createCommentVNode("", true)]),
								createElementVNode("div", _hoisted_6$5, [renderSlot(_ctx.$slots, "body")]),
								_ctx.$slots.footer ? (openBlock(), createElementBlock("div", _hoisted_7$5, [renderSlot(_ctx.$slots, "footer")])) : createCommentVNode("", true)
							]),
							_: 3
						}, 16, ["class"])], 42, _hoisted_1$44)]),
						_: 3
					}, 8, ["present"])]),
					_: 3
				}))]),
				_: 3
			}, 8, ["open"]);
		};
	}
});
// src/components/InputDocumentationButton/InputDocumentationButton.ts?vue&type=script&src=true&lang.ts
var InputDocumentationButton_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputDocumentationButton",
	components: {
		Button: Button_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		Modal: Modal_default,
		Text: Text_default
	},
	setup() {
		const { translate } = useGlobalResourceManager();
		const { isOpen, open, close } = useModal();
		return {
			translate,
			isOpen,
			open,
			close
		};
	}
});
// src/components/InputDocumentationButton/InputDocumentationButton.vue
function _sfc_render$18(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_Image = resolveComponent("Image");
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_Modal = resolveComponent("Modal");
	return openBlock(), createElementBlock(Fragment, null, [createVNode(_component_Button, {
		variant: "link",
		icon: "info",
		size: "extrasmall",
		class: "input-documentation-button",
		tabindex: "-1",
		onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.open(), ["stop"]))
	}), createVNode(_component_Modal, {
		"is-open": _ctx.isOpen,
		"onUpdate:isOpen": _cache[1] || (_cache[1] = ($event) => _ctx.isOpen = $event),
		class: "input-documentation-modal",
		dismissible: true,
		maximizable: false,
		"dismiss-on-click-outside": true,
		onClose: _cache[2] || (_cache[2] = ($event) => _ctx.close())
	}, {
		header: withCtx(() => [createVNode(_component_HorizontalLayout, { "vertical-align": "center" }, {
			default: withCtx(() => [createVNode(_component_Image, {
				name: "info",
				size: "extralarge",
				class: "input-documentation-modal-icon"
			}), createVNode(_component_Text, {
				size: "extralarge",
				weight: "strong"
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "header", {}, void 0, true)]),
				_: 3
			})]),
			_: 3
		})]),
		body: withCtx(() => [renderSlot(_ctx.$slots, "body", {}, void 0, true)]),
		_: 3
	}, 8, ["is-open"])], 64);
}
var InputDocumentationButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputDocumentationButton_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$18], ["__scopeId", "data-v-089db859"]]);
// src/components/InputLabel/InputLabel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$43 = ["for"];
var _hoisted_2$20 = {
	key: 0,
	class: "input-label-required"
};
// src/components/InputLabel/InputLabel.vue
var InputLabel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputLabel",
	props: /*@__PURE__*/ mergeDefaults({
		size: {},
		weight: {},
		label: {},
		required: { type: Boolean },
		documentation: {},
		htmlFor: {},
		aiSuggestion: {}
	}, {
		...smallTextPropsDefaults,
		documentation: void 0,
		htmlFor: void 0,
		aiSuggestion: void 0
	}),
	emits: ["aiApply", "aiCancel"],
	setup(__props) {
		const { classes } = useText(__props);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				space: "extrasmall",
				"vertical-align": "center",
				wrap: false,
				class: "input-label"
			}, {
				default: withCtx(() => [
					createElementVNode("label", {
						for: __props.htmlFor,
						class: normalizeClass(unref(classes))
					}, [
						createTextVNode(toDisplayString(__props.label) + " ", 1),
						createVNode(AiSuggestionIndicator_default, {
							suggestion: __props.aiSuggestion,
							onApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
							onCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
						}, null, 8, ["suggestion"]),
						__props.required ? (openBlock(), createElementBlock("span", _hoisted_2$20, " *")) : createCommentVNode("", true)
					], 10, _hoisted_1$43),
					__props.documentation ? (openBlock(), createBlock(InputDocumentationButton_default, { key: 0 }, {
						header: withCtx(() => [createTextVNode(toDisplayString(__props.label), 1)]),
						body: withCtx(() => [createVNode(MarkdownViewer_default, {
							source: __props.documentation,
							sanitize: true
						}, null, 8, ["source"])]),
						_: 1
					})) : createCommentVNode("", true),
					renderSlot(_ctx.$slots, "default", {}, void 0, true)
				]),
				_: 3
			});
		};
	}
}), [["__scopeId", "data-v-cd57ec2c"]]);
// src/components/InputMessage/InputMessage.vue
var InputMessage_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputMessage",
	props: {
		text: {},
		severity: { default: void 0 },
		maxLines: { default: 1 },
		showIcon: {
			type: Boolean,
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		const textClass = computed(() => {
			switch (props.severity) {
				case "information": return "input-message-information";
				case "warning": return "input-message-warning";
				default: return "input-message-error";
			}
		});
		const liveAttributes = computed(() => textClass.value === "input-message-error" ? { role: "alert" } : { "aria-live": "polite" });
		const iconName = computed(() => {
			switch (props.severity) {
				case "information": return "info";
				case "warning": return "warning";
				default: return "error";
			}
		});
		return (_ctx, _cache) => {
			return __props.showIcon ? (openBlock(), createBlock(HorizontalLayout_default, mergeProps({
				key: 0,
				space: "extrasmall",
				"vertical-align": "top",
				wrap: false,
				class: "input-message-row"
			}, liveAttributes.value), {
				default: withCtx(() => [createVNode(Image_default, {
					name: iconName.value,
					size: "small",
					class: normalizeClass(["input-message-icon", textClass.value])
				}, null, 8, ["name", "class"]), createVNode(Text_default, {
					size: "small",
					"max-lines": __props.maxLines,
					tooltip: __props.text,
					class: normalizeClass(["input-message", textClass.value])
				}, {
					default: withCtx(() => [createTextVNode(toDisplayString(__props.text), 1)]),
					_: 1
				}, 8, [
					"max-lines",
					"tooltip",
					"class"
				])]),
				_: 1
			}, 16)) : (openBlock(), createBlock(Text_default, mergeProps({ key: 1 }, liveAttributes.value, {
				size: "small",
				"max-lines": __props.maxLines,
				tooltip: __props.text,
				class: ["input-message", textClass.value]
			}), {
				default: withCtx(() => [createTextVNode(toDisplayString(__props.text), 1)]),
				_: 1
			}, 16, [
				"max-lines",
				"tooltip",
				"class"
			]));
		};
	}
}), [["__scopeId", "data-v-0b3173d7"]]);
// src/utils/keyboard.ts
function isTypeaheadKey(event) {
	if (event.target instanceof HTMLInputElement) return false;
	if (event.key.length !== 1) return false;
	if (event.ctrlKey || event.altKey || event.metaKey) return false;
	return !event.isComposing;
}
// src/components/Spinner/Spinner.ts?vue&type=script&src=true&lang.ts
var Spinner_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Spinner",
	props: { size: {
		type: String,
		default: "medium"
	} },
	setup(props) {
		return { spinnerClasses: computed(() => [`spinner-${props.size}`]) };
	}
});
// src/components/Spinner/Spinner.vue
function _sfc_render$17(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", { class: normalizeClass(["spinner-container", _ctx.spinnerClasses]) }, [..._cache[0] || (_cache[0] = [createElementVNode("svg", {
		class: "spinner",
		fill: "none",
		viewBox: "0 0 24 24"
	}, [createElementVNode("circle", {
		cx: "12",
		cy: "12",
		r: "10",
		stroke: "currentColor",
		"stroke-width": "4",
		style: { "opacity": "0.25" }
	}), createElementVNode("path", {
		fill: "currentColor",
		d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
	})], -1)])], 2);
}
var Spinner_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Spinner_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$17], ["__scopeId", "data-v-8740c195"]]);
// src/composables/useSelectableListFilter.ts
function useSelectableListFilter(options) {
	const searchText = ref(null);
	const showSelected = ref(false);
	const displayedItems = computed(() => {
		const items = options.items();
		if (options.multiple() && options.searchable() && showSelected.value) {
			const selectedItems = options.selectedItems();
			return items.filter((item) => selectedItems.some((selectedItem) => options.isSameItem(selectedItem, item)));
		}
		if (!options.searchable()) return items;
		const normalizedSearch = searchText.value?.trim().toLocaleLowerCase();
		if (!normalizedSearch) return items;
		return items.filter((item) => options.getItemLabel(item).toLocaleLowerCase().includes(normalizedSearch));
	});
	watch([
		options.multiple,
		options.searchable,
		() => options.selectedItems().length
	], ([multiple, searchable, selectedCount]) => {
		if (!multiple || !searchable || selectedCount === 0) showSelected.value = false;
	});
	function handleSearch(setFocusedIndex) {
		showSelected.value = false;
		setFocusedIndex(0);
	}
	function toggleShowSelected(setFocusedIndex) {
		showSelected.value = !showSelected.value;
		setFocusedIndex(0);
	}
	return {
		displayedItems,
		searchText,
		showSelected,
		handleSearch,
		toggleShowSelected
	};
}
// src/components/SelectableItem/SelectableItem.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$42 = ["type", "checked"];
// src/components/SelectableItem/SelectableItem.vue
var SelectableItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SelectableItem",
	props: {
		selected: { type: Boolean },
		focused: { type: Boolean },
		controlType: {}
	},
	emits: ["click", "checked"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		function handleClick(event) {
			if (event.target instanceof HTMLInputElement) return;
			emit("click", event);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				role: "option",
				class: "selectable-item",
				"aria-selected": __props.selected,
				"data-focused": __props.focused || void 0,
				onClick: handleClick
			}, {
				default: withCtx(() => [__props.controlType ? (openBlock(), createElementBlock("input", {
					key: 0,
					type: __props.controlType,
					checked: __props.selected,
					"aria-hidden": "true",
					tabindex: "-1",
					onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"])),
					onChange: _cache[1] || (_cache[1] = ($event) => emit("checked", $event))
				}, null, 40, _hoisted_1$42)) : createCommentVNode("", true), renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_: 3
			}, 8, ["aria-selected", "data-focused"]);
		};
	}
}), [["__scopeId", "data-v-b57dbc4f"]]);
// src/components/SelectableList/SelectableList.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$41 = [
	"id",
	"aria-busy",
	"aria-disabled",
	"aria-required",
	"data-focused",
	"aria-multiselectable",
	"aria-activedescendant",
	"tabindex"
];
// src/components/SelectableList/SelectableList.vue
var SelectableList_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SelectableList",
	props: {
		items: {},
		selectedItems: {},
		getItemKey: { type: Function },
		isSameItem: { type: Function },
		listId: {},
		multiple: { type: Boolean },
		required: { type: Boolean },
		disabled: { type: Boolean },
		loading: { type: Boolean },
		tabIndex: {},
		focusSelectedOnFocus: { type: Boolean },
		clearFocusOnBlur: { type: Boolean },
		selectOnEnter: { type: Boolean },
		selectOnTab: { type: Boolean },
		listAttributes: {}
	},
	emits: [
		"mounted",
		"select",
		"escape"
	],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const list = useTemplateRef("list");
		const focused = ref(false);
		const focusedIndex = ref(-1);
		const focusedItemId = computed(() => focusedIndex.value < 0 ? void 0 : getItemId(focusedIndex.value));
		watch(() => props.items.map(props.getItemKey), (itemKeys, previousItemKeys) => {
			if (itemKeys.length === 0) {
				focusedIndex.value = -1;
				return;
			}
			const previouslyFocusedKey = previousItemKeys?.[focusedIndex.value];
			const updatedIndex = previouslyFocusedKey === void 0 ? -1 : itemKeys.indexOf(previouslyFocusedKey);
			focusedIndex.value = updatedIndex >= 0 ? updatedIndex : Math.min(Math.max(focusedIndex.value, 0), itemKeys.length - 1);
		}, { flush: "sync" });
		onMounted(() => emit("mounted", list.value));
		function getItemId(index) {
			return `${props.listId}-option-${index}`;
		}
		function isSelected(item) {
			return props.selectedItems.some((selectedItem) => props.isSameItem(selectedItem, item));
		}
		function selectItem(item, index, originalEvent, source) {
			focusedIndex.value = index;
			emit("select", {
				item,
				index,
				source,
				originalEvent,
				checked: source === "checked" && originalEvent.target instanceof HTMLInputElement ? originalEvent.target.checked : !isSelected(item)
			});
		}
		function focusSelectedItem() {
			const selectedIndex = props.items.findIndex(isSelected);
			if (selectedIndex !== -1) {
				focusedIndex.value = selectedIndex;
				return;
			}
			if (props.items.length > 0) {
				focusedIndex.value = 0;
				return;
			}
			focusedIndex.value = -1;
		}
		function clearFocus() {
			focusedIndex.value = -1;
		}
		function setFocusedIndex(index) {
			focusedIndex.value = props.items.length === 0 ? -1 : Math.min(Math.max(index, 0), props.items.length - 1);
		}
		function handleKeydown(event) {
			const textInput = isTextInput(event);
			if (event.key === "Escape") {
				emit("escape", event);
				return;
			}
			const navigationOffset = getNavigationOffset(event.key);
			if (navigationOffset !== void 0) {
				event.preventDefault();
				setFocusedIndex(focusedIndex.value + navigationOffset);
				return;
			}
			const focusBoundary = getFocusBoundary(event.key, textInput);
			if (focusBoundary !== void 0) {
				event.preventDefault();
				setFocusedIndex(focusBoundary);
				return;
			}
			if (shouldSelectWithKeyboard(event, textInput) && hasFocusedItem()) {
				event.preventDefault();
				selectFocusedItem(event, "keyboard");
				return;
			}
			if (props.selectOnTab && event.key === "Tab" && hasFocusedItem()) selectFocusedItem(event, "tab");
		}
		function isTextInput(event) {
			return event.target instanceof HTMLInputElement && event.target.type === "text";
		}
		function getNavigationOffset(key) {
			if (key === "ArrowDown") return 1;
			if (key === "ArrowUp") return -1;
		}
		function getFocusBoundary(key, textInput) {
			if (textInput) return;
			if (key === "Home") return 0;
			if (key === "End") return props.items.length - 1;
		}
		function shouldSelectWithKeyboard(event, textInput) {
			if (event.key === " ") return !textInput;
			return props.selectOnEnter && event.key === "Enter";
		}
		function hasFocusedItem() {
			return focusedIndex.value >= 0 && focusedIndex.value < props.items.length;
		}
		function selectFocusedItem(event, source) {
			selectItem(props.items[focusedIndex.value], focusedIndex.value, event, source);
		}
		function focus() {
			if (props.disabled) return;
			list.value?.focus();
		}
		function handleListKeydown(event) {
			if (!props.disabled || event.key === "Escape") handleKeydown(event);
		}
		function handleFocus() {
			focused.value = true;
			if (props.focusSelectedOnFocus) focusSelectedItem();
		}
		function handleBlur() {
			focused.value = false;
			if (props.clearFocusOnBlur) clearFocus();
		}
		__expose({
			focusedItemId,
			focus,
			focusSelectedItem,
			clearFocus,
			setFocusedIndex
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "selectable-list",
				onKeydown: handleListKeydown
			}, [
				renderSlot(_ctx.$slots, "header", {
					focusedItemId: focusedItemId.value,
					setFocusedIndex
				}, void 0, true),
				createElementVNode("div", mergeProps({
					id: __props.listId,
					ref_key: "list",
					ref: list,
					class: "selectable-list-items"
				}, __props.listAttributes, {
					role: "listbox",
					"aria-busy": __props.loading || void 0,
					"aria-disabled": __props.disabled || void 0,
					"aria-required": __props.required || void 0,
					"data-focused": focused.value || void 0,
					"aria-multiselectable": __props.multiple || void 0,
					"aria-activedescendant": focusedItemId.value,
					tabindex: __props.disabled ? -1 : __props.tabIndex,
					onFocus: handleFocus,
					onBlur: handleBlur
				}), [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, index) => {
					return renderSlot(_ctx.$slots, "item", {
						item,
						itemId: getItemId(index),
						index,
						selected: isSelected(item),
						focused: focusedIndex.value === index,
						focus: () => !__props.disabled && (focusedIndex.value = index),
						select: (event, source) => !__props.disabled && selectItem(item, index, event, source)
					}, void 0, true, __props.getItemKey(item));
				}), 128))], 16, _hoisted_1$41),
				__props.items.length === 0 ? renderSlot(_ctx.$slots, "empty", {}, void 0, true, 0) : createCommentVNode("", true)
			], 32);
		};
	}
}), [["__scopeId", "data-v-f5948def"]]);
// src/components/SelectableList/SelectableListHeader.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$40 = { class: "selectable-list-header-search-container" };
var _hoisted_2$19 = [
	"aria-busy",
	"aria-controls",
	"aria-activedescendant",
	"aria-label",
	"placeholder",
	"disabled",
	"tabindex",
	"autofocus"
];
var _hoisted_3$11 = {
	key: 0,
	class: "selectable-list-header-search-actions"
};
// src/components/SelectableList/SelectableListHeader.vue
var SelectableListHeader_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SelectableListHeader",
	props: /*@__PURE__*/ mergeModels({
		listId: {},
		disabled: {
			type: Boolean,
			default: false
		},
		loading: { type: Boolean },
		showSelected: { type: Boolean },
		selectedCount: {},
		autofocus: {
			type: Boolean,
			default: false
		},
		tabIndex: {},
		activeDescendant: {}
	}, {
		"modelValue": { default: null },
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels(["toggleShowSelected"], ["update:modelValue"]),
	setup(__props, { expose: __expose, emit: __emit }) {
		const emit = __emit;
		const searchText = useModel(__props, "modelValue", {
			get: (value) => value,
			set: (value) => value || null
		});
		const { translate } = useGlobalResourceManager();
		const input = useTemplateRef("input");
		function focus() {
			input.value?.focus();
		}
		__expose({ focus });
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				"vertical-align": "center",
				wrap: false,
				class: "selectable-list-header"
			}, {
				default: withCtx(() => [createElementVNode("div", _hoisted_1$40, [withDirectives(createElementVNode("input", {
					ref_key: "input",
					ref: input,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => searchText.value = $event),
					role: "combobox",
					class: "selectable-list-header-search",
					autocomplete: "off",
					"aria-expanded": "true",
					"aria-autocomplete": "list",
					"aria-busy": __props.loading,
					"aria-controls": __props.listId,
					"aria-activedescendant": __props.activeDescendant,
					"aria-label": unref(translate)("Search"),
					placeholder: unref(translate)("Search"),
					disabled: __props.disabled,
					tabindex: __props.tabIndex,
					autofocus: __props.autofocus
				}, null, 8, _hoisted_2$19), [[vModelText, searchText.value]]), __props.loading || _ctx.$slots.actions ? (openBlock(), createElementBlock("div", _hoisted_3$11, [__props.loading ? (openBlock(), createBlock(Spinner_default, {
					key: 0,
					class: "selectable-list-header-search-spinner",
					size: "extrasmall"
				})) : createCommentVNode("", true), renderSlot(_ctx.$slots, "actions", {}, void 0, true)])) : createCommentVNode("", true)]), __props.selectedCount !== void 0 ? (openBlock(), createBlock(Button_default, {
					key: 0,
					variant: __props.showSelected ? "primary" : "default",
					disabled: __props.selectedCount === 0,
					"aria-label": unref(translate)(__props.showSelected ? "ShowAllValues" : "ShowSelectedValues", __props.selectedCount),
					size: "small",
					icon: "filterCheckOutline",
					label: __props.selectedCount,
					"aria-controls": __props.listId,
					"aria-pressed": __props.showSelected,
					class: "selectable-list-header-show-selected-button",
					onClick: _cache[1] || (_cache[1] = ($event) => emit("toggleShowSelected"))
				}, null, 8, [
					"variant",
					"disabled",
					"aria-label",
					"label",
					"aria-controls",
					"aria-pressed"
				])) : createCommentVNode("", true)]),
				_: 3
			});
		};
	}
}), [["__scopeId", "data-v-f55e21c7"]]);
// src/components/Select/SelectDropdown.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$39 = {
	class: "select-dropdown-empty",
	role: "status",
	"aria-live": "polite"
};
var typeaheadResetDelay = 700;
// src/components/Select/SelectDropdown.vue
var SelectDropdown_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SelectDropdown",
	props: {
		listId: {},
		options: {},
		selectedOptions: {},
		getOptionKey: { type: Function },
		getOptionLabel: { type: Function },
		isSameOption: { type: Function },
		multiple: { type: Boolean },
		searchable: { type: Boolean },
		loading: { type: Boolean },
		required: { type: Boolean }
	},
	emits: [
		"show",
		"hide",
		"select"
	],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const popover = useTemplateRef("popover");
		const selectableList = useTemplateRef("selectableList");
		const searchInput = useTemplateRef("searchInput");
		const panelWidth = ref("");
		let target = null;
		let restoreFocusOnHide = false;
		let typeaheadText = "";
		let typeaheadResetTimeout;
		let typeaheadFocusedIndex;
		const { displayedItems: displayedOptions, searchText, showSelected, handleSearch, toggleShowSelected } = useSelectableListFilter({
			items: () => props.options,
			selectedItems: () => props.selectedOptions,
			multiple: () => props.multiple,
			searchable: () => props.searchable,
			getItemLabel: props.getOptionLabel,
			isSameItem: props.isSameOption
		});
		function setTarget(popoverTarget) {
			target = popoverTarget;
			panelWidth.value = `${popoverTarget.getBoundingClientRect().width}px`;
		}
		function toggle(popoverTarget) {
			setTarget(popoverTarget);
			popover.value?.toggle(popoverTarget);
		}
		function show(popoverTarget) {
			setTarget(popoverTarget);
			popover.value?.show(popoverTarget);
		}
		async function handleShow() {
			emit("show");
			await nextTick();
			if (typeaheadFocusedIndex === void 0) selectableList.value?.focusSelectedItem();
			else {
				selectableList.value?.setFocusedIndex(typeaheadFocusedIndex);
				typeaheadFocusedIndex = void 0;
			}
			(typeaheadText ? selectableList.value : searchInput.value ?? selectableList.value)?.focus();
		}
		function handleHide() {
			resetTypeahead();
			searchText.value = "";
			showSelected.value = false;
			selectableList.value?.clearFocus();
			emit("hide");
			if (restoreFocusOnHide) {
				target?.focus();
				restoreFocusOnHide = false;
			}
		}
		function hide(restoreFocus = false) {
			restoreFocusOnHide = restoreFocus;
			popover.value?.hide();
		}
		function handleEscape(event) {
			event.preventDefault();
			hide(true);
		}
		function typeahead(popoverTarget, key) {
			const focusedIndex = findTypeaheadMatch(key);
			if (focusedIndex === -1) return;
			typeaheadFocusedIndex = focusedIndex;
			show(popoverTarget);
			selectableList.value?.setFocusedIndex(focusedIndex);
			selectableList.value?.focus();
		}
		function handleTypeaheadKeydown(event) {
			if (!isTypeaheadKey(event)) return;
			event.preventDefault();
			const focusedIndex = findTypeaheadMatch(event.key);
			if (focusedIndex !== -1) selectableList.value?.setFocusedIndex(focusedIndex);
		}
		function findTypeaheadMatch(key) {
			typeaheadText += key;
			clearTimeout(typeaheadResetTimeout);
			typeaheadResetTimeout = setTimeout(resetTypeahead, typeaheadResetDelay);
			const normalizedText = typeaheadText.toLocaleLowerCase();
			return props.options.findIndex((option) => props.getOptionLabel(option).toLocaleLowerCase().startsWith(normalizedText));
		}
		function resetTypeahead() {
			clearTimeout(typeaheadResetTimeout);
			typeaheadResetTimeout = void 0;
			typeaheadText = "";
			typeaheadFocusedIndex = void 0;
		}
		onBeforeUnmount(resetTypeahead);
		__expose({
			toggle,
			show,
			hide,
			typeahead
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Popover_default, {
				ref_key: "popover",
				ref: popover,
				"side-offset": 0,
				"show-arrow": false,
				class: "select-dropdown",
				onShow: handleShow,
				onHide: handleHide
			}, {
				default: withCtx(() => [createVNode(SelectableList_default, {
					ref_key: "selectableList",
					ref: selectableList,
					items: unref(displayedOptions),
					"selected-items": __props.selectedOptions,
					"get-item-key": __props.getOptionKey,
					"is-same-item": __props.isSameOption,
					"list-id": __props.listId,
					multiple: __props.multiple,
					disabled: __props.loading && __props.options.length > 0,
					loading: __props.loading,
					required: __props.required,
					"tab-index": -1,
					"focus-selected-on-focus": false,
					"clear-focus-on-blur": false,
					"select-on-enter": true,
					"select-on-tab": true,
					class: "select-dropdown-list",
					style: normalizeStyle({ minWidth: panelWidth.value }),
					onSelect: _cache[1] || (_cache[1] = ($event) => emit("select", $event)),
					onEscape: handleEscape,
					onKeydown: handleTypeaheadKeydown
				}, {
					header: withCtx(({ focusedItemId, setFocusedIndex }) => [__props.searchable ? (openBlock(), createBlock(SelectableListHeader_default, {
						key: 0,
						ref_key: "searchInput",
						ref: searchInput,
						modelValue: unref(searchText),
						"onUpdate:modelValue": [_cache[0] || (_cache[0] = ($event) => isRef(searchText) ? searchText.value = $event : null), ($event) => unref(handleSearch)(setFocusedIndex)],
						"list-id": __props.listId,
						"active-descendant": focusedItemId,
						loading: __props.loading,
						"selected-count": __props.multiple ? __props.selectedOptions.length : void 0,
						"show-selected": unref(showSelected),
						onToggleShowSelected: ($event) => unref(toggleShowSelected)(setFocusedIndex)
					}, null, 8, [
						"modelValue",
						"list-id",
						"active-descendant",
						"loading",
						"selected-count",
						"show-selected",
						"onUpdate:modelValue",
						"onToggleShowSelected"
					])) : createCommentVNode("", true)]),
					item: withCtx(({ item, itemId, selected, focused, focus, select }) => [(openBlock(), createBlock(SelectableItem_default, {
						key: __props.getOptionKey(item),
						id: itemId,
						class: "select-option",
						selected,
						focused,
						"control-type": __props.multiple ? "checkbox" : void 0,
						"aria-label": __props.getOptionLabel(item),
						onMouseenter: focus,
						onClick: ($event) => select($event, "click"),
						onChecked: ($event) => select($event, "checked")
					}, {
						default: withCtx(() => [renderSlot(_ctx.$slots, "option", { option: item }, () => [createTextVNode(toDisplayString(__props.getOptionLabel(item)), 1)], true)]),
						_: 2
					}, 1032, [
						"id",
						"selected",
						"focused",
						"control-type",
						"aria-label",
						"onMouseenter",
						"onClick",
						"onChecked"
					]))]),
					empty: withCtx(() => [createElementVNode("span", _hoisted_1$39, toDisplayString(unref(translate)(__props.loading ? "Loading" : __props.options.length === 0 ? "NoValues" : "NoResultFound")), 1)]),
					_: 3
				}, 8, [
					"items",
					"selected-items",
					"get-item-key",
					"is-same-item",
					"list-id",
					"multiple",
					"disabled",
					"loading",
					"required",
					"style"
				])]),
				_: 3
			}, 512);
		};
	}
}), [["__scopeId", "data-v-36f80541"]]);
// src/components/Select/Select.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$38 = [
	"id",
	"aria-expanded",
	"aria-controls",
	"aria-disabled",
	"aria-busy",
	"aria-required",
	"data-focused",
	"tabindex"
];
var _hoisted_2$18 = ["title"];
var _hoisted_3$10 = {
	key: 0,
	class: "select-invalid-value"
};
var _hoisted_4$7 = {
	key: 2,
	class: "select-placeholder"
};
var _hoisted_5$6 = { class: "select-actions" };
var _hoisted_6$4 = ["aria-label"];
var _hoisted_7$4 = ["aria-label"];
// src/components/Select/Select.vue
var Select_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Select",
	props: {
		multiple: { type: Boolean },
		modelValue: {},
		id: {},
		values: {},
		required: { type: Boolean },
		disabled: { type: Boolean },
		keyProperty: {},
		displayProperty: {},
		searchable: { type: Boolean },
		loading: { type: Boolean },
		caret: { type: Boolean },
		invalidValue: {},
		placeholder: {},
		tabIndex: {}
	},
	emits: [
		"mounted",
		"hide",
		"show",
		"update:modelValue"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { getItemKey: getOptionKey, getItemLabel: getOptionLabel, isSameItem: isSameOption } = useSelectableItemProperties(props);
		const { translate } = useGlobalResourceManager();
		const trigger = useTemplateRef("trigger");
		const popover = useTemplateRef("popover");
		const open = ref(false);
		const { focused } = useFocus(trigger);
		const listboxId = computed(() => `${props.id}-listbox`);
		const triggerTabIndex = computed(() => props.disabled ? -1 : props.tabIndex ?? 0);
		const dataFocused = computed(() => open.value || focused.value || void 0);
		const selectedOptions = computed(() => {
			if (props.multiple) return Array.isArray(props.modelValue) ? props.modelValue : [];
			return props.modelValue == null ? [] : [props.modelValue];
		});
		const clearable = computed(() => !props.required && !props.disabled && selectedOptions.value.length > 0);
		onMounted(() => emit("mounted", trigger.value));
		function handleToggle() {
			if (!props.disabled) {
				trigger.value.focus();
				popover.value?.toggle(trigger.value);
			}
		}
		function handleKeydown(event) {
			if (props.disabled) return;
			if (clearable.value && (event.key === "Backspace" || event.key === "Delete")) {
				event.preventDefault();
				handleClear();
				return;
			}
			if (event.key === "Enter" || event.key === " " || event.key === "ArrowDown") {
				event.preventDefault();
				popover.value?.show(trigger.value);
				return;
			}
			if (isTypeaheadKey(event)) {
				event.preventDefault();
				popover.value?.typeahead(trigger.value, event.key);
			}
		}
		function handleClear() {
			trigger.value.focus();
			clear();
		}
		function handleDropdownShow() {
			open.value = true;
			emit("show");
		}
		function handleDropdownHide() {
			open.value = false;
			emit("hide");
		}
		function handleSelectOption(event) {
			if (props.multiple) {
				const modelValue = Array.isArray(props.modelValue) ? props.modelValue : [];
				emit("update:modelValue", event.checked ? [...modelValue, event.item] : modelValue.filter((selectedOption) => !isSameOption(selectedOption, event.item)));
				if (event.source === "tab") popover.value?.hide();
				return;
			}
			if (props.modelValue == null || !isSameOption(props.modelValue, event.item)) emit("update:modelValue", event.item);
			popover.value?.hide(true);
		}
		function removeOption(option) {
			if (!props.multiple) return;
			const updatedModelValue = selectedOptions.value.filter((selectedOption) => !isSameOption(selectedOption, option));
			if (updatedModelValue.length !== selectedOptions.value.length) emit("update:modelValue", updatedModelValue);
		}
		function clear() {
			emit("update:modelValue", props.multiple ? [] : null);
		}
		const tooltip = computed(() => selectedOptions.value.map(getOptionLabel).join(", "));
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "trigger",
				ref: trigger,
				class: "select",
				id: __props.id,
				role: "combobox",
				"aria-haspopup": "listbox",
				"aria-expanded": open.value,
				"aria-controls": __props.disabled ? void 0 : listboxId.value,
				"aria-disabled": __props.disabled,
				"aria-busy": __props.loading,
				"aria-required": __props.required || void 0,
				"data-focused": dataFocused.value,
				tabindex: triggerTabIndex.value,
				onClick: handleToggle,
				onKeydown: handleKeydown
			}, [
				renderSlot(_ctx.$slots, "before", {}, void 0, true),
				createElementVNode("div", {
					class: "select-values",
					title: tooltip.value
				}, [__props.invalidValue != null ? (openBlock(), createElementBlock("span", _hoisted_3$10, toDisplayString(__props.invalidValue), 1)) : selectedOptions.value.length > 0 ? renderSlot(_ctx.$slots, "values", {
					getOptionKey: unref(getOptionKey),
					getOptionLabel: unref(getOptionLabel),
					removeOption
				}, void 0, true, 1) : __props.placeholder ? (openBlock(), createElementBlock("span", _hoisted_4$7, toDisplayString(__props.placeholder), 1)) : createCommentVNode("", true)], 8, _hoisted_2$18),
				createElementVNode("div", _hoisted_5$6, [
					__props.loading ? (openBlock(), createBlock(Spinner_default, {
						key: 0,
						class: "select-loading-spinner",
						size: "extrasmall"
					})) : createCommentVNode("", true),
					renderSlot(_ctx.$slots, "after", {}, void 0, true),
					clearable.value ? (openBlock(), createElementBlock("button", {
						key: 1,
						type: "button",
						class: "select-clear-button input-clear-button",
						"aria-label": unref(translate)("Clear"),
						tabindex: "-1",
						onClick: withModifiers(handleClear, ["stop"])
					}, [createVNode(Image_default, {
						name: "erase",
						size: "small"
					})], 8, _hoisted_6$4)) : createCommentVNode("", true),
					__props.caret && !__props.disabled ? (openBlock(), createElementBlock("button", {
						key: 2,
						type: "button",
						class: "select-caret-button",
						"aria-label": unref(translate)("Choose"),
						tabindex: "-1",
						onClick: withModifiers(handleToggle, ["stop"])
					}, [createVNode(Image_default, { name: "chevronDown" })], 8, _hoisted_7$4)) : createCommentVNode("", true)
				]),
				!__props.disabled ? (openBlock(), createBlock(SelectDropdown_default, {
					key: 0,
					ref_key: "popover",
					ref: popover,
					"list-id": listboxId.value,
					options: __props.values,
					"selected-options": selectedOptions.value,
					"get-option-key": unref(getOptionKey),
					"get-option-label": unref(getOptionLabel),
					"is-same-option": unref(isSameOption),
					multiple: __props.multiple,
					searchable: __props.searchable,
					loading: __props.loading,
					required: __props.required,
					onShow: handleDropdownShow,
					onHide: handleDropdownHide,
					onSelect: handleSelectOption
				}, {
					option: withCtx(({ option }) => [renderSlot(_ctx.$slots, "option", {
						option,
						getOptionLabel: unref(getOptionLabel)
					}, () => [createTextVNode(toDisplayString(unref(getOptionLabel)(option)), 1)], true)]),
					_: 3
				}, 8, [
					"list-id",
					"options",
					"selected-options",
					"get-option-key",
					"get-option-label",
					"is-same-option",
					"multiple",
					"searchable",
					"loading",
					"required"
				])) : createCommentVNode("", true)
			], 40, _hoisted_1$38);
		};
	}
}), [["__scopeId", "data-v-0f8e405d"]]);
// src/components/Combobox/Combobox.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$37 = { class: "combobox-value" };
// src/components/Combobox/Combobox.vue
var Combobox_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Combobox",
	props: {
		...inputProps,
		...contentProps,
		modelValue: {
			type: null,
			default: null
		},
		invalidValue: {
			type: String,
			default: void 0
		},
		values: {
			type: Array,
			default: []
		},
		keyProperty: {
			type: String,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		searchable: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		caret: {
			type: Boolean,
			default: true
		}
	},
	emits: [
		...inputEmits,
		"update:invalidValue",
		"show",
		"hide"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const contentStyleObject = useContentStyle(props);
		const emit = __emit;
		const invalidValue = useInputInvalidValue(props, emit);
		const { input, id, classes, ariaAttributes, isLabelVisible, isMessageVisible, messageId, tabIndex } = useInput(props, emit);
		const { disabledOrReadonly, keyProperty, displayProperty, getOptionValue } = useSelectProps(props);
		const { getItemLabel: getOptionLabel, isSameItem: isSameOption } = useSelectableItemProperties(reactive({
			keyProperty,
			displayProperty
		}));
		watch([
			getInvalidValue,
			() => props.modelValue,
			() => props.values
		], ([value]) => invalidValue.value = value, { immediate: true });
		const selectedOption = computed({
			get() {
				return props.valueProperty ? findOption(props.modelValue) : props.modelValue;
			},
			set(value) {
				emit("update:modelValue", getOptionValue(value));
			}
		});
		function getInvalidValue() {
			const value = props.modelValue;
			if (value == null) return null;
			if (props.valueProperty) return props.values.some((option) => getOptionValue(option) === value) ? null : String(value);
			if (props.keyProperty ? props.values.some((option) => isSameOption(option, value)) : props.values.includes(value)) return null;
			return typeof value === "object" ? getOptionLabel(value) : String(value);
		}
		function findOption(value) {
			return props.values.find((option) => getOptionValue(option) === value);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["combobox neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(Select_default, mergeProps({ id: unref(id) }, {
				...unref(ariaAttributes),
				"aria-label": _ctx.label
			}, {
				modelValue: selectedOption.value,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => selectedOption.value = $event),
				values: __props.values,
				"key-property": unref(keyProperty),
				"display-property": unref(displayProperty),
				required: _ctx.required,
				disabled: unref(disabledOrReadonly),
				loading: __props.loading,
				caret: __props.caret,
				searchable: __props.searchable,
				"invalid-value": unref(invalidValue),
				placeholder: _ctx.placeholder,
				"tab-index": unref(tabIndex),
				"show-selection-control": false,
				class: ["neos-input-content", _ctx.contentClass],
				style: unref(contentStyleObject),
				onMounted: _cache[3] || (_cache[3] = ($event) => input.value = $event),
				onShow: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("show")),
				onHide: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("hide"))
			}), {
				before: withCtx(() => [renderSlot(_ctx.$slots, "before", {}, void 0, true)]),
				values: withCtx(({ getOptionLabel }) => [createElementVNode("span", _hoisted_1$37, [renderSlot(_ctx.$slots, "value", { option: selectedOption.value }, () => [createTextVNode(toDisplayString(getOptionLabel(selectedOption.value)), 1)], true)])]),
				after: withCtx(() => [renderSlot(_ctx.$slots, "after", {}, void 0, true)]),
				option: withCtx(({ option, getOptionLabel }) => [renderSlot(_ctx.$slots, "option", { option }, () => [createTextVNode(toDisplayString(getOptionLabel(option)), 1)], true)]),
				_: 3
			}, 16, [
				"id",
				"modelValue",
				"values",
				"key-property",
				"display-property",
				"required",
				"disabled",
				"loading",
				"caret",
				"searchable",
				"invalid-value",
				"placeholder",
				"tab-index",
				"class",
				"style"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				id: unref(messageId),
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, [
				"id",
				"text",
				"severity"
			])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-ca11824f"]]);
// src/components/BooleanCombobox/BooleanCombobox.vue
var BooleanCombobox_default = /* @__PURE__ */ defineComponent({
	__name: "BooleanCombobox",
	props: {
		...inputProps,
		modelValue: {
			type: Boolean,
			default: void 0
		},
		trueDisplay: {
			type: String,
			default: "Yes"
		},
		falseDisplay: {
			type: String,
			default: "No"
		},
		nullDisplay: {
			type: String,
			default: "Undefined"
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const focused = useVModel(props, "focused", emit);
		const values = [
			{
				caption: translate(props.trueDisplay),
				value: true
			},
			{
				caption: translate(props.falseDisplay),
				value: false
			},
			{
				caption: translate(props.nullDisplay),
				value: null
			}
		];
		function handleChange(value) {
			emit("update:modelValue", value);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Combobox_default, {
				focused: unref(focused),
				"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => isRef(focused) ? focused.value = $event : null),
				"model-value": __props.modelValue,
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				readonly: _ctx.readonly,
				required: _ctx.required,
				"input-display-mode": _ctx.inputDisplayMode,
				"tab-stop": _ctx.tabStop,
				values,
				"value-property": "value",
				"display-property": "caption",
				"onUpdate:modelValue": handleChange
			}, null, 8, [
				"focused",
				"model-value",
				"label",
				"label-position",
				"readonly",
				"required",
				"input-display-mode",
				"tab-stop"
			]);
		};
	}
});
// src/composables/useCalendar.ts
var cellsPerRow = 4;
var rowsPerColumn = 3;
var cellsPerColumn = 12;
function toCalendarDate(date) {
	return date ? new CalendarDate(date.getFullYear(), date.getMonth() + 1, date.getDate()) : void 0;
}
function toDate(value) {
	return value ? value.toDate(getLocalTimeZone()) : null;
}
function chunk(items, size) {
	return Array.from({ length: Math.ceil(items.length / size) }, (_, index) => items.slice(index * size, (index + 1) * size));
}
function useCalendar(date, props, view) {
	const localizator = useLocalizator();
	const locale = computed(() => localizator.currentCulture);
	const minValue = computed(() => toCalendarDate(props.minValue));
	const maxValue = computed(() => toCalendarDate(props.maxValue));
	const hasSwitchedView = ref(false);
	const placeholder = shallowRef(toCalendarDate(date.value) ?? today(getLocalTimeZone()));
	watch(date, (value) => {
		const calendarDate = toCalendarDate(value);
		if (calendarDate) placeholder.value = calendarDate;
	});
	const firstMonthColumnYear = ref(placeholder.value.year);
	watch(view, (value) => {
		if (value === "month") firstMonthColumnYear.value = placeholder.value.year;
	});
	watch(placeholder, (value) => {
		if (value.year < firstMonthColumnYear.value) firstMonthColumnYear.value = value.year;
		else if (value.year >= firstMonthColumnYear.value + props.numberOfColumns) firstMonthColumnYear.value = value.year - props.numberOfColumns + 1;
	});
	const monthColumns = computed(() => Array.from({ length: props.numberOfColumns }, (_, index) => {
		const year = firstMonthColumnYear.value + index;
		const months = Array.from({ length: cellsPerColumn }, (_, month) => placeholder.value.set({
			year,
			month: month + 1,
			day: 1
		}));
		return {
			key: String(year),
			caption: String(year),
			rows: chunk(months, cellsPerRow)
		};
	}));
	function nextMonthPage(value) {
		return value.set({ year: firstMonthColumnYear.value + props.numberOfColumns });
	}
	function previousMonthPage(value) {
		return value.set({ year: firstMonthColumnYear.value - 1 });
	}
	const yearsPerPage = computed(() => cellsPerColumn * props.numberOfColumns);
	function toYearColumns(rows) {
		return chunk(rows, rowsPerColumn).map((columnRows) => {
			const lastRow = columnRows[columnRows.length - 1];
			const first = columnRows[0][0].year;
			const last = lastRow[lastRow.length - 1].year;
			return {
				key: String(first),
				caption: `${first} – ${last}`,
				rows: columnRows
			};
		});
	}
	function switchView(nextView) {
		hasSwitchedView.value = true;
		view.value = nextView;
	}
	const monthFormatter = computed(() => new Intl.DateTimeFormat(locale.value, { month: "long" }));
	function formatMonth(value) {
		return monthFormatter.value.format(value.toDate(getLocalTimeZone()));
	}
	function clamp(value) {
		if (minValue.value && value.compare(minValue.value) < 0) return minValue.value;
		if (maxValue.value && value.compare(maxValue.value) > 0) return maxValue.value;
		return value;
	}
	return {
		locale,
		hasSwitchedView,
		placeholder,
		minValue,
		maxValue,
		monthColumns,
		yearsPerPage,
		nextMonthPage,
		previousMonthPage,
		toYearColumns,
		switchView,
		formatMonth,
		clamp
	};
}
// src/components/Calendar/Calendar.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$36 = { class: "calendar-header" };
var _hoisted_2$17 = {
	key: 1,
	class: "calendar-nav-placeholder"
};
var _hoisted_3$9 = {
	key: 2,
	class: "calendar-heading"
};
var _hoisted_4$6 = { class: "calendar-heading-text calendar-month-caption" };
var _hoisted_5$5 = { class: "calendar-heading-text" };
var _hoisted_6$3 = {
	key: 3,
	class: "calendar-heading"
};
var _hoisted_7$3 = {
	key: 5,
	class: "calendar-nav-placeholder"
};
var _hoisted_8$3 = { class: "calendar-header" };
var _hoisted_9$2 = {
	key: 1,
	class: "calendar-nav-placeholder"
};
var _hoisted_10$2 = {
	key: 2,
	class: "calendar-heading calendar-heading-text"
};
var _hoisted_11$1 = {
	key: 5,
	class: "calendar-nav-placeholder"
};
var _hoisted_12$1 = { class: "calendar-header" };
var _hoisted_13$1 = {
	key: 1,
	class: "calendar-nav-placeholder"
};
var _hoisted_14$1 = { class: "calendar-heading" };
var _hoisted_15$1 = {
	key: 3,
	class: "calendar-nav-placeholder"
};
// src/components/Calendar/Calendar.vue
var Calendar_default = /* @__PURE__ */ defineComponent({
	__name: "Calendar",
	props: /*@__PURE__*/ mergeModels({
		minValue: { default: void 0 },
		maxValue: { default: void 0 },
		numberOfColumns: { default: 1 },
		selectionView: { default: "day" },
		viewLocked: {
			type: Boolean,
			default: false
		}
	}, {
		"modelValue": { default: null },
		"modelModifiers": {},
		"view": { default: "day" },
		"viewModifiers": {}
	}),
	emits: ["update:modelValue", "update:view"],
	setup(__props) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const view = useModel(__props, "view");
		const { locale, hasSwitchedView, placeholder, minValue, maxValue, monthColumns, yearsPerPage, nextMonthPage, previousMonthPage, toYearColumns, switchView, formatMonth, clamp } = useCalendar(modelValue, props, view);
		const hideOtherMonths = computed(() => props.numberOfColumns > 1);
		const selectedDate = computed(() => toCalendarDate(modelValue.value));
		const monthPickerValue = computed(() => props.selectionView === "month" ? selectedDate.value : placeholder.value);
		const yearPickerValue = computed(() => props.selectionView === "year" ? selectedDate.value : placeholder.value);
		function onDateSelect(value) {
			modelValue.value = toDate(value);
		}
		function onMonthSelect(value) {
			if (props.selectionView === "month") {
				modelValue.value = toDate(value && clamp(startOfMonth(value)));
				return;
			}
			if (value) placeholder.value = value;
			switchView("day");
		}
		function onYearSelect(value) {
			if (props.selectionView === "year") {
				modelValue.value = toDate(value && clamp(startOfYear(value)));
				return;
			}
			if (value) placeholder.value = value;
			switchView("month");
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["calendar", { "calendar-hide-other-months": hideOtherMonths.value }]) }, [view.value === "day" ? (openBlock(), createBlock(unref(CalendarRoot), {
				key: 0,
				placeholder: unref(placeholder),
				"onUpdate:placeholder": _cache[2] || (_cache[2] = ($event) => isRef(placeholder) ? placeholder.value = $event : null),
				"model-value": selectedDate.value,
				locale: unref(locale),
				"min-value": unref(minValue),
				"max-value": unref(maxValue),
				"number-of-months": __props.numberOfColumns,
				"initial-focus": unref(hasSwitchedView),
				"disable-days-outside-current-view": hideOtherMonths.value,
				"fixed-weeks": "",
				class: "calendar-days",
				"onUpdate:modelValue": onDateSelect
			}, {
				default: withCtx(({ weekDays, grid }) => [(openBlock(true), createElementBlock(Fragment, null, renderList(grid, (month, index) => {
					return openBlock(), createElementBlock("div", {
						key: month.value.toString(),
						class: "calendar-month"
					}, [createElementVNode("div", _hoisted_1$36, [
						index === 0 ? (openBlock(), createBlock(unref(CalendarPrev), {
							key: 0,
							class: "calendar-nav-button calendar-prev"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronLeft",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_2$17)),
						__props.viewLocked ? (openBlock(), createElementBlock("div", _hoisted_3$9, [createElementVNode("span", _hoisted_4$6, toDisplayString(unref(formatMonth)(month.value)), 1), createElementVNode("span", _hoisted_5$5, toDisplayString(month.value.year), 1)])) : (openBlock(), createElementBlock("div", _hoisted_6$3, [createElementVNode("button", {
							type: "button",
							class: "calendar-heading-button calendar-month-button",
							onClick: _cache[0] || (_cache[0] = ($event) => unref(switchView)("month"))
						}, toDisplayString(unref(formatMonth)(month.value)), 1), createElementVNode("button", {
							type: "button",
							class: "calendar-heading-button calendar-year-button",
							onClick: _cache[1] || (_cache[1] = ($event) => unref(switchView)("year"))
						}, toDisplayString(month.value.year), 1)])),
						index === grid.length - 1 ? (openBlock(), createBlock(unref(CalendarNext), {
							key: 4,
							class: "calendar-nav-button calendar-next"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronRight",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_7$3))
					]), createVNode(unref(CalendarGrid), { class: "calendar-grid" }, {
						default: withCtx(() => [createVNode(unref(CalendarGridHead), null, {
							default: withCtx(() => [createVNode(unref(CalendarGridRow), { class: "calendar-week" }, {
								default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(weekDays, (day) => {
									return openBlock(), createBlock(unref(CalendarHeadCell), {
										key: day,
										class: "calendar-week-day"
									}, {
										default: withCtx(() => [createTextVNode(toDisplayString(day), 1)]),
										_: 2
									}, 1024);
								}), 128))]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024), createVNode(unref(CalendarGridBody), null, {
							default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(month.rows, (weekDates, weekIndex) => {
								return openBlock(), createBlock(unref(CalendarGridRow), {
									key: `week-${weekIndex}`,
									class: "calendar-week"
								}, {
									default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(weekDates, (weekDate) => {
										return openBlock(), createBlock(unref(CalendarCell), {
											key: weekDate.toString(),
											date: weekDate,
											class: "calendar-cell"
										}, {
											default: withCtx(() => [createVNode(unref(CalendarCellTrigger), {
												day: weekDate,
												month: month.value,
												class: "calendar-cell-trigger calendar-day"
											}, null, 8, ["day", "month"])]),
											_: 2
										}, 1032, ["date"]);
									}), 128))]),
									_: 2
								}, 1024);
							}), 128))]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)]);
				}), 128))]),
				_: 1
			}, 8, [
				"placeholder",
				"model-value",
				"locale",
				"min-value",
				"max-value",
				"number-of-months",
				"initial-focus",
				"disable-days-outside-current-view"
			])) : view.value === "month" ? (openBlock(), createBlock(unref(MonthPickerRoot), {
				key: 1,
				placeholder: unref(placeholder),
				"onUpdate:placeholder": _cache[4] || (_cache[4] = ($event) => isRef(placeholder) ? placeholder.value = $event : null),
				"model-value": monthPickerValue.value,
				locale: unref(locale),
				"min-value": unref(minValue),
				"max-value": unref(maxValue),
				"next-page": unref(nextMonthPage),
				"prev-page": unref(previousMonthPage),
				"initial-focus": unref(hasSwitchedView),
				class: "calendar-pickers",
				"onUpdate:modelValue": _cache[5] || (_cache[5] = (value) => onMonthSelect(value))
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(monthColumns), (column, index) => {
					return openBlock(), createElementBlock("div", {
						key: column.key,
						class: "calendar-picker"
					}, [createElementVNode("div", _hoisted_8$3, [
						index === 0 ? (openBlock(), createBlock(unref(MonthPickerPrev), {
							key: 0,
							class: "calendar-nav-button calendar-prev"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronLeft",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_9$2)),
						__props.viewLocked ? (openBlock(), createElementBlock("span", _hoisted_10$2, toDisplayString(column.caption), 1)) : (openBlock(), createElementBlock("button", {
							key: 3,
							type: "button",
							class: "calendar-heading-button calendar-year-button",
							onClick: _cache[3] || (_cache[3] = ($event) => unref(switchView)("year"))
						}, toDisplayString(column.caption), 1)),
						index === __props.numberOfColumns - 1 ? (openBlock(), createBlock(unref(MonthPickerNext), {
							key: 4,
							class: "calendar-nav-button calendar-next"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronRight",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_11$1))
					]), createVNode(unref(MonthPickerGrid), { class: "calendar-grid" }, {
						default: withCtx(() => [createVNode(unref(MonthPickerGridBody), null, {
							default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(column.rows, (monthRow, rowIndex) => {
								return openBlock(), createBlock(unref(MonthPickerGridRow), {
									key: `month-row-${rowIndex}`,
									class: "calendar-picker-row"
								}, {
									default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(monthRow, (month) => {
										return openBlock(), createBlock(unref(MonthPickerCell), {
											key: month.toString(),
											date: month
										}, {
											default: withCtx(() => [createVNode(unref(MonthPickerCellTrigger), {
												month,
												class: "calendar-cell-trigger calendar-picker-cell"
											}, null, 8, ["month"])]),
											_: 2
										}, 1032, ["date"]);
									}), 128))]),
									_: 2
								}, 1024);
							}), 128))]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)]);
				}), 128))]),
				_: 1
			}, 8, [
				"placeholder",
				"model-value",
				"locale",
				"min-value",
				"max-value",
				"next-page",
				"prev-page",
				"initial-focus"
			])) : (openBlock(), createBlock(unref(YearPickerRoot), {
				key: 2,
				placeholder: unref(placeholder),
				"onUpdate:placeholder": _cache[6] || (_cache[6] = ($event) => isRef(placeholder) ? placeholder.value = $event : null),
				"model-value": yearPickerValue.value,
				locale: unref(locale),
				"min-value": unref(minValue),
				"max-value": unref(maxValue),
				"years-per-page": unref(yearsPerPage),
				"initial-focus": unref(hasSwitchedView),
				class: "calendar-pickers",
				"onUpdate:modelValue": _cache[7] || (_cache[7] = (value) => onYearSelect(value))
			}, {
				default: withCtx(({ grid }) => [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(toYearColumns)(grid.rows), (column, index) => {
					return openBlock(), createElementBlock("div", {
						key: column.key,
						class: "calendar-picker"
					}, [createElementVNode("div", _hoisted_12$1, [
						index === 0 ? (openBlock(), createBlock(unref(YearPickerPrev), {
							key: 0,
							class: "calendar-nav-button calendar-prev"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronLeft",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_13$1)),
						createElementVNode("span", _hoisted_14$1, toDisplayString(column.caption), 1),
						index === __props.numberOfColumns - 1 ? (openBlock(), createBlock(unref(YearPickerNext), {
							key: 2,
							class: "calendar-nav-button calendar-next"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronRight",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_15$1))
					]), createVNode(unref(YearPickerGrid), { class: "calendar-grid" }, {
						default: withCtx(() => [createVNode(unref(YearPickerGridBody), null, {
							default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(column.rows, (yearRow, rowIndex) => {
								return openBlock(), createBlock(unref(YearPickerGridRow), {
									key: `year-row-${rowIndex}`,
									class: "calendar-picker-row"
								}, {
									default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(yearRow, (year) => {
										return openBlock(), createBlock(unref(YearPickerCell), {
											key: year.toString(),
											date: year
										}, {
											default: withCtx(() => [createVNode(unref(YearPickerCellTrigger), {
												year,
												class: "calendar-cell-trigger calendar-picker-cell"
											}, null, 8, ["year"])]),
											_: 2
										}, 1032, ["date"]);
									}), 128))]),
									_: 2
								}, 1024);
							}), 128))]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)]);
				}), 128))]),
				_: 1
			}, 8, [
				"placeholder",
				"model-value",
				"locale",
				"min-value",
				"max-value",
				"years-per-page",
				"initial-focus"
			]))], 2);
		};
	}
});
// src/components/CalendarRange/CalendarRange.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$35 = { class: "calendar-header" };
var _hoisted_2$16 = {
	key: 1,
	class: "calendar-nav-placeholder"
};
var _hoisted_3$8 = {
	key: 2,
	class: "calendar-heading"
};
var _hoisted_4$5 = { class: "calendar-heading-text calendar-month-caption" };
var _hoisted_5$4 = { class: "calendar-heading-text" };
var _hoisted_6$2 = {
	key: 3,
	class: "calendar-heading"
};
var _hoisted_7$2 = {
	key: 5,
	class: "calendar-nav-placeholder"
};
var _hoisted_8$2 = { class: "calendar-header" };
var _hoisted_9$1 = {
	key: 1,
	class: "calendar-nav-placeholder"
};
var _hoisted_10$1 = { class: "calendar-heading" };
var _hoisted_11 = {
	key: 0,
	class: "calendar-heading-text"
};
var _hoisted_12 = ["aria-label", "title"];
var _hoisted_13 = {
	key: 3,
	class: "calendar-nav-placeholder"
};
var _hoisted_14 = { class: "calendar-header" };
var _hoisted_15 = {
	key: 1,
	class: "calendar-nav-placeholder"
};
var _hoisted_16 = { class: "calendar-heading" };
var _hoisted_17 = { class: "calendar-heading-caption" };
var _hoisted_18 = ["aria-label", "title"];
var _hoisted_19 = {
	key: 3,
	class: "calendar-nav-placeholder"
};
// src/components/CalendarRange/CalendarRange.vue
var CalendarRange_default = /* @__PURE__ */ defineComponent({
	__name: "CalendarRange",
	props: /*@__PURE__*/ mergeModels({
		minValue: { default: void 0 },
		maxValue: { default: void 0 },
		numberOfColumns: { default: 1 },
		viewLocked: {
			type: Boolean,
			default: false
		}
	}, {
		"start": { default: null },
		"startModifiers": {},
		"end": { default: null },
		"endModifiers": {},
		"view": { default: "day" },
		"viewModifiers": {}
	}),
	emits: [
		"update:start",
		"update:end",
		"update:view"
	],
	setup(__props) {
		const props = __props;
		const start = useModel(__props, "start");
		const end = useModel(__props, "end");
		const view = useModel(__props, "view");
		const { translate } = useGlobalResourceManager();
		const { locale, hasSwitchedView, placeholder, minValue, maxValue, monthColumns, yearsPerPage, nextMonthPage, previousMonthPage, toYearColumns, switchView, formatMonth, clamp } = useCalendar(start, props, view);
		const hideOtherMonths = computed(() => props.numberOfColumns > 1);
		const range = computed(() => ({
			start: toCalendarDate(start.value),
			end: toCalendarDate(end.value)
		}));
		function onDayRangeChange(value) {
			start.value = toDate(value.start);
			end.value = toDate(value.end);
		}
		function onMonthRangeChange(value) {
			start.value = toDate(value.start && clamp(startOfMonth(value.start)));
			end.value = toDate(value.end && clamp(endOfMonth(value.end)));
		}
		function onYearRangeChange(value) {
			start.value = toDate(value.start && clamp(startOfYear(value.start)));
			end.value = toDate(value.end && clamp(endOfYear(value.end)));
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["calendar calendar-range", {
				"calendar-range-complete": start.value && end.value,
				"calendar-hide-other-months": hideOtherMonths.value
			}]) }, [view.value === "day" ? (openBlock(), createBlock(unref(RangeCalendarRoot), {
				key: 0,
				placeholder: unref(placeholder),
				"onUpdate:placeholder": _cache[2] || (_cache[2] = ($event) => isRef(placeholder) ? placeholder.value = $event : null),
				"model-value": range.value,
				locale: unref(locale),
				"min-value": unref(minValue),
				"max-value": unref(maxValue),
				"number-of-months": __props.numberOfColumns,
				"initial-focus": unref(hasSwitchedView),
				"disable-days-outside-current-view": hideOtherMonths.value,
				"fixed-weeks": "",
				class: "calendar-days",
				"onUpdate:modelValue": onDayRangeChange
			}, {
				default: withCtx(({ weekDays, grid }) => [(openBlock(true), createElementBlock(Fragment, null, renderList(grid, (month, index) => {
					return openBlock(), createElementBlock("div", {
						key: month.value.toString(),
						class: "calendar-month"
					}, [createElementVNode("div", _hoisted_1$35, [
						index === 0 ? (openBlock(), createBlock(unref(RangeCalendarPrev), {
							key: 0,
							class: "calendar-nav-button calendar-prev"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronLeft",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_2$16)),
						__props.viewLocked ? (openBlock(), createElementBlock("div", _hoisted_3$8, [createElementVNode("span", _hoisted_4$5, toDisplayString(unref(formatMonth)(month.value)), 1), createElementVNode("span", _hoisted_5$4, toDisplayString(month.value.year), 1)])) : (openBlock(), createElementBlock("div", _hoisted_6$2, [createElementVNode("button", {
							type: "button",
							class: "calendar-heading-button calendar-month-button",
							onClick: _cache[0] || (_cache[0] = ($event) => unref(switchView)("month"))
						}, toDisplayString(unref(formatMonth)(month.value)), 1), createElementVNode("button", {
							type: "button",
							class: "calendar-heading-button calendar-year-button",
							onClick: _cache[1] || (_cache[1] = ($event) => unref(switchView)("year"))
						}, toDisplayString(month.value.year), 1)])),
						index === grid.length - 1 ? (openBlock(), createBlock(unref(RangeCalendarNext), {
							key: 4,
							class: "calendar-nav-button calendar-next"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronRight",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_7$2))
					]), createVNode(unref(RangeCalendarGrid), { class: "calendar-grid" }, {
						default: withCtx(() => [createVNode(unref(RangeCalendarGridHead), null, {
							default: withCtx(() => [createVNode(unref(RangeCalendarGridRow), { class: "calendar-week" }, {
								default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(weekDays, (day) => {
									return openBlock(), createBlock(unref(RangeCalendarHeadCell), {
										key: day,
										class: "calendar-week-day"
									}, {
										default: withCtx(() => [createTextVNode(toDisplayString(day), 1)]),
										_: 2
									}, 1024);
								}), 128))]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024), createVNode(unref(RangeCalendarGridBody), null, {
							default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(month.rows, (weekDates, weekIndex) => {
								return openBlock(), createBlock(unref(RangeCalendarGridRow), {
									key: `week-${weekIndex}`,
									class: "calendar-week"
								}, {
									default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(weekDates, (weekDate) => {
										return openBlock(), createBlock(unref(RangeCalendarCell), {
											key: weekDate.toString(),
											date: weekDate,
											class: "calendar-cell"
										}, {
											default: withCtx(() => [createVNode(unref(RangeCalendarCellTrigger), {
												day: weekDate,
												month: month.value,
												class: "calendar-cell-trigger calendar-day"
											}, null, 8, ["day", "month"])]),
											_: 2
										}, 1032, ["date"]);
									}), 128))]),
									_: 2
								}, 1024);
							}), 128))]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)]);
				}), 128))]),
				_: 1
			}, 8, [
				"placeholder",
				"model-value",
				"locale",
				"min-value",
				"max-value",
				"number-of-months",
				"initial-focus",
				"disable-days-outside-current-view"
			])) : view.value === "month" ? (openBlock(), createBlock(unref(MonthRangePickerRoot), {
				key: 1,
				placeholder: unref(placeholder),
				"onUpdate:placeholder": _cache[5] || (_cache[5] = ($event) => isRef(placeholder) ? placeholder.value = $event : null),
				"model-value": range.value,
				locale: unref(locale),
				"min-value": unref(minValue),
				"max-value": unref(maxValue),
				"next-page": unref(nextMonthPage),
				"prev-page": unref(previousMonthPage),
				"initial-focus": unref(hasSwitchedView),
				class: "calendar-pickers",
				"onUpdate:modelValue": onMonthRangeChange
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(monthColumns), (column, index) => {
					return openBlock(), createElementBlock("div", {
						key: column.key,
						class: "calendar-picker"
					}, [createElementVNode("div", _hoisted_8$2, [
						index === 0 ? (openBlock(), createBlock(unref(MonthRangePickerPrev), {
							key: 0,
							class: "calendar-nav-button calendar-prev"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronLeft",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_9$1)),
						createElementVNode("div", _hoisted_10$1, [__props.viewLocked ? (openBlock(), createElementBlock("span", _hoisted_11, toDisplayString(column.caption), 1)) : (openBlock(), createElementBlock("button", {
							key: 1,
							type: "button",
							class: "calendar-heading-button calendar-year-button",
							onClick: _cache[3] || (_cache[3] = ($event) => unref(switchView)("year"))
						}, toDisplayString(column.caption), 1)), index === 0 && !__props.viewLocked ? (openBlock(), createElementBlock("button", {
							key: 2,
							type: "button",
							class: "calendar-nav-button calendar-days-button",
							"aria-label": unref(translate)("Calendar_BackToDays"),
							title: unref(translate)("Calendar_BackToDays"),
							onClick: _cache[4] || (_cache[4] = ($event) => unref(switchView)("day"))
						}, [createVNode(Image_default, {
							name: "calendar",
							size: "small"
						})], 8, _hoisted_12)) : createCommentVNode("", true)]),
						index === __props.numberOfColumns - 1 ? (openBlock(), createBlock(unref(MonthRangePickerNext), {
							key: 2,
							class: "calendar-nav-button calendar-next"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronRight",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_13))
					]), createVNode(unref(MonthRangePickerGrid), { class: "calendar-grid" }, {
						default: withCtx(() => [createVNode(unref(MonthRangePickerGridBody), null, {
							default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(column.rows, (monthRow, rowIndex) => {
								return openBlock(), createBlock(unref(MonthRangePickerGridRow), {
									key: `month-row-${rowIndex}`,
									class: "calendar-picker-row"
								}, {
									default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(monthRow, (month) => {
										return openBlock(), createBlock(unref(MonthRangePickerCell), {
											key: month.toString(),
											date: month,
											class: "calendar-cell"
										}, {
											default: withCtx(() => [createVNode(unref(MonthRangePickerCellTrigger), {
												month,
												class: "calendar-cell-trigger calendar-picker-cell"
											}, null, 8, ["month"])]),
											_: 2
										}, 1032, ["date"]);
									}), 128))]),
									_: 2
								}, 1024);
							}), 128))]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)]);
				}), 128))]),
				_: 1
			}, 8, [
				"placeholder",
				"model-value",
				"locale",
				"min-value",
				"max-value",
				"next-page",
				"prev-page",
				"initial-focus"
			])) : (openBlock(), createBlock(unref(YearRangePickerRoot), {
				key: 2,
				placeholder: unref(placeholder),
				"onUpdate:placeholder": _cache[7] || (_cache[7] = ($event) => isRef(placeholder) ? placeholder.value = $event : null),
				"model-value": range.value,
				locale: unref(locale),
				"min-value": unref(minValue),
				"max-value": unref(maxValue),
				"years-per-page": unref(yearsPerPage),
				"initial-focus": unref(hasSwitchedView),
				class: "calendar-pickers",
				"onUpdate:modelValue": onYearRangeChange
			}, {
				default: withCtx(({ grid }) => [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(toYearColumns)(grid.rows), (column, index) => {
					return openBlock(), createElementBlock("div", {
						key: column.key,
						class: "calendar-picker"
					}, [createElementVNode("div", _hoisted_14, [
						index === 0 ? (openBlock(), createBlock(unref(YearRangePickerPrev), {
							key: 0,
							class: "calendar-nav-button calendar-prev"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronLeft",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_15)),
						createElementVNode("div", _hoisted_16, [createElementVNode("span", _hoisted_17, toDisplayString(column.caption), 1), index === 0 && !__props.viewLocked ? (openBlock(), createElementBlock("button", {
							key: 0,
							type: "button",
							class: "calendar-nav-button calendar-days-button",
							"aria-label": unref(translate)("Calendar_BackToDays"),
							title: unref(translate)("Calendar_BackToDays"),
							onClick: _cache[6] || (_cache[6] = ($event) => unref(switchView)("day"))
						}, [createVNode(Image_default, {
							name: "calendar",
							size: "small"
						})], 8, _hoisted_18)) : createCommentVNode("", true)]),
						index === __props.numberOfColumns - 1 ? (openBlock(), createBlock(unref(YearRangePickerNext), {
							key: 2,
							class: "calendar-nav-button calendar-next"
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "chevronRight",
								size: "small"
							})]),
							_: 1
						})) : (openBlock(), createElementBlock("span", _hoisted_19))
					]), createVNode(unref(YearRangePickerGrid), { class: "calendar-grid" }, {
						default: withCtx(() => [createVNode(unref(YearRangePickerGridBody), null, {
							default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(column.rows, (yearRow, rowIndex) => {
								return openBlock(), createBlock(unref(YearRangePickerGridRow), {
									key: `year-row-${rowIndex}`,
									class: "calendar-picker-row"
								}, {
									default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(yearRow, (year) => {
										return openBlock(), createBlock(unref(YearRangePickerCell), {
											key: year.toString(),
											date: year,
											class: "calendar-cell"
										}, {
											default: withCtx(() => [createVNode(unref(YearRangePickerCellTrigger), {
												year,
												class: "calendar-cell-trigger calendar-picker-cell"
											}, null, 8, ["year"])]),
											_: 2
										}, 1032, ["date"]);
									}), 128))]),
									_: 2
								}, 1024);
							}), 128))]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)]);
				}), 128))]),
				_: 1
			}, 8, [
				"placeholder",
				"model-value",
				"locale",
				"min-value",
				"max-value",
				"years-per-page",
				"initial-focus"
			]))], 2);
		};
	}
});
// src/directives/event.ts
function getOwner(el, binding) {
	return binding.instance ?? el;
}
function observeSize(el, binding) {
	const handlers = el.__neos_resizeHandlers ??= /* @__PURE__ */ new Map();
	const owner = getOwner(el, binding);
	const isNewOwner = !handlers.has(owner);
	handlers.set(owner, binding.value);
	if (el.__neos_resizeObserver === void 0) {
		const observer = new ResizeObserver(() => {
			const rect = el.getBoundingClientRect();
			const previous = el.__neos_renderedSize;
			if (previous !== void 0 && previous.width === rect.width && previous.height === rect.height) return;
			const size = {
				width: rect.width,
				height: rect.height
			};
			el.__neos_renderedSize = size;
			el.__neos_resizeHandlers?.forEach((handler) => handler({ size }));
		});
		observer.observe(el, { box: "border-box" });
		el.__neos_resizeObserver = observer;
	} else if (isNewOwner && el.__neos_renderedSize !== void 0) binding.value({ size: el.__neos_renderedSize });
}
function unobserveSize(el, binding) {
	el.__neos_resizeHandlers?.delete(getOwner(el, binding));
	if ((el.__neos_resizeHandlers?.size ?? 0) > 0) return;
	el.__neos_resizeObserver?.disconnect();
	delete el.__neos_resizeObserver;
	delete el.__neos_resizeHandlers;
	delete el.__neos_renderedSize;
}
function isResizeBinding(binding) {
	return binding.arg === "resize";
}
/**
* v-neos-event directive.
* Used to call a handler on events that are not DOM events on the node itself.
*/
var neosEvent = {
	mounted(el, binding) {
		if (isResizeBinding(binding)) observeSize(el, binding);
	},
	updated(el, binding) {
		if (isResizeBinding(binding)) observeSize(el, binding);
	},
	beforeUnmount(el, binding) {
		if (isResizeBinding(binding)) unobserveSize(el, binding);
	}
};
// src/components/CanvasLayout/CanvasLayout.ts?vue&type=script&src=true&lang.ts
var RESIZE_SETTLE_DELAY_MS = 120;
var CanvasLayout_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "CanvasLayout",
	directives: { neosEvent },
	setup() {
		const isResizing = ref(false);
		let settleTimeout;
		function handleResize() {
			isResizing.value = true;
			clearTimeout(settleTimeout);
			settleTimeout = setTimeout(() => {
				isResizing.value = false;
			}, RESIZE_SETTLE_DELAY_MS);
		}
		onBeforeUnmount(() => {
			clearTimeout(settleTimeout);
		});
		useComponentAutomationProperties();
		return {
			isResizing,
			handleResize
		};
	}
});
// src/components/CanvasLayout/CanvasLayout.vue
function _sfc_render$16(_ctx, _cache, $props, $setup, $data, $options) {
	const _directive_neos_event = resolveDirective("neos-event");
	return withDirectives((openBlock(), createElementBlock("div", { class: normalizeClass(["canvas-layout", { "canvas-layout-resizing": _ctx.isResizing }]) }, [renderSlot(_ctx.$slots, "default")], 2)), [[
		_directive_neos_event,
		_ctx.handleResize,
		"resize"
	]]);
}
var CanvasLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(CanvasLayout_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$16]]);
// src/components/Card/Card.ts?vue&type=script&src=true&lang.ts
var Card_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Card",
	components: { VerticalLayout: VerticalLayout_default },
	props: {
		space: {
			type: String,
			default: "small"
		},
		align: {
			type: String,
			default: "stretch"
		}
	},
	setup() {
		useComponentAutomationProperties();
	}
});
// src/components/Card/Card.vue
function _sfc_render$15(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(_component_VerticalLayout, {
		space: _ctx.space,
		align: _ctx.align,
		class: "card"
	}, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
		_: 3
	}, 8, ["space", "align"]);
}
var Card_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Card_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$15], ["__scopeId", "data-v-a6c80180"]]);
// src/components/Carousel/Carousel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$34 = ["aria-live"];
var _hoisted_2$15 = ["aria-hidden", "inert"];
var _hoisted_3$7 = [
	"tabindex",
	"aria-label",
	"aria-current",
	"onClick"
];
var swipeThreshold = 20;
// src/components/Carousel/Carousel.vue
var Carousel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Carousel",
	props: {
		source: {},
		pageSize: { default: 1 },
		scrollStep: { default: 1 },
		autoScrollInterval: { default: 0 },
		circular: { type: Boolean },
		navigationArrows: {
			type: Boolean,
			default: true
		},
		paginationIndicators: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		const props = __props;
		const { translate } = useGlobalResourceManager();
		const page = ref(0);
		const focusedIndicator = ref(0);
		const autoScrollStopped = ref(false);
		const hovered = ref(false);
		const focusWithin = ref(false);
		const animated = ref(true);
		let touchStart;
		const rootElement = ref();
		const indicatorListElement = ref();
		const scrollable = computed(() => props.source.length > props.pageSize);
		const pageCount = computed(() => scrollable.value ? Math.ceil((props.source.length - props.pageSize) / props.scrollStep) + 1 : 1);
		const firstVisibleIndex = computed(() => Math.min(page.value * props.scrollStep, Math.max(props.source.length - props.pageSize, 0)));
		const canMoveBackward = computed(() => scrollable.value && (props.circular || page.value > 0));
		const canMoveForward = computed(() => scrollable.value && (props.circular || page.value < pageCount.value - 1));
		const autoScrollEnabled = computed(() => props.autoScrollInterval > 0 && scrollable.value && !autoScrollStopped.value);
		const autoScrollPaused = computed(() => hovered.value || focusWithin.value);
		const autoScrollActive = computed(() => autoScrollEnabled.value && !autoScrollPaused.value);
		const itemListStyle = computed(() => ({ transform: `translate3d(${-100 * firstVisibleIndex.value / props.pageSize}%, 0, 0)` }));
		const { pause, resume } = useIntervalFn(goToNextPage, () => props.autoScrollInterval, { immediate: false });
		watch(autoScrollActive, (active) => active ? resume() : pause(), { immediate: true });
		watch(pageCount, (count) => {
			if (page.value >= count) goToPage(count - 1);
			if (focusedIndicator.value >= count) focusedIndicator.value = page.value;
		});
		let indicatorFocusedBeforeUpdate = false;
		onBeforeUpdate(() => {
			indicatorFocusedBeforeUpdate = indicatorListElement.value?.contains(document.activeElement) === true;
		});
		onUpdated(() => {
			if (!focusWithin.value || rootElement.value.contains(document.activeElement)) return;
			if (indicatorFocusedBeforeUpdate && indicatorListElement.value) indicatorListElement.value.querySelectorAll(".carousel-indicator-button")[focusedIndicator.value].focus();
			else focusWithin.value = false;
		});
		function isItemVisible(index) {
			return index >= firstVisibleIndex.value && index < firstVisibleIndex.value + props.pageSize;
		}
		function goToPage(index, withAnimation = true) {
			animated.value = withAnimation;
			page.value = index;
			focusedIndicator.value = index;
		}
		function goToNextPage() {
			if (page.value === pageCount.value - 1) goToPage(0, false);
			else goToPage(page.value + 1);
		}
		function moveBackward() {
			if (!canMoveBackward.value) return;
			autoScrollStopped.value = true;
			if (page.value === 0) goToPage(pageCount.value - 1, false);
			else goToPage(page.value - 1);
		}
		function moveForward() {
			if (!canMoveForward.value) return;
			autoScrollStopped.value = true;
			goToNextPage();
		}
		function handleIndicatorClick(index) {
			autoScrollStopped.value = true;
			goToPage(index, !(props.circular && isJumpBetweenFirstAndLastPages(index)));
		}
		function isJumpBetweenFirstAndLastPages(index) {
			const lastIndex = pageCount.value - 1;
			return page.value === lastIndex && index === 0 || page.value === 0 && index === lastIndex;
		}
		function handleIndicatorKeydown(event) {
			const lastIndex = pageCount.value - 1;
			const target = {
				ArrowLeft: Math.max(focusedIndicator.value - 1, 0),
				ArrowRight: Math.min(focusedIndicator.value + 1, lastIndex),
				Home: 0,
				End: lastIndex
			}[event.key];
			if (target === void 0) return;
			event.preventDefault();
			focusedIndicator.value = target;
			event.currentTarget.querySelectorAll(".carousel-indicator-button")[target].focus();
		}
		function handleIndicatorFocusout(event) {
			if (!event.currentTarget.contains(event.relatedTarget)) focusedIndicator.value = page.value;
		}
		function handleFocusout(event) {
			if (!event.currentTarget.contains(event.relatedTarget)) focusWithin.value = false;
		}
		function handleTouchStart(event) {
			if (event.touches.length > 1) {
				touchStart = void 0;
				return;
			}
			const touch = event.changedTouches[0];
			touchStart = {
				x: touch.pageX,
				y: touch.pageY
			};
		}
		function handleTouchCancel() {
			touchStart = void 0;
		}
		function handleTouchEnd(event) {
			if (!touchStart) return;
			const touch = event.changedTouches[0];
			const distanceX = touch.pageX - touchStart.x;
			const distanceY = touch.pageY - touchStart.y;
			touchStart = void 0;
			if (Math.abs(distanceX) <= swipeThreshold || Math.abs(distanceX) <= Math.abs(distanceY)) return;
			if (distanceX < 0) moveForward();
			else moveBackward();
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "rootElement",
				ref: rootElement,
				class: "carousel",
				role: "region",
				style: normalizeStyle({ "--carousel-page-size": __props.pageSize }),
				onMouseenter: _cache[0] || (_cache[0] = ($event) => hovered.value = true),
				onMouseleave: _cache[1] || (_cache[1] = ($event) => hovered.value = false),
				onFocusin: _cache[2] || (_cache[2] = ($event) => focusWithin.value = true),
				onFocusout: handleFocusout
			}, [__props.source.length ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "carousel-content",
				"aria-live": autoScrollActive.value ? "off" : "polite"
			}, [
				__props.navigationArrows ? (openBlock(), createBlock(Button_default, {
					key: 0,
					class: "carousel-prev-button",
					variant: "ghost",
					icon: "chevronLeft",
					"aria-label": unref(translate)("PreviousPage"),
					disabled: !canMoveBackward.value,
					onClick: moveBackward
				}, null, 8, ["aria-label", "disabled"])) : createCommentVNode("", true),
				createElementVNode("div", {
					class: "carousel-viewport",
					onTouchstart: handleTouchStart,
					onTouchend: handleTouchEnd,
					onTouchcancel: handleTouchCancel
				}, [createElementVNode("div", {
					class: normalizeClass(["carousel-item-list", { "carousel-item-list-instant": !animated.value }]),
					style: normalizeStyle(itemListStyle.value)
				}, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.source, (item, index) => {
					return openBlock(), createElementBlock("div", {
						key: index,
						class: normalizeClass(["carousel-item", { "carousel-item-active": isItemVisible(index) }]),
						role: "group",
						"aria-hidden": isItemVisible(index) ? void 0 : true,
						inert: isItemVisible(index) ? void 0 : true
					}, [renderSlot(_ctx.$slots, "item", { context: item }, void 0, true)], 10, _hoisted_2$15);
				}), 128))], 6)], 32),
				__props.navigationArrows ? (openBlock(), createBlock(Button_default, {
					key: 1,
					class: "carousel-next-button",
					variant: "ghost",
					icon: "chevronRight",
					"aria-label": unref(translate)("NextPage"),
					disabled: !canMoveForward.value,
					onClick: moveForward
				}, null, 8, ["aria-label", "disabled"])) : createCommentVNode("", true)
			], 8, _hoisted_1$34)) : createCommentVNode("", true), __props.source.length && __props.paginationIndicators ? (openBlock(), createElementBlock("ul", {
				key: 1,
				ref_key: "indicatorListElement",
				ref: indicatorListElement,
				class: "carousel-indicator-list",
				onKeydown: handleIndicatorKeydown,
				onFocusout: handleIndicatorFocusout
			}, [(openBlock(true), createElementBlock(Fragment, null, renderList(pageCount.value, (index) => {
				return openBlock(), createElementBlock("li", {
					key: index,
					class: normalizeClass(["carousel-indicator", { "carousel-indicator-active": index - 1 === page.value }])
				}, [createElementVNode("button", {
					type: "button",
					class: "carousel-indicator-button",
					tabindex: index - 1 === focusedIndicator.value ? 0 : -1,
					"aria-label": unref(translate)("GoToPage", index),
					"aria-current": index - 1 === page.value ? "page" : void 0,
					onClick: ($event) => handleIndicatorClick(index - 1)
				}, null, 8, _hoisted_3$7)], 2);
			}), 128))], 544)) : createCommentVNode("", true)], 36);
		};
	}
}), [["__scopeId", "data-v-b08327a3"]]);
// src/components/Chart/Chart.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$33 = { class: "chart" };
var _hoisted_2$14 = { ref: "canvas" };
// src/components/Chart/Chart.vue
var Chart_default = /* @__PURE__ */ defineComponent({
	__name: "Chart",
	props: {
		type: {},
		data: {},
		options: { default: () => ({}) },
		itemLabels: {},
		elementClick: {}
	},
	setup(__props) {
		const props = __props;
		useComponentAutomationProperties();
		const canvasElement = useTemplateRef("canvas");
		const chart = shallowRef();
		onMounted(() => {
			init();
		});
		onBeforeUnmount(() => {
			destroy();
		});
		watch(() => props.type, () => {
			init();
		});
		watch([
			() => props.data,
			() => props.options,
			() => props.itemLabels
		], () => {
			update();
		});
		watch(() => props.elementClick !== void 0, (hasElementClick) => {
			update();
			if (!hasElementClick && chart.value && !props.options.onHover) chart.value.canvas.style.cursor = "";
		});
		function toLines(result) {
			if (Array.isArray(result)) return result;
			if (result) return [result];
			return [];
		}
		function resolvedOptions() {
			return withElementClick(withItemLabels(props.options));
		}
		function withItemLabels(options) {
			if (!props.itemLabels) return options;
			const pluginsOption = options.plugins;
			const tooltipOption = options.plugins?.tooltip;
			if (pluginsOption === false || tooltipOption === false) return options;
			const itemLabels = props.itemLabels;
			const originalFooter = options.plugins?.tooltip?.callbacks?.footer;
			return {
				...options,
				plugins: {
					...options.plugins,
					tooltip: {
						...options.plugins?.tooltip,
						callbacks: {
							...options.plugins?.tooltip?.callbacks,
							footer(tooltipItems) {
								const index = tooltipItems[0]?.dataIndex;
								const ownLines = index === void 0 ? [] : itemLabels[index] ?? [];
								const originalResult = originalFooter?.apply(this, [tooltipItems]);
								return [...toLines(originalResult), ...ownLines];
							}
						}
					}
				}
			};
		}
		function withElementClick(options) {
			if (!props.elementClick) return options;
			const originalOnClick = options.onClick;
			const originalOnHover = options.onHover;
			return {
				...options,
				onClick(event, elements, chartInstance) {
					const clickedElement = findElementAt(event, chartInstance);
					const args = clickedElement && toElementClickEventArgs(chartInstance.data, clickedElement);
					originalOnClick?.call(chartInstance, event, elements, chartInstance);
					if (args) props.elementClick?.(args);
				},
				onHover(event, elements, chartInstance) {
					if (originalOnHover) {
						originalOnHover.call(chartInstance, event, elements, chartInstance);
						return;
					}
					chartInstance.canvas.style.cursor = findElementAt(event, chartInstance) ? "pointer" : "";
				}
			};
		}
		function findElementAt(event, chartInstance) {
			if (!event.native) return;
			return chartInstance.getElementsAtEventForMode(event.native, "nearest", { intersect: true }, false)[0];
		}
		function toElementClickEventArgs(data, element) {
			const dataset = data.datasets[element.datasetIndex];
			const label = data.labels?.[element.index];
			const value = dataset?.data[element.index];
			return {
				datasetIndex: element.datasetIndex,
				index: element.index,
				label: label === void 0 || label === null ? null : String(label),
				datasetLabel: dataset?.label ?? null,
				value: typeof value === "number" ? value : null
			};
		}
		async function init() {
			const { Chart } = await import("chart.js/auto");
			const guardedAnnotationPlugin = {
				...annotationPlugin,
				beforeDraw(chartInstance, args, options) {
					if (!chartInstance.chartArea) return;
					annotationPlugin.beforeDraw?.(chartInstance, args, options);
				},
				afterDraw(chartInstance, args, options) {
					if (!chartInstance.chartArea) return;
					annotationPlugin.afterDraw?.(chartInstance, args, options);
				},
				beforeDatasetsDraw(chartInstance, args, options) {
					if (!chartInstance.chartArea) return;
					annotationPlugin.beforeDatasetsDraw?.(chartInstance, args, options);
				},
				afterDatasetsDraw(chartInstance, args, options, cancelable) {
					if (!chartInstance.chartArea) return;
					annotationPlugin.afterDatasetsDraw?.(chartInstance, args, options, cancelable);
				},
				beforeDatasetDraw(chartInstance, args, options) {
					if (!chartInstance.chartArea) return;
					annotationPlugin.beforeDatasetDraw?.(chartInstance, args, options);
				}
			};
			Chart.register(guardedAnnotationPlugin);
			destroy();
			chart.value = new Chart(canvasElement.value, {
				type: props.type,
				data: props.data,
				options: resolvedOptions()
			});
		}
		function update() {
			if (!chart.value) return;
			chart.value.data = props.data;
			chart.value.options = resolvedOptions();
			chart.value.update();
		}
		function destroy() {
			if (chart.value) {
				chart.value.destroy();
				chart.value = void 0;
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$33, [createElementVNode("canvas", _hoisted_2$14, null, 512)]);
		};
	}
});
// src/components/Checkbox/Checkbox.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$32 = [
	"id",
	"checked",
	"disabled",
	"tabindex"
];
// src/components/Checkbox/Checkbox.vue
var Checkbox_default = /* @__PURE__ */ defineComponent({
	__name: "Checkbox",
	props: /*@__PURE__*/ mergeModels({
		...inputProps,
		...contentProps,
		labelPosition: {
			type: String,
			default: "right"
		}
	}, {
		"modelValue": {
			type: Boolean,
			default: false
		},
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([...inputEmits], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const contentStyleObject = useContentStyle(props);
		const emit = __emit;
		const modelValue = useModel(__props, "modelValue");
		const { input, id, classes, ariaAttributes, isLabelVisible, isMessageVisible, messageId, tabIndex } = useInput(props, emit);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["neos-input checkbox", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				class: "checkbox-content-input-label",
				label: _ctx.label,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createElementVNode("div", {
				class: normalizeClass(["checkbox-content neos-input-content", _ctx.contentClass]),
				style: normalizeStyle(unref(contentStyleObject))
			}, [withDirectives(createElementVNode("input", mergeProps({
				id: unref(id),
				ref: (el) => input.value = el,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => modelValue.value = $event)
			}, unref(ariaAttributes), {
				type: "checkbox",
				checked: modelValue.value,
				disabled: _ctx.disabled || _ctx.readonly,
				tabindex: unref(tabIndex)
			}), null, 16, _hoisted_1$32), [[vModelCheckbox, modelValue.value]]), renderSlot(_ctx.$slots, "default")], 6)]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				id: unref(messageId),
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, [
				"id",
				"text",
				"severity"
			])) : createCommentVNode("", true)], 2);
		};
	}
});
// src/components/Chip/Chip.vue
var _sfc_main = {};
var _hoisted_1$31 = { class: "chip" };
function _sfc_render$14(_ctx, _cache) {
	return openBlock(), createElementBlock("div", _hoisted_1$31, [renderSlot(_ctx.$slots, "default")]);
}
var Chip_default = /*#__PURE__*/ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render$14]]);
// src/components/ConfirmPopover/ConfirmPopover.vue
var ConfirmPopover_default = /* @__PURE__ */ defineComponent({
	__name: "ConfirmPopover",
	props: {
		message: {},
		confirmLabel: { default: void 0 },
		confirmIcon: { default: void 0 },
		confirmVariant: { default: "primary" }
	},
	emits: ["confirm"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		function handleConfirm(close) {
			close();
			emit("confirm");
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Popover_default, {
				side: "bottom",
				align: "start",
				class: "confirm-popover"
			}, {
				trigger: withCtx(() => [renderSlot(_ctx.$slots, "trigger")]),
				default: withCtx(({ close }) => [createVNode(VerticalLayout_default, { space: "small" }, {
					default: withCtx(() => [createVNode(Text_default, { class: "confirm-popover-message" }, {
						default: withCtx(() => [createTextVNode(toDisplayString(props.message), 1)]),
						_: 1
					}), createVNode(ButtonsLayout_default, null, {
						default: withCtx(() => [createVNode(Button_default, {
							variant: "ghost",
							size: "small",
							label: unref(translate)("Cancel"),
							class: "confirm-popover-cancel",
							animated: "",
							onClick: close
						}, null, 8, ["label", "onClick"]), createVNode(Button_default, {
							variant: props.confirmVariant,
							size: "small",
							icon: props.confirmIcon,
							label: props.confirmLabel ?? unref(translate)("Confirm"),
							class: "confirm-popover-confirm",
							animated: "",
							onClick: ($event) => handleConfirm(close)
						}, null, 8, [
							"variant",
							"icon",
							"label",
							"onClick"
						])]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024)]),
				_: 3
			});
		};
	}
});
// src/components/ContextMenuItem/ContextMenuItem.vue
var ContextMenuItem_default = /* @__PURE__ */ defineComponent({
	__name: "ContextMenuItem",
	props: {
		item: {},
		hasSubmenu: { type: Boolean },
		size: {}
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				align: "space-between",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createVNode(HorizontalLayout_default, {
					"vertical-align": "center",
					wrap: false
				}, {
					default: withCtx(() => [
						__props.item.icon === "empty" ? (openBlock(), createElementBlock("div", {
							key: 0,
							class: "context-menu-item-image empty",
							style: normalizeStyle(`width: var(--image-${__props.size}-size); height: var(--image-${__props.size}-size);`)
						}, null, 4)) : __props.item.icon ? (openBlock(), createBlock(Image_default, {
							key: 1,
							name: __props.item.icon,
							size: __props.size,
							class: "context-menu-item-image"
						}, null, 8, ["name", "size"])) : createCommentVNode("", true),
						createVNode(Text_default, { "max-lines": 1 }, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.item.label), 1)]),
							_: 1
						}),
						__props.item.badge ? (openBlock(), createBlock(Badge_default, {
							key: 2,
							value: __props.item.badge,
							severity: __props.item.badgeSeverity
						}, null, 8, ["value", "severity"])) : createCommentVNode("", true)
					]),
					_: 1
				}), __props.hasSubmenu ? (openBlock(), createBlock(Image_default, {
					key: 0,
					name: "chevronRight",
					size: __props.size
				}, null, 8, ["size"])) : createCommentVNode("", true)]),
				_: 1
			});
		};
	}
});
// src/composables/useNavigableClick.ts
/**
* Centralizes "which HTML tag to render for an openable target, and how to intercept its click".
*
* This is intentionally headless: it has no dependency on Router or on any specific button
* implementation.
*
* No real `href` is computed anywhere yet (that is future work): `href` is always `undefined`
* for every current caller, so `tag` always resolves to `fallbackTag` and `handleClick` always
* runs `onNavigate` unconditionally, matching today's exact plain-button/div click behavior.
*/
/**
* Whether any modifier key that should let the browser handle a click natively (open in new
* tab/window, context menu, etc.) is held.
*/
function hasModifierKey(event) {
	const hasPrimaryModifier = event.ctrlKey || event.metaKey;
	const hasSecondaryModifier = event.shiftKey || event.altKey;
	return hasPrimaryModifier || hasSecondaryModifier;
}
/** The tag to render for a single openable target: 'a' once it has a real href, else fallbackTag. */
function getNavigableTag(href, fallbackTag) {
	return href ? "a" : fallbackTag;
}
/**
* The click-interception decision for a single openable target, factored out of useNavigableClick
* so a consumer rendering a whole list of them (e.g. GlobalSearchResult) can apply it per item
* without a per-item Ref/composable call.
*/
function handleNavigableClick(href, fallbackTag, onNavigate, event) {
	if (getNavigableTag(href, fallbackTag) !== "a") {
		onNavigate();
		return;
	}
	if (event.button === 0 && !hasModifierKey(event)) {
		event.preventDefault();
		onNavigate();
	}
}
function useNavigableClick(href, onNavigate, fallbackTag) {
	const tag = computed(() => getNavigableTag(href.value, fallbackTag));
	function handleClick(event) {
		handleNavigableClick(href.value, fallbackTag, onNavigate, event);
	}
	return {
		tag,
		handleClick
	};
}
// src/components/Menu/MenuItems.vue
var MenuItems_default = /* @__PURE__ */ defineComponent({
	__name: "MenuItems",
	props: {
		items: {},
		itemClass: {},
		submenuClass: {},
		target: {}
	},
	setup(__props) {
		const props = __props;
		function hasSubmenu(item) {
			return item.items !== void 0 && item.items.length > 0;
		}
		function getHref(item) {
			return item.disabled ? void 0 : item.href;
		}
		function runCommand(item, event) {
			item.command?.({
				originalEvent: event,
				item,
				target: props.target
			});
		}
		function handleSelect(item, event) {
			if (getHref(item) === void 0) runCommand(item, event);
		}
		/**
		* Runs the command of an item with a link on a plain click only, and lets the browser follow the
		* link on a modified click (ctrl/cmd, shift...). A middle click never reaches this handler and is
		* always handled natively. Selecting the item with the keyboard clicks it without any modifier.
		* An item with a link but no command has nothing to run in-app: its link is always followed.
		*/
		function handleClick(item, event) {
			const href = getHref(item);
			if (href !== void 0 && item.command !== void 0) handleNavigableClick(href, "div", () => runCommand(item, event), event);
		}
		return (_ctx, _cache) => {
			const _component_MenuItems = resolveComponent("MenuItems", true);
			return openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, index) => {
				return openBlock(), createElementBlock(Fragment, { key: index }, [item.separator ? (openBlock(), createBlock(unref(DropdownMenuSeparator), {
					key: 0,
					class: "menu-separator"
				})) : hasSubmenu(item) ? (openBlock(), createBlock(unref(DropdownMenuSub), { key: 1 }, {
					default: withCtx(() => [createVNode(unref(DropdownMenuSubTrigger), mergeProps({
						class: [
							"menu-item",
							__props.itemClass,
							item.class
						],
						disabled: item.disabled,
						"text-value": item.label
					}, { ref_for: true }, item.attributes), {
						default: withCtx(() => [renderSlot(_ctx.$slots, "item", {
							item,
							hasSubmenu: true
						})]),
						_: 2
					}, 1040, [
						"class",
						"disabled",
						"text-value"
					]), createVNode(unref(DropdownMenuPortal), null, {
						default: withCtx(() => [createVNode(unref(DropdownMenuSubContent), {
							class: normalizeClass(["menu-content", __props.submenuClass]),
							"align-offset": -5,
							"collision-padding": 10,
							onPointerdownCapture: unref(ignoreInteractionWhileClosing),
							onClickCapture: unref(ignoreInteractionWhileClosing)
						}, {
							default: withCtx(() => [createVNode(_component_MenuItems, {
								items: item.items,
								"item-class": __props.itemClass,
								"submenu-class": __props.submenuClass,
								target: __props.target
							}, {
								item: withCtx((slotProps) => [renderSlot(_ctx.$slots, "item", mergeProps({ ref_for: true }, slotProps))]),
								_: 3
							}, 8, [
								"items",
								"item-class",
								"submenu-class",
								"target"
							])]),
							_: 2
						}, 1032, [
							"class",
							"onPointerdownCapture",
							"onClickCapture"
						])]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024)) : (openBlock(), createBlock(unref(DropdownMenuItem), mergeProps({
					key: 2,
					as: unref(getNavigableTag)(getHref(item), "div"),
					href: getHref(item),
					class: [
						"menu-item",
						__props.itemClass,
						item.class
					],
					disabled: item.disabled,
					"text-value": item.label
				}, { ref_for: true }, item.attributes, {
					onSelect: ($event) => handleSelect(item, $event),
					onClick: ($event) => handleClick(item, $event)
				}), {
					default: withCtx(() => [renderSlot(_ctx.$slots, "item", {
						item,
						hasSubmenu: false
					})]),
					_: 2
				}, 1040, [
					"as",
					"href",
					"class",
					"disabled",
					"text-value",
					"onSelect",
					"onClick"
				]))], 64);
			}), 128);
		};
	}
});
// src/components/Menu/MenuOverlay.vue
var MenuOverlay_default = /* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "MenuOverlay",
	props: /*@__PURE__*/ mergeModels({
		kind: {},
		items: {},
		reference: {},
		target: {},
		side: {},
		sideOffset: {},
		portalKey: {}
	}, {
		"open": {
			type: Boolean,
			required: true
		},
		"openModifiers": {}
	}),
	emits: ["update:open"],
	setup(__props) {
		const open = useModel(__props, "open");
		function handleFocusOutside(event) {
			event.preventDefault();
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DropdownMenuRoot), {
				open: open.value,
				"onUpdate:open": _cache[0] || (_cache[0] = ($event) => open.value = $event),
				modal: false
			}, {
				default: withCtx(() => [(openBlock(), createBlock(unref(DropdownMenuPortal), { key: __props.portalKey }, {
					default: withCtx(() => [createVNode(unref(DropdownMenuContent), mergeProps({ class: ["menu-content", __props.kind] }, _ctx.$attrs, {
						reference: __props.reference,
						side: __props.side,
						align: "start",
						"side-offset": __props.sideOffset,
						"collision-padding": 10,
						onFocusOutside: handleFocusOutside,
						onPointerdownCapture: unref(ignoreInteractionWhileClosing),
						onClickCapture: unref(ignoreInteractionWhileClosing)
					}), {
						default: withCtx(() => [createVNode(MenuItems_default, {
							items: __props.items,
							"item-class": `${__props.kind}-item`,
							"submenu-class": `${__props.kind}-submenu`,
							target: __props.target
						}, {
							item: withCtx((slotProps) => [renderSlot(_ctx.$slots, "item", normalizeProps(guardReactiveProps(slotProps)))]),
							_: 3
						}, 8, [
							"items",
							"item-class",
							"submenu-class",
							"target"
						])]),
						_: 3
					}, 16, [
						"class",
						"reference",
						"side",
						"side-offset",
						"onPointerdownCapture",
						"onClickCapture"
					])]),
					_: 3
				}))]),
				_: 3
			}, 8, ["open"]);
		};
	}
});
// src/components/ContextMenu/ContextMenu.vue
var ContextMenu_default = /* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "ContextMenu",
	props: {
		items: {},
		size: { default: "medium" }
	},
	setup(__props, { expose: __expose }) {
		const open = shallowRef(false);
		const pointReference = shallowRef(createPointReference(0, 0));
		const targetElement = shallowRef();
		/**
		* Shows the menu at the position of the pointer.
		* Reka's context menu can only be opened by its own trigger wrapping the target area: the dropdown
		* menu primitives are used instead, positioned against a zero-sized element located at the pointer,
		* so that the menu can be opened from any event (a cell of a grid for instance).
		*/
		const { portalKey, show, hide, toggle } = useOverlay(open, (event) => {
			pointReference.value = createPointReference(event.clientX, event.clientY);
			targetElement.value = event.target instanceof Element ? event.target : void 0;
		});
		__expose({
			show,
			hide,
			toggle
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(MenuOverlay_default, mergeProps({
				open: open.value,
				"onUpdate:open": _cache[0] || (_cache[0] = ($event) => open.value = $event)
			}, _ctx.$attrs, {
				kind: "context-menu",
				items: __props.items,
				reference: pointReference.value,
				target: targetElement.value,
				side: "right",
				"side-offset": 2,
				"portal-key": unref(portalKey)
			}), {
				item: withCtx(({ item, hasSubmenu }) => [renderSlot(_ctx.$slots, "item", {
					item,
					hasSubmenu,
					size: __props.size
				}, () => [createVNode(ContextMenuItem_default, {
					item,
					"has-submenu": hasSubmenu,
					size: __props.size
				}, null, 8, [
					"item",
					"has-submenu",
					"size"
				])])]),
				_: 3
			}, 16, [
				"open",
				"items",
				"reference",
				"target",
				"portal-key"
			]);
		};
	}
});
// src/composables/useDatagridAddRow.ts
var AddRow = class extends Row {
	constructor(..._args) {
		super(..._args);
		this.isAddRow = true;
	}
};
/**
* Gets the functionalities of the add row of the data grid.
*/
function useDatagridAddRow(emit) {
	async function addRowAdding(grid) {
		if (grid.editableCollectionView) {
			grid.finishEditing();
			return !!await new Promise((resolve) => {
				emit("addRowAdding", resolve);
			});
		}
		return false;
	}
	/**
	* Gets a value indicating whether there is an add item to commit,
	* without any asynchronous call so that it can be used before handling a keyboard event.
	*/
	function canCommitAddRow(grid) {
		return !!grid.editableCollectionView?.currentAddItem && !!grid.rows[grid.selection.row];
	}
	async function addRowCommitting(grid) {
		return canCommitAddRow(grid) ? emitAddRowCommitting(grid) : false;
	}
	/**
	* Emits the addRowCommitting event, once canCommitAddRow has returned true.
	*/
	async function emitAddRowCommitting(grid) {
		const currentRow = grid.rows[grid.selection.row];
		grid.finishEditing();
		const cancelable = grid.editableCollectionView.currentAddItem !== currentRow.dataItem;
		const committed = await new Promise((resolve) => {
			emit("addRowCommitting", cancelable, resolve);
		});
		if (committed) addAddRow(grid);
		return committed;
	}
	return {
		buildAddRow,
		addRowAdding,
		canCommitAddRow,
		emitAddRowCommitting,
		addRowCommitting
	};
}
/**
* Adds the add row.
*/
function addAddRow(grid) {
	if (!grid.rows.some((r) => r instanceof AddRow)) {
		grid.rows.push(new AddRow());
		return true;
	}
	return false;
}
/**
* Removes the add row.
*/
function removeAddRow(grid) {
	const index = grid.rows.findIndex((r) => r instanceof AddRow);
	if (index !== -1) {
		grid.rows.splice(index, 1);
		return true;
	}
	return false;
}
/**
* Builds the add row.
*/
function buildAddRow(grid, addRow = true) {
	let built = false;
	if (grid.editableCollectionView) {
		if (!addRow || grid.editableCollectionView.isAddingNew) built ||= removeAddRow(grid);
		if (addRow && !grid.editableCollectionView.isAddingNew) built ||= addAddRow(grid);
	}
	return built;
}
// src/composables/useDatagridCheckboxCell.ts
function isIndeterminateCheckboxCell(column, value) {
	return column.isExpressionCode && typeof value === "string" && value.startsWith("=");
}
function getCheckboxCellValue(value) {
	if (value === true || value === "true") return true;
	if (value === false || value === "false") return false;
}
function changeCheckboxCellValue(columns, hit, readOnly) {
	const col = hit.getColumn();
	const column = columns.get(col.name);
	const row = hit.getRow();
	if (!column || readOnly(col, row.dataItem)) return;
	const newValue = getNewCheckboxCellValue(column, row.dataItem[column.name]);
	if (newValue !== void 0) row.dataItem[column.name] = newValue;
}
function getNewCheckboxCellValue(column, value) {
	if (!column.isExpressionCode) return !value;
	if (value === "true") return "false";
	if (value === "false") return "true";
}
// src/composables/useDatagridDragDrop.ts
var dragScrollEdgeThreshold = 48;
var dragScrollStep = 24;
var undefinedHit$1 = {
	hit: void 0,
	row: void 0
};
/**
* The current row drag, shared by every grid of the page to tell a drag from the grid itself from one
* coming from elsewhere.
*/
var _drag;
var _dropRowElement;
var _dropGridElement;
/**
* The instance that shows the drop markers. An instance identifies itself by an object of its own, since
* the grid reference is cleared before the instance is disposed.
*/
var _dropOwner;
function getRowIndex(row) {
	return row.grid.collectionView.sourceCollection.indexOf(row.dataItem);
}
function useDatagridDragDrop(props, grid, translate) {
	const rowDragDrop = computed(() => !!props.rowDrop || !!props.rowDraggable);
	const owner = {};
	function handleDragstart(event) {
		const { hit, row } = getHit(event);
		if (!row) return;
		resetDragRows();
		const items = props.rowDraggable ? getDraggedItems(row) : [row.dataItem];
		const rowElement = getRowElement(hit);
		_drag = {
			owner,
			grid: row.grid,
			row,
			items,
			rowElements: items.length > 1 ? getRenderedRowElements(row.grid, items) : [rowElement]
		};
		for (const element of _drag.rowElements) element.setAttribute("data-drag", "true");
		const drag = _drag;
		event.target.addEventListener("dragend", () => {
			if (_drag === drag) handleDragend();
		}, { once: true });
		if (event.dataTransfer) {
			event.dataTransfer.effectAllowed = props.rowDraggable ? "copyMove" : "move";
			if (items.length > 1) setMultipleRowsDragImage(event.dataTransfer, items.length);
			else event.dataTransfer.setDragImage(rowElement, 0, 0);
		}
		if (props.rowDraggable) props.rowDragstart?.({
			items,
			event
		});
	}
	function handleDragover(event) {
		if (event.defaultPrevented) return;
		if (isDragFromThisGrid()) handleInternalDragover(event);
		else handleExternalDragover(event);
	}
	function handleDragleave(event) {
		const container = event.currentTarget;
		if (!(event.relatedTarget instanceof Node) || !container.contains(event.relatedTarget)) {
			resetDropRow();
			resetDropGrid();
		}
	}
	function handleDrop(event) {
		if (event.defaultPrevented) return;
		if (isDragFromThisGrid()) handleInternalDrop(event);
		else handleExternalDrop(event);
	}
	function handleDragend() {
		resetDragRows();
		resetDropRow();
		resetDropGrid();
	}
	function isDragFromThisGrid() {
		return !!_drag && _drag.grid === grid.value;
	}
	function handleInternalDragover(event) {
		if (!_drag || !props.rowDrop || _drag.items.length > 1) return;
		updateAutoScroll(_drag.grid, event);
		const { hit, row } = getHit(event);
		if (!row) {
			resetDropRow();
			return;
		}
		const rowIndex = getRowIndex(row);
		const dragRowIndex = getRowIndex(_drag.row);
		if (rowIndex === dragRowIndex) {
			resetDropRow();
			return;
		}
		if (getRowElement(hit) === _dropRowElement) {
			acceptInternalDragover(event);
			return;
		}
		if (!props.rowDragover || props.rowDragover({
			item: row.dataItem,
			newIndex: rowIndex
		})) {
			acceptInternalDragover(event);
			setDropRow(getRowElement(hit), rowIndex > dragRowIndex ? "bottom" : "top");
		}
	}
	function acceptInternalDragover(event) {
		event.preventDefault();
		if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
	}
	function handleInternalDrop(event) {
		if (!_drag || !props.rowDrop || _drag.items.length > 1) return;
		const draggedRow = _drag.row;
		const { row } = getHit(event);
		if (!row) return;
		event.preventDefault();
		props.rowDrop({
			item: draggedRow.dataItem,
			newIndex: getRowIndex(row)
		});
	}
	function handleExternalDragover(event) {
		if (!props.externalRowDrop || !grid.value) return;
		const target = getExternalDropTarget(event);
		if (props.externalRowDragover && !props.externalRowDragover({
			newIndex: target.newIndex,
			event
		})) {
			resetDropRow();
			resetDropGrid();
			return;
		}
		updateAutoScroll(grid.value, event);
		event.preventDefault();
		setDropGrid(grid.value.hostElement);
		if (target.marker) setDropRow(target.marker.rowElement, target.marker.position);
		else resetDropRow();
	}
	function handleExternalDrop(event) {
		resetDropRow();
		resetDropGrid();
		if (!props.externalRowDrop || !grid.value) return;
		const { newIndex } = getExternalDropTarget(event);
		if (props.externalRowDragover && !props.externalRowDragover({
			newIndex,
			event
		})) return;
		event.preventDefault();
		props.externalRowDrop({
			newIndex,
			event
		});
	}
	/**
	* Gets where an external drag is dropped: before the row under the pointer when on its upper half,
	* after it otherwise, and at the end outside the rows.
	*/
	function getExternalDropTarget(event) {
		const flexGrid = grid.value;
		const hit = flexGrid.hitTest(event);
		const rowIndex = hit.cellType === CellType.Cell ? getRowIndex(hit.getRow()) : -1;
		if (rowIndex < 0) {
			const newIndex = flexGrid.collectionView.sourceCollection.length;
			const lastRowElement = flexGrid.cells.getCellElement(flexGrid.rows.length - 1, 0)?.parentElement;
			return lastRowElement ? {
				newIndex,
				marker: {
					rowElement: lastRowElement,
					position: "bottom"
				}
			} : { newIndex };
		}
		const rowElement = getRowElement(hit);
		const rect = flexGrid.cells.getCellBoundingRect(hit.row, hit.col);
		return event.clientY < rect.top + rect.height / 2 ? {
			newIndex: rowIndex,
			marker: {
				rowElement,
				position: "top"
			}
		} : {
			newIndex: rowIndex + 1,
			marker: {
				rowElement,
				position: "bottom"
			}
		};
	}
	/**
	* Gets the selected items when the dragged row is selected, the item of the dragged row otherwise.
	*/
	function getDraggedItems(row) {
		const selectionBinding = props.selectionBinding;
		if (!selectionBinding || !row.dataItem[selectionBinding]) return [row.dataItem];
		const items = /* @__PURE__ */ new Set();
		for (const gridRow of row.grid.rows) {
			const item = gridRow.dataItem;
			if (item?.[selectionBinding]) items.add(item);
		}
		return [...items];
	}
	function getHit(event) {
		if (grid.value && event.target instanceof HTMLElement && event.target.closest(".row-drag-col") && event.target.closest(".wj-flexgrid") === grid.value.hostElement) {
			const hit = grid.value.hitTest(event);
			if (hit.cellType === CellType.Cell && hit.getColumn().name === "$$row-drag") {
				const row = hit.getRow();
				if (row.dataItem) return {
					hit,
					row
				};
			}
		}
		return undefinedHit$1;
	}
	/**
	* Gets the row element of the hit, whose target is the element under the pointer, which can be inside
	* the content of a cell.
	*/
	function getRowElement(hit) {
		return hit.target.closest(".wj-row");
	}
	/**
	* Gets the elements of the rows of the items that are rendered: the grid only renders the visible rows.
	*/
	function getRenderedRowElements(flexGrid, items) {
		const draggedItems = new Set(items);
		const elements = [];
		for (const row of flexGrid.rows) if (draggedItems.has(row.dataItem)) {
			const element = flexGrid.cells.getCellElement(row.index, 0)?.parentElement;
			if (element) elements.push(element);
		}
		return elements;
	}
	function setMultipleRowsDragImage(dataTransfer, count) {
		const image = document.createElement("div");
		image.className = "datagrid-drag-image";
		image.textContent = translate("DatagridDraggedRows", count);
		document.body.append(image);
		dataTransfer.setDragImage(image, 0, 0);
		setTimeout(() => image.remove());
	}
	function updateAutoScroll(flexGrid, event) {
		const scrollRoot = flexGrid._root;
		const maxScrollTop = scrollRoot.scrollHeight - scrollRoot.clientHeight;
		if (maxScrollTop <= 0) return;
		const scrollRootRect = scrollRoot.getBoundingClientRect();
		if (event.clientY <= scrollRootRect.top + dragScrollEdgeThreshold) {
			scrollRoot.scrollTop = Math.max(0, scrollRoot.scrollTop - dragScrollStep);
			return;
		}
		if (event.clientY >= scrollRootRect.bottom - dragScrollEdgeThreshold) scrollRoot.scrollTop = Math.min(maxScrollTop, scrollRoot.scrollTop + dragScrollStep);
	}
	function setDropRow(element, position) {
		if (element !== _dropRowElement) {
			resetDropRow();
			_dropRowElement = element;
		}
		element.setAttribute("data-drop", position);
		_dropOwner = owner;
	}
	function setDropGrid(element) {
		if (element !== _dropGridElement) {
			resetDropGrid();
			_dropGridElement = element;
			element.setAttribute("data-external-drop", "true");
		}
		_dropOwner = owner;
	}
	function resetDragRows() {
		if (_drag) {
			for (const element of _drag.rowElements) element.removeAttribute("data-drag");
			_drag = void 0;
		}
	}
	function resetDropRow() {
		if (_dropRowElement) {
			_dropRowElement.removeAttribute("data-drop");
			_dropRowElement = void 0;
		}
	}
	function resetDropGrid() {
		if (_dropGridElement) {
			_dropGridElement.removeAttribute("data-external-drop");
			_dropGridElement = void 0;
		}
	}
	onScopeDispose(() => {
		if (_drag?.owner === owner) resetDragRows();
		if (_dropOwner === owner) {
			resetDropRow();
			resetDropGrid();
		}
	});
	return {
		rowDragDrop,
		handleDragstart,
		handleDragover,
		handleDragleave,
		handleDragend,
		handleDrop
	};
}
// src/utils/datagridUtils.ts
/**
* Name of the empty system column that fills the width left after the data columns,
* so that the rows always extend to the right edge of the grid.
*/
var FILLER_COLUMN_NAME = "$$filler";
/**
* Name of the system column holding the row actions at the right end of the grid.
*/
var ROW_ACTIONS_COLUMN_NAME = "$$row-actions";
/**
* Selector of the elements holding the row actions: the cell content of the row actions column,
* and the overlay displayed over the rows.
*/
var ROW_ACTIONS_SELECTOR = ".row-actions, .datagrid-row-actions";
/**
* Elements the Tab key stops on: a negative tabindex only allows to focus an element by script.
*/
var FOCUSABLE_SELECTOR = [
	"button:not([disabled], [tabindex^=\"-\"])",
	"a[href]:not([tabindex^=\"-\"])",
	"input:not([disabled], [tabindex^=\"-\"])",
	"select:not([disabled], [tabindex^=\"-\"])",
	"textarea:not([disabled], [tabindex^=\"-\"])",
	"[tabindex]:not([tabindex^=\"-\"])"
].join(", ");
function isAddRow(row) {
	return row instanceof AddRow;
}
function isDetailRow(row) {
	return row instanceof DetailRow;
}
function isGroupRow(row) {
	return row instanceof GroupRow;
}
function isSingleColumnRow(row) {
	return isDetailRow(row) || isGroupRow(row);
}
function isSystemRow(row) {
	return isAddRow(row) || isSingleColumnRow(row);
}
/**
* Indicates whether a row displays the row actions: only a data row with its item, never the
* add row (no item until a value is typed), a group row or a detail row.
*/
function isRowActionsRow(row) {
	return !!row.dataItem && !isSystemRow(row);
}
/**
* Gets the element holding the row actions that contains the given target, if any.
*/
function getRowActionsElement(target) {
	return target instanceof Element ? target.closest(ROW_ACTIONS_SELECTOR) : null;
}
/**
* Gets the elements of a container that the Tab key stops on, in the order of the document.
*/
function getFocusableElements(container) {
	return container ? Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)) : [];
}
function isEditingCell(grid, row, col) {
	if (!grid.editRange) return false;
	if (col === void 0) return grid.editRange.containsRow(row);
	return grid.editRange.contains(row, col);
}
function hitTestContainsColumn(hit, col) {
	if (hit.mergedRange) return hit.mergedRange.containsColumn(col);
	return hit.col === col;
}
function adjustColumnIndexForMergedRange(gridPanel, rowIndex, colIndex, backward) {
	const mergedRange = gridPanel.grid.getMergedRange(gridPanel, rowIndex, colIndex);
	if (mergedRange) return backward ? mergedRange.col : mergedRange.col2;
	return colIndex;
}
/**
* Gets the index of the last data column: the filler and row actions columns, when present,
* are always the last columns of the grid, in this order.
*/
function getLastDataColumnIndex(columns) {
	const firstTrailingColumn = columns.getColumn("$$filler") ?? columns.getColumn("$$row-actions");
	return (firstTrailingColumn ? firstTrailingColumn.index : columns.length) - 1;
}
/**
* Gets the index of the last visible data column: the last data column can be hidden (e.g. by
* the column chooser) while remaining in the columns of the grid.
*/
function getLastVisibleDataColumnIndex(columns) {
	let index = getLastDataColumnIndex(columns);
	while (index > 0 && !columns[index].isVisible) index--;
	return index;
}
// src/composables/useDatagridFillerColumn.ts
/**
* Width Wijmo leaves out of the width shared between star-sized columns (see
* `ColumnCollection._updateStarSizes`).
*/
var STAR_SIZING_HALF_PIXEL = .5;
/**
* Width left by star-sized columns below which they are considered to take up the whole
* remaining width: besides the half pixel above, Wijmo rounds the widths it shares between them.
*/
var STAR_SIZING_TOLERANCE = 2;
/**
* Manages the filler column: an empty column placed after the data columns that takes up the
* width they leave, so that the rows (background, borders, hover, selection) always extend to
* the right edge of the grid, and the row actions end up on that edge.
* Its width is computed rather than star-sized: a star-sized last data column (see
* `autoSizeGridColumns`) would otherwise share the remaining width with it. It is zero as soon
* as the other columns overflow the grid, and half a pixel when star-sized columns take up the
* remaining width (unless they are capped by their maximum width before).
*/
function useDatagridFillerColumn(grid) {
	watch(grid, (currentGrid, _, onCleanup) => {
		if (!currentGrid) return;
		currentGrid.updatedView.addHandler(fitFillerColumnWidth);
		onCleanup(() => currentGrid.updatedView.removeHandler(fitFillerColumnWidth));
	}, { immediate: true });
}
function fitFillerColumnWidth(grid) {
	const fillerColumn = grid.columns.getColumn(FILLER_COLUMN_NAME);
	if (!fillerColumn) return;
	let otherColumnsWidth = 0;
	let hasStarSizedColumn = false;
	for (const column of grid.columns) if (column !== fillerColumn && column.isVisible) {
		otherColumnsWidth += column.renderWidth;
		hasStarSizedColumn ||= typeof column.width === "string";
	}
	const remainingWidth = grid._root.clientWidth - otherColumnsWidth;
	let width;
	if (!hasStarSizedColumn || remainingWidth <= 0) width = Math.max(0, Math.floor(remainingWidth));
	else if (remainingWidth < STAR_SIZING_TOLERANCE) width = STAR_SIZING_HALF_PIXEL;
	else width = Math.floor(remainingWidth - STAR_SIZING_HALF_PIXEL);
	if (width !== fillerColumn.width) {
		fillerColumn.width = width;
		if (hasStarSizedColumn) grid.columns._updateStarSizes(grid.clientSize.width);
	}
}
// src/composables/useDatagridMergeManager.ts
function useDatagridMergeManager(props, grid, systemColumnCount, columnsMap) {
	watch([grid, () => props.colspan], ([grid, colspan]) => {
		if (grid) {
			if (colspan) grid.mergeManager = new CustomMergeManager(colspan, systemColumnCount, columnsMap);
			else if (grid.mergeManager instanceof CustomMergeManager) grid.mergeManager = new MergeManager();
		}
	});
}
var CustomMergeManager = class extends MergeManager {
	constructor(colspan, systemColumnCount, columnsMap) {
		super();
		this.colspan = colspan;
		this.systemColumnCount = systemColumnCount;
		this.columnsMap = columnsMap;
	}
	getMergedRange(p, r, c) {
		if (p.cellType !== CellType.Cell) return null;
		if (c < this.systemColumnCount.value) return null;
		const column = p.columns[c];
		if (!column?.name || c > getLastDataColumnIndex(p.columns)) return null;
		const row = p.rows[r];
		if (!row || isSystemRow(row)) return null;
		const item = row?.dataItem;
		if (!item) return null;
		const colspan = this.getColspan(item, column);
		const range = colspan === -1 ? this.getFullRowRange(p, r) : this.getPartialRowRange(p, r, c, item, colspan);
		if (range.col === range.col2) return null;
		return range;
	}
	getFullRowRange(p, r) {
		return new CellRange(r, this.systemColumnCount.value, r, getLastDataColumnIndex(p.columns));
	}
	getPartialRowRange(p, r, c, item, colspan) {
		let c1 = c;
		for (let i = c - 1; i >= this.systemColumnCount.value; i--) {
			const colspan = this.getColspan(item, p.columns[i]);
			if (i + colspan >= c) c1 = i;
		}
		return new CellRange(r, c1, r, Math.min(c + colspan, getLastDataColumnIndex(p.columns)));
	}
	getColspan(item, column) {
		return this.colspan({
			item,
			column: this.columnsMap.value.get(column.name)
		});
	}
};
// src/composables/useDatagridRowActions.ts
var undefinedHit = {
	hit: void 0,
	row: void 0,
	item: void 0
};
/**
* Class of the row the row actions are displayed on. While the pointer is over the row actions,
* it is no longer over the row itself: this class keeps the row styled as hovered.
*/
var ROW_ACTIONS_HOVERED_ROW_CLASS = "row-actions-hovered";
/**
* Width of the bottom border of the rows (see Datagrid.css), left visible under the row actions.
*/
var ROW_BORDER_WIDTH = 1;
/**
* CSS custom property holding the background of the row actions (see Datagrid.css).
*/
var ROW_ACTIONS_BACKGROUND_PROPERTY = "--row-actions-background";
/**
* Delay between two checks of the dropdown opened by a row action, while it is displayed.
*/
var DROPDOWN_CHECK_DELAY = 100;
function isTransparent(color) {
	return color === "transparent" || /^rgba\(.*,\s*0\)$/.test(color);
}
/**
* Gets the background of the given row itself: the one of its system cells (filler column first),
* which hold no data, so that only the row level styles apply to them (hover, selection, style
* rules applying to the whole row), unlike the style rules of a column or a column template.
* Returns undefined without any system cell rendered, or with a transparent one.
*/
function getRowBackground(rowElement) {
	const cell = rowElement?.querySelector(":scope > .filler-col") ?? rowElement?.querySelector(":scope > .system-col");
	if (!cell) return;
	const background = getComputedStyle(cell).backgroundColor;
	return isTransparent(background) ? void 0 : background;
}
/**
* Gets the `left` of the row actions: the right edge of the visible rows, in the coordinates of
* the content (see updateCurrentRow).
*/
function getRowActionsLeft(grid) {
	return `${Math.min(grid.cells.hostElement.offsetWidth, grid._root.clientWidth + grid._root.scrollLeft)}px`;
}
function getHit(grid, event) {
	const hit = grid.hitTest(event);
	if (hit.cellType === CellType.Cell) {
		const row = hit.getRow();
		if (row && isRowActionsRow(row)) return {
			hit,
			row,
			item: row.dataItem
		};
	}
	return undefinedHit;
}
function useDatagridRowActions(props, grid) {
	const rowActionsElement = shallowRef();
	const currentRow = shallowRef();
	const rowActionsItem = computed(() => currentRow.value?.item);
	const rowActionsRowIndex = computed(() => currentRow.value?.rowIndex);
	let hoveredRowElement;
	/**
	* Value indicating whether the row actions were displayed by the keyboard: they then stay
	* displayed as long as the focus is in them, whatever the pointer does.
	*/
	let displayedByKeyboard = false;
	let dropdownCheckTimer;
	onScopeDispose(() => clearTimeout(dropdownCheckTimer));
	/**
	* Value indicating whether the hovered row is selected: the actions then take the background
	* of a selected row.
	*/
	const rowActionsSelected = computed(() => !!props.selectionBinding && currentRow.value?.item[props.selectionBinding] === true);
	watch(grid, (newGrid, oldGrid) => {
		if (oldGrid) {
			oldGrid.beginningEdit.removeHandler(handleBeginningEdit);
			oldGrid.updatedView.removeHandler(handleUpdatedView);
			oldGrid._root.removeEventListener("scroll", handleScroll);
			oldGrid._root.removeEventListener("mouseleave", handleMouseleave);
			oldGrid._root.removeEventListener("mousemove", handleMousemouse);
		}
		if (newGrid) {
			newGrid.beginningEdit.addHandler(handleBeginningEdit);
			newGrid.updatedView.addHandler(handleUpdatedView);
			newGrid._root.addEventListener("scroll", handleScroll);
			newGrid._root.addEventListener("mouseleave", handleMouseleave);
			newGrid._root.addEventListener("mousemove", handleMousemouse);
		}
	}, { immediate: true });
	watch(rowActionsElement, (element) => {
		if (!element) resetCurrentRow();
	});
	async function handleMousemouse(event) {
		if (!grid.value || !rowActionsElement.value || isFocusKeptInRowActions()) return;
		if (currentRow.value && currentRow.value.target === event.target) return;
		const { hit, row, item } = getHit(grid.value, event);
		if (!hit || isEditingCell(grid.value, hit.row)) {
			resetCurrentRow();
			return;
		}
		if (isCurrentRow(item)) return;
		displayedByKeyboard = false;
		currentRow.value = {
			item,
			rowIndex: hit.row,
			target: event.target
		};
		setHoveredRowElement(grid.value.cells.getCellElement(hit.row, hit.col)?.parentElement ?? void 0);
		await nextTick();
		moveRowActions(grid.value, rowActionsElement.value, hit.row, hit.col, row);
	}
	/**
	* Displays the row actions over the given row for the keyboard, and gets the element holding
	* them once the actions of its item are rendered. They stay displayed while the focus is in them.
	* Returns undefined when the row cannot display them (add row, group row, row being edited)
	* or is not rendered.
	*/
	async function showRowActions(rowIndex, colIndex) {
		const currentGrid = grid.value;
		const element = rowActionsElement.value;
		const row = currentGrid?.rows[rowIndex];
		if (!currentGrid || !element || !row || !isRowActionsRow(row)) return;
		currentGrid.scrollIntoView(rowIndex, colIndex);
		const cell = currentGrid.cells.getCellElement(rowIndex, colIndex);
		if (!cell || isEditingCell(currentGrid, rowIndex)) return;
		displayedByKeyboard = true;
		currentRow.value = {
			item: row.dataItem,
			rowIndex,
			target: null
		};
		setHoveredRowElement(cell.parentElement ?? void 0);
		await nextTick();
		moveRowActions(currentGrid, element, rowIndex, colIndex, row);
		return currentRow.value ? element : void 0;
	}
	/**
	* Moves the row actions over the given row, once the actions of its item are rendered.
	*/
	function moveRowActions(currentGrid, rowActionsElement, rowIndex, colIndex, row) {
		if (rowActionsElement.parentElement !== currentGrid._root) currentGrid._root.append(rowActionsElement);
		const cell = currentGrid.cells.getCellElement(rowIndex, colIndex);
		if (!cell) {
			resetCurrentRow();
			return;
		}
		updateCurrentRow(currentGrid, rowActionsElement, row, cell);
	}
	function handleMouseleave() {
		if (!isDropdownActive() && !isFocusKeptInRowActions()) resetCurrentRow();
	}
	/**
	* Hides the row actions displayed by the keyboard when none of them takes the focus, which
	* would otherwise leave them over the row. The ones displayed by the pointer stay.
	*/
	function hideRowActionsDisplayedByKeyboard() {
		if (displayedByKeyboard) resetCurrentRow();
	}
	/**
	* Hides the row actions displayed by the keyboard once the focus has left them. While a
	* dropdown opened by one of the actions is displayed, they stay, as it is anchored to them,
	* and they are hidden when it closes without giving the focus back to them.
	* The check is deferred, as the dropdown is not displayed yet when the focus leaves.
	*/
	function handleRowActionsFocusout() {
		if (displayedByKeyboard) scheduleFocusCheck(0);
	}
	function scheduleFocusCheck(delay) {
		clearTimeout(dropdownCheckTimer);
		dropdownCheckTimer = setTimeout(() => {
			if (!displayedByKeyboard || isFocusInRowActions()) return;
			if (isDropdownActive()) scheduleFocusCheck(DROPDOWN_CHECK_DELAY);
			else resetCurrentRow();
		}, delay);
	}
	function handleBeginningEdit() {
		resetCurrentRow();
	}
	/**
	* The row actions displayed by the keyboard stay while the focus is in them: they scroll
	* vertically with their row, and are moved back to the right edge of the visible rows.
	*/
	function handleScroll() {
		if (!isFocusKeptInRowActions()) {
			resetCurrentRow();
			return;
		}
		const element = rowActionsElement.value;
		element.style.left = getRowActionsLeft(grid.value);
	}
	/**
	* The row may be drawn again with another background (e.g. once selected by a click on it).
	*/
	function handleUpdatedView() {
		if (currentRow.value && rowActionsElement.value) updateBackground(rowActionsElement.value);
	}
	function updateCurrentRow(grid, rowActionsElement, row, cell) {
		const height = row.height ?? grid.rows.defaultSize;
		const top = Number(cell.style.top.substring(0, cell.style.top.length - 2));
		rowActionsElement.style.display = "flex";
		rowActionsElement.style.height = `${height - ROW_BORDER_WIDTH}px`;
		rowActionsElement.style.top = `${grid.columnHeaders.rows.minSize + top}px`;
		rowActionsElement.style.left = getRowActionsLeft(grid);
		rowActionsElement.style.width = "max-content";
		rowActionsElement.style.transform = "translateX(-100%)";
		updateBackground(rowActionsElement);
	}
	/**
	* The actions take the background of the row (e.g. set by a style rule applying to the whole
	* row), and otherwise the hover or selection background of the theme (see Datagrid.css).
	*/
	function updateBackground(rowActionsElement) {
		const background = getRowBackground(hoveredRowElement);
		if (background) rowActionsElement.style.setProperty(ROW_ACTIONS_BACKGROUND_PROPERTY, background);
		else rowActionsElement.style.removeProperty(ROW_ACTIONS_BACKGROUND_PROPERTY);
	}
	function resetCurrentRow() {
		displayedByKeyboard = false;
		currentRow.value = void 0;
		if (rowActionsElement.value) rowActionsElement.value.style.display = "none";
		setHoveredRowElement(void 0);
	}
	function setHoveredRowElement(rowElement) {
		hoveredRowElement?.classList.remove(ROW_ACTIONS_HOVERED_ROW_CLASS);
		hoveredRowElement = rowElement;
		hoveredRowElement?.classList.add(ROW_ACTIONS_HOVERED_ROW_CLASS);
	}
	function isCurrentRow(item) {
		return currentRow.value?.item === item;
	}
	function isInRowActions(target) {
		return rowActionsElement.value?.contains(target) ?? false;
	}
	function isFocusInRowActions() {
		return !!document.activeElement && isInRowActions(document.activeElement);
	}
	function isFocusKeptInRowActions() {
		return displayedByKeyboard && isFocusInRowActions();
	}
	return {
		rowActionsItem,
		rowActionsRowIndex,
		rowActionsElement,
		rowActionsSelected,
		isInRowActions,
		showRowActions,
		hideRowActionsDisplayedByKeyboard,
		handleRowActionsFocusout
	};
}
// src/composables/useDatagridRowActionsColumn.ts
/**
* Minimum width of the row actions column (one small button).
*/
var MIN_WIDTH = 32;
/**
* CSS custom property holding the width of the fade zone (see Datagrid.css).
*/
var FADE_WIDTH_PROPERTY = "--row-actions-fade-width";
/**
* Manages the row actions column: a column frozen at the right end of the grid that holds
* the row actions, so that they never cover the data.
* - Its width fits the widest actions rendered so far. It only grows, so that it does not
*   change while scrolling through rows with a different number of visible actions.
* - The `data-row-actions-overflow` attribute of the grid indicates that data columns are
*   hidden under the actions column, so that the column can fade them out, over the width given
*   by the `--row-actions-fade-width` property.
*/
function useDatagridRowActionsColumn(grid, enabled) {
	watch([grid, enabled], ([currentGrid, isEnabled], _, onCleanup) => {
		if (!currentGrid || !isEnabled) return;
		const handleScroll = () => {
			const column = currentGrid.columns.getColumn(ROW_ACTIONS_COLUMN_NAME);
			if (column) updateOverflow(currentGrid, column);
		};
		currentGrid.updatedView.addHandler(handleUpdatedView);
		currentGrid._root.addEventListener("scroll", handleScroll);
		onCleanup(() => {
			currentGrid.updatedView.removeHandler(handleUpdatedView);
			currentGrid._root.removeEventListener("scroll", handleScroll);
			currentGrid.hostElement.removeAttribute("data-row-actions-overflow");
			currentGrid.hostElement.style.removeProperty(FADE_WIDTH_PROPERTY);
		});
	}, { immediate: true });
}
function handleUpdatedView(grid) {
	const column = grid.columns.getColumn(ROW_ACTIONS_COLUMN_NAME);
	if (column) {
		fitColumnWidth(grid, column);
		updateOverflow(grid, column);
	}
}
function fitColumnWidth(grid, column) {
	let contentWidth = 0;
	for (const element of grid.cells.hostElement.querySelectorAll(".row-actions")) if (element.closest(".wj-flexgrid") === grid.hostElement) contentWidth = Math.max(contentWidth, element.scrollWidth);
	const width = Math.max(MIN_WIDTH, contentWidth + 16);
	if (width > column.renderWidth) column.width = width;
}
/**
* Indicates whether data columns are under the row actions column: the right edge of the last
* data column, in the visible area, goes beyond the left edge of the row actions column.
* The positions come from the columns themselves rather than from the scroll metrics of the grid,
* which Wijmo alters to keep the column frozen on the right (it shifts the scroll position by a
* pixel), so that they could still report an overflow once scrolled to the right end.
* The fade zone never goes beyond the hidden data columns: close to the right end, a fade zone
* wider than them would reveal the empty grid background beyond, as a light band.
* Without overflow, the fade zone is set to zero rather than removed: a grid in a row detail
* would otherwise inherit the fade zone of this grid, and fade out its own row actions.
*/
function updateOverflow(grid, rowActionsColumn) {
	const lastDataColumn = grid.columns[getLastDataColumnIndex(grid.columns)];
	const root = grid._root;
	const hiddenWidth = (lastDataColumn ? lastDataColumn.pos + lastDataColumn.renderWidth - root.scrollLeft : 0) - (root.clientWidth - rowActionsColumn.renderWidth);
	const overflow = hiddenWidth > 1;
	grid.hostElement.toggleAttribute("data-row-actions-overflow", overflow);
	if (overflow) grid.hostElement.style.setProperty(FADE_WIDTH_PROPERTY, `${Math.min(16, hiddenWidth)}px`);
	else grid.hostElement.style.setProperty(FADE_WIDTH_PROPERTY, "0px");
}
// src/composables/useDatagridRowDetail.ts
function useDatagridRowDetail(props) {
	const rowDetailComponent = ref();
	function isRowDetailVisible(row) {
		return rowDetailComponent.value?.control.isDetailVisible(row) ?? false;
	}
	function getRowDetailColumnIcon(row) {
		return isRowDetailVisible(row) ? "chevronDown" : "chevronRight";
	}
	function toggleRowDetail(row) {
		if (!rowDetailComponent.value) return false;
		if (isRowDetailVisible(row)) rowDetailComponent.value.control.hideDetail(row);
		else rowDetailComponent.value.control.showDetail(row, props.rowDetailVisibilityMode === "single");
		return true;
	}
	function expandRowDetail(row) {
		if (!rowDetailComponent.value) return false;
		if (!isRowDetailVisible(row)) {
			rowDetailComponent.value.control.showDetail(row, false);
			return true;
		}
		return false;
	}
	function expandRowDetailsOnLoad(rows, currentRowIndex) {
		if (!props.rowDetailExpandedByDefault) return false;
		if (props.rowDetailVisibilityMode === "single") {
			const currentRow = rows[currentRowIndex];
			if (currentRow) return expandRowDetail(currentRow);
			return false;
		}
		for (const row of rows) if (!isSystemRow(row)) expandRowDetail(row);
		return true;
	}
	function expandRowDetailOnAdd(row) {
		if (!props.rowDetailExpandedByDefault) return false;
		return expandRowDetail(row);
	}
	return {
		rowDetailComponent,
		getRowDetailColumnIcon,
		toggleRowDetail,
		expandRowDetailsOnLoad,
		expandRowDetailOnAdd
	};
}
// src/composables/useDatagridValidation.ts
function useDatagridValidation(grid) {
	const messages = /* @__PURE__ */ new WeakMap();
	const validationTooltip = shallowRef();
	let followsSelection = false;
	watch(grid, (flexGrid, _, onCleanup) => {
		if (!flexGrid) return;
		flexGrid.selectionChanged.addHandler(handleSelectionChanged);
		flexGrid.updatedView.addHandler(handleUpdatedView);
		flexGrid.gotFocus.addHandler(handleGotFocus);
		flexGrid.lostFocus.addHandler(handleLostFocus);
		flexGrid.scrollPositionChanged.addHandler(handleScrollPositionChanged);
		flexGrid.hostElement.addEventListener("keydown", handleKeydown, true);
		flexGrid._root.addEventListener("mousemove", handleMousemove);
		flexGrid._root.addEventListener("mouseleave", handleMouseleave);
		onCleanup(() => {
			flexGrid.selectionChanged.removeHandler(handleSelectionChanged);
			flexGrid.updatedView.removeHandler(handleUpdatedView);
			flexGrid.gotFocus.removeHandler(handleGotFocus);
			flexGrid.lostFocus.removeHandler(handleLostFocus);
			flexGrid.scrollPositionChanged.removeHandler(handleScrollPositionChanged);
			flexGrid.hostElement.removeEventListener("keydown", handleKeydown, true);
			flexGrid._root.removeEventListener("mousemove", handleMousemove);
			flexGrid._root.removeEventListener("mouseleave", handleMouseleave);
			hideValidationTooltip();
		});
	}, { immediate: true });
	function setCellValidationMessage(cell, message) {
		if (message) {
			cell.classList.add(`${message.severity}-cell`);
			if (message.severity === "error") cell.setAttribute("aria-invalid", "true");
			else cell.removeAttribute("aria-invalid");
			messages.set(cell, message);
		} else if (messages.has(cell)) {
			for (const severity of validationMessageSeverities) cell.classList.remove(`${severity}-cell`);
			cell.removeAttribute("aria-invalid");
			messages.delete(cell);
		}
	}
	function hideValidationTooltip() {
		followsSelection = false;
		validationTooltip.value = void 0;
	}
	function showValidationTooltip(cell) {
		const message = cell ? messages.get(cell) : void 0;
		const current = validationTooltip.value;
		if (cell && message) {
			if (!(current?.cell === cell && current.message.text === message.text && current.message.severity === message.severity)) validationTooltip.value = {
				cell,
				message
			};
		} else validationTooltip.value = void 0;
	}
	function showSelectedCellValidationTooltip(flexGrid) {
		const { row, col } = flexGrid.selection;
		showValidationTooltip(row >= 0 && col >= 0 ? flexGrid.cells.getCellElement(row, col) : void 0);
	}
	function handleKeydown(event) {
		if (!isOnCells(event.target)) return;
		followsSelection = true;
		showSelectedCellValidationTooltip(grid.value);
	}
	function handleUpdatedView(flexGrid) {
		if (followsSelection) showSelectedCellValidationTooltip(flexGrid);
		else showValidationTooltip(validationTooltip.value?.cell);
	}
	function handleSelectionChanged(flexGrid) {
		if (followsSelection) showSelectedCellValidationTooltip(flexGrid);
	}
	function handleGotFocus() {
		const element = document.activeElement;
		if (isOnCells(element) && element.matches(":focus-visible")) {
			followsSelection = true;
			showSelectedCellValidationTooltip(grid.value);
		}
	}
	function handleLostFocus() {
		if (followsSelection) hideValidationTooltip();
	}
	function handleMousemove(event) {
		followsSelection = false;
		const hit = grid.value.hitTest(event);
		showValidationTooltip(hit.cellType === CellType.Cell ? hit.panel.getCellElement(hit.row, hit.col) : void 0);
	}
	function handleMouseleave() {
		if (!followsSelection) hideValidationTooltip();
	}
	function handleScrollPositionChanged(flexGrid) {
		if (followsSelection) showSelectedCellValidationTooltip(flexGrid);
		else hideValidationTooltip();
	}
	function isOnCells(target) {
		return target instanceof Element && target.closest(".wj-flexgrid") === grid.value.hostElement && !getRowActionsElement(target) && !target.closest(".wj-colheaders, .wj-topleft");
	}
	return {
		validationTooltip,
		setCellValidationMessage,
		hideValidationTooltip
	};
}
// src/exporting/utils.ts
function createTempCellElement(grid) {
	const element = document.createElement("div");
	element.style.visibility = "hidden";
	grid.cells.hostElement.append(element);
	element.dispose = () => {
		grid.cellFactory.disposeCell(element);
		element.remove();
	};
	return element;
}
function getDisplayTemplateText(grid, row, col) {
	const element = createTempCellElement(grid);
	grid.cellFactory.updateCell(grid.cells, row, col, element);
	const text = element.innerText;
	element.dispose();
	return text;
}
// src/utils/DatagridCollectionView.ts
var DatagridCollectionView = class {
	constructor() {
		this.sourceCollection = [];
		this.items = [];
		this.canFilter = true;
		this.canGroup = true;
		this.canSort = true;
		this.currentPosition = -1;
		this.newItemIndex = -1;
		this.isEditingItem = false;
		this.filter = () => true;
		this.groupDescriptions = new ObservableArray$1();
		this.groups = [];
		this.sortDescriptions = new ObservableArray$1();
		this.collectionChanged = new Event$1();
		this.currentChanged = new Event$1();
		this.currentChanging = new Event$1();
	}
	get isEmpty() {
		return this.sourceCollection.length === 0;
	}
	get canAddNew() {
		return true;
	}
	get canCancelEdit() {
		return true;
	}
	get canRemove() {
		return true;
	}
	/**
	* Gets a value indicating whether a change is raised for each modified property of an item.
	*/
	get raisesItemPropertyChanges() {
		return false;
	}
	get currentItem() {}
	get currentAddItem() {}
	get isAddingNew() {
		return false;
	}
	contains() {
		return true;
	}
	moveCurrentTo() {
		return true;
	}
	moveCurrentToFirst() {
		return true;
	}
	moveCurrentToLast() {
		return true;
	}
	moveCurrentToNext() {
		return true;
	}
	moveCurrentToPosition() {
		return true;
	}
	moveCurrentToPrevious() {
		return true;
	}
	refresh() {}
	beginUpdate() {}
	endUpdate() {}
	deferUpdate() {}
	addNew() {}
	insertAt() {}
	commitNew() {}
	cancelNew() {}
	editItem() {}
	commitEdit() {}
	cancelEdit() {}
	remove() {}
	removeAt() {}
	implementsInterface(interfaceName) {
		return interfaceName === "INotifyCollectionChanged" || interfaceName === "ICollectionView" || interfaceName === "IEditableCollectionView";
	}
};
// src/utils/style.ts
/**
* Converts space-separated space tokens (CSS shorthand order) to a CSS property value.
*
* @param abstractedValue - The abstracted multi-size value.
*/
function getMultiSpaceValue(abstractedValue) {
	return getPredefinedSizingValue(abstractedValue, SpaceValues);
}
/**
* Converts space-separated corner radius tokens (CSS shorthand order) to a CSS property value.
*
* @param abstractedValue - The abstracted multi-size value.
*/
function getMultiRadiusValue(abstractedValue) {
	return getPredefinedSizingValue(abstractedValue, CornerRadiusValues);
}
/**
* Converts Neos content align values to divider align values.
* - We use culturally invariant vocabulary (e.g. 'start' | 'end').
* - Whereas the divider uses occidental vocabulary (e.g. 'left' | 'right').
*/
function convertInvariantTextAlignToOccidentalTextAlign(align) {
	switch (align) {
		case "center": return "center";
		case "end": return "right";
		default: return "left";
	}
}
function convertTextAlignToAlignItems(align, explicitDefaultValue) {
	switch (align) {
		case "center": return "center";
		case "end": return "flex-end";
		case "start": return explicitDefaultValue ? "flex-start" : "";
		default: return "";
	}
}
/**
* Converts space-separated sizing tokens (CSS shorthand order) to a CSS property value,
* keeping an unknown token as it is.
*
* @param abstractedValue - The abstracted multi-size value.
* @param spacingValues - The CSS value of each token.
*/
function getPredefinedSizingValue(abstractedValue, spacingValues) {
	return splitOnSpaces(abstractedValue).map((r) => Object.hasOwn(spacingValues, r) ? spacingValues[r] : r).join(" ");
}
/**
* Splits a value on its spaces, ignoring the leading, trailing and repeated ones.
*
* @param value - The value to split.
*/
function splitOnSpaces(value) {
	return value.split(" ").filter((part) => part !== "");
}
/**
* Matches the "TokenName/0.6" alpha notation (a theme token name, a literal slash, then the alpha, with no
* space anywhere in the value).
*/
var tokenAlphaNotationExpression = /^([^\s/]+)\/([^\s/]+)$/;
/**
* A legacy CSS system color keyword that, as a bare value, is the theme token of the same name.
*/
var legacyColorLiteralKeywordTokenName = "background";
/**
* True for a genuine CSS color literal that can never be mistaken for a theme token name: a hex code,
* or a function call (`rgb(...)`, `hsl(...)`, `color-mix(...)`, ...).
*/
function isLiteralColorSyntax(value) {
	return value.startsWith("#") || value.includes("(");
}
/**
* Returns the value if it is a color supported by the browser (`CSS.supports('color', value)`),
* or the value of the CSS variable with that name (`var(--thatParamValue)`),
* or, when the value uses the "TokenName/0.6" notation, that token's color rendered at the given alpha.
* The generator resolves literal template directive values with the same rules (TemplateDirectiveValues.Color).
*/
function getColorValue(value) {
	const alphaMatch = tokenAlphaNotationExpression.exec(value);
	if (alphaMatch != null && !isLiteralColorSyntax(alphaMatch[1])) return getTokenAlphaColorValue(alphaMatch[1], alphaMatch[2]);
	return value !== legacyColorLiteralKeywordTokenName && CSS.supports("color", value) ? value : `var(--${value})`;
}
/**
* Same alpha notation as `getColorValue`, but a bare value is always a theme token, even a CSS color
* keyword (`gray`, `white`...), for the token-only colors of Splitter and TreeView.
*/
function getTokenOnlyColorValue(value) {
	const alphaMatch = tokenAlphaNotationExpression.exec(value);
	if (alphaMatch != null) return getTokenAlphaColorValue(alphaMatch[1], alphaMatch[2]);
	return `var(--${value})`;
}
/**
* Renders a theme token's color at the given alpha, copied verbatim into a calc() rather than rounded
* to a percentage (a sub-1% alpha such as "0.004" would otherwise render fully transparent).
*/
function getTokenAlphaColorValue(tokenName, alpha) {
	return `color-mix(in srgb, var(--${tokenName}) calc(${alpha} * 100%), transparent)`;
}
// src/exporting/csv.ts
async function exportToCsvFile(grid, columns, systemColumnCount) {
	const csv = await getClipString(grid, columns, new CellRange(0, systemColumnCount, grid.rows.length - 1, getLastDataColumnIndex(grid.columns)));
	saveAs(new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" }), "export.csv");
}
/**
* The following code is coming from https://www.grapecity.com/forums/wijmo/subtotal-aggregated-column-identififcation.
* The original "getClipString" method uses raw values and not the displayed values.
**/
/* v8 ignore next -- @preserve */
async function getClipString(grid, columns, rng) {
	const tempCellElement = createTempCellElement(grid);
	let text = `${getHeaderString(grid, rng, tempCellElement)}\n`;
	for (let r = rng.topRow; r <= rng.bottomRow; r++) {
		if (grid.rows[r] instanceof AddRow) continue;
		text += `${await getRowString(grid, columns, rng, r)}\n`;
	}
	tempCellElement.dispose();
	return text;
}
/* v8 ignore next -- @preserve */
function getHeaderString(grid, rng, tempCellElement) {
	let text = "";
	const row = grid.columnHeaders.rows.length - 1;
	let firstCell = true;
	for (let c = rng.leftCol; c <= rng.rightCol; c++) {
		if (!grid.columns[c].isVisible) continue;
		if (!firstCell) text += ",";
		firstCell = false;
		grid.cellFactory.updateCell(grid.columnHeaders, row, c, tempCellElement);
		text += tempCellElement.querySelector(".column-caption")?.innerText?.replaceAll(",", "");
	}
	return text;
}
/* v8 ignore next -- @preserve */
async function getRowString(grid, columns, rng, r) {
	let text = "";
	let firstCell = true;
	for (let c = rng.leftCol; c <= rng.rightCol; c++) {
		const col = grid.columns[c];
		if (!col.isVisible) continue;
		if (firstCell) firstCell = false;
		else text += ",";
		const column = columns.get(col.name);
		if (column) {
			if (column.displayTemplate) text += escapeValue(getDisplayTemplateText(grid, r, c));
			else if (column.displayText) {
				const item = grid.rows[r].dataItem;
				const value = getPropertyByPath(item, column.name);
				text += escapeValue(await column.displayText(value, item));
			}
		}
	}
	return text;
}
function escapeValue(value) {
	return value.includes(",") || value.includes("\n") || value.includes("\"") ? `"${value.replaceAll("\"", "\"\"")}"` : value;
}
// src/exporting/xlsx.ts
async function exportToXlsxFile(grid, columns) {
	const { FlexGridXlsxConverter } = await import("@mescius/wijmo.grid.xlsx");
	FlexGridXlsxConverter.saveAsync(grid, {
		includeStyles: false,
		includeColumns(col) {
			if (grid.collectionView.groupDescriptions.length > 0) {
				if (col.name === "$$row-indicator") return true;
				if (grid.collectionView.groupDescriptions.some((d) => d instanceof PropertyGroupDescription$1 && d.propertyName === col.name)) return false;
			}
			return columns.get(col.name)?.visible === true;
		},
		formatItem(args) {
			if (args.panel === grid.columnHeaders) formatColumnHeader(args, columns);
			else if (args.panel === grid.cells) formatCell(args, grid, columns);
		}
	}, "export.xlsx");
}
function formatColumnHeader(args, columns) {
	const col = args.getColumn();
	if (col.name === "$$row-indicator") args.xlsxCell.value = void 0;
	else {
		const column = columns.get(col.name);
		if (column) updateCellAlignment(args.xlsxCell.style, column.align);
	}
}
function formatCell(args, grid, columns) {
	const item = args.getRow().dataItem;
	if (!item) {
		args.xlsxCell.value = void 0;
		return;
	}
	if (item instanceof CollectionViewGroup$1) formatGroupRowCell(args, grid, columns, item);
	else formatRowCell(args, grid, columns, item);
}
function formatRowCell(args, grid, columns, item) {
	const columnName = args.getColumn().name;
	const column = columns.get(columnName);
	if (!column) return;
	args.xlsxCell.isDate = false;
	args.xlsxCell.isNumber = false;
	if (column.displayTemplate) args.xlsxCell.value = getDisplayTemplateText(grid, args.row, args.col);
	else if (column.displayTextSync) {
		const value = getPropertyByPath(item, columnName);
		args.xlsxCell.value = column.displayTextSync(value, item);
	}
	updateCellAlignment(args.xlsxCell.style, column.align);
}
function formatGroupRowCell(args, grid, columns, item) {
	const groupDescription = item.groupDescription;
	const isFirstColumn = grid.columns.firstVisibleIndex === args.col;
	const columnName = isFirstColumn ? groupDescription.propertyName : args.getColumn().name;
	const column = columns.get(columnName);
	if (!column) return;
	if (isFirstColumn && column.displayTextSync) args.xlsxCell.value = column.displayTextSync(item.name, item);
	updateCellAlignment(args.xlsxCell.style, isFirstColumn ? "start" : column.align);
}
function updateCellAlignment(style, align) {
	style.wordWrap = true;
	style.vAlign = 1;
	if (align === "end") style.hAlign = 3;
	else if (align === "center") style.hAlign = 2;
	else style.hAlign = 1;
}
// src/components/ListBox/ListBox.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$30 = {
	class: "list-box-empty",
	role: "status",
	"aria-live": "polite"
};
// src/components/ListBox/ListBox.vue
var ListBox_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "ListBox",
	props: /*@__PURE__*/ mergeModels({
		...inputProps,
		...contentProps,
		values: {
			type: Array,
			default: () => []
		},
		keyProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		multiple: {
			type: Boolean,
			default: false
		},
		toggleOnClick: {
			type: Boolean,
			default: false
		},
		searchable: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		}
	}, {
		"modelValue": { default: () => [] },
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([...inputEmits], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const contentStyleObject = useContentStyle(props);
		const emit = __emit;
		const modelValue = useModel(__props, "modelValue");
		const { input, id, classes, ariaAttributes, isLabelVisible, isMessageVisible, messageId, tabIndex } = useInput(props, emit);
		const { getItemKey, getItemLabel, isSameItem } = useSelectableItemProperties(props);
		const { translate } = useGlobalResourceManager();
		const containerTabIndex = computed(() => tabIndex.value ?? 0);
		const { displayedItems: displayedValues, searchText, showSelected, handleSearch, toggleShowSelected } = useSelectableListFilter({
			items: () => props.values,
			selectedItems: () => modelValue.value,
			multiple: () => props.multiple,
			searchable: () => props.searchable,
			getItemLabel,
			isSameItem
		});
		function handleSelection(event) {
			if (props.readonly || props.disabled || props.loading) return;
			if (event.source === "click") {
				const mouseEvent = event.originalEvent;
				if (!props.multiple || !props.toggleOnClick && !mouseEvent.ctrlKey) {
					modelValue.value = [event.item];
					return;
				}
			}
			if (props.multiple) {
				if (event.checked) modelValue.value = [...modelValue.value, event.item];
				else modelValue.value = modelValue.value.filter((item) => !isSameItem(item, event.item));
			} else modelValue.value = [event.item];
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["list-box neos-input", unref(classes)]) }, [
				unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
					key: 0,
					label: _ctx.label,
					required: _ctx.required,
					documentation: _ctx.documentation,
					"html-for": unref(id),
					"ai-suggestion": _ctx.aiSuggestion,
					onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
					onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
				}, null, 8, [
					"label",
					"required",
					"documentation",
					"html-for",
					"ai-suggestion"
				])) : createCommentVNode("", true),
				createVNode(SelectableList_default, {
					"list-id": unref(id),
					items: unref(displayedValues),
					"selected-items": modelValue.value,
					"get-item-key": unref(getItemKey),
					"is-same-item": unref(isSameItem),
					multiple: __props.multiple,
					disabled: _ctx.disabled || _ctx.readonly || __props.loading && __props.values.length > 0,
					loading: __props.loading,
					required: _ctx.required,
					"tab-index": containerTabIndex.value,
					"focus-selected-on-focus": "",
					"clear-focus-on-blur": "",
					"select-on-enter": false,
					"select-on-tab": false,
					"list-attributes": {
						...unref(ariaAttributes),
						"aria-label": _ctx.label
					},
					class: normalizeClass(["list-box-container", _ctx.contentClass]),
					style: normalizeStyle(unref(contentStyleObject)),
					onMounted: _cache[3] || (_cache[3] = ($event) => input.value = $event),
					onSelect: handleSelection
				}, {
					header: withCtx(({ focusedItemId, setFocusedIndex }) => [__props.searchable ? (openBlock(), createBlock(SelectableListHeader_default, {
						key: 0,
						modelValue: unref(searchText),
						"onUpdate:modelValue": [_cache[2] || (_cache[2] = ($event) => isRef(searchText) ? searchText.value = $event : null), ($event) => unref(handleSearch)(setFocusedIndex)],
						class: "list-box-search-header",
						"list-id": unref(id),
						"active-descendant": focusedItemId,
						disabled: _ctx.disabled,
						loading: __props.loading,
						"tab-index": unref(tabIndex),
						"selected-count": __props.multiple ? modelValue.value.length : void 0,
						"show-selected": unref(showSelected),
						"show-selected-button-class": "list-box-show-selected-button",
						onToggleShowSelected: ($event) => unref(toggleShowSelected)(setFocusedIndex)
					}, null, 8, [
						"modelValue",
						"list-id",
						"active-descendant",
						"disabled",
						"loading",
						"tab-index",
						"selected-count",
						"show-selected",
						"onUpdate:modelValue",
						"onToggleShowSelected"
					])) : createCommentVNode("", true)]),
					item: withCtx(({ item, itemId, selected, focused, select }) => [createVNode(SelectableItem_default, {
						id: itemId,
						"data-key": unref(getItemKey)(item),
						"control-type": __props.multiple ? "checkbox" : "radio",
						selected,
						focused,
						class: "list-box-item",
						"aria-label": unref(getItemLabel)(item),
						onClick: ($event) => select($event, "click"),
						onChecked: ($event) => select($event, "checked")
					}, {
						default: withCtx(() => [createElementVNode("span", null, toDisplayString(unref(getItemLabel)(item)), 1)]),
						_: 2
					}, 1032, [
						"id",
						"data-key",
						"control-type",
						"selected",
						"focused",
						"aria-label",
						"onClick",
						"onChecked"
					])]),
					empty: withCtx(() => [createElementVNode("span", _hoisted_1$30, toDisplayString(unref(translate)(__props.loading ? "Loading" : __props.values.length === 0 ? "NoValues" : "NoResultFound")), 1)]),
					_: 1
				}, 8, [
					"list-id",
					"items",
					"selected-items",
					"get-item-key",
					"is-same-item",
					"multiple",
					"disabled",
					"loading",
					"required",
					"tab-index",
					"list-attributes",
					"class",
					"style"
				]),
				unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
					key: 1,
					id: unref(messageId),
					text: _ctx.messageText,
					severity: _ctx.messageSeverity
				}, null, 8, [
					"id",
					"text",
					"severity"
				])) : createCommentVNode("", true)
			], 2);
		};
	}
}), [["__scopeId", "data-v-81c2c1f1"]]);
// src/components/DatagridContextMenu/DatagridContextMenu.ts?vue&type=script&src=true&lang.ts
var DatagridContextMenu_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridContextMenu",
	components: {
		DatagridColumnPicker: /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
			__name: "DatagridColumnPicker",
			props: {
				grid: {
					type: Object,
					required: true
				},
				columns: {
					type: Object,
					required: true
				}
			},
			emits: ["columnsChanged"],
			setup(__props, { expose: __expose, emit: __emit }) {
				const props = __props;
				const emit = __emit;
				const popover = ref();
				const pickerColumns = ref([]);
				const selectedColumns = ref([]);
				function show(event) {
					pickerColumns.value = getColumns();
					selectedColumns.value = pickerColumns.value.filter((column) => column.visible);
					popover.value.show(event);
				}
				function hide() {
					popover.value.hide();
				}
				function getColumns() {
					const cols = [];
					for (const column of props.grid.columns) {
						const col = column.name && props.columns.get(column.name);
						if (!col) continue;
						const caption = col.pickerCaption ?? col.caption;
						if (caption && col.movable !== false) cols.push({
							name: col.name,
							caption,
							visible: column.visible,
							visibleIndex: column.visibleIndex
						});
					}
					return cols.sort((a, b) => {
						if (a.visible && !b.visible) return -1;
						if (!a.visible && b.visible) return 1;
						if (a.visible && b.visible) return a.visibleIndex - b.visibleIndex;
						return a.caption.localeCompare(b.caption);
					});
				}
				function handleSelectionChanged(columns) {
					selectedColumns.value = columns;
					let changed = false;
					for (const column of props.grid.columns) if (pickerColumns.value.some((c) => c.name === column.name)) {
						const newVisible = columns.some((c) => c.name === column.name);
						if (column.visible !== newVisible) {
							column.visible = newVisible;
							changed = true;
						}
					}
					if (changed) emit("columnsChanged", props.grid);
				}
				__expose({
					show,
					hide
				});
				return (_ctx, _cache) => {
					return openBlock(), createBlock(Popover_default, {
						ref_key: "popover",
						ref: popover,
						class: "datagrid-column-picker"
					}, {
						default: withCtx(() => [createVNode(ListBox_default, {
							"model-value": selectedColumns.value,
							values: pickerColumns.value,
							"key-property": "name",
							"display-property": "caption",
							multiple: "",
							"toggle-on-click": "",
							searchable: "",
							class: "datagrid-column-picker-list-box",
							"onUpdate:modelValue": handleSelectionChanged
						}, null, 8, ["model-value", "values"])]),
						_: 1
					}, 512);
				};
			}
		}), [["__scopeId", "data-v-6bfcb625"]]),
		ContextMenu: ContextMenu_default
	},
	props: {
		grid: {
			type: Object,
			required: true
		},
		columns: {
			type: Object,
			required: true
		},
		getRowContextMenuItems: {
			type: Function,
			default: void 0
		},
		systemColumnCount: {
			type: Number,
			required: true
		},
		groupable: {
			type: Boolean,
			required: true
		},
		groupPanelVisible: {
			type: Boolean,
			default: void 0
		},
		exportable: {
			type: Boolean,
			default: true
		},
		columnPicker: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:groupPanelVisible", "columnsChanged"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const contextMenu = ref();
		const columnPickerEl = ref();
		const contextMenuItems = ref([]);
		let lastToggleId = 0;
		onBeforeUnmount(cancel);
		/**
		* Shows the menu once the given selection change is done, so that the row commands
		* act on the final selection. A menu requested since then takes precedence.
		*/
		async function toggle(event, selectionChange) {
			const toggleId = ++lastToggleId;
			const hit = hitTest(event);
			if (!hit) return;
			const getItems = getMenuItemsBuilder(hit);
			await selectionChange?.catch(() => void 0);
			if (toggleId !== lastToggleId) return;
			contextMenuItems.value = getItems();
			if (contextMenuItems.value.length > 0) {
				await nextTick();
				if (toggleId === lastToggleId) {
					columnPickerEl.value.hide();
					contextMenu.value.show(event);
				}
			}
		}
		/**
		* Cancels the menu waiting for a selection change.
		*/
		function cancel() {
			lastToggleId++;
		}
		function hitTest(event) {
			const hit = props.grid.hitTest(event);
			if (hit.cellType === CellType.ColumnHeader) {
				const domColumnName = event.target?.closest("[data-column]")?.getAttribute("data-column");
				const wijmoColumnName = hit.getColumn()?.name;
				if (domColumnName && domColumnName !== wijmoColumnName) {
					const domColumnIndex = props.grid.columns.findIndex((c) => c.name === domColumnName);
					if (domColumnIndex !== -1) hit._col = domColumnIndex;
				}
			}
			return hit.cellType === CellType.ColumnHeader || hit.cellType === CellType.Cell ? hit : void 0;
		}
		/**
		* The clicked row item is read right away because the rows can change during the selection change.
		*/
		function getMenuItemsBuilder(hit) {
			if (hit.cellType === CellType.Cell) {
				const item = hit.getRow()?.dataItem;
				return () => getCellMenuItems(item);
			}
			return () => getColumnHeaderMenuItems(hit);
		}
		function getCellMenuItems(item) {
			if (!props.getRowContextMenuItems) return [];
			if (!item || item instanceof CollectionViewGroup$1) return [];
			return props.getRowContextMenuItems(item, () => contextMenu.value.hide());
		}
		function getColumnHeaderMenuItems(hit) {
			const column = hit.getColumn();
			const col = props.columns.get(column.name);
			const items = [];
			if (props.groupable) {
				if (col) items.push({
					label: translate("GroupByColumn"),
					icon: "addGroup",
					attributes: { "data-command": "GROUP_BY_COLUMN" },
					disabled: !col.groupable,
					command() {
						contextMenu.value.hide();
						hit.grid.collectionView.groupDescriptions.push(new PropertyGroupDescription$1(column.name));
						column.visible = false;
						emit("update:groupPanelVisible", true);
					}
				});
				items.push({
					label: props.groupPanelVisible ? translate("HideGroupPanel") : translate("ShowGroupPanel"),
					icon: "groupPanel",
					attributes: { "data-command": "TOGGLE_GROUP_PANEL" },
					command() {
						contextMenu.value.hide();
						emit("update:groupPanelVisible", !props.groupPanelVisible);
					}
				});
			}
			if (props.exportable) {
				if (items.length > 0) items.push({ separator: true });
				items.push({
					label: translate("ExportDisplayedDataToCsvFile"),
					icon: "csv",
					disabled: hit.grid.collectionView.groupDescriptions.length > 0,
					attributes: { "data-command": "EXPORT_TO_CSV" },
					command() {
						contextMenu.value.hide();
						exportToCsvFile(hit.grid, props.columns, props.systemColumnCount);
					}
				}, {
					label: translate("ExportDisplayedDataToXlsxFile"),
					icon: "excel",
					attributes: { "data-command": "EXPORT_TO_XLSX" },
					command() {
						contextMenu.value.hide();
						exportToXlsxFile(hit.grid, props.columns);
					}
				});
			}
			if (props.columnPicker) {
				if (items.length > 0) items.push({ separator: true });
				if (col) items.push({
					label: translate("HideColumn"),
					icon: "removeColumn",
					attributes: { "data-command": "HIDE_COLUMN" },
					command() {
						contextMenu.value.hide();
						hit.grid.finishEditing();
						column.visible = false;
						emitColumnsChanged(hit.grid);
					}
				});
				items.push({
					label: translate("ChooseColumns"),
					icon: "columnPicker",
					attributes: { "data-command": "SHOW_COLUMN_PICKER" },
					async command() {
						columnPickerEl.value.show({ currentTarget: props.grid._eCHdr });
					}
				});
			}
			return items;
		}
		function emitColumnsChanged(grid) {
			emit("columnsChanged", grid);
		}
		return {
			translate,
			contextMenu,
			contextMenuItems,
			columnPickerEl,
			toggle,
			cancel,
			emitColumnsChanged
		};
	}
});
// src/components/DatagridContextMenu/DatagridContextMenu.vue
function _sfc_render$13(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_ContextMenu = resolveComponent("ContextMenu");
	const _component_DatagridColumnPicker = resolveComponent("DatagridColumnPicker");
	return _ctx.contextMenuItems.length > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(_component_ContextMenu, {
		ref: "contextMenu",
		items: _ctx.contextMenuItems,
		class: "datagrid-context-menu",
		size: "small"
	}, null, 8, ["items"]), createVNode(_component_DatagridColumnPicker, {
		ref: "columnPickerEl",
		grid: _ctx.grid,
		columns: _ctx.columns,
		onColumnsChanged: _ctx.emitColumnsChanged
	}, null, 8, [
		"grid",
		"columns",
		"onColumnsChanged"
	])], 64)) : createCommentVNode("", true);
}
var DatagridContextMenu_default = /*#__PURE__*/ _plugin_vue_export_helper_default(DatagridContextMenu_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$13]]);
// src/components/DatagridGroupPanel/DatagridGroupPanel.ts?vue&type=script&src=true&lang.ts
var DatagridGroupPanel_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridGroupPanel",
	components: { WjGroupPanel },
	props: {
		grid: {
			type: Object,
			default: void 0
		},
		draggingColumn: {
			type: Object,
			default: void 0
		}
	},
	emits: ["sort"],
	setup(props, { emit }) {
		const root = ref();
		const { translate } = useGlobalResourceManager();
		watch([root, () => props.grid], () => {
			if (root.value && props.grid) {
				root.value.control.grid = props.grid;
				root.value.control._updateSort = function(event, marker) {
					const index = this._getElementIndex(marker);
					const groupDescription = this._gds[index];
					emit("sort", event, this._g.getColumn(groupDescription.propertyName));
				};
			}
		});
		function handleInitialization(panel) {
			panel.hostElement.addEventListener("drop", (e) => {
				if (props.draggingColumn && !props.draggingColumn.groupable) e.stopImmediatePropagation();
			}, true);
		}
		return {
			root,
			translate,
			handleInitialization
		};
	}
});
// src/components/DatagridGroupPanel/DatagridGroupPanel.vue
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_WjGroupPanel = resolveComponent("WjGroupPanel");
	return openBlock(), createBlock(_component_WjGroupPanel, {
		ref: "root",
		placeholder: _ctx.translate("GroupPanelPlaceholder"),
		initialized: _ctx.handleInitialization,
		class: "datagrid-group-panel"
	}, null, 8, ["placeholder", "initialized"]);
}
var DatagridGroupPanel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(DatagridGroupPanel_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$12]]);
// src/components/DatagridSummaryCell/DatagridSummaryCell.ts?vue&type=script&src=true&lang.ts
var DatagridSummaryCell_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridSummaryCell",
	components: {
		HorizontalLayout: HorizontalLayout_default,
		Text: Text_default
	},
	props: {
		types: {
			type: Object,
			required: true
		},
		type: {
			type: String,
			required: true
		},
		value: {
			type: Number,
			required: true
		},
		format: {
			type: String,
			default: void 0
		},
		align: {
			type: String,
			default: "left"
		},
		tag: {
			type: Boolean,
			default: true
		}
	},
	setup(props) {
		const currentType = computed(() => props.types[props.type]);
		return {
			typeTag: computed(() => props.tag ? currentType.value?.tag : void 0),
			typeCaption: computed(() => currentType.value?.caption ?? void 0),
			formattedValue: computed(() => props.format ? Globalize.format(props.value, props.format) : props.value)
		};
	}
});
// src/components/DatagridSummaryCell/DatagridSummaryCell.vue
var _hoisted_1$29 = {
	key: 0,
	class: "tag"
};
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	return openBlock(), createBlock(_component_HorizontalLayout, {
		align: _ctx.align,
		space: "extrasmall",
		"vertical-align": "center",
		wrap: false,
		class: "datagrid-summary-cell",
		"data-type": _ctx.type,
		title: _ctx.typeCaption
	}, {
		default: withCtx(() => [_ctx.typeTag ? (openBlock(), createElementBlock("span", _hoisted_1$29, toDisplayString(_ctx.typeTag), 1)) : createCommentVNode("", true), createVNode(_component_Text, {
			size: "small",
			weight: "strong",
			class: "value"
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formattedValue), 1)]),
			_: 1
		})]),
		_: 1
	}, 8, [
		"align",
		"data-type",
		"title"
	]);
}
var DatagridSummaryCell_default = /*#__PURE__*/ _plugin_vue_export_helper_default(DatagridSummaryCell_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$11], ["__scopeId", "data-v-b753086d"]]);
// src/components/DatagridValidationTooltip/DatagridValidationTooltip.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$28 = ["id"];
// src/components/DatagridValidationTooltip/DatagridValidationTooltip.vue
var DatagridValidationTooltip_default = /* @__PURE__ */ defineComponent({
	__name: "DatagridValidationTooltip",
	props: { tooltip: {} },
	emits: ["hide"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const messageId = useId();
		watch(() => props.tooltip?.cell, (cell, oldCell) => {
			oldCell?.removeAttribute("aria-describedby");
			cell?.setAttribute("aria-describedby", messageId);
		}, { immediate: true });
		function onOpenChange(open) {
			if (!open) emit("hide");
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(TooltipProvider), null, {
				default: withCtx(() => [createVNode(unref(TooltipRoot), {
					open: !!__props.tooltip,
					"onUpdate:open": onOpenChange
				}, {
					default: withCtx(() => [createVNode(unref(TooltipTrigger), {
						as: "span",
						hidden: "",
						reference: __props.tooltip?.cell
					}, null, 8, ["reference"]), createVNode(unref(TooltipPortal), null, {
						default: withCtx(() => [__props.tooltip ? (openBlock(), createBlock(unref(TooltipContent), {
							key: 0,
							class: normalizeClass(["datagrid-tooltip", `datagrid-tooltip-${__props.tooltip.message.severity}`]),
							side: "top",
							"side-offset": 4,
							"collision-padding": 10,
							"hide-when-detached": "",
							onPointerDownOutside: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"]))
						}, {
							default: withCtx(() => [createElementVNode("span", { id: unref(messageId) }, toDisplayString(__props.tooltip.message.text), 9, _hoisted_1$28)]),
							_: 1
						}, 8, ["class"])) : createCommentVNode("", true)]),
						_: 1
					})]),
					_: 1
				}, 8, ["open"])]),
				_: 1
			});
		};
	}
});
// src/components/DotLoader/DotLoader.vue
var DotLoader_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "DotLoader",
	props: { size: { default: "medium" } },
	setup(__props) {
		const props = __props;
		const loaderClasses = computed(() => [`dot-loader-${props.size}`]);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["dot-loader", loaderClasses.value]) }, [..._cache[0] || (_cache[0] = [
				createElementVNode("div", { class: "dot-loader-dot-1" }, null, -1),
				createElementVNode("div", { class: "dot-loader-dot-2" }, null, -1),
				createElementVNode("div", { class: "dot-loader-dot-3" }, null, -1)
			])], 2);
		};
	}
}), [["__scopeId", "data-v-85a86eeb"]]);
// src/components/LoadingOverlay/LoadingOverlay.ts?vue&type=script&src=true&lang.ts
var LoadingOverlay_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "LoadingOverlay",
	components: {
		DotLoader: DotLoader_default,
		HorizontalLayout: HorizontalLayout_default,
		Text: Text_default,
		VerticalLayout: VerticalLayout_default
	},
	props: {
		message: {
			type: String,
			default: void 0
		},
		focusTrap: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const root = ref();
		let modalCount = 0;
		let returnFocusElement = null;
		const { activate, deactivate } = useFocusTrap(root, {
			allowOutsideClick: true,
			fallbackFocus: document.createElement("div"),
			setReturnFocus: () => {
				if (returnFocusElement) {
					const el = returnFocusElement;
					returnFocusElement = null;
					return el;
				}
				return false;
			}
		});
		watch(() => props.message, () => {
			if (props.focusTrap && props.message) {
				modalCount = document.querySelectorAll(".modal").length;
				returnFocusElement = document.activeElement;
			}
		});
		watch([() => props.focusTrap, root], ([focusTrap, el]) => {
			if (focusTrap && el) activate();
			else {
				if (document.querySelectorAll(".modal").length > modalCount) returnFocusElement = null;
				deactivate();
			}
		}, {
			immediate: true,
			flush: "post"
		});
		return { root };
	}
});
// src/components/LoadingOverlay/LoadingOverlay.vue
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_DotLoader = resolveComponent("DotLoader");
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(Transition, { name: "loading-overlay" }, {
		default: withCtx(() => [_ctx.message ? (openBlock(), createBlock(_component_VerticalLayout, {
			key: 0,
			ref: "root",
			align: "center",
			class: "loading-overlay"
		}, {
			default: withCtx(() => [createVNode(_component_HorizontalLayout, {
				space: "extrasmall",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createVNode(_component_DotLoader), createVNode(_component_Text, { tabindex: "0" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.message), 1)]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 512)) : createCommentVNode("", true)]),
		_: 1
	});
}
var LoadingOverlay_default = /*#__PURE__*/ _plugin_vue_export_helper_default(LoadingOverlay_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$10], ["__scopeId", "data-v-7bcfd36a"]]);
// src/components/Datagrid/datagridCommonProps.ts
/**
* Props shared by the design system datagrid and the application datagrid,
* which passes them through to the design system one.
*/
var datagridCommonProps = {
	editable: {
		type: Boolean,
		default: false
	},
	selectionColumn: {
		type: Boolean,
		default: true
	},
	groupPanelVisible: {
		type: Boolean,
		default: void 0
	},
	autoRowHeight: {
		type: Boolean,
		default: false
	},
	booleanDisplayMode: {
		type: String,
		default: "checkbox"
	},
	resizeColumnsOnRefresh: {
		type: Boolean,
		default: false
	},
	exportable: {
		type: Boolean,
		default: true
	},
	columnPicker: {
		type: Boolean,
		default: true
	},
	summaryTag: {
		type: Boolean,
		default: true
	},
	rowDetailVisibilityMode: {
		type: String,
		default: "single"
	},
	rowDetailExpandedByDefault: {
		type: Boolean,
		default: false
	},
	rowClickSelectionMode: {
		type: String,
		default: "replace"
	},
	rowDraggable: {
		type: Boolean,
		default: false
	},
	rowDragover: {
		type: Function,
		default: void 0
	},
	rowDrop: {
		type: Function,
		default: void 0
	}
};
// src/components/Datagrid/Datagrid.ts?vue&type=script&src=true&lang.ts
var MAX_SORT_DESCRIPTIONS = 10;
/**
* Restore columns aggregate.
*/
function restoreColumnsAggregate(grid, columnsMap) {
	for (const column of grid.columns) if (columnsMap.get(column.name)?.groupSummaryType !== void 0 && grid.collectionView && !grid.collectionView.groupDescriptions.some((gd) => gd.propertyName === column.name)) column.aggregate = Aggregate$1.Sum;
	else column.aggregate = Aggregate$1.None;
}
/**
* Restore group rows state.
*/
function restoreGroupRowsState(grid) {
	grid.restoringGroupRowsState = true;
	for (const row of grid.rows) if (isGroupRow(row)) {
		Object.defineProperty(row, "hasChildren", { value: true });
		row.isCollapsed = row.dataItem.isCollapsed;
	}
	grid.restoringGroupRowsState = false;
}
/**
* Gets the visible columns.
*/
function getVisibleColumns(grid) {
	return grid.columns.filter((c) => c.isVisible);
}
function isStarSizedColumn(width) {
	return typeof width === "string" && width.trim().endsWith("*");
}
function getAutoSizedColumnWidth(column, neosColumn) {
	const minInitialWidth = neosColumn.minInitialWidth;
	return minInitialWidth && minInitialWidth > column.renderWidth ? minInitialWidth : column.renderWidth;
}
function getAutoSizedLastColumnWidth(grid, column, neosColumn, totalWidth, firstRender) {
	const width = getAutoSizedColumnWidth(column, neosColumn);
	if (totalWidth + width <= grid._root.clientWidth) return firstRender ? "*" : grid._root.clientWidth - totalWidth;
	return width;
}
/**
* Autosizes the grid columns.
*/
function autoSizeGridColumns(grid, columnsMap, firstRender) {
	let totalWidth = 8;
	const columns = getVisibleColumns(grid).filter((c) => c.name !== "$$filler" && c.name !== "$$row-actions");
	const rowActionsColumn = grid.columns.getColumn(ROW_ACTIONS_COLUMN_NAME);
	if (rowActionsColumn?.isVisible) totalWidth += rowActionsColumn.renderWidth;
	const hasStarSizedColumn = columns.some((column) => column.name && isStarSizedColumn(columnsMap.get(column.name)?.width));
	for (let index = 0; index < columns.length; index++) {
		const column = columns[index];
		const neosColumn = column.name && columnsMap.get(column.name);
		if (neosColumn && neosColumn.width == null) {
			grid.autoSizeColumn(column.index, false);
			let width;
			if (!hasStarSizedColumn && index === columns.length - 1) width = getAutoSizedLastColumnWidth(grid, column, neosColumn, totalWidth, firstRender);
			else width = getAutoSizedColumnWidth(column, neosColumn);
			if (typeof width !== "number" || width > column.renderWidth) column.width = width;
		}
		totalWidth += column.renderWidth;
	}
}
/**
* Autosizes the grid rows.
*/
function autoSizeGridRows(grid, autoRowHeight) {
	if (autoRowHeight) grid.autoRowHeights = true;
	return autoRowHeight;
}
/**
* Hides grouping columns.
*/
function hideGroupingColumns(grid) {
	for (const groupDescription of grid.collectionView.groupDescriptions) {
		const propertyName = groupDescription.propertyName;
		const column = grid.columns.getColumn(propertyName);
		if (column) column.visible = false;
	}
}
/**
* Converts the boolean to the visibility value.
*/
function convertBooleanToVisibility(visible) {
	return visible ? void 0 : "hidden";
}
/**
* Gets the selection mode by mouse event.
*/
function getSelectionModeByMouseEvent(event, rowClickSelectionMode) {
	if (event.shiftKey && !event.ctrlKey) return "range";
	if (event.ctrlKey && !event.shiftKey) return "multi";
	if (rowClickSelectionMode === "toggle") return event.button === 2 ? "add" : "multi";
	if (event.button === 2) return "single-select-only";
	return "single";
}
var nonTextInputTypes = /* @__PURE__ */ new Set([
	"checkbox",
	"radio",
	"button",
	"submit",
	"reset",
	"image",
	"file"
]);
function isTextEntryElement(target) {
	if (target instanceof HTMLInputElement) return !nonTextInputTypes.has(target.type);
	return target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}
function isLinkElement(target) {
	return target instanceof Element && target.closest("a[href]") !== null;
}
function convertColumnWidth(width) {
	if (width == null || typeof width !== "string" || isStarSizedColumn(width)) return width;
	const parsedWidth = Number(width);
	return Number.isNaN(parsedWidth) ? width : parsedWidth;
}
function canNavigateWithArrowKey(event) {
	return !event.altKey && !isDropdownActive();
}
/**
* Gets a value indicating whether a key pressed on a row action is handled by the grid: Tab,
* Escape and the shortcuts with a modifier key.
*/
function isRowActionKeyLeftToGrid(event) {
	return ["Tab", "Escape"].includes(event.key) || event.ctrlKey || event.metaKey || event.altKey;
}
function preventKeyDefaultBehavior(event) {
	event.preventDefault();
	event.stopImmediatePropagation();
}
var Datagrid_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Datagrid",
	components: {
		DatagridContextMenu: DatagridContextMenu_default,
		DatagridGroupPanel: DatagridGroupPanel_default,
		DatagridSummaryCell: DatagridSummaryCell_default,
		DatagridValidationTooltip: DatagridValidationTooltip_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		InputDocumentationButton: InputDocumentationButton_default,
		LoadingOverlay: LoadingOverlay_default,
		MarkdownViewer: MarkdownViewer_default,
		VerticalLayout: VerticalLayout_default,
		WjFlexGrid,
		WjFlexGridCellTemplate,
		WjFlexGridColumn,
		WjFlexGridDetail
	},
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		columns: {
			type: Array,
			required: true
		},
		getRowContextMenuItems: {
			type: Function,
			default: void 0
		},
		...datagridCommonProps,
		source: {
			type: Object,
			required: true
		},
		addRow: {
			type: Boolean,
			default: false
		},
		groupable: {
			type: Boolean,
			default: false
		},
		selectionColumnHeader: {
			type: Boolean,
			default: true
		},
		onSelectionColumnHeaderCheck: {
			type: Function,
			default: void 0
		},
		onRowSelect: {
			type: Function,
			default: void 0
		},
		selectionBinding: {
			type: String,
			default: void 0
		},
		rowHeight: {
			type: Number,
			default: 56
		},
		infiniteScrolling: {
			type: Boolean,
			default: false
		},
		loadRows: {
			type: Function,
			default: void 0
		},
		enterKeyActsAsTab: {
			type: Boolean,
			default: false
		},
		summaries: {
			type: Object,
			default: void 0
		},
		resizeColumnsOnFirstLoad: {
			type: Boolean,
			default: false
		},
		colspan: {
			type: Function,
			default: void 0
		},
		rowActionsLocation: {
			type: String,
			default: "overlay"
		},
		rowDragstart: {
			type: Function,
			default: void 0
		},
		externalRowDragover: {
			type: Function,
			default: void 0
		},
		externalRowDrop: {
			type: Function,
			default: void 0
		}
	},
	emits: [
		"update:groupPanelVisible",
		"rowClick",
		"rowDoubleClick",
		"formatCell",
		"validateCell",
		"positionChanging",
		"addRowAdding",
		"addRowCommitting",
		"toggleGroup",
		"columnsChanged"
	],
	setup(props, { emit, slots }) {
		const { translate } = useGlobalResourceManager();
		const columnsMap = computed(() => new Map(props.columns.map((c) => [c.name, c])));
		const hasColumnHeaderContextMenu = computed(() => props.groupable || props.columnPicker || props.exportable);
		const headerSelectorValue = ref(false);
		const groupLoadPromises = /* @__PURE__ */ new WeakMap();
		const isGroupPanelVisible = useVModel(props, "groupPanelVisible", emit, { passive: true });
		/**
		* Grid.
		*/
		const _grid = shallowRef();
		/**
		* Gets the system column count.
		*/
		const systemColumnCount = computed(() => {
			let count = 0;
			if (rowDragDrop.value) count++;
			if (slots["row-detail"]) count++;
			if (slots["row-indicator"]) count++;
			if (props.selectionColumn) count++;
			return count;
		});
		/**
		* Value indicating whether the row actions are displayed in a column frozen at the right end
		* of the grid, rather than over the hovered row.
		* Wijmo cannot freeze columns on both sides: when data columns are frozen on the left,
		* the row actions fall back to the overlay.
		*/
		const hasRowActionsColumn = computed(() => !!slots["row-actions"] && props.rowActionsLocation === "column" && !props.columns.some((c) => c.frozen));
		/**
		* Value indicating whether the ready state of the grid.
		*/
		const readyState = ref();
		/**
		* Value indicating whether the grid is visible.
		*/
		const isVisible = computed(() => readyState.value === "visible");
		/**
		* Value indicating whether the grid is empty.
		*/
		const isEmpty = ref(false);
		/**
		* Value indicating whether the grid is tall enough to hold the no data slot without
		* crowding out the rows.
		*/
		const hasRoomForNoData = ref(false);
		/**
		* Overlay message
		*/
		const loadingMessage = translate("LoadingData");
		const loadingOverlayMessage = computed(() => props.loading ? loadingMessage : void 0);
		/**
		* Caption of the row actions column, only read by screen readers.
		*/
		const rowActionsCaption = translate("Actions");
		/**
		* Value indicating whether the "stay in edit mode" is active.
		*/
		let stayInEditMode = false;
		/**
		* Last selected row index.
		*/
		let lastSelectedRowIndex = 0;
		/**
		* Row selection changes are applied one after the other, so that each one reads
		* the selection state left by the previous one, even when a selection rule is slow.
		*/
		let pendingRowSelection = Promise.resolve();
		/**
		* Handling of the last mousedown event, including the position and selection changes it triggers.
		*/
		let pendingMousedown = Promise.resolve();
		/**
		* Value indicating whether the columns should be resized on next refresh.
		*/
		let resizeColumnsOnNextRefresh = props.resizeColumnsOnFirstLoad;
		/**
		* Value indicating whether the row details should be expanded on next refresh.
		*/
		let expandRowDetailsOnLoadOnNextRefresh = props.rowDetailExpandedByDefault;
		/**
		* Raw items whose row is redrawn on the next row refresh.
		*/
		const itemsToRefresh = /* @__PURE__ */ new Set();
		/**
		* Dragging column.
		*/
		const draggingColumn = ref();
		/**
		* Context menu instance.
		*/
		const contextMenu = ref();
		/**
		* Display column sort index.
		*/
		const displayColumnSortIndex = ref(false);
		const { validationTooltip, setCellValidationMessage, hideValidationTooltip } = useDatagridValidation(_grid);
		const { buildAddRow, addRowAdding, canCommitAddRow, emitAddRowCommitting, addRowCommitting } = useDatagridAddRow(emit);
		const { rowDetailComponent, getRowDetailColumnIcon, toggleRowDetail, expandRowDetailsOnLoad, expandRowDetailOnAdd } = useDatagridRowDetail(props);
		const { rowDragDrop, handleDragstart, handleDragover, handleDragleave, handleDragend, handleDrop } = useDatagridDragDrop(props, _grid, translate);
		const { rowActionsItem, rowActionsRowIndex, rowActionsElement, rowActionsSelected, isInRowActions, showRowActions, hideRowActionsDisplayedByKeyboard, handleRowActionsFocusout } = useDatagridRowActions(props, _grid);
		useDatagridRowActionsColumn(_grid, hasRowActionsColumn);
		useDatagridFillerColumn(_grid);
		useDatagridMergeManager(props, _grid, systemColumnCount, columnsMap);
		watch(() => props.summaries, () => _grid.value && buildSummaryRow(_grid.value));
		watch(() => props.addRow, () => _grid.value && buildAddRow(_grid.value, props.addRow));
		watch(() => props.rowHeight, () => _grid.value && setRowHeight(_grid.value));
		watch(hasRowActionsColumn, () => _grid.value && setFrozenColumns(_grid.value), { flush: "post" });
		function handleInitialization(grid) {
			_grid.value = grid;
			grid._cvCollectionChanged = handleCollectionChanged;
			grid.columnHeaders.rows.minSize = 40;
			grid.rows.onCollectionChanged = handleRowsCollectionChanged;
			const originalGetDesiredWidth = grid["_getDesiredWidth"];
			grid["_getDesiredWidth"] = function(p, r, c, e) {
				const width = originalGetDesiredWidth.call(this, p, r, c, e);
				e.innerHTML = "";
				return width;
			};
			setRowHeight(grid);
			setFrozenColumns(grid);
			grid._wantsInput = isDropdownActive;
			grid.select(-1, -1);
			buildSummaryRow(grid);
		}
		function setRowHeight(grid) {
			grid.rows.defaultSize = props.rowHeight;
			if (!slots["row-detail"]) {
				grid.rows.minSize = props.rowHeight;
				if (!props.autoRowHeight) grid.rows.maxSize = props.rowHeight;
			}
		}
		function setFrozenColumns(grid) {
			const frozenColumns = props.columns.filter((c) => c.frozen);
			if (frozenColumns.length > 0) grid.frozenColumns = frozenColumns.length + systemColumnCount.value;
			else grid.frozenColumns = 0;
			grid.columns.frozenEnd = hasRowActionsColumn.value ? 1 : 0;
		}
		function resetColumns() {
			if (_grid.value) {
				setFrozenColumns(_grid.value);
				autoSizeGridColumns(_grid.value, columnsMap.value, false);
			}
		}
		function refresh() {
			if (_grid.value) _grid.value.invalidate(false);
		}
		/**
		* Handles the collection changed to update the rows.
		*/
		function handleCollectionChanged(sender, args) {
			switch (args.action) {
				case NotifyCollectionChangedAction$1.Change:
					handleChangeCollectionChanged(this, args);
					break;
				case NotifyCollectionChangedAction$1.Add: {
					resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
					const newRow = new Row(args.item);
					this.rows.insert(args.index, newRow);
					expandRowDetailOnAdd(newRow);
					break;
				}
				case NotifyCollectionChangedAction$1.Remove: {
					resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
					const index = this.rows.findIndex((r) => r.dataItem === args.item);
					if (index !== -1) this.rows.removeAt(index);
					break;
				}
				default:
					resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
					expandRowDetailsOnLoadOnNextRefresh ||= props.rowDetailExpandedByDefault;
					this._bindGrid(false);
			}
		}
		function handleSuggestionChange(grid, args, column) {
			if (!args.isSuggestionChange) return false;
			const rowIndex = findItemRowIndex(grid, args.item);
			const colIndex = column.index;
			if (grid.currentEditingCell?.col === column && grid.currentEditingCell.row === grid.rows[rowIndex]) return true;
			if (stayInEditMode && isEditingCell(grid, rowIndex, colIndex)) return true;
			if (rowIndex !== -1 && colIndex >= 0) grid.refreshRange(new CellRange(rowIndex, colIndex, rowIndex, colIndex));
			return true;
		}
		function handleChangeCollectionChanged(grid, args) {
			if (props.selectionBinding && args.col === props.selectionBinding) {
				refreshItemRow(grid, args.item);
				return;
			}
			const column = grid.columns.find((c) => c.name === args.col);
			if (!column?.isVisible) return;
			resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
			if (handleSuggestionChange(grid, args, column)) return;
			if (grid.currentEditingCell) {
				if (grid.currentEditingCell.col === column && isSameItem(grid.currentEditingCell.row.dataItem, args.item)) {
					grid.currentEditingCell.value = args.value;
					return;
				}
				grid.stayInEditModeWhileInvalidating = true;
				grid.invalidate(false);
				return;
			}
			if (props.resizeColumnsOnRefresh || grid.collectionView.groups?.length) grid.invalidate(false);
			else refreshItemRow(grid, args.item);
		}
		/**
		* Redraws the rendered cells of the row bound to an item. Unlike an invalidate, it neither
		* redraws the other rows nor recomputes the layout. Like an invalidate, it is deferred: a
		* lookup sets its display value right after its value, without a change on a visible column.
		*/
		function refreshItemRow(grid, item) {
			if (itemsToRefresh.size === 0) setTimeout(() => refreshItemRows(grid));
			itemsToRefresh.add(toRaw(item));
		}
		function refreshItemRows(grid) {
			if (_grid.value === grid) for (const item of itemsToRefresh) {
				const rowIndex = findItemRowIndex(grid, item);
				if (rowIndex !== -1) grid.refreshRange(new CellRange(rowIndex, 0, rowIndex, grid.columns.length - 1));
			}
			itemsToRefresh.clear();
		}
		/**
		* Gets the index of the row bound to an item. The index of the item in the collection is not
		* the row index as soon as group rows are displayed.
		*/
		function findItemRowIndex(grid, item) {
			return grid.rows.findIndex((r) => isSameItem(r.dataItem, item));
		}
		/**
		* Tells whether two items are the same. A collection change gives the raw item while the row
		* may be bound to its reactive proxy.
		*/
		function isSameItem(item, otherItem) {
			return toRaw(item) === toRaw(otherItem);
		}
		function handleLoadedRows(grid) {
			if (!_grid.value) handleInitialization(grid);
			if (grid.collectionView) {
				restoreColumnsAggregate(grid, columnsMap.value);
				restoreGroupRowsState(grid);
			}
		}
		/**
		* Handles the refreshing event.
		*/
		function handleRefreshing(grid) {
			if (!readyState.value && grid.hostElement.clientHeight > 0) {
				let deferVisible = false;
				isGroupPanelVisible.value ??= grid.collectionView.groupDescriptions.length > 0;
				hasRoomForNoData.value = grid.hostElement.clientHeight >= 380;
				autoSizeGridColumns(grid, columnsMap.value, true);
				deferVisible ||= autoSizeGridRows(grid, props.autoRowHeight);
				hideGroupingColumns(grid);
				buildAddRow(grid, props.addRow);
				readyState.value = deferVisible ? "initialized" : "visible";
			} else if (readyState.value === "initialized") readyState.value = "visible";
			else if (resizeColumnsOnNextRefresh && grid.rows.some((r) => !isSystemRow(r))) {
				autoSizeGridColumns(grid, columnsMap.value, false);
				resizeColumnsOnNextRefresh = false;
			}
			loadRowsIfInfiniteScrollingAndNoScroll(grid);
			displayColumnSortIndex.value = grid.collectionView.sortDescriptions.length > 1;
		}
		/**
		* Handles the refreshed event.
		*/
		function handleRefreshed(grid) {
			if (isVisible.value && grid.collectionView instanceof DatagridCollectionView) {
				if (grid.collectionView.lastAddedItem) {
					if (grid.collectionView.lastAddedItem !== grid.collectionView.currentAddItem) selectLastAddedItem(grid, grid.collectionView.lastAddedItem);
					grid.collectionView.lastAddedItem = void 0;
				} else if (grid.collectionView.currentItem) selectCurrentItem(grid);
			}
		}
		/**
		* Selects the first editable cell of the row of the last added item.
		*/
		function selectLastAddedItem(grid, lastAddedItem) {
			const colIndex = getFirstEditableColIndex(grid, lastAddedItem);
			selectCell(grid, grid.rows.findIndex((r) => r.dataItem === lastAddedItem), colIndex);
		}
		/**
		* Selects the current item.
		*/
		function selectCurrentItem(grid) {
			let currentRowIndex = grid.selection.row;
			const currentRow = grid.rows[currentRowIndex];
			if (isDetailRow(currentRow)) currentRowIndex--;
			const rowIndex = grid.rows.findIndex((r) => r.dataItem === grid.collectionView.currentItem);
			if (rowIndex !== currentRowIndex) grid.select(rowIndex, grid.selection.col);
			if (expandRowDetailsOnLoadOnNextRefresh) {
				expandRowDetailsOnLoadOnNextRefresh = false;
				expandRowDetailsOnLoad(grid.rows, rowIndex);
			}
		}
		/**
		* Handles the rows collection changed event to refresh the grid.
		*/
		function handleRowsCollectionChanged() {
			this._dirty = true;
			isEmpty.value = this.length === 0;
			if (isVisible.value && !buildAddRow(this.grid, props.addRow)) this.grid.invalidate(true);
		}
		function handleItemsSourceChanged(grid) {
			if (grid.itemsSource) {
				grid.collectionView.collectionChanged.addHandler(handleHeaderSelectorCollectionChanged);
				updateHeaderSelectorValue();
			}
		}
		/**
		* Updates the header selector unless only another property of an item changed.
		*/
		function handleHeaderSelectorCollectionChanged(sender, args) {
			if (!(args.action === NotifyCollectionChangedAction$1.Change && args.col !== void 0 && args.col !== props.selectionBinding)) updateHeaderSelectorValue();
		}
		/**
		* Updates the value of the header selector.
		*/
		function updateHeaderSelectorValue() {
			if (_grid.value && props.selectionBinding && _grid.value.collectionView && _grid.value.collectionView.items.length > 0) {
				let headerSelectorValueChecked = true;
				for (const item of _grid.value.collectionView.items) if (!item[props.selectionBinding]) {
					headerSelectorValueChecked = false;
					break;
				}
				headerSelectorValue.value = headerSelectorValueChecked;
			}
		}
		/**
		* Handles the mousedown event.
		*/
		function handleMousedown(event) {
			contextMenu.value?.cancel();
			pendingMousedown = processMousedown(event);
			return pendingMousedown;
		}
		async function processMousedown(event) {
			if (!_grid.value) return;
			if (event.target instanceof HTMLElement && event.target.getAttribute("wj-part") === "root") {
				event.preventDefault();
				return;
			}
			if (isInRowActionsColumn(event.target)) {
				event.stopImmediatePropagation();
				return;
			}
			stayInEditMode = false;
			const hit = _grid.value.hitTest(event);
			if (event.button === 0 && props.selectionColumn && props.selectionBinding !== void 0 && hit.col === systemColumnCount.value - 1) await handleMousedownOnSelectionCell(event, hit, props.selectionBinding);
			else if (hit.cellType === CellType.Cell) await handleMousedownOnCell(_grid.value, event, hit);
		}
		function isInRowActionsColumn(target) {
			return target instanceof Element && !!target.closest(".row-actions");
		}
		async function handleMousedownOnSelectionCell(event, hit, selectionBinding) {
			if (props.selectionColumnHeader && props.onSelectionColumnHeaderCheck && hit.cellType === CellType.ColumnHeader) {
				event.preventDefault();
				const newValue = !headerSelectorValue.value;
				if (await props.onSelectionColumnHeaderCheck(newValue)) headerSelectorValue.value = newValue;
				return;
			}
			const row = hit.getRow();
			if (hit.cellType === CellType.Cell && row.dataItem) {
				event.preventDefault();
				const item = row.dataItem;
				await queueRowSelection(() => requestRowSelect(item, !item[selectionBinding]));
			}
		}
		async function handleMousedownOnCell(grid, event, hit) {
			const row = hit.getRow();
			if (isGroupRow(row)) {
				event.stopImmediatePropagation();
				handleMousedownOnGroupRowCell(grid, event, hit, row);
				return;
			}
			if (props.rowDraggable && hit.getColumn().name === "$$row-drag") return;
			let rowSelection;
			if (row.dataItem !== grid.collectionView.currentItem) {
				event.stopImmediatePropagation();
				document.activeElement.blur();
				if (!await positionChanging(grid, hit.row)) return;
				rowSelection = selectCellAndRow();
			} else if (!hitTestContainsColumn(hit, grid.selection.col)) {
				event.stopImmediatePropagation();
				rowSelection = selectCellAndRow();
			} else rowSelection = selectRow(grid, hit.row, getSelectionModeByMouseEvent(event, props.rowClickSelectionMode));
			if (event.target instanceof HTMLElement && event.target.classList.contains("checkbox-cell")) changeCheckboxCellValue(columnsMap.value, hit, (col, item) => isReadOnlyColumn(col, item, true));
			if (hit.getColumn().name == "$$row-detail") toggleRowDetail(row);
			else emit("rowClick", row.dataItem);
			await rowSelection;
			function selectCellAndRow() {
				grid._mouseHdl._selDown = grid.selection;
				selectCell(grid, hit.row, hit.col, event.button === 0);
				return selectRow(grid, hit.row, getSelectionModeByMouseEvent(event, props.rowClickSelectionMode));
			}
		}
		function handleMousedownOnGroupRowCell(grid, event, hit, row) {
			grid._mouseHdl._selDown = grid.selection;
			if (event.target instanceof HTMLElement && event.target.closest(".wj-elem-collapse")) row.isCollapsed = !row.isCollapsed;
			grid.select(hit.row, hit.col);
		}
		/**
		* Gets a value indicating whether the hit is on the row indicator column header.
		*/
		function isRowIndicatorColumnHeader(hit) {
			return hit.col === 0 && (rowDragDrop.value || slots["row-detail"] || slots["row-indicator"]);
		}
		/**
		* Changes the position.
		*/
		function positionChanging(grid, rowIndex) {
			let row = grid.rows[rowIndex];
			if (isDetailRow(row)) {
				if (rowIndex === grid.selection.row + 1) return Promise.resolve(true);
				row = grid.rows[rowIndex - 1];
			} else if (rowIndex === grid.selection.row - 1 && isDetailRow(grid.rows[grid.selection.row])) return Promise.resolve(true);
			if (isAddRow(row)) {
				if (!props.addRow) return new Promise((resolve) => {
					emit("positionChanging", -1, (canceled) => {
						resolve(!canceled);
					});
				});
				return addRowAdding(grid);
			}
			return new Promise((resolve) => {
				const index = grid.collectionView.sourceCollection.indexOf(row.dataItem);
				emit("positionChanging", index, (canceled) => {
					if (!_grid.value) {
						resolve(false);
						return;
					}
					grid.focus();
					if (!canceled || index === -1) resolve(true);
					else resolve(false);
				});
			});
		}
		/**
		* Handles the click event.
		*/
		function handleClick(event) {
			if (!_grid.value) return;
			const hit = _grid.value.hitTest(event);
			if (hit.cellType === CellType.ColumnHeader) handleClickOnColumnHeader(event, hit);
		}
		function handleClickOnColumnHeader(event, hit) {
			if (event.button !== 0) return;
			if (isRowIndicatorColumnHeader(hit)) {
				if (hasColumnHeaderContextMenu.value) toggleContextMenu(event);
			} else if (event.target instanceof HTMLElement && event.target.closest("[data-column]")) sortColumn(event, hit.getColumn());
		}
		function sortColumn(event, column) {
			if (!_grid.value || !column.name || !column.allowSorting) return;
			const currentSort = _grid.value.collectionView.sortDescriptions.find((s) => s.property === column.name);
			const sorts = event.ctrlKey ? _grid.value.collectionView.sortDescriptions.filter((s) => s.property !== column.name) : [];
			if (currentSort) {
				if (currentSort.ascending) sorts.push(new SortDescription$1(column.name, false));
			} else if (sorts.length >= MAX_SORT_DESCRIPTIONS) return;
			else sorts.push(new SortDescription$1(column.name, true));
			_grid.value.collectionView.sortDescriptions.splice(0, _grid.value.collectionView.sortDescriptions.length, ...sorts);
		}
		function isSystemColumn(column) {
			return column.name?.startsWith("$$") || column.name === props.selectionBinding;
		}
		/**
		* Handles the double click event.
		*/
		function handleDoubleClick(event) {
			if (!_grid.value || isInRowActions(event.target)) return;
			const hit = _grid.value.hitTest(event);
			if (hit.cellType !== CellType.Cell) return;
			const col = hit.getColumn();
			const row = hit.getRow();
			if (!isSystemColumn(col) && !isSystemRow(row) && !isEditableCell(col, row.dataItem)) emit("rowDoubleClick", event, row.dataItem);
		}
		/**
		* A boolean cell is edited by a click on its checkbox, without any edit slot.
		*/
		function isEditableCell(col, item) {
			return !isReadOnlyColumn(col, item, getDatagridColumn(col)?.dataType === DataType$1.Boolean);
		}
		/**
		* Handles the keydown event.
		*/
		function handleKeydown(event) {
			if (!_grid.value || _grid.value.rows.length === 0) return;
			if (event.defaultPrevented) return;
			const rowActions = getRowActionsElement(event.target);
			if (rowActions) {
				if (rowActions.closest(".wj-flexgrid") === _grid.value.hostElement) handleRowActionsTab(_grid.value, event);
				return;
			}
			const hit = _grid.value.hitTest(event.target);
			if (hit.cellType === CellType.Cell) {
				if (_grid.value.selection.row < 0 && hit.row > 0) _grid.value.select(hit.row, hit.col);
				handleKeydownCellShortcuts(event, hit);
			}
			handleKeyboardNavigation(_grid.value, event);
		}
		function handleKeydownCellShortcuts(event, hit) {
			if (event.ctrlKey && event.key === "s") _grid.value?.finishEditing(false);
			const target = event.target;
			if (target instanceof HTMLElement && target.querySelector(".checkbox-cell") && event.key === " ") changeCheckboxCellValue(columnsMap.value, hit, (col, item) => isReadOnlyColumn(col, item, true));
		}
		/**
		* Handles the navigation by keyboard.
		* Each handler decides synchronously whether the grid handles the key and, if so, prevents
		* the default behavior before any asynchronous call: once an await has been reached,
		* the browser has already applied the default behavior (e.g. moving the focus out on Tab).
		*/
		async function handleKeyboardNavigation(grid, event) {
			switch (event.key) {
				case "ArrowUp":
					await handleArrowUp(grid, event);
					break;
				case "ArrowDown":
					await handleArrowDown(grid, event);
					break;
				case "Enter":
					if (props.enterKeyActsAsTab) await handleTabKeyNavigation(grid, event);
					else await handleEnterNavigation(grid, event);
					break;
				case "Tab": await handleTabKeyNavigation(grid, event);
			}
		}
		async function handleTabKeyNavigation(grid, event) {
			const currentEditDelegatesToComponent = grid.currentEditDelegatesToComponent;
			grid.finishEditing();
			if (currentEditDelegatesToComponent) {
				preventKeyDefaultBehavior(event);
				await new Promise((resolve) => {
					setTimeout(resolve);
				});
			}
			const target = findTabTarget(grid, event.shiftKey, grid.selection.row, grid.selection.col);
			if (isRowEndReachedWithRowActions(grid, event, target) && await focusRowActionsOnTab(grid, event, target)) return;
			if (!target) return;
			if (!currentEditDelegatesToComponent) preventKeyDefaultBehavior(event);
			await navigateToTabTarget(grid, event.shiftKey, grid.selection.row, target);
		}
		/**
		* Handles the arrow up navigation.
		*/
		async function handleArrowUp(grid, event) {
			if (canNavigateWithArrowKey(event)) await navigateToRow(grid, event, findPreviousRowTarget(grid, grid.selection.row), () => grid.selection.col, event.shiftKey ? "range" : "single");
		}
		/**
		* Handles the arrow down navigation.
		*/
		async function handleArrowDown(grid, event) {
			if (canNavigateWithArrowKey(event)) await navigateToRow(grid, event, findNextRowTarget(grid, grid.selection.row), () => grid.selection.col, event.shiftKey ? "range" : "single");
		}
		/**
		* Handles the enter navigation.
		*/
		async function handleEnterNavigation(grid, event) {
			if (isDropdownActive()) return;
			if (event.shiftKey) await navigateToRow(grid, event, findPreviousRowTarget(grid, grid.selection.row), () => grid.selection.col, "single");
			else await navigateToRow(grid, event, findNextRowTarget(grid, grid.selection.row), () => getNextColumnIndexOnEnterNavigation(grid), "single");
		}
		/**
		* Moves the selection to the row of the given target, found from the current row.
		* The default behavior of the key is prevented before any asynchronous call,
		* and only when there is a target: otherwise the browser applies it.
		* The column is only computed once the position has changed.
		*/
		async function navigateToRow(grid, event, target, getColIndex, selectionMode) {
			if (!target) return;
			preventKeyDefaultBehavior(event);
			const rowIndex = target.kind === "row" ? target.rowIndex : await resolveRowIndex(grid, grid.selection.row, target);
			if (rowIndex === void 0) return;
			if (await positionChanging(grid, rowIndex)) {
				selectCell(grid, rowIndex, getColIndex());
				selectRow(grid, rowIndex, selectionMode);
			}
		}
		/**
		* Gets a value indicating whether the tab navigation reaches the end of a row that displays
		* row actions, which come after its last cell.
		*/
		function isRowEndReachedWithRowActions(grid, event, target) {
			return !event.shiftKey && (!target || target.kind === "row") && canFocusRowActions(grid, grid.selection.row);
		}
		/**
		* Moves the focus to the first row action of the current row.
		* Returns true when the key is handled. The default behavior is prevented before any
		* asynchronous call, so a row that finally has no action to focus must go on by itself.
		*/
		async function focusRowActionsOnTab(grid, event, target) {
			preventKeyDefaultBehavior(event);
			if (await focusRowActions(grid, grid.selection.row, "first")) return true;
			if (!target) {
				focusOutsideGrid(grid);
				return true;
			}
			return false;
		}
		let stopWatchingFocusLoss;
		/**
		* Handles the keydown event of the element holding the row actions, before the grid does:
		* the grid would treat the keys of an action as those of the selected cell (e.g. Enter moves
		* the selection and Space starts editing) and cancel their default behavior, which runs the
		* action. Tab and Escape are left to the grid, and so are the shortcuts with a modifier key.
		*/
		function handleRowActionKeydown(event) {
			if (isRowActionKeyLeftToGrid(event)) return;
			event.stopPropagation();
			if (event.key === " " && event.target instanceof HTMLAnchorElement) {
				event.preventDefault();
				event.target.click();
			}
			if ((event.key === "Enter" || event.key === " ") && _grid.value) restoreFocusWhenLost(_grid.value);
		}
		/**
		* Handles the Tab key on a row action: it moves between the actions of the row by default,
		* and goes back to the cells (Shift+Tab from the first action) or to the next row (Tab from
		* the last action) once it reaches their edge.
		*/
		function handleRowActionsTab(grid, event) {
			if (event.key !== "Tab") return;
			const action = event.target;
			const actions = getFocusableElements(getRowActionsElement(action));
			const edgeIndex = event.shiftKey ? 0 : actions.length - 1;
			if (actions.indexOf(action) !== edgeIndex) return;
			const rowIndex = getRowActionsRowIndex(grid, action);
			const lastColumnIndex = getLastDataColumnIndex(grid.columns);
			const target = findTabTarget(grid, event.shiftKey, rowIndex, event.shiftKey ? lastColumnIndex + 1 : lastColumnIndex);
			if (!target) return;
			preventKeyDefaultBehavior(event);
			action.blur();
			grid.focus();
			navigateToTabTarget(grid, event.shiftKey, rowIndex, target);
		}
		/**
		* An action may remove its own button (e.g. deleting the row), possibly long after it was
		* run (a server call): the focus would then drop on the page. The grid is watched until it
		* does, and gets the focus back, on the current cell. The watch stops as soon as the focus
		* goes elsewhere (e.g. a dialog opened by the action), and with the grid.
		*/
		function restoreFocusWhenLost(grid) {
			stopWatchingFocusLoss?.();
			const observer = new MutationObserver(() => {
				if (document.activeElement === document.body) {
					stopWatching();
					if (grid.hostElement?.isConnected) grid.focus();
				}
			});
			const stopWatching = () => {
				observer.disconnect();
				document.removeEventListener("focusin", stopWatching);
				stopWatchingFocusLoss = void 0;
			};
			observer.observe(grid.hostElement, {
				childList: true,
				subtree: true
			});
			document.addEventListener("focusin", stopWatching);
			stopWatchingFocusLoss = stopWatching;
		}
		/**
		* Gets the row of a row action. It is not always the selected row: pressing an action with
		* the mouse does not select its row. The overlay is only displayed on a row, and hidden
		* once it is reset, so that its row is known whenever the focus is in it.
		*/
		function getRowActionsRowIndex(grid, action) {
			return hasRowActionsColumn.value ? grid.hitTest(action).row : rowActionsRowIndex.value;
		}
		/**
		* Gets a value indicating whether the row displays row actions, which may all be hidden
		* for its item: only the elements rendered tell.
		*/
		function canFocusRowActions(grid, rowIndex) {
			const row = grid.rows[rowIndex];
			return !!row && isRowActionsRow(row) && (hasRowActionsColumn.value || !!rowActionsElement.value);
		}
		/**
		* Gets the element holding the row actions of the given row: the content of its cell
		* of the row actions column, or the overlay moved over the row.
		*/
		async function getRowActionsContainer(grid, rowIndex) {
			if (!hasRowActionsColumn.value) return showRowActions(rowIndex, grid.selection.col);
			const column = grid.columns.getColumn(ROW_ACTIONS_COLUMN_NAME);
			if (!column) return;
			grid.scrollIntoView(rowIndex, column.index);
			return grid.cells.getCellElement(rowIndex, column.index)?.querySelector(".row-actions");
		}
		/**
		* Moves the focus to the first or last row action of the given row.
		* Returns false when the row has no action that takes the focus, and its row actions
		* displayed by the keyboard are then hidden.
		*/
		async function focusRowActions(grid, rowIndex, position) {
			const container = await getRowActionsContainer(grid, rowIndex);
			const actions = getFocusableElements(container);
			const action = position === "first" ? actions[0] : actions.at(-1);
			let focused = false;
			if (container && action) {
				container.style.visibility = "visible";
				action.focus();
				container.style.removeProperty("visibility");
				focused = document.activeElement === action;
			}
			if (!focused) hideRowActionsDisplayedByKeyboard();
			return focused;
		}
		/**
		* Moves the focus to the first element that follows the grid in the page and takes it, as
		* the browser would have done by default (a hidden element does not), or releases it when
		* there is none.
		*/
		function focusOutsideGrid(grid) {
			if (!getFocusableElements(document.body).filter((element) => !grid.hostElement.contains(element) && !!(grid.hostElement.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING)).some((element) => {
				element.focus();
				return document.activeElement === element;
			})) document.activeElement.blur();
		}
		/**
		* Finds the target of a tab navigation from the given cell, without any asynchronous call.
		* Hidden or non-tabbable cells of the current row are skipped. Once the edge of the row is reached,
		* the target is the previous or next row, whose cells are only checked by
		* navigateToTabTarget after the position has changed.
		* Returns undefined when the navigation leaves the grid.
		*/
		function findTabTarget(grid, shiftKey, rowIndex, colIndex) {
			const nextTabColIndex = getNextTabColIndex(grid, shiftKey, rowIndex, colIndex);
			if (nextTabColIndex === "rowEdge") {
				const rowTarget = shiftKey ? findPreviousRowTarget(grid, rowIndex) : findNextRowTarget(grid, rowIndex);
				return rowTarget ? {
					kind: "row",
					row: rowTarget
				} : void 0;
			}
			const tabStop = isTabStopCell(grid, rowIndex, nextTabColIndex);
			if (tabStop === void 0) return;
			return tabStop ? {
				kind: "cell",
				colIndex: nextTabColIndex
			} : findTabTarget(grid, shiftKey, rowIndex, nextTabColIndex);
		}
		/**
		* Gets a value indicating whether the tab navigation can stop on the given cell:
		* its column must be visible (read at that moment, since a delegated edit or a position
		* changing rule may have changed it) and the cell tabbable.
		* Returns undefined when the cell does not exist: no data column (the filler and row actions
		* columns at the end of the grid are not data columns), or a row removed while a position
		* change was processed (e.g. by a rule reloading the source).
		*/
		function isTabStopCell(grid, rowIndex, colIndex) {
			const column = grid.columns[colIndex];
			const row = grid.rows[rowIndex];
			if (!column || !row || colIndex > getLastDataColumnIndex(grid.columns)) return;
			return column.isVisible && isCellTabbable(column, row.dataItem);
		}
		/**
		* Gets the index of the column reached by the tab navigation in the given row,
		* or 'rowEdge' when the edge of the row is reached (the previous row is then reached
		* backward, the next one forward).
		*/
		function getNextTabColIndex(grid, shiftKey, rowIndex, colIndex) {
			const lastColumnIndex = getLastDataColumnIndex(grid.columns);
			colIndex = adjustColumnIndexForMergedRange(grid.cells, rowIndex, colIndex, shiftKey);
			if (isSingleColumnRow(grid.rows[rowIndex])) return "rowEdge";
			if (shiftKey) return colIndex > systemColumnCount.value ? colIndex - 1 : "rowEdge";
			if (colIndex < systemColumnCount.value) return systemColumnCount.value;
			return colIndex < lastColumnIndex ? colIndex + 1 : "rowEdge";
		}
		/**
		* Moves the selection to the target found by findTabTarget from the given row.
		* When the target is another row, its first (or last, backward) cell is selected
		* if it is tabbable, otherwise the tab navigation goes on from that cell.
		*/
		async function navigateToTabTarget(grid, shiftKey, rowIndex, target) {
			if (target.kind === "cell") {
				selectCell(grid, rowIndex, target.colIndex);
				return;
			}
			const targetRowIndex = target.row.kind === "row" ? target.row.rowIndex : await resolveRowIndex(grid, rowIndex, target.row);
			if (targetRowIndex === void 0) return;
			if (!await positionChanging(grid, targetRowIndex)) return;
			const colIndex = shiftKey ? getLastDataColumnIndex(grid.columns) : systemColumnCount.value;
			if (shiftKey && await selectLastRowAction(grid, targetRowIndex, colIndex)) {
				selectRow(grid, targetRowIndex);
				return;
			}
			selectTabbableCell(grid, shiftKey, targetRowIndex, colIndex);
			selectRow(grid, targetRowIndex);
		}
		/**
		* Enters the given row backward by its last row action, which comes after its last cell.
		* Returns false when the row has no action to focus.
		*/
		async function selectLastRowAction(grid, rowIndex, colIndex) {
			if (!canFocusRowActions(grid, rowIndex)) return false;
			grid.select(rowIndex, colIndex);
			return focusRowActions(grid, rowIndex, "last");
		}
		/**
		* Selects the given cell of a row reached by the tab navigation when it is a tab stop,
		* otherwise goes on with the tab navigation from that cell.
		*/
		function selectTabbableCell(grid, shiftKey, rowIndex, colIndex) {
			const tabStop = isTabStopCell(grid, rowIndex, colIndex);
			if (tabStop === void 0) return;
			if (tabStop) {
				selectCell(grid, rowIndex, colIndex);
				return;
			}
			const nextTarget = findTabTarget(grid, shiftKey, rowIndex, colIndex);
			if (!shiftKey && (!nextTarget || nextTarget.kind === "row") && canFocusRowActions(grid, rowIndex)) enterRowActions(grid, rowIndex, colIndex, nextTarget);
			else if (nextTarget) navigateToTabTarget(grid, shiftKey, rowIndex, nextTarget);
		}
		/**
		* Enters a row reached forward by its first row action, when none of its cells is a tab stop.
		* The tab navigation goes on from the row when it has no action that takes the focus.
		*/
		async function enterRowActions(grid, rowIndex, colIndex, nextTarget) {
			grid.select(rowIndex, colIndex);
			if (await focusRowActions(grid, rowIndex, "first")) return;
			if (nextTarget) navigateToTabTarget(grid, false, rowIndex, nextTarget);
			else focusOutsideGrid(grid);
		}
		function findPreviousRowTarget(grid, index) {
			const rowIndex = findPreviousVisibleRowIndex(grid, index);
			return rowIndex === void 0 ? void 0 : {
				kind: "row",
				rowIndex
			};
		}
		/**
		* Finds the target of a navigation to the row following the given one,
		* without any asynchronous call.
		*/
		function findNextRowTarget(grid, index) {
			const partiallyLoadedGroup = findPartiallyLoadedGroup(grid, index);
			if (partiallyLoadedGroup) return {
				kind: "partialGroup",
				group: partiallyLoadedGroup
			};
			for (let i = index + 1; i < grid.rows.length; i++) if (grid.rows[i].isVisible) return {
				kind: "row",
				rowIndex: i
			};
			if (props.addRow && canCommitAddRow(grid)) return { kind: "addRow" };
		}
		/**
		* Gets the index of the row reached by the given target, found from the given row,
		* once its asynchronous processing is done, or undefined when that processing
		* does not provide any row.
		*/
		async function resolveRowIndex(grid, index, target) {
			switch (target.kind) {
				case "partialGroup":
					if (!await loadMoreRowsOnPartialServerGroup(grid, target.group)) return;
					await waitForLoadedRowsMaterialization(grid);
					return findFirstDataRowIndexAfterLoad(grid, index);
				case "addRow": return await emitAddRowCommitting(grid) ? index + 1 : void 0;
			}
		}
		async function findFirstDataRowIndexAfterLoad(grid, index) {
			for (let i = index + 1; i < grid.rows.length; i++) {
				const row = grid.rows[i];
				if (!row.isVisible) continue;
				if (isGroupRow(row)) {
					if (!row.isCollapsed) continue;
					const group = row.dataItem;
					if (typeof group.toggle !== "function") return;
					await group.toggle(true, getPageRowsCount(grid));
					await waitForLoadedRowsMaterialization(grid);
					return findFirstDataRowIndexAfterLoad(grid, i - 1);
				}
				if (isSystemRow(row)) continue;
				return i;
			}
		}
		async function loadMoreRowsOnPartialServerGroup(grid, group) {
			const existingLoad = groupLoadPromises.get(group);
			if (existingLoad !== void 0) return existingLoad;
			const serverGroup = group.group;
			const previousCount = getServerGroupLoadedCount(grid, group, serverGroup);
			const load = async () => {
				const top = getPageRowsCount(grid);
				if (typeof group.loadData === "function") {
					if (await group.loadData(top) === false) return false;
				} else if (props.loadRows) await props.loadRows(top, group);
				else return false;
				return getServerGroupLoadedCount(grid, group, serverGroup) > previousCount;
			};
			const loadPromise = load().finally(() => {
				groupLoadPromises.delete(group);
			});
			groupLoadPromises.set(group, loadPromise);
			return loadPromise;
		}
		async function waitForLoadedRowsMaterialization(grid) {
			grid.refresh();
			await nextTick();
		}
		function findPartiallyLoadedGroup(grid, index) {
			const group = findLastPartiallyLoadedGroupBeforeRow(grid, index);
			const currentRow = grid.rows[index];
			if (!group || !currentRow || isGroupRow(currentRow) || isSystemRow(currentRow)) return;
			if (!group.group) return;
			return isLastVisibleRowBeforeNextGroup(grid, index, group.level) ? group : void 0;
		}
		function findLastPartiallyLoadedGroupBeforeRow(grid, index) {
			const ancestors = [];
			for (let i = 0; i <= index; i++) {
				const row = grid.rows[i];
				if (!isGroupRow(row)) continue;
				const currentGroup = row.dataItem;
				while (ancestors.length > 0 && ancestors[ancestors.length - 1].group.level >= currentGroup.level) ancestors.pop();
				ancestors.push({
					group: currentGroup,
					isPartial: isPartiallyLoadedGroupRow(grid, row, currentGroup)
				});
			}
			for (let i = ancestors.length - 1; i >= 0; i--) if (ancestors[i].isPartial) return ancestors[i].group;
		}
		function isPartiallyLoadedGroupRow(grid, row, group) {
			const serverGroup = group.group;
			const loadedCount = serverGroup ? getServerGroupLoadedCount(grid, group, serverGroup) : 0;
			return !row.isCollapsed && serverGroup?.totalRecordCount !== void 0 && loadedCount < serverGroup.totalRecordCount;
		}
		function getServerGroupLoadedCount(grid, group, serverGroup) {
			return (() => {
				if (serverGroup.groupDescription?.isLastLevel !== void 0) return serverGroup.groupDescription.isLastLevel;
				if (serverGroup.level !== void 0 && grid.collectionView.groupDescriptions.length > 0) return serverGroup.level === grid.collectionView.groupDescriptions.length - 1;
				return true;
			})() ? serverGroup.items.length : serverGroup.groups?.length ?? 0;
		}
		function isLastVisibleRowBeforeNextGroup(grid, index, groupLevel) {
			for (let i = index + 1; i < grid.rows.length; i++) {
				const nextRow = grid.rows[i];
				if (isGroupRow(nextRow)) return nextRow.dataItem.level <= groupLevel;
				if (!nextRow.isVisible) continue;
				if (isSystemRow(nextRow)) continue;
				return false;
			}
			return true;
		}
		function findPreviousVisibleRowIndex(grid, index) {
			for (let i = index - 1; i > -1; i--) if (grid.rows[i].isVisible) return i;
		}
		/**
		* Gets the index of the next column on enter navigation.
		* If the grid is editable, has the add row and the current row is the last row,
		* The next column will the first editable column of the next row. If there is no editable column, it will be the first column.
		* Otherwise, it the current column.
		*/
		function getNextColumnIndexOnEnterNavigation(grid) {
			if (props.editable && props.addRow && grid.selection.row === grid.rows.length - 2) {
				const item = grid.rows[grid.selection.row + 1].dataItem;
				return getFirstEditableColIndex(grid, item);
			}
			return grid.selection.col;
		}
		function getFirstEditableColIndex(grid, item) {
			const lastColumnIndex = getLastDataColumnIndex(grid.columns);
			for (let index = systemColumnCount.value; index <= lastColumnIndex; index++) {
				const column = grid.columns[index];
				if (column.isVisible && !isReadOnlyColumn(column, item, true)) return index;
			}
			return systemColumnCount.value;
		}
		/**
		* Gets a value indicating whether the cell can be focused using the Tab key.
		*/
		function isCellTabbable(col, item) {
			const column = getDatagridColumn(col);
			if (props.editable && column.readOnly?.(item)) return false;
			return !column.tabStop || column.tabStop(item);
		}
		async function selectCell(grid, rowIndex, colIndex, quickEditing = true) {
			grid.stayInEditModeWhileInvalidating = false;
			grid.select(rowIndex, colIndex);
			startEditing(grid, rowIndex, colIndex, quickEditing);
		}
		async function startEditing(grid, rowIndex, colIndex, quickEditing = true) {
			if (props.addRow) await addRowCommitting(grid);
			if (quickEditing) {
				const row = grid.rows[rowIndex];
				const col = grid.columns[colIndex];
				if (row && !isReadOnlyColumn(col, row.dataItem, false)) setTimeout(() => grid.startEditing(false), 50);
			}
		}
		function selectRow(grid, rowIndex, mode = "single") {
			const selectionBinding = props.selectionBinding;
			if (!selectionBinding) return Promise.resolve();
			const normalizedMode = getNormalizedRowSelectionMode(mode);
			const selectedItem = getSelectableRow(grid, rowIndex).dataItem;
			const rangeItems = normalizedMode === "range" ? getRangeItems(grid, lastSelectedRowIndex, rowIndex) : [];
			const otherItems = normalizedMode === "single" || normalizedMode === "single-select-only" ? getOtherRowItems(grid, selectedItem) : [];
			lastSelectedRowIndex = rowIndex;
			return queueRowSelection(async () => {
				const selected = !selectedItem[selectionBinding];
				const effectiveMode = normalizedMode === "single-select-only" && selected ? "single" : normalizedMode;
				const changes = rangeItems.map((item) => requestRowSelect(item, selected));
				changes.push(requestRowSelect(selectedItem, selected || effectiveMode !== "multi"));
				if (effectiveMode === "single") changes.push(...otherItems.map((item) => requestRowSelect(item, false)));
				await waitForAll(changes);
			});
		}
		/**
		* Unlike Promise.all, waits for every change to be done before reporting the first failure,
		* so that the next selection change does not start while some are still running.
		*/
		async function waitForAll(changes) {
			const failure = (await Promise.allSettled(changes)).find((result) => result.status === "rejected");
			if (failure) throw failure.reason;
		}
		/**
		* Runs the given selection change once the previous ones are done,
		* unless the grid has been unmounted in the meantime.
		*/
		function queueRowSelection(change) {
			const result = pendingRowSelection.then(() => _grid.value ? change() : void 0).then(() => void 0);
			pendingRowSelection = result.catch(() => void 0);
			return result;
		}
		/**
		* Without the selection column, only one row can be selected: every mode is forced to single,
		* which also forces the toggle row click selection mode back to replace.
		*/
		function getNormalizedRowSelectionMode(mode) {
			if (!props.selectionColumn && mode !== "single") return "single";
			return mode;
		}
		function getSelectableRow(grid, rowIndex) {
			const row = grid.rows[rowIndex];
			return isDetailRow(row) ? grid.rows[rowIndex - 1] : row;
		}
		function getRangeItems(grid, fromRowIndex, toRowIndex) {
			const items = [];
			for (const row of grid.rows) if (row.index >= fromRowIndex && row.index < toRowIndex || row.index > toRowIndex && row.index <= fromRowIndex) items.push(row.dataItem);
			return items;
		}
		function getOtherRowItems(grid, selectedItem) {
			const items = [];
			for (const row of grid.rows) if (row.dataItem && row.dataItem !== selectedItem) items.push(row.dataItem);
			return items;
		}
		/**
		* Asks the owner of the items to change the selection state of the item.
		*/
		async function requestRowSelect(item, selected) {
			if (props.selectionBinding && selected !== item[props.selectionBinding]) await props.onRowSelect?.(item, selected);
		}
		/**
		* Handles the beginning edit event.
		*/
		function handleBeginningEdit(grid, args) {
			const col = args.getColumn();
			const item = args.getRow().dataItem;
			args.cancel = isReadOnlyColumn(col, item, false);
		}
		function isReadOnlyColumn(col, item, ignoreSlot) {
			if (props.editable && item) {
				const column = getDatagridColumn(col);
				if (column && !isIndeterminateCheckboxCell(column, getCellValue(column.name, item)) && (ignoreSlot || slots[`${col.name}-edit`])) return column.readOnly?.(item) ?? false;
			}
			return true;
		}
		/**
		* Handles the cell edit ending event.
		*/
		async function handleCellEditEnding(grid, args) {
			args._rng.col2 = args._rng.col;
			if (grid.currentEditDelegatesToComponent) args.cancel = true;
			if (grid.collectionView instanceof DatagridCollectionView && grid.collectionView.raisesItemPropertyChanges && args.getRow().dataItem) args.refresh = false;
			if (grid.stayInEditModeWhileInvalidating) {
				args.stayInEditMode = true;
				grid.stayInEditModeWhileInvalidating = false;
				return;
			}
			if (!args.cancel && grid.hostElement.contains(document.activeElement)) triggerChangeOnActiveInput();
			if (stayInEditMode) {
				args.stayInEditMode = true;
				return;
			}
			grid.currentEditingCell = void 0;
			grid.currentEditDelegatesToComponent = false;
		}
		function handleFormatItem(grid, args) {
			if (args.panel === grid.cells) {
				setCellValidationMessage(args.cell, void 0);
				const item = args.getRow().dataItem;
				if (item instanceof CollectionViewGroup$1) formatGroupRow(args, item);
				else if (item) formatItemRow(grid, args, item);
				else formatAddRow(grid, args);
			}
		}
		/**
		* Formats an item row.
		*/
		function formatItemRow(grid, args, item) {
			if (args.col === grid.columns.firstVisibleIndex) {
				args.cell.style.paddingLeft = "";
				args.cell.style.paddingRight = "";
			}
			if (args.col === grid.columns.firstVisibleIndex && props.selectionBinding && args.cell.parentElement) args.cell.parentElement.classList.toggle("selected", item[props.selectionBinding] === true);
			const col = args.getColumn();
			const column = getDatagridColumn(args.getColumn());
			if (column) {
				args.cell.style.alignItems = convertTextAlignToAlignItems(column.align, false);
				const isReadOnly = isReadOnlyColumn(col, item, true);
				args.cell.classList.toggle("read-only", isReadOnly);
				args.cell.querySelector("input[type=\"checkbox\"]")?.toggleAttribute("disabled", isReadOnly);
				if (isEditingCell(grid, args.row, args.col)) args.cell.classList.toggle("wj-state-active", true);
				else emitFormatCell(column, item, args.cell, isReadOnly);
				emitValidateCell(args.cell, item, column);
				return;
			}
			if (!isDetailRow(args.getRow())) emitFormatCell(void 0, item, args.cell, true);
			if (col.name === "$$row-drag") args.cell.setAttribute("draggable", "true");
			else if (col.name === "$$row-indicator") emitValidateCell(args.cell, item);
		}
		/**
		* Formats a group row.
		*/
		function formatGroupRow(args, item) {
			if (item.groupDescription instanceof PropertyGroupDescription$1 && args.cell.hasAttribute("aria-expanded")) {
				const column = columnsMap.value.get(item.groupDescription.propertyName);
				if (column) {
					if (props.selectionBinding && args.cell.parentElement) args.cell.parentElement.classList.toggle("selected", false);
					emitFormatCell(column, item, args.cell, true);
				}
			}
		}
		/**
		* Formats an add row.
		*/
		function formatAddRow(grid, args) {
			if (args.col === grid.columns.firstVisibleIndex && args.cell.parentElement) args.cell.parentElement.classList.toggle("selected", false);
			const column = getDatagridColumn(args.getColumn());
			if (column) args.cell.style.alignItems = convertTextAlignToAlignItems(column.align, false);
		}
		/**
		* Emits a formatCell event.
		*/
		function emitFormatCell(column, item, cell, readOnly) {
			emit("formatCell", column, item, cell, readOnly, props.autoRowHeight);
		}
		/**
		* Emits a validateCell event.
		*/
		function emitValidateCell(cell, item, column) {
			emit("validateCell", item, column, (message) => setCellValidationMessage(cell, message));
		}
		/**
		* Toggles whether the mounted edit component persists its value itself.
		*/
		function toggleDelegateEditToComponent(value) {
			if (!_grid.value) return;
			_grid.value.currentEditDelegatesToComponent = value;
		}
		/**
		* Toggles the "stay in edit mode".
		*/
		function toggleStayInEditMode(value) {
			if (!_grid.value) return;
			stayInEditMode = value;
			if (!_grid.value.editRange && !value) startEditing(_grid.value, _grid.value.selection.row, _grid.value.selection.col);
		}
		/**
		* Toggles the datagrid read only state.
		*/
		function toggleReadOnly(value) {
			if (!_grid.value) return;
			_grid.value.isReadOnly = value;
			if (!value) startEditing(_grid.value, _grid.value.selection.row, _grid.value.selection.col);
		}
		/**
		* Toggles the context menu, whose row commands are built once the mousedown that preceded it,
		* which can change the current row and the selection, is handled.
		* The browser menu is always prevented, since whether the grid menu has commands is only known
		* after the selection change, except in a text field where it offers paste and spell checking,
		* and on a link where it offers to open it in a new tab.
		*/
		function toggleContextMenu(event) {
			if (isTextEntryElement(event.target)) return;
			if (isLinkElement(event.target)) {
				contextMenu.value.cancel();
				return;
			}
			event.preventDefault();
			contextMenu.value.toggle(event, pendingMousedown);
		}
		/**
		* Override the wijmo cell persistence behaviour.
		* Loosing focus on the editable cell component replace the editable cell with the display cell.
		* Some component (eg: Lookup) can persist their value asynchronously, so the model update take place
		* when the component is already unmounted.
		* To ensure that the data is updated, this override will force the update to the wijmo cell instance.
		*/
		function getCellInstanceOverride(cell) {
			const currentValue = shallowRef(cell.value);
			const currentEditingCell = {
				...cell,
				get value() {
					return currentValue.value;
				},
				set value(newValue) {
					currentValue.value = newValue;
					cell.value = newValue;
				}
			};
			if (_grid.value) {
				_grid.value.currentEditingCell = currentEditingCell;
				_grid.value.currentEditDelegatesToComponent = false;
			}
			return currentEditingCell;
		}
		/**
		* Gets the current sort image name.
		*/
		function getCurrentSortImageName(column) {
			if (column.currentSort === null) return "swap";
			return column.currentSort === "+" ? "arrowUp" : "arrowDown";
		}
		useComponentAutomationProperties();
		onBeforeUnmount(() => {
			stopWatchingFocusLoss?.();
			if (!_grid.value) return;
			_grid.value.finishEditing();
			_grid.value.collectionView?.collectionChanged.removeHandler(handleHeaderSelectorCollectionChanged);
			_grid.value = void 0;
		});
		function loadRowsIfInfiniteScrollingAndNoScroll(grid) {
			if (props.infiniteScrolling && grid._root.scrollHeight <= grid._root.clientHeight) {
				const pageRowsCount = getPageRowsCount(grid);
				if (grid.rows.length < pageRowsCount) props.loadRows?.(pageRowsCount);
			}
		}
		/**
		* Handles the mouse wheel event.
		*/
		async function handleWheel() {
			await commitAddRow();
		}
		/**
		* Handles the scroll position changed event.
		*/
		function handleScrollPositionChanged(grid) {
			if (props.infiniteScrolling && grid.viewRange.bottomRow >= grid.rows.length - 10) {
				let group;
				for (const row of grid.rows) {
					if (isGroupRow(row) && !row.isCollapsed) group = row.dataItem;
					if (row.index === grid.viewRange.bottomRow) break;
				}
				props.loadRows?.(getPageRowsCount(grid), group);
			}
		}
		/**
		* Handles the group collapsed change event.
		*/
		function handleGroupCollapsedChanged(grid, args) {
			if (!grid.restoringGroupRowsState) {
				const row = args.getRow();
				emit("toggleGroup", row.dataItem, row.isCollapsed, getPageRowsCount(grid));
			}
		}
		/**
		* Handles the dragging column event.
		*/
		function handleDraggingColumn(grid, args) {
			draggingColumn.value = getDatagridColumn(args.getColumn());
		}
		/**
		* Handles the dragging column over event: a column cannot be moved after the filler and
		* row actions columns, which must remain the last ones.
		*/
		function handleDraggingColumnOver(grid, args) {
			args.cancel = args.col > getLastDataColumnIndex(grid.columns);
		}
		/**
		* Handles the selection changing event: the filler and row actions columns hold no data, so
		* the selection never goes into them (ArrowRight or End key, click on their cells). It stops
		* on the last visible data cell of the row instead.
		*/
		function handleSelectionChanging(grid, args) {
			if (args.col > getLastDataColumnIndex(grid.columns)) {
				args.cancel = true;
				const range = new CellRange(args.row, getLastVisibleDataColumnIndex(grid.columns));
				queueMicrotask(() => grid.select(range));
			}
		}
		/**
		* Handles the dragged column event.
		*/
		function handleDraggedColumn(grid) {
			emitColumnsChanged(grid);
		}
		/**
		* Handles the resizing column event.
		*/
		function handleResizingColumn(grid, e) {
			grid.columnHeaders.getCellElement(0, e.col).setAttribute("data-resizing", "true");
			grid.columnHeaders.hostElement.setAttribute("data-resizing-column", "true");
		}
		/**
		* Handles the resized column event.
		*/
		function handleResizedColumn(grid, e) {
			grid.columnHeaders.getCellElement(0, e.col).removeAttribute("data-resizing");
			grid.columnHeaders.hostElement.removeAttribute("data-resizing-column");
			emitColumnsChanged(grid);
		}
		/**
		* Emits a columns changed event.
		*/
		function emitColumnsChanged(grid) {
			const columns = [];
			for (const col of grid.columns) {
				const column = getDatagridColumn(col);
				if (column?.tag) columns.push({
					tag: column.tag,
					visible: col.visible,
					position: col.visible ? col.visibleIndex : 0,
					width: col.width?.toString()
				});
			}
			emit("columnsChanged", columns);
		}
		/**
		* Handles the got focus event.
		*/
		async function handleGotFocus(grid) {
			if (grid.selection.row === -1 && grid.rows.length > 0 && !(document.activeElement instanceof HTMLButtonElement)) {
				if (isAddRow(grid.rows[0])) await addRowAdding(grid);
				selectCell(grid, 0, systemColumnCount.value);
			}
		}
		/**
		* Handles the lost focus event.
		*/
		function handleLostFocus(grid) {
			commitAddRow(grid);
		}
		/**
		* Handles the copying event.
		*/
		async function handleCopying(grid, args) {
			const item = args.getRow().dataItem;
			const isGroupRow = item.groupDescription instanceof PropertyGroupDescription$1;
			const columnName = isGroupRow ? item.groupDescription.propertyName : args.getColumn().name;
			const column = columnsMap.value.get(columnName);
			if (column) {
				let text;
				if (!isGroupRow && column.displayTemplate) text = getDisplayTemplateText(grid, args.row, args.col);
				else if (column.displayText) {
					const value = isGroupRow ? item.name : getPropertyByPath(item, columnName);
					text = await column.displayText(value, item);
				}
				if (text != null) {
					args.cancel = true;
					await navigator.clipboard.writeText(text);
				}
			}
		}
		/**
		* Handles the pasting cell event.
		*/
		function handlePastingCell(grid, args) {
			args.cancel = isReadOnlyColumn(args.getColumn(), args.getRow().dataItem, true);
		}
		/**
		* Builds the summary row.
		*/
		function buildSummaryRow(grid) {
			if (props.summaries) {
				if (grid.columnFooters.rows.length === 0) {
					const row = new Row(props.summaries);
					grid.columnFooters.rows.push(row);
				} else grid.columnFooters.rows[0].dataItem = props.summaries;
				grid.invalidate(false);
			} else grid.columnFooters.rows.clear();
		}
		/**
		* Gets the page rows count.
		*/
		function getPageRowsCount(grid) {
			return Math.ceil(grid.hostElement.clientHeight / grid.rows.defaultSize) + 10;
		}
		function getCellValue(path, item) {
			return item ? getPropertyByPath(item, path) : void 0;
		}
		function getDatagridColumn(column) {
			return columnsMap.value.get(column.name);
		}
		async function commitAddRow(grid = _grid.value) {
			if (grid && props.addRow && !stayInEditMode) await addRowCommitting(grid);
		}
		return {
			columnsMap,
			contextMenu,
			convertBooleanToVisibility,
			convertColumnWidth,
			DataType: DataType$1,
			displayColumnSortIndex,
			draggingColumn,
			emitColumnsChanged,
			getCellInstanceOverride,
			getCellValue,
			getCheckboxCellValue,
			getCurrentSortImageName,
			getRowDetailColumnIcon,
			grid: _grid,
			handleBeginningEdit,
			handleCellEditEnding,
			handleClick,
			handleCopying,
			handleDoubleClick,
			handleDragend,
			handleDragleave,
			handleDraggedColumn,
			handleDraggingColumn,
			handleDraggingColumnOver,
			handleSelectionChanging,
			handleDragover,
			handleDragstart,
			handleDrop,
			handleFormatItem,
			handleGotFocus,
			handleGroupCollapsedChanged,
			handleInitialization,
			handleItemsSourceChanged,
			handleKeydown,
			handleLoadedRows,
			handleLostFocus,
			handleMousedown,
			handlePastingCell,
			handleRefreshed,
			handleRefreshing,
			handleResizedColumn,
			handleResizingColumn,
			handleRowActionKeydown,
			handleRowActionsFocusout,
			handleScrollPositionChanged,
			handleWheel,
			hideValidationTooltip,
			hasColumnHeaderContextMenu,
			hasRowActionsColumn,
			headerSelectorValue,
			isEmpty,
			isGroupPanelVisible,
			isIndeterminateCheckboxCell,
			isRowActionsRow,
			hasRoomForNoData,
			isVisible,
			loadingOverlayMessage,
			refresh,
			resetColumns,
			rowActionsCaption,
			rowActionsElement,
			rowActionsItem,
			rowActionsSelected,
			rowDetailComponent,
			rowDragDrop,
			sortColumn,
			systemColumnCount,
			toggleContextMenu,
			toggleDelegateEditToComponent,
			toggleReadOnly,
			toggleStayInEditMode,
			validationTooltip
		};
	}
});
// src/components/Datagrid/Datagrid.vue
var _hoisted_1$27 = {
	key: 0,
	class: "row-action"
};
var _hoisted_2$13 = {
	key: 1,
	class: "row-indicator"
};
var _hoisted_3$6 = ["checked"];
var _hoisted_4$4 = ["checked"];
var _hoisted_5$3 = ["data-sort"];
var _hoisted_6$1 = { key: 0 };
var _hoisted_7$1 = {
	key: 0,
	class: "switch-content"
};
var _hoisted_8$1 = ["checked"];
var _hoisted_9 = ["checked", ".indeterminate"];
var _hoisted_10 = { class: "sr-only" };
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_DatagridGroupPanel = resolveComponent("DatagridGroupPanel");
	const _component_DatagridContextMenu = resolveComponent("DatagridContextMenu");
	const _component_DatagridValidationTooltip = resolveComponent("DatagridValidationTooltip");
	const _component_LoadingOverlay = resolveComponent("LoadingOverlay");
	const _component_Image = resolveComponent("Image");
	const _component_WjFlexGridCellTemplate = resolveComponent("WjFlexGridCellTemplate");
	const _component_WjFlexGridColumn = resolveComponent("WjFlexGridColumn");
	const _component_MarkdownViewer = resolveComponent("MarkdownViewer");
	const _component_InputDocumentationButton = resolveComponent("InputDocumentationButton");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_DatagridSummaryCell = resolveComponent("DatagridSummaryCell");
	const _component_WjFlexGridDetail = resolveComponent("WjFlexGridDetail");
	const _component_WjFlexGrid = resolveComponent("WjFlexGrid");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(_component_VerticalLayout, {
		class: "datagrid",
		style: normalizeStyle({ visibility: _ctx.convertBooleanToVisibility(_ctx.isVisible) }),
		"data-editable": _ctx.editable
	}, {
		default: withCtx(() => [_ctx.grid ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
			_ctx.groupable ? withDirectives((openBlock(), createBlock(_component_DatagridGroupPanel, {
				key: 0,
				grid: _ctx.grid,
				"dragging-column": _ctx.draggingColumn,
				onSort: _ctx.sortColumn
			}, null, 8, [
				"grid",
				"dragging-column",
				"onSort"
			])), [[vShow, _ctx.isGroupPanelVisible]]) : createCommentVNode("", true),
			createVNode(_component_DatagridContextMenu, {
				ref: "contextMenu",
				"group-panel-visible": _ctx.isGroupPanelVisible,
				"onUpdate:groupPanelVisible": _cache[0] || (_cache[0] = ($event) => _ctx.isGroupPanelVisible = $event),
				grid: _ctx.grid,
				columns: _ctx.columnsMap,
				"get-row-context-menu-items": _ctx.getRowContextMenuItems,
				"system-column-count": _ctx.systemColumnCount,
				groupable: _ctx.groupable,
				exportable: _ctx.exportable,
				"column-picker": _ctx.columnPicker,
				onColumnsChanged: _ctx.emitColumnsChanged
			}, null, 8, [
				"group-panel-visible",
				"grid",
				"columns",
				"get-row-context-menu-items",
				"system-column-count",
				"groupable",
				"exportable",
				"column-picker",
				"onColumnsChanged"
			]),
			createVNode(_component_DatagridValidationTooltip, {
				tooltip: _ctx.validationTooltip,
				onHide: _ctx.hideValidationTooltip
			}, null, 8, ["tooltip", "onHide"])
		], 64)) : createCommentVNode("", true), createVNode(_component_VerticalLayout, {
			class: "datagrid-body",
			space: "none",
			onDragover: _ctx.handleDragover,
			onDragleave: _ctx.handleDragleave,
			onDrop: _ctx.handleDrop
		}, {
			default: withCtx(() => [
				_ctx.hasRoomForNoData && _ctx.isEmpty ? renderSlot(_ctx.$slots, "no-data", {}, void 0, void 0, 0) : createCommentVNode("", true),
				createVNode(_component_LoadingOverlay, { message: _ctx.loadingOverlayMessage }, null, 8, ["message"]),
				createVNode(_component_WjFlexGrid, {
					"items-source": _ctx.source,
					"selection-mode": "Cell",
					"headers-visibility": "Column",
					"key-action-tab": "None",
					"sticky-headers": true,
					"validate-edits": false,
					"defer-resizing": true,
					"clone-frozen-cells": false,
					"virtualization-threshold": [0, 100],
					"preserve-outline-state": false,
					"group-header-format": "{value}",
					"allow-sorting": "None",
					"loaded-rows": _ctx.handleLoadedRows,
					refreshing: _ctx.handleRefreshing,
					refreshed: _ctx.handleRefreshed,
					"items-source-changed": _ctx.handleItemsSourceChanged,
					"beginning-edit": _ctx.handleBeginningEdit,
					"cell-edit-ending": _ctx.handleCellEditEnding,
					"format-item": _ctx.handleFormatItem,
					"scroll-position-changed": _ctx.handleScrollPositionChanged,
					"group-collapsed-changing": _ctx.handleGroupCollapsedChanged,
					"dragging-column": _ctx.handleDraggingColumn,
					"dragging-column-over": _ctx.handleDraggingColumnOver,
					"selection-changing": _ctx.handleSelectionChanging,
					"dragged-column": _ctx.handleDraggedColumn,
					"resizing-column": _ctx.handleResizingColumn,
					"resized-column": _ctx.handleResizedColumn,
					"got-focus": _ctx.handleGotFocus,
					"lost-focus": _ctx.handleLostFocus,
					copying: _ctx.handleCopying,
					"pasting-cell": _ctx.handlePastingCell,
					"data-add-row": _ctx.addRow,
					"data-row-drag-drop": _ctx.rowDragDrop || void 0,
					"data-external-row-drop": !!_ctx.externalRowDrop || void 0,
					onMousedown: _ctx.handleMousedown,
					onClick: _ctx.handleClick,
					onDblclick: _ctx.handleDoubleClick,
					onKeydown: _ctx.handleKeydown,
					onContextmenu: _ctx.toggleContextMenu,
					onDragstart: _ctx.handleDragstart,
					onDragend: _ctx.handleDragend,
					onWheel: _ctx.handleWheel
				}, {
					default: withCtx(() => [
						_ctx.rowDragDrop ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 0,
							name: "$$row-drag",
							width: 28,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col row-drag-col"
						}, {
							default: withCtx(() => [createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
								default: withCtx(() => [_ctx.hasColumnHeaderContextMenu ? (openBlock(), createBlock(_component_Image, {
									key: 0,
									name: "cog",
									size: "small"
								})) : createCommentVNode("", true)]),
								_: 1
							}), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx(() => [createVNode(_component_Image, { name: "dragVertical" })]),
								_: 1
							})]),
							_: 1
						})) : createCommentVNode("", true),
						_ctx.$slots["row-detail"] ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 1,
							name: "$$row-detail",
							width: 28,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col row-detail-col"
						}, {
							default: withCtx(() => [createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
								default: withCtx(() => [_ctx.hasColumnHeaderContextMenu && !_ctx.rowDragDrop ? (openBlock(), createBlock(_component_Image, {
									key: 0,
									name: "cog",
									size: "small"
								})) : createCommentVNode("", true)]),
								_: 1
							}), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx((cell) => [createVNode(_component_Image, {
									name: _ctx.getRowDetailColumnIcon(cell.row),
									size: "small"
								}, null, 8, ["name"])]),
								_: 1
							})]),
							_: 1
						})) : createCommentVNode("", true),
						_ctx.$slots["row-indicator"] ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 2,
							name: "$$row-indicator",
							width: 28,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col row-indicator-col"
						}, {
							default: withCtx(() => [createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
								default: withCtx(() => [_ctx.hasColumnHeaderContextMenu && !_ctx.rowDragDrop && !_ctx.$slots["row-detail"] ? (openBlock(), createBlock(_component_Image, {
									key: 0,
									name: "cog",
									size: "small"
								})) : createCommentVNode("", true)]),
								_: 1
							}), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx((cell) => [_ctx.$slots["row-action"] ? (openBlock(), createElementBlock("div", _hoisted_1$27, [renderSlot(_ctx.$slots, "row-action", { item: cell.row.dataItem })])) : createCommentVNode("", true), _ctx.$slots["row-indicator"] ? (openBlock(), createElementBlock("div", _hoisted_2$13, [renderSlot(_ctx.$slots, "row-indicator", { item: cell.item })])) : createCommentVNode("", true)]),
								_: 3
							})]),
							_: 3
						})) : createCommentVNode("", true),
						_ctx.selectionColumn && _ctx.selectionBinding ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 3,
							width: 28,
							name: _ctx.selectionBinding,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col selection-col"
						}, {
							default: withCtx(() => [_ctx.selectionColumnHeader ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
								key: 0,
								"cell-type": "ColumnHeader"
							}, {
								default: withCtx(() => [createElementVNode("input", {
									type: "checkbox",
									class: "header-selector",
									checked: _ctx.headerSelectorValue,
									tabindex: "-1",
									onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["prevent"]))
								}, null, 8, _hoisted_3$6), _cache[8] || (_cache[8] = createElementVNode("span", { class: "checkbox-rounded" }, null, -1))]),
								_: 1
							})) : createCommentVNode("", true), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx((cell) => [createElementVNode("input", {
									type: "checkbox",
									class: "row-selector",
									checked: cell.item?.[_ctx.selectionBinding],
									tabindex: "-1",
									onClick: _cache[2] || (_cache[2] = withModifiers(() => {}, ["prevent"]))
								}, null, 8, _hoisted_4$4), _cache[9] || (_cache[9] = createElementVNode("span", { class: "checkbox-rounded" }, null, -1))]),
								_: 1
							})]),
							_: 1
						}, 8, ["name"])) : createCommentVNode("", true),
						(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columns, (column, i) => {
							return openBlock(), createBlock(_component_WjFlexGridColumn, {
								key: column.name + i,
								name: column.name,
								binding: column.name,
								header: column.caption,
								visible: column.visible,
								"allow-sorting": column.sortable,
								"allow-dragging": column.movable,
								"data-type": column.dataType,
								"is-read-only": !_ctx.editable,
								"is-required": false,
								width: _ctx.convertColumnWidth(column.width),
								"min-width": column.minWidth,
								"max-width": column.maxWidth
							}, {
								default: withCtx(() => [
									createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
										default: withCtx((cell) => [createVNode(_component_HorizontalLayout, {
											space: "extrasmall",
											"vertical-align": "center",
											wrap: false,
											align: column.align,
											"data-column": column.name,
											"data-sortable": column.sortable,
											title: column.caption
										}, {
											default: withCtx(() => [
												createElementVNode("span", { class: normalizeClass(["column-caption", { "column-caption-not-loaded": column.notLoaded }]) }, toDisplayString(column.caption), 3),
												column.documentation ? (openBlock(), createBlock(_component_InputDocumentationButton, { key: 0 }, {
													header: withCtx(() => [createTextVNode(toDisplayString(column.caption), 1)]),
													body: withCtx(() => [createVNode(_component_MarkdownViewer, {
														source: column.documentation,
														sanitize: true
													}, null, 8, ["source"])]),
													_: 2
												}, 1024)) : createCommentVNode("", true),
												column.sortable ? (openBlock(), createElementBlock("div", {
													key: 1,
													class: "sort-info",
													"data-sort": cell.col.currentSort
												}, [createVNode(_component_Image, {
													name: _ctx.getCurrentSortImageName(cell.col),
													size: "small"
												}, null, 8, ["name"]), _ctx.displayColumnSortIndex && cell.col.currentSortIndex > -1 ? (openBlock(), createElementBlock("span", _hoisted_6$1, toDisplayString(cell.col.currentSortIndex + 1), 1)) : createCommentVNode("", true)], 8, _hoisted_5$3)) : createCommentVNode("", true)
											]),
											_: 2
										}, 1032, [
											"align",
											"data-column",
											"data-sortable",
											"title"
										])]),
										_: 2
									}, 1024),
									_ctx.$slots[`${column.name}-edit`] ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
										key: 0,
										"cell-type": "CellEdit"
									}, {
										default: withCtx((cell) => [renderSlot(_ctx.$slots, `${column.name}-edit`, {
											column,
											cell: _ctx.getCellInstanceOverride(cell),
											toggleDelegateEditToComponent: _ctx.toggleDelegateEditToComponent,
											toggleStayInEditMode: _ctx.toggleStayInEditMode,
											toggleReadOnly: _ctx.toggleReadOnly
										})]),
										_: 2
									}, 1024)) : column.dataType == _ctx.DataType.Boolean ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
										key: 1,
										"cell-type": "Cell"
									}, {
										default: withCtx((cell) => [_ctx.booleanDisplayMode === "switch" ? (openBlock(), createElementBlock("div", _hoisted_7$1, [createElementVNode("label", null, [createElementVNode("input", {
											type: "checkbox",
											checked: _ctx.getCheckboxCellValue(_ctx.getCellValue(column.name, cell.item)),
											tabindex: "-1",
											onClick: _cache[3] || (_cache[3] = withModifiers(() => {}, ["prevent"]))
										}, null, 8, _hoisted_8$1), _cache[10] || (_cache[10] = createElementVNode("span", { class: "checkbox-cell" }, null, -1))])])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createElementVNode("input", {
											type: "checkbox",
											checked: _ctx.getCheckboxCellValue(_ctx.getCellValue(column.name, cell.item)),
											".indeterminate": _ctx.isIndeterminateCheckboxCell(column, _ctx.getCellValue(column.name, cell.item)),
											class: "checkbox-cell",
											tabindex: "-1",
											onClick: _cache[4] || (_cache[4] = withModifiers(() => {}, ["prevent"]))
										}, null, 40, _hoisted_9), _cache[11] || (_cache[11] = createElementVNode("span", { class: "checkbox-cell-overlay" }, null, -1))], 64))]),
										_: 2
									}, 1024)) : createCommentVNode("", true),
									_ctx.$slots[`${column.name}-display`] ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
										key: 2,
										"cell-type": "Cell"
									}, {
										default: withCtx((cell) => [cell.item ? renderSlot(_ctx.$slots, `${column.name}-display`, {
											column,
											cell: {
												...cell,
												value: _ctx.getCellValue(column.name, cell.item)
											}
										}, void 0, void 0, 0) : createCommentVNode("", true)]),
										_: 2
									}, 1024)) : createCommentVNode("", true),
									createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Group" }, {
										default: withCtx((cell) => [column.groupSummaryType !== void 0 && cell.value != void 0 ? (openBlock(), createBlock(_component_DatagridSummaryCell, {
											key: 0,
											types: column.summaryTypes,
											type: column.groupSummaryType,
											value: cell.value,
											format: column.format,
											align: column.align,
											tag: _ctx.summaryTag,
											"data-column": column.name
										}, null, 8, [
											"types",
											"type",
											"value",
											"format",
											"align",
											"tag",
											"data-column"
										])) : createCommentVNode("", true)]),
										_: 2
									}, 1024),
									createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnFooter" }, {
										default: withCtx((cell) => [column.totalSummaryType !== void 0 && cell.value != void 0 ? (openBlock(), createBlock(_component_DatagridSummaryCell, {
											key: 0,
											types: column.summaryTypes,
											type: column.totalSummaryType,
											value: cell.value,
											format: column.format,
											align: column.align,
											tag: _ctx.summaryTag,
											"data-column": column.name
										}, null, 8, [
											"types",
											"type",
											"value",
											"format",
											"align",
											"tag",
											"data-column"
										])) : createCommentVNode("", true)]),
										_: 2
									}, 1024)
								]),
								_: 2
							}, 1032, [
								"name",
								"binding",
								"header",
								"visible",
								"allow-sorting",
								"allow-dragging",
								"data-type",
								"is-read-only",
								"width",
								"min-width",
								"max-width"
							]);
						}), 128)),
						createVNode(_component_WjFlexGridColumn, {
							name: "$$filler",
							width: 0,
							"min-width": 0,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col filler-col"
						}),
						_ctx.hasRowActionsColumn ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 4,
							name: "$$row-actions",
							width: 32,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col row-actions-col"
						}, {
							default: withCtx(() => [createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
								default: withCtx(() => [createElementVNode("span", _hoisted_10, toDisplayString(_ctx.rowActionsCaption), 1)]),
								_: 1
							}), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx((cell) => [_ctx.isRowActionsRow(cell.row) ? (openBlock(), createElementBlock("div", {
									key: 0,
									class: "row-actions",
									onKeydown: _cache[5] || (_cache[5] = (...args) => _ctx.handleRowActionKeydown && _ctx.handleRowActionKeydown(...args))
								}, [renderSlot(_ctx.$slots, "row-actions", { item: cell.item })], 32)) : createCommentVNode("", true)]),
								_: 3
							})]),
							_: 3
						})) : createCommentVNode("", true),
						_ctx.$slots["row-detail"] ? (openBlock(), createBlock(_component_WjFlexGridDetail, {
							key: 5,
							ref: "rowDetailComponent"
						}, {
							default: withCtx((cell) => [renderSlot(_ctx.$slots, "row-detail", { item: cell.item })]),
							_: 3
						}, 512)) : createCommentVNode("", true)
					]),
					_: 3
				}, 8, [
					"items-source",
					"loaded-rows",
					"refreshing",
					"refreshed",
					"items-source-changed",
					"beginning-edit",
					"cell-edit-ending",
					"format-item",
					"scroll-position-changed",
					"group-collapsed-changing",
					"dragging-column",
					"dragging-column-over",
					"selection-changing",
					"dragged-column",
					"resizing-column",
					"resized-column",
					"got-focus",
					"lost-focus",
					"copying",
					"pasting-cell",
					"data-add-row",
					"data-row-drag-drop",
					"data-external-row-drop",
					"onMousedown",
					"onClick",
					"onDblclick",
					"onKeydown",
					"onContextmenu",
					"onDragstart",
					"onDragend",
					"onWheel"
				]),
				_ctx.$slots["row-actions"] && !_ctx.hasRowActionsColumn ? (openBlock(), createElementBlock("div", {
					key: 1,
					ref: "rowActionsElement",
					class: normalizeClass(["datagrid-row-actions", { selected: _ctx.rowActionsSelected }]),
					onFocusout: _cache[6] || (_cache[6] = (...args) => _ctx.handleRowActionsFocusout && _ctx.handleRowActionsFocusout(...args)),
					onKeydown: _cache[7] || (_cache[7] = (...args) => _ctx.handleRowActionKeydown && _ctx.handleRowActionKeydown(...args))
				}, [renderSlot(_ctx.$slots, "row-actions", { item: _ctx.rowActionsItem })], 34)) : createCommentVNode("", true),
				_ctx.$slots.footer ? (openBlock(), createBlock(_component_VerticalLayout, {
					key: 2,
					class: "datagrid-footer"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "footer")]),
					_: 3
				})) : createCommentVNode("", true)
			]),
			_: 3
		}, 8, [
			"onDragover",
			"onDragleave",
			"onDrop"
		])]),
		_: 3
	}, 8, ["style", "data-editable"]);
}
var Datagrid_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Datagrid_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$9]]);
// src/components/Divider/Divider.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$26 = {
	key: 0,
	class: "divider-content"
};
// src/components/Divider/Divider.vue
var Divider_default = /* @__PURE__ */ defineComponent({
	__name: "Divider",
	props: {
		contentAlign: { default: "center" },
		layout: { default: "horizontal" },
		type: { default: "solid" },
		color: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		const slots = useSlots();
		const classes = computed(() => {
			const align = convertInvariantTextAlignToOccidentalTextAlign(props.contentAlign);
			const alignClass = props.layout === "horizontal" ? `divider-${align}` : "divider-center";
			return [
				`divider-${props.layout}`,
				`divider-${props.type}`,
				alignClass
			];
		});
		const colorValue = computed(() => props.color ? getColorValue(props.color) : void 0);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Separator), {
				orientation: __props.layout,
				class: normalizeClass(["divider", classes.value]),
				style: normalizeStyle({ "--divider-border-color": colorValue.value })
			}, {
				default: withCtx(() => [unref(slots).default ? (openBlock(), createElementBlock("div", _hoisted_1$26, [renderSlot(_ctx.$slots, "default")])) : createCommentVNode("", true)]),
				_: 3
			}, 8, [
				"orientation",
				"class",
				"style"
			]);
		};
	}
});
// src/components/DocumentationButton/DocumentationButton.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$25 = ["innerHTML"];
// src/components/DocumentationButton/DocumentationButton.vue
var DocumentationButton_default = /* @__PURE__ */ defineComponent({
	__name: "DocumentationButton",
	props: {
		text: {},
		title: {},
		markdown: { type: Boolean }
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(InputDocumentationButton_default, null, {
				header: withCtx(() => [createTextVNode(toDisplayString(__props.title), 1)]),
				body: withCtx(() => [__props.markdown ? (openBlock(), createBlock(MarkdownViewer_default, {
					key: 0,
					source: __props.text,
					sanitize: true
				}, null, 8, ["source"])) : (openBlock(), createElementBlock("div", {
					key: 1,
					innerHTML: __props.text
				}, null, 8, _hoisted_1$25))]),
				_: 1
			});
		};
	}
});
// src/components/Dropdown/Dropdown.ts?vue&type=script&src=true&lang.ts
var Dropdown_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Dropdown",
	props: {
		active: {
			type: Boolean,
			default: void 0
		},
		element: {
			type: Object,
			default: void 0
		},
		limitWidthToAnchor: {
			type: String,
			default: "none"
		},
		offset: {
			type: Number,
			default: 0
		},
		customClass: {
			type: String,
			default: void 0
		}
	},
	emits: ["update:active"],
	setup(props, { emit }) {
		const internalActive = ref(false);
		const isActive = computed({
			get: () => props.active ?? internalActive.value,
			set: (value) => {
				internalActive.value = value;
				if (props.active !== void 0) emit("update:active", value);
			}
		});
		const toggler = ref();
		const anchor = computed(() => props.element ?? toggler.value);
		const content = ref();
		const style = shallowRef();
		const portalKey = useOverlayPortalKey(isActive);
		onMounted(() => {
			window.addEventListener("resize", updateDropdownStyle);
			document.addEventListener("scroll", onScroll, {
				capture: true,
				passive: true
			});
		});
		onUnmounted(() => {
			window.removeEventListener("resize", updateDropdownStyle);
			document.removeEventListener("scroll", onScroll, { capture: true });
		});
		onClickOutside(content, () => isActive.value = false, { ignore: [anchor] });
		function updateDropdownStyle() {
			if (!isActive.value || !anchor.value || !content.value) return;
			const styleValue = {};
			const rectAnchor = anchor.value.getBoundingClientRect();
			const rectContent = content.value.getBoundingClientRect();
			if (rectContent.height + props.offset <= document.documentElement.clientHeight - rectAnchor.y - rectAnchor.height) styleValue.top = `${rectAnchor.y + rectAnchor.height + props.offset}px`;
			else styleValue.top = `${rectAnchor.y - props.offset - rectContent.height}px`;
			let contentWidth;
			switch (props.limitWidthToAnchor) {
				case "absolute":
					styleValue.width = `${rectAnchor.width}px`;
					contentWidth = rectAnchor.width;
					break;
				case "min":
					styleValue.minWidth = `${rectAnchor.width}px`;
					contentWidth = rectContent.width;
					break;
				case "max":
					styleValue.maxWidth = `${rectAnchor.width}px`;
					contentWidth = rectAnchor.width;
					break;
				default:
					styleValue.width = "unset";
					contentWidth = rectContent.width;
			}
			const availableWidthRightToAnchorPosition = document.documentElement.clientWidth - rectAnchor.x;
			if (contentWidth <= availableWidthRightToAnchorPosition) styleValue.left = `${rectAnchor.x}px`;
			else {
				let left = rectAnchor.x + rectAnchor.width - contentWidth;
				if (left + contentWidth > document.documentElement.clientWidth) left = document.documentElement.clientWidth - contentWidth;
				styleValue.left = `${left}px`;
			}
			style.value = styleValue;
		}
		function onScroll(e) {
			if (!isActive.value || !(e.target instanceof HTMLElement)) return;
			if (anchor.value?.contains(e.target) || content.value?.contains(e.target)) return;
			isActive.value = false;
		}
		return {
			isActive,
			toggler,
			anchor,
			content,
			style,
			portalKey,
			updateDropdownStyle
		};
	}
});
// src/components/Dropdown/Dropdown.vue
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock(Fragment, null, [_ctx.$slots.toggler ? (openBlock(), createElementBlock("div", {
		key: 0,
		ref: "toggler",
		class: "dropdown-trigger",
		onClick: _cache[0] || (_cache[0] = ($event) => _ctx.isActive = !_ctx.isActive)
	}, [renderSlot(_ctx.$slots, "toggler", {}, void 0, true)], 512)) : createCommentVNode("", true), (openBlock(), createBlock(Teleport, {
		key: _ctx.portalKey,
		to: "body"
	}, [createVNode(Transition, {
		name: "dropdown-content",
		appear: ""
	}, {
		default: withCtx(() => [_ctx.isActive ? (openBlock(), createElementBlock("div", {
			key: 0,
			ref: "content",
			class: normalizeClass(["dropdown-content", _ctx.customClass]),
			style: normalizeStyle(_ctx.style),
			onVnodeMounted: _cache[1] || (_cache[1] = (...args) => _ctx.updateDropdownStyle && _ctx.updateDropdownStyle(...args))
		}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 6)) : createCommentVNode("", true)]),
		_: 3
	})]))], 64);
}
var Dropdown_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Dropdown_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$8], ["__scopeId", "data-v-9d9a2fa1"]]);
// src/components/DropdownMenuItem/DropdownMenuItem.vue
var DropdownMenuItem_default = /* @__PURE__ */ defineComponent({
	__name: "DropdownMenuItem",
	props: {
		item: {},
		hasSubmenu: { type: Boolean },
		size: {}
	},
	setup(__props) {
		const props = __props;
		const slots = useSlots();
		const hasActions = computed(() => props.hasSubmenu || slots.default);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				align: "space-between",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createVNode(HorizontalLayout_default, {
					"vertical-align": "center",
					wrap: false
				}, {
					default: withCtx(() => [
						__props.item.icon === "empty" ? (openBlock(), createElementBlock("div", {
							key: 0,
							class: "dropdown-menu-item-image empty",
							style: normalizeStyle(`width: var(--image-${__props.size}-size); height: var(--image-${__props.size}-size);`)
						}, null, 4)) : __props.item.icon ? (openBlock(), createBlock(Image_default, {
							key: 1,
							name: __props.item.icon,
							size: __props.size,
							class: "dropdown-menu-item-image"
						}, null, 8, ["name", "size"])) : createCommentVNode("", true),
						createVNode(Text_default, { "max-lines": 1 }, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.item.label), 1)]),
							_: 1
						}),
						__props.item.badge ? (openBlock(), createBlock(Badge_default, {
							key: 2,
							value: __props.item.badge,
							severity: __props.item.badgeSeverity
						}, null, 8, ["value", "severity"])) : createCommentVNode("", true)
					]),
					_: 1
				}), __props.item.sublabel || hasActions.value ? (openBlock(), createBlock(HorizontalLayout_default, {
					key: 0,
					space: "none",
					"vertical-align": "center"
				}, {
					default: withCtx(() => [
						__props.item.sublabel ? (openBlock(), createBlock(Text_default, {
							key: 0,
							size: "extrasmall",
							class: "dropdown-menu-item-sublabel"
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.item.sublabel), 1)]),
							_: 1
						})) : createCommentVNode("", true),
						renderSlot(_ctx.$slots, "default"),
						__props.hasSubmenu ? (openBlock(), createBlock(Image_default, {
							key: 1,
							name: "chevronRight",
							size: __props.size
						}, null, 8, ["size"])) : createCommentVNode("", true)
					]),
					_: 3
				})) : createCommentVNode("", true)]),
				_: 3
			});
		};
	}
});
// src/components/DropdownMenu/DropdownMenu.vue
var DropdownMenu_default = /* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "DropdownMenu",
	props: {
		items: {},
		size: { default: "medium" }
	},
	setup(__props, { expose: __expose }) {
		const open = shallowRef(false);
		const reference = shallowRef(createPointReference(0, 0));
		const targetElement = computed(() => reference.value instanceof Element ? reference.value : void 0);
		const { portalKey, show, hide, toggle } = useOverlay(open, (event) => {
			if (event.currentTarget instanceof Element) reference.value = event.currentTarget;
		});
		function handleInteractOutside(event) {
			if (isInteractionInside(event, reference.value)) event.preventDefault();
		}
		__expose({
			show,
			hide,
			toggle
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(MenuOverlay_default, mergeProps({
				open: open.value,
				"onUpdate:open": _cache[0] || (_cache[0] = ($event) => open.value = $event)
			}, _ctx.$attrs, {
				kind: "dropdown-menu",
				items: __props.items,
				reference: reference.value,
				target: targetElement.value,
				side: "bottom",
				"side-offset": 4,
				"portal-key": unref(portalKey),
				onInteractOutside: handleInteractOutside
			}), {
				item: withCtx(({ item, hasSubmenu }) => [renderSlot(_ctx.$slots, "item", {
					item,
					hasSubmenu,
					size: __props.size
				}, () => [createVNode(DropdownMenuItem_default, {
					item,
					"has-submenu": hasSubmenu,
					size: __props.size
				}, null, 8, [
					"item",
					"has-submenu",
					"size"
				])])]),
				_: 3
			}, 16, [
				"open",
				"items",
				"reference",
				"target",
				"portal-key"
			]);
		};
	}
});
// src/components/RadioGroup/RadioGroup.ts?vue&type=script&src=true&lang.ts
var RadioGroup_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "RadioGroup",
	components: {
		HorizontalLayout: HorizontalLayout_default,
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		VerticalLayout: VerticalLayout_default
	},
	props: {
		...inputProps,
		...contentProps,
		modelValue: {
			type: [
				String,
				Number,
				Boolean,
				Date,
				Object
			],
			default: null
		},
		values: {
			type: Array,
			default: () => []
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		disabledProperty: {
			type: String,
			default: void 0
		},
		orientation: {
			type: String,
			default: "horizontal"
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const contentStyleObject = useContentStyle(props);
		const localizator = useLocalizator();
		const { id, classes, ariaAttributes, isLabelVisible, isMessageVisible, messageId, tabIndex } = useInput(props, emit);
		const containerComponent = computed(() => props.orientation === "horizontal" ? HorizontalLayout_default : VerticalLayout_default);
		function getValue(value) {
			if (value && props.valueProperty) return value[props.valueProperty];
			return value;
		}
		function getDisplayValue(value) {
			if (value && props.displayProperty) return localizator.translate(value[props.displayProperty]);
			return localizator.translate(value);
		}
		function isValueDisabled(value) {
			return !!value && !!props.disabledProperty && !!value[props.disabledProperty];
		}
		function getId(value) {
			const v = getDisplayValue(value);
			return `${id}_${v ?? "null"}`;
		}
		return {
			contentStyleObject,
			id,
			classes,
			ariaAttributes,
			isLabelVisible,
			isMessageVisible,
			messageId,
			tabIndex,
			containerComponent,
			getValue,
			getDisplayValue,
			getId,
			isValueDisabled
		};
	}
});
// src/components/RadioGroup/RadioGroup.vue
var _hoisted_1$24 = [
	"id",
	"name",
	"disabled",
	"checked",
	"tabindex",
	"onChange"
];
var _hoisted_2$12 = ["for"];
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["radio-group neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		class: "radio-group-label",
		label: _ctx.label,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createElementVNode("div", mergeProps({
		..._ctx.ariaAttributes,
		"aria-label": _ctx.label
	}, {
		role: "radiogroup",
		class: ["neos-input-content", [{ "neos-input-disabled": _ctx.disabled }, _ctx.contentClass]],
		style: _ctx.contentStyleObject
	}), [(openBlock(), createBlock(resolveDynamicComponent(_ctx.containerComponent), null, {
		default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.values, (value) => {
			return openBlock(), createBlock(_component_HorizontalLayout, {
				key: value,
				class: normalizeClass(["radio-group-element", { "radio-group-element-disabled": _ctx.isValueDisabled(value) }]),
				wrap: false,
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createElementVNode("input", {
					id: _ctx.getId(value),
					type: "radio",
					name: _ctx.id,
					disabled: _ctx.disabled || _ctx.readonly || _ctx.isValueDisabled(value),
					checked: _ctx.modelValue === _ctx.getValue(value),
					tabindex: _ctx.tabIndex,
					onChange: ($event) => _ctx.$emit("update:modelValue", _ctx.getValue(value))
				}, null, 40, _hoisted_1$24), createElementVNode("label", { for: _ctx.getId(value) }, toDisplayString(_ctx.getDisplayValue(value)), 9, _hoisted_2$12)]),
				_: 2
			}, 1032, ["class"]);
		}), 128))]),
		_: 1
	})), renderSlot(_ctx.$slots, "default", {}, void 0, true)], 16)]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		id: _ctx.messageId,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, [
		"id",
		"text",
		"severity"
	])) : createCommentVNode("", true)], 2);
}
var RadioGroup_default = /*#__PURE__*/ _plugin_vue_export_helper_default(RadioGroup_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$7], ["__scopeId", "data-v-def8e489"]]);
// src/components/Switch/Switch.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$23 = [
	"id",
	"checked",
	"disabled",
	"tabindex"
];
// src/components/Switch/Switch.vue
var Switch_default = /* @__PURE__ */ defineComponent({
	__name: "Switch",
	props: {
		...inputProps,
		...contentProps,
		modelValue: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: "medium"
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const contentStyleObject = useContentStyle(props);
		const emit = __emit;
		const { id, classes, ariaAttributes, isLabelVisible, isMessageVisible, messageId, tabIndex } = useInput(props, emit);
		function handleChange(event) {
			emit("update:modelValue", event.target.checked);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["switch neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createElementVNode("div", {
				class: normalizeClass(["switch-content neos-input-content", [_ctx.contentClass, `switch-${__props.size}`]]),
				style: normalizeStyle(unref(contentStyleObject))
			}, [createElementVNode("label", null, [createElementVNode("input", mergeProps({
				id: unref(id),
				ref: "input"
			}, unref(ariaAttributes), {
				type: "checkbox",
				checked: __props.modelValue,
				disabled: _ctx.disabled || _ctx.readonly,
				tabindex: unref(tabIndex),
				onChange: handleChange
			}), null, 16, _hoisted_1$23), _cache[2] || (_cache[2] = createElementVNode("span", null, null, -1))]), renderSlot(_ctx.$slots, "default")], 6)]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				id: unref(messageId),
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, [
				"id",
				"text",
				"severity"
			])) : createCommentVNode("", true)], 2);
		};
	}
});
// src/components/DynamicCheckbox/DynamicCheckbox.vue
var DynamicCheckbox_default = /* @__PURE__ */ defineComponent({
	__name: "DynamicCheckbox",
	props: /*@__PURE__*/ mergeModels({
		...inputProps,
		trueLabel: {
			type: String,
			default: "Yes"
		},
		falseLabel: {
			type: String,
			default: "No"
		},
		nullLabel: {
			type: String,
			default: "Undefined"
		},
		displayMode: {
			type: String,
			default: "switch"
		}
	}, {
		"modelValue": {
			type: [Boolean, null],
			default: null
		},
		"modelModifiers": {},
		"focused": {
			type: Boolean,
			default: void 0
		},
		"focusedModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([...inputEmits], ["update:modelValue", "update:focused"]),
	setup(__props) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const focused = useModel(__props, "focused");
		const { translate } = useGlobalResourceManager();
		const radioGroupValues = computed(() => {
			const values = [{
				value: true,
				label: translate(props.trueLabel)
			}, {
				value: false,
				label: translate(props.falseLabel)
			}];
			if (!props.required) values.push({
				value: null,
				label: translate(props.nullLabel)
			});
			return values;
		});
		const radioGroupOrientation = computed(() => props.displayMode === "vertical-radio" ? "vertical" : void 0);
		return (_ctx, _cache) => {
			return _ctx.required && __props.displayMode === "switch" ? (openBlock(), createBlock(Switch_default, {
				key: 0,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "checkbox",
				onAiApply: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion"
			])) : _ctx.required && __props.displayMode === "checkbox" ? (openBlock(), createBlock(Checkbox_default, {
				key: 1,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[5] || (_cache[5] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "checkbox",
				onAiApply: _cache[6] || (_cache[6] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[7] || (_cache[7] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion"
			])) : (openBlock(), createBlock(RadioGroup_default, {
				key: 2,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[9] || (_cache[9] = ($event) => focused.value = $event),
				class: "checkbox",
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				values: radioGroupValues.value,
				"value-property": "value",
				"display-property": "label",
				orientation: radioGroupOrientation.value,
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[10] || (_cache[10] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[11] || (_cache[11] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"values",
				"orientation",
				"ai-suggestion"
			]));
		};
	}
});
// src/components/SelectButton/SelectButton.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$22 = { class: "select-button-item-content" };
// src/components/SelectButton/SelectButton.vue
var SelectButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SelectButton",
	props: /*@__PURE__*/ mergeModels({
		...inputProps,
		...contentProps,
		values: {
			type: Array,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		}
	}, {
		"modelValue": {
			type: [
				String,
				Boolean,
				Number,
				Date,
				Object,
				null
			],
			default: null
		},
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([...inputEmits], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const contentStyleObject = useContentStyle(props);
		const emit = __emit;
		const localizator = useLocalizator();
		const { input, id, classes, ariaAttributes, isLabelVisible, isMessageVisible, messageId, tabIndex } = useInput(props, emit, { focusWithin: true });
		const itemAttributes = computed(() => ({
			"aria-invalid": ariaAttributes.value["aria-invalid"],
			"aria-describedby": ariaAttributes.value["aria-describedby"]
		}));
		const modelValue = useModel(__props, "modelValue");
		/**
		* Value of the toggle group.
		* Reka compares the values of the items with the selected one by deep equality.
		* The selection is never left undefined, otherwise Reka would keep its own uncontrolled state.
		* Reka gives undefined when the selected item is pressed again: the selection is then cleared,
		* unless a value is required.
		*/
		const selectedValue = computed({
			get: () => modelValue.value,
			set: (value) => {
				if (value !== void 0) modelValue.value = value;
				else if (!props.required) modelValue.value = null;
			}
		});
		function getOptionValue(option) {
			return props.valueProperty ? getPropertyByPath(option, props.valueProperty) : option;
		}
		function getOptionLabel(option) {
			if (!props.displayProperty) return option;
			const displayPropertyValue = getPropertyByPath(option, props.displayProperty);
			if (displayPropertyValue == null) return "";
			if (typeof displayPropertyValue !== "object" || displayPropertyValue instanceof Date) return displayPropertyValue.toString();
			return localizator.translate(displayPropertyValue) ?? "";
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["select-button neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(unref(ToggleGroupRoot), {
				id: unref(id),
				ref: (el) => input.value = el,
				"aria-label": _ctx.label,
				type: "single",
				class: normalizeClass(["neos-input-content select-button-group", _ctx.contentClass]),
				style: normalizeStyle(unref(contentStyleObject)),
				modelValue: selectedValue.value,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => selectedValue.value = $event),
				disabled: _ctx.disabled || _ctx.readonly,
				"roving-focus": _ctx.tabStop
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.values, (option, index) => {
					return openBlock(), createBlock(unref(ToggleGroupItem), mergeProps({ key: index }, { ref_for: true }, itemAttributes.value, {
						class: "select-button-item",
						value: getOptionValue(option),
						tabindex: unref(tabIndex)
					}), {
						default: withCtx(() => [createElementVNode("span", _hoisted_1$22, toDisplayString(getOptionLabel(option)), 1)]),
						_: 2
					}, 1040, ["value", "tabindex"]);
				}), 128))]),
				_: 1
			}, 8, [
				"id",
				"aria-label",
				"class",
				"style",
				"modelValue",
				"disabled",
				"roving-focus"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				id: unref(messageId),
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, [
				"id",
				"text",
				"severity"
			])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-60378304"]]);
// src/components/DynamicCombobox/DynamicCombobox.vue
var DynamicCombobox_default = /* @__PURE__ */ defineComponent({
	__name: "DynamicCombobox",
	props: /*@__PURE__*/ mergeModels({
		...inputProps,
		values: {
			type: Array,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		displayMode: {
			type: String,
			default: "list"
		}
	}, {
		"modelValue": {
			type: [
				String,
				Boolean,
				Number,
				Date,
				Object,
				null
			],
			default: null
		},
		"modelModifiers": {},
		"invalidValue": { default: void 0 },
		"invalidValueModifiers": {},
		"focused": {
			type: Boolean,
			default: void 0
		},
		"focusedModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([...inputEmits], [
		"update:modelValue",
		"update:invalidValue",
		"update:focused"
	]),
	setup(__props) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const invalidValue = useModel(__props, "invalidValue");
		const focused = useModel(__props, "focused");
		const radioGroupOrientation = computed(() => props.displayMode === "vertical-radio" ? "vertical" : void 0);
		return (_ctx, _cache) => {
			return __props.displayMode === "list" || _ctx.inputDisplayMode === "datagrid" ? (openBlock(), createBlock(Combobox_default, {
				key: 0,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => modelValue.value = $event),
				"invalid-value": invalidValue.value,
				"onUpdate:invalidValue": _cache[1] || (_cache[1] = ($event) => invalidValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[2] || (_cache[2] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				required: _ctx.required,
				readonly: _ctx.readonly,
				disabled: _ctx.disabled,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				placeholder: _ctx.placeholder,
				"tab-stop": _ctx.tabStop,
				"input-display-mode": _ctx.inputDisplayMode,
				values: __props.values,
				"value-property": __props.valueProperty,
				"display-property": __props.displayProperty,
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiCancel"))
			}, createSlots({ _: 2 }, [_ctx.$slots.value ? {
				name: "value",
				fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "value", { option })]),
				key: "0"
			} : void 0, _ctx.$slots.option ? {
				name: "option",
				fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "option", { option })]),
				key: "1"
			} : void 0]), 1032, [
				"modelValue",
				"invalid-value",
				"focused",
				"label",
				"label-position",
				"required",
				"readonly",
				"disabled",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"placeholder",
				"tab-stop",
				"input-display-mode",
				"values",
				"value-property",
				"display-property",
				"ai-suggestion"
			])) : __props.displayMode === "select-button" ? (openBlock(), createBlock(SelectButton_default, {
				key: 1,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[6] || (_cache[6] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				required: _ctx.required,
				readonly: _ctx.readonly,
				disabled: _ctx.disabled,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				placeholder: _ctx.placeholder,
				"tab-stop": _ctx.tabStop,
				"input-display-mode": _ctx.inputDisplayMode,
				values: __props.values,
				"value-property": __props.valueProperty,
				"display-property": __props.displayProperty,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "combobox",
				onAiApply: _cache[7] || (_cache[7] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[8] || (_cache[8] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"required",
				"readonly",
				"disabled",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"placeholder",
				"tab-stop",
				"input-display-mode",
				"values",
				"value-property",
				"display-property",
				"ai-suggestion"
			])) : (openBlock(), createBlock(RadioGroup_default, {
				key: 2,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[10] || (_cache[10] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				required: _ctx.required,
				readonly: _ctx.readonly,
				disabled: _ctx.disabled,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				placeholder: _ctx.placeholder,
				"tab-stop": _ctx.tabStop,
				"input-display-mode": _ctx.inputDisplayMode,
				values: __props.values,
				"value-property": __props.valueProperty,
				"display-property": __props.displayProperty,
				orientation: radioGroupOrientation.value,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "combobox",
				onAiApply: _cache[11] || (_cache[11] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[12] || (_cache[12] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"required",
				"readonly",
				"disabled",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"placeholder",
				"tab-stop",
				"input-display-mode",
				"values",
				"value-property",
				"display-property",
				"orientation",
				"ai-suggestion"
			]));
		};
	}
});
// src/components/GridLayout/GridLayout.ts?vue&type=script&src=true&lang.ts
var logger = new ConsoleLogger({ name: "GridLayout" });
function convertStyleAbstraction(abstractValue) {
	const starRegex = /(?:^| )((\d*)\*)/g;
	let starMatch;
	do {
		starMatch = starRegex.exec(abstractValue);
		if (starMatch != null) {
			const valueToReplace = starMatch[1];
			let value = starMatch[2];
			if (value == null || value === "") value = "1";
			abstractValue = abstractValue.replace(valueToReplace, `minmax(0, ${value}fr)`);
		}
	} while (starMatch != null);
	abstractValue = abstractValue.replaceAll("fit", "max-content").replaceAll(/(\d)(\s|$)/g, "$1px$2");
	return abstractValue;
}
var BREAKPOINT_ORDER = [
	"small",
	"medium",
	"large",
	"extralarge",
	"extraextralarge"
];
function isValidThresholds(thresholds) {
	const values = BREAKPOINT_ORDER.map((breakpoint) => thresholds[breakpoint]);
	const areAllValidNumbers = values.every((value) => Number.isFinite(value) && value >= 0);
	const isStrictlyIncreasing = values.every((value, index) => index === 0 || value > values[index - 1]);
	return areAllValidNumbers && isStrictlyIncreasing;
}
function resolveThresholds(props) {
	const thresholds = {
		small: props.thresholdSmall ?? BreakpointValues.small,
		medium: props.thresholdMedium ?? BreakpointValues.medium,
		large: props.thresholdLarge ?? BreakpointValues.large,
		extralarge: props.thresholdExtralarge ?? BreakpointValues.extralarge,
		extraextralarge: props.thresholdExtraextralarge ?? BreakpointValues.extraextralarge
	};
	if (!isValidThresholds(thresholds)) {
		logger.warn(`Invalid custom breakpoint thresholds (expected non-negative, strictly increasing values for small/medium/large/extralarge/extraextralarge, got ${JSON.stringify(thresholds)}). Falling back to default breakpoints.`);
		return { ...BreakpointValues };
	}
	return thresholds;
}
function resolveBreakpointClass(width, thresholds) {
	if (width >= thresholds.extraextralarge) return "neos-grid-layout--bp-extraextralarge";
	if (width >= thresholds.extralarge) return "neos-grid-layout--bp-extralarge";
	if (width >= thresholds.large) return "neos-grid-layout--bp-large";
	if (width >= thresholds.medium) return "neos-grid-layout--bp-medium";
	if (width >= thresholds.small) return "neos-grid-layout--bp-small";
	return "neos-grid-layout--bp-base";
}
var GridLayout_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "GridLayout",
	props: {
		rows: {
			type: String,
			default: ""
		},
		rowsSmall: {
			type: String,
			default: ""
		},
		rowsMedium: {
			type: String,
			default: ""
		},
		rowsLarge: {
			type: String,
			default: ""
		},
		rowsExtralarge: {
			type: String,
			default: ""
		},
		rowsExtraextralarge: {
			type: String,
			default: ""
		},
		columns: {
			type: String,
			default: ""
		},
		columnsSmall: {
			type: String,
			default: ""
		},
		columnsMedium: {
			type: String,
			default: ""
		},
		columnsLarge: {
			type: String,
			default: ""
		},
		columnsExtralarge: {
			type: String,
			default: ""
		},
		columnsExtraextralarge: {
			type: String,
			default: ""
		},
		rowsAuto: {
			type: String,
			default: ""
		},
		rowsAutoSmall: {
			type: String,
			default: ""
		},
		rowsAutoMedium: {
			type: String,
			default: ""
		},
		rowsAutoLarge: {
			type: String,
			default: ""
		},
		rowsAutoExtralarge: {
			type: String,
			default: ""
		},
		rowsAutoExtraextralarge: {
			type: String,
			default: ""
		},
		gap: {
			type: String,
			default: ""
		},
		gapSmall: {
			type: String,
			default: ""
		},
		gapMedium: {
			type: String,
			default: ""
		},
		gapLarge: {
			type: String,
			default: ""
		},
		gapExtralarge: {
			type: String,
			default: ""
		},
		gapExtraextralarge: {
			type: String,
			default: ""
		},
		breakpointScope: {
			type: String,
			default: "window"
		},
		thresholdSmall: {
			type: Number,
			default: void 0
		},
		thresholdMedium: {
			type: Number,
			default: void 0
		},
		thresholdLarge: {
			type: Number,
			default: void 0
		},
		thresholdExtralarge: {
			type: Number,
			default: void 0
		},
		thresholdExtraextralarge: {
			type: Number,
			default: void 0
		}
	},
	setup(props) {
		const style = {
			"--grid-layout-rows": convertStyleAbstraction(props.rows),
			"--grid-layout-columns": convertStyleAbstraction(props.columns),
			"--grid-layout-rows-auto": convertStyleAbstraction(props.rowsAuto),
			"--grid-layout-gap": SpaceValues[props.gap] || ""
		};
		style["--grid-layout-rows-small"] = convertStyleAbstraction(props.rowsSmall);
		style["--grid-layout-rows-medium"] = convertStyleAbstraction(props.rowsMedium);
		style["--grid-layout-rows-large"] = convertStyleAbstraction(props.rowsLarge);
		style["--grid-layout-rows-extralarge"] = convertStyleAbstraction(props.rowsExtralarge);
		style["--grid-layout-rows-extraextralarge"] = convertStyleAbstraction(props.rowsExtraextralarge);
		style["--grid-layout-columns-small"] = convertStyleAbstraction(props.columnsSmall);
		style["--grid-layout-columns-medium"] = convertStyleAbstraction(props.columnsMedium);
		style["--grid-layout-columns-large"] = convertStyleAbstraction(props.columnsLarge);
		style["--grid-layout-columns-extralarge"] = convertStyleAbstraction(props.columnsExtralarge);
		style["--grid-layout-columns-extraextralarge"] = convertStyleAbstraction(props.columnsExtraextralarge);
		style["--grid-layout-rows-auto-small"] = convertStyleAbstraction(props.rowsAutoSmall);
		style["--grid-layout-rows-auto-medium"] = convertStyleAbstraction(props.rowsAutoMedium);
		style["--grid-layout-rows-auto-large"] = convertStyleAbstraction(props.rowsAutoLarge);
		style["--grid-layout-rows-auto-extralarge"] = convertStyleAbstraction(props.rowsAutoExtralarge);
		style["--grid-layout-rows-auto-extraextralarge"] = convertStyleAbstraction(props.rowsAutoExtraextralarge);
		style["--grid-layout-gap-small"] = SpaceValues[props.gapSmall] || "";
		style["--grid-layout-gap-medium"] = SpaceValues[props.gapMedium] || "";
		style["--grid-layout-gap-large"] = SpaceValues[props.gapLarge] || "";
		style["--grid-layout-gap-extralarge"] = SpaceValues[props.gapExtralarge] || "";
		style["--grid-layout-gap-extraextralarge"] = SpaceValues[props.gapExtraextralarge] || "";
		const gridEl = ref();
		const isContainerScope = props.breakpointScope === "container";
		const hasCustomThresholds = [
			props.thresholdSmall,
			props.thresholdMedium,
			props.thresholdLarge,
			props.thresholdExtralarge,
			props.thresholdExtraextralarge
		].some((value) => value != null);
		const isDynamic = isContainerScope || hasCustomThresholds;
		function useTrackedWidth() {
			if (!isDynamic) return ref(0);
			return isContainerScope ? useElementSize(gridEl).width : useWindowSize().width;
		}
		const width = useTrackedWidth();
		const thresholds = computed(() => isDynamic ? resolveThresholds(props) : void 0);
		const breakpointClass = computed(() => thresholds.value ? resolveBreakpointClass(width.value, thresholds.value) : void 0);
		useComponentAutomationProperties();
		return {
			style,
			gridEl,
			breakpointClass
		};
	}
});
// src/components/GridLayout/GridLayout.vue
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		ref: "gridEl",
		class: normalizeClass(["neos-grid-layout", _ctx.breakpointClass]),
		style: normalizeStyle(_ctx.style)
	}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 6);
}
var GridLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(GridLayout_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$6], ["__scopeId", "data-v-e5241b52"]]);
// src/components/GroupBox/GroupBox.vue
var GroupBox_default = /* @__PURE__ */ defineComponent({
	__name: "GroupBox",
	props: /*@__PURE__*/ mergeModels({
		expandable: { type: Boolean },
		headerPadding: {},
		contentPadding: {}
	}, {
		"expanded": {
			type: Boolean,
			default: true
		},
		"expandedModifiers": {}
	}),
	emits: ["update:expanded"],
	setup(__props) {
		const props = __props;
		const expanded = useModel(__props, "expanded");
		useComponentAutomationProperties();
		const { translate } = useGlobalResourceManager();
		const headerStyle = computed(() => props.headerPadding ? { padding: SpaceValues[props.headerPadding] } : void 0);
		const contentStyle = computed(() => props.contentPadding ? { padding: SpaceValues[props.contentPadding] } : void 0);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(CollapsibleRoot), {
				open: expanded.value,
				"onUpdate:open": _cache[0] || (_cache[0] = ($event) => expanded.value = $event),
				class: normalizeClass(["group-box", { "group-box-expandable": __props.expandable }]),
				"unmount-on-hide": false
			}, {
				default: withCtx(() => [_ctx.$slots.header || __props.expandable ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "group-box-header neos-horizontal-content",
					style: normalizeStyle(headerStyle.value)
				}, [renderSlot(_ctx.$slots, "header"), __props.expandable ? (openBlock(), createBlock(unref(CollapsibleTrigger), {
					key: 0,
					class: "group-box-toggle-button",
					"aria-label": unref(translate)("GroupBoxToggle")
				}, {
					default: withCtx(() => [createVNode(Image_default, {
						class: normalizeClass(["group-box-toggle-button-icon", { collapsed: !expanded.value }]),
						name: "chevronUp"
					}, null, 8, ["class"])]),
					_: 1
				}, 8, ["aria-label"])) : createCommentVNode("", true)], 4)) : createCommentVNode("", true), createVNode(unref(CollapsibleContent), {
					class: "group-box-content-container",
					onPointerdownCapture: unref(ignoreInteractionWhileClosing),
					onClickCapture: unref(ignoreInteractionWhileClosing)
				}, {
					default: withCtx(() => [createElementVNode("div", {
						class: "group-box-content neos-vertical-content",
						style: normalizeStyle(contentStyle.value)
					}, [renderSlot(_ctx.$slots, "content")], 4)]),
					_: 3
				}, 8, ["onPointerdownCapture", "onClickCapture"])]),
				_: 3
			}, 8, ["open", "class"]);
		};
	}
});
// src/components/Heading/Heading.vue
var Heading_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Heading",
	props: {
		level: { default: 1 },
		maxLines: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		useComponentAutomationProperties();
		const { classes, styles } = useTextMaxLines(props);
		const tag = computed(() => `h${props.level}`);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(resolveDynamicComponent(tag.value), {
				class: normalizeClass(["heading", unref(classes)]),
				style: normalizeStyle(unref(styles))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_: 3
			}, 8, ["class", "style"]);
		};
	}
}), [["__scopeId", "data-v-dce8b0d5"]]);
// src/components/HtmlViewer/HtmlViewer.ts?vue&type=script&src=true&lang.ts
var HtmlViewer_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "HtmlViewer",
	props: {
		html: {
			type: String,
			required: true
		},
		css: {
			type: String,
			default: void 0
		}
	},
	setup(props) {
		let styleElement;
		function _removeStyleElement() {
			if (styleElement) {
				styleElement.remove();
				styleElement = void 0;
			}
		}
		const purifiedHtml = computed(() => DOMPurify.sanitize(`<html><body>${props.html}</body></html>`));
		watch(() => props.css, (css) => {
			if (css) {
				styleElement = document.createElement("style");
				styleElement.innerHTML = css;
				document.head.append(styleElement);
			} else _removeStyleElement();
		}, { immediate: true });
		onUnmounted(() => _removeStyleElement());
		return { purifiedHtml };
	}
});
// src/components/HtmlViewer/HtmlViewer.vue
var _hoisted_1$21 = ["innerHTML"];
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: "html-viewer",
		innerHTML: _ctx.purifiedHtml
	}, null, 8, _hoisted_1$21);
}
var HtmlViewer_default = /*#__PURE__*/ _plugin_vue_export_helper_default(HtmlViewer_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$5]]);
// src/components/Textbox/getTextboxInput.ts
/**
* Gets the input of a textbox through its own reference: a query on its element could return an
* input given in its before slot instead.
*/
function getTextboxInput(textbox) {
	return textbox.input;
}
// src/composables/useSpeech.ts
function useSpeech(props, culture, handleChange) {
	const speech = useSpeechRecognition({ lang: culture });
	/**
	* Indicates whether speech recognition is supported in the current browser and the speech button should be displayed.
	*/
	const displaySpeechButton = computed(() => props.speech && speech.isSupported.value);
	/**
	* Indicates whether the speech recognition is currently listening.
	*/
	const isListeningToSpeech = computed(() => speech.isListening.value);
	/**
	* Variant to apply to the speech button.
	*/
	const speechButtonVariant = computed(() => speech.isListening.value ? "ghost-primary" : "ghost");
	/**
	* The text that corresponds to the speech recognition result.
	*/
	const currentSpeech = ref(null);
	onMounted(() => {
		if (props.speech === "immediate") handleSpeechButtonClick();
	});
	watch([speech.result, speech.isFinal], ([result, isFinal]) => {
		currentSpeech.value = result;
		if (isFinal) {
			persistSpeech();
			speech.isListening.value = false;
		}
	});
	/**
	* Handles the click event of the speech button.
	* If speech recognition is already listening, it persists the current speech.
	*/
	function handleSpeechButtonClick() {
		if (speech.isListening.value) persistSpeech();
		speech.isListening.value = !speech.isListening.value;
	}
	function persistSpeech() {
		if (handleChange && currentSpeech.value !== null) handleChange(currentSpeech.value);
		currentSpeech.value = null;
	}
	return {
		currentSpeech,
		displaySpeechButton,
		handleSpeechButtonClick,
		isListeningToSpeech,
		speechButtonVariant
	};
}
/**
* Indicates whether the browser supports speech recognition.
* @returns true wen the browser supports speech recognition; otherwise false.
*/
function isSpeechSupported() {
	const w = window;
	return (w.SpeechRecognition ?? w.webkitSpeechRecognition) !== void 0;
}
// src/composables/useStringInput.ts
function useStringInput() {
	function normalizeWhiteSpaceInput(whiteSpaceHandling, inputText) {
		switch (whiteSpaceHandling) {
			case WhiteSpaceHandling.noLeadingAndTrailingWhiteSpace:
			case WhiteSpaceHandling.noLeadingWhiteSpace: return inputText.trimStart();
			case WhiteSpaceHandling.noTrailingWhiteSpace: return inputText.trimEnd();
			case WhiteSpaceHandling.noWhiteSpace: return inputText.replaceAll(/\s/g, "");
		}
		return inputText;
	}
	/**
	* Normalizes a text as the textbox does at each input: its character casing then its white space.
	* @param characterCasing - The character casing.
	* @param whiteSpaceHandling - The white space handling.
	* @param inputText - The text.
	* @returns The normalized text.
	*/
	function normalizeTypedText(characterCasing, whiteSpaceHandling, inputText) {
		let text = inputText;
		switch (characterCasing) {
			case CharacterCasing.upperCasing:
				text = text.toUpperCase();
				break;
			case CharacterCasing.lowerCasing: text = text.toLocaleLowerCase();
		}
		return normalizeWhiteSpaceInput(whiteSpaceHandling, text);
	}
	function normalizeWhiteSpaceToEmit(whiteSpaceHandling, inputText) {
		if (whiteSpaceHandling === WhiteSpaceHandling.noLeadingAndTrailingWhiteSpace) return inputText.trim();
		return inputText;
	}
	return {
		normalizeTypedText,
		normalizeWhiteSpaceInput,
		normalizeWhiteSpaceToEmit
	};
}
// src/utils/focus.ts
function focusExceptOnTouchDevice(element) {
	if (element && !supportsTouch()) element.focus();
}
// src/components/Textbox/Textbox.ts?vue&type=script&src=true&lang.ts
var datagridMinRows = 1;
var datagridMaxRows = 10;
/**
* The properties that the text area inherits only when the content style sets them (see Textbox.css).
*/
var textareaInheritedProperties = [
	"text-align",
	"overflow-wrap",
	"cursor"
];
var Textbox_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Textbox",
	components: {
		Button: Button_default,
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		Image: Image_default
	},
	props: {
		...inputProps,
		...contentProps,
		modelValue: {
			type: String,
			default: null
		},
		updateMode: {
			type: String,
			default: "default"
		},
		maxLength: {
			type: Number,
			default: void 0
		},
		multiLines: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: "text"
		},
		rows: {
			type: Number,
			default: 10
		},
		tooltip: {
			type: String,
			default: void 0
		},
		clear: {
			type: Boolean,
			default: false
		},
		speech: {
			type: [Boolean, String],
			default: false
		},
		characterCasing: {
			type: String,
			default: void 0
		},
		whiteSpaceHandling: {
			type: String,
			default: void 0
		}
	},
	emits: [
		...inputEmits,
		"input",
		"listeningToSpeech",
		"keydown"
	],
	setup(props, { emit }) {
		const contentStyleObject = useContentStyle(props);
		const contentInheritanceClasses = computed(() => textareaInheritedProperties.filter((property) => isStyleSet(contentStyleObject.value, property)).map((property) => `textbox-content-${property}`));
		const { input, id, classes, ariaAttributes, isLabelVisible, isMessageVisible, messageId, tabIndex } = useInput(props, emit);
		const { currentSpeech, displaySpeechButton, handleSpeechButtonClick, isListeningToSpeech, speechButtonVariant } = useSpeech(props, useLocalizator().currentCulture, emitNewValue);
		const { translate } = useGlobalResourceManager();
		const localValue = ref(props.modelValue ?? "");
		const isInputEmpty = ref(localValue.value.length === 0);
		watch(() => props.modelValue, (newVal) => {
			localValue.value = newVal ?? "";
			isInputEmpty.value = localValue.value.length === 0;
		});
		watch(currentSpeech, (speech) => {
			if (speech != null) {
				localValue.value = speech;
				isInputEmpty.value = localValue.value.length === 0;
			}
		});
		const hasSuggestionPlaceholder = computed(() => props.type !== "password" && isInputEmpty.value && props.aiSuggestion?.suggestedValue != null);
		const suggestionPlaceholderText = computed(() => String(props.aiSuggestion.suggestedValue));
		const placeholderText = computed(() => {
			if (hasSuggestionPlaceholder.value) return;
			return props.placeholder ?? (isListeningToSpeech.value ? translate("ListeningToSpeech") : void 0);
		});
		const text = computed(() => localValue.value);
		const textareaRows = ref();
		const { normalizeTypedText, normalizeWhiteSpaceToEmit } = useStringInput();
		watch(() => props.rows, () => {
			if (props.inputDisplayMode === "form" && props.multiLines) textareaRows.value = props.rows;
		});
		watch(isListeningToSpeech, (value) => emit("listeningToSpeech", value));
		onMounted(() => {
			if (props.multiLines) {
				if (props.inputDisplayMode === "datagrid") {
					if (props.modelValue) textareaRows.value = Math.min(Math.max(props.modelValue.split(`\n`).length, datagridMinRows), datagridMaxRows);
					else textareaRows.value = datagridMinRows;
				} else textareaRows.value = props.rows;
			}
		});
		function handleFocus(event) {
			event.target.select();
		}
		function handleBeforeAfterContentFocusin() {
			focusExceptOnTouchDevice(input.value);
		}
		function handleChange(event) {
			const element = event.target;
			emitNewValue(element.value);
		}
		function handleInput(event) {
			const element = event.target;
			isInputEmpty.value = !element.value;
			if (props.updateMode === "immediate") {
				localValue.value = element.value;
				isInputEmpty.value = localValue.value.length === 0;
				if (element.value != props.modelValue) emit("update:modelValue", element.value !== "" ? element.value : null);
				emit("input", event);
				return;
			}
			if (element.value) {
				const value = normalizeTypedText(props.characterCasing, props.whiteSpaceHandling, element.value);
				if (value !== element.value) {
					const { selectionStart, selectionEnd } = element;
					element.value = value;
					element.setSelectionRange(selectionStart, selectionEnd);
				}
			}
			localValue.value = element.value;
			emit("input", event);
		}
		function handleKeyDown(event) {
			if (hasSuggestionPlaceholder.value) {
				if (event.key === "Tab" && !event.shiftKey && !event.ctrlKey && !event.altKey) {
					event.preventDefault();
					event.stopPropagation();
					emit("aiApply");
					return;
				}
				if (event.key === "Escape") {
					event.preventDefault();
					event.stopPropagation();
					emit("aiCancel");
					return;
				}
			}
			if (props.inputDisplayMode === "datagrid" && props.multiLines) keyDown(event);
			emit("keydown", event);
		}
		function handleClearButtonClick() {
			emitNewValue(null);
			isInputEmpty.value = true;
			localValue.value = "";
		}
		function emitNewValue(value) {
			value = value !== "" ? value : null;
			const oldValue = props.modelValue;
			if (value) {
				switch (props.characterCasing) {
					case CharacterCasing.camelCasing:
						value = toCamelCase(value, true);
						break;
					case CharacterCasing.pascalCasing: value = toPascalCase(value);
				}
				value = normalizeWhiteSpaceToEmit(props.whiteSpaceHandling, value);
			}
			if (value != oldValue) emit("update:modelValue", value);
			if (value && (input.value instanceof HTMLInputElement || input.value instanceof HTMLTextAreaElement) && shouldResetInputValue(value, oldValue)) input.value.value = value;
			localValue.value = value ?? "";
			isInputEmpty.value = localValue.value.length === 0;
		}
		function keyDown(event) {
			switch (event.key) {
				case "Enter":
					if (event.altKey && !event.ctrlKey && !event.shiftKey) {
						const textarea = event.target;
						let cursorPos = textarea.selectionEnd;
						let value = textarea.value;
						value = `${value.substring(0, cursorPos)}\n${value.substring(cursorPos)}`;
						textarea.value = value;
						cursorPos += 1;
						textarea.setSelectionRange(cursorPos, cursorPos);
						if (cursorPos === value.length) textarea.scrollTop = textarea.scrollHeight;
						event.stopPropagation();
					}
					break;
				case "ArrowUp":
				case "ArrowDown": if (!event.altKey && !event.ctrlKey && !event.shiftKey) event.stopPropagation();
			}
		}
		function shouldResetInputValue(newValue, oldValue) {
			return props.inputDisplayMode === "form" && newValue === oldValue;
		}
		return {
			contentInheritanceClasses,
			contentStyleObject,
			aiSuggestion: computed(() => props.aiSuggestion),
			classes,
			displaySpeechButton,
			handleBeforeAfterContentFocusin,
			handleChange,
			handleClearButtonClick,
			handleFocus,
			handleInput,
			handleKeyDown,
			handleSpeechButtonClick,
			hasSuggestionPlaceholder,
			id,
			input,
			ariaAttributes,
			isLabelVisible,
			isMessageVisible,
			messageId,
			placeholderText,
			speechButtonVariant,
			suggestionPlaceholderText,
			tabIndex,
			text,
			textareaRows
		};
	}
});
/**
* Whether a style object sets a property, written in kebab case or in camel case.
*
* @param style - The style object.
* @param property - The property name, in kebab case.
*/
function isStyleSet(style, property) {
	const value = style[property] ?? style[camelize(property)];
	return value != null && value !== "";
}
// src/components/Textbox/Textbox.vue
var _hoisted_1$20 = ["title"];
var _hoisted_2$11 = {
	key: 1,
	class: "textbox-suggestion-placeholder"
};
var _hoisted_3$5 = { class: "textbox-suggestion-text" };
var _hoisted_4$3 = [
	"id",
	"value",
	"disabled",
	"rows",
	"maxlength",
	"readonly",
	"tabindex",
	"placeholder"
];
var _hoisted_5$2 = [
	"id",
	"type",
	"value",
	"tabindex",
	"placeholder",
	"maxlength",
	"disabled",
	"readonly"
];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_Image = resolveComponent("Image");
	const _component_Button = resolveComponent("Button");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["textbox neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createElementVNode("div", {
		class: normalizeClass(["textbox-content neos-input-content", [_ctx.contentClass, _ctx.contentInheritanceClasses]]),
		style: normalizeStyle(_ctx.contentStyleObject),
		title: _ctx.tooltip ?? void 0
	}, [
		_ctx.$slots.before ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: "textbox-before-content",
			onFocusin: _cache[2] || (_cache[2] = (...args) => _ctx.handleBeforeAfterContentFocusin && _ctx.handleBeforeAfterContentFocusin(...args))
		}, [renderSlot(_ctx.$slots, "before", {}, void 0, true)], 32)) : createCommentVNode("", true),
		_ctx.hasSuggestionPlaceholder ? (openBlock(), createElementBlock("div", _hoisted_2$11, [createVNode(_component_Image, {
			class: "textbox-suggestion-icon",
			name: "ai"
		}), createElementVNode("span", _hoisted_3$5, toDisplayString(_ctx.suggestionPlaceholderText), 1)])) : createCommentVNode("", true),
		_ctx.multiLines ? (openBlock(), createElementBlock("textarea", mergeProps({
			key: 2,
			id: _ctx.id,
			ref: "input"
		}, _ctx.ariaAttributes, {
			value: _ctx.text,
			disabled: _ctx.disabled,
			rows: _ctx.textareaRows,
			maxlength: _ctx.maxLength,
			readonly: _ctx.readonly,
			class: "textbox-textarea",
			tabindex: _ctx.tabIndex,
			placeholder: _ctx.placeholderText,
			spellcheck: "false",
			autocomplete: "nope",
			onChange: _cache[3] || (_cache[3] = (...args) => _ctx.handleChange && _ctx.handleChange(...args)),
			onInput: _cache[4] || (_cache[4] = (...args) => _ctx.handleInput && _ctx.handleInput(...args)),
			onKeydown: _cache[5] || (_cache[5] = (...args) => _ctx.handleKeyDown && _ctx.handleKeyDown(...args))
		}), "        ", 16, _hoisted_4$3)) : (openBlock(), createElementBlock("input", mergeProps({
			key: 3,
			id: _ctx.id,
			ref: "input"
		}, _ctx.ariaAttributes, {
			type: _ctx.type,
			value: _ctx.text,
			class: "textbox-input",
			tabindex: _ctx.tabIndex,
			placeholder: _ctx.placeholderText,
			maxlength: _ctx.maxLength,
			disabled: _ctx.disabled,
			readonly: _ctx.readonly,
			spellcheck: "false",
			autocomplete: "nope",
			onChange: _cache[6] || (_cache[6] = (...args) => _ctx.handleChange && _ctx.handleChange(...args)),
			onInput: _cache[7] || (_cache[7] = (...args) => _ctx.handleInput && _ctx.handleInput(...args)),
			onFocus: _cache[8] || (_cache[8] = (...args) => _ctx.handleFocus && _ctx.handleFocus(...args)),
			onKeydown: _cache[9] || (_cache[9] = (...args) => _ctx.handleKeyDown && _ctx.handleKeyDown(...args))
		}), null, 16, _hoisted_5$2)),
		_ctx.$slots.default || _ctx.clear || _ctx.displaySpeechButton ? (openBlock(), createElementBlock("div", {
			key: 4,
			class: "textbox-after-content",
			onFocusin: _cache[12] || (_cache[12] = (...args) => _ctx.handleBeforeAfterContentFocusin && _ctx.handleBeforeAfterContentFocusin(...args))
		}, [
			renderSlot(_ctx.$slots, "default", {}, void 0, true),
			_ctx.displaySpeechButton ? (openBlock(), createBlock(_component_Button, {
				key: 0,
				class: "input-speech-button",
				size: "small",
				variant: _ctx.speechButtonVariant,
				icon: "microphone",
				tabindex: "-1",
				onClick: _cache[10] || (_cache[10] = ($event) => _ctx.handleSpeechButtonClick())
			}, null, 8, ["variant"])) : createCommentVNode("", true),
			_ctx.clear ? withDirectives((openBlock(), createBlock(_component_Button, {
				key: 1,
				class: "input-clear-button",
				size: "small",
				variant: "ghost",
				icon: "erase",
				tabindex: "-1",
				onClick: _cache[11] || (_cache[11] = ($event) => _ctx.handleClearButtonClick())
			}, null, 512)), [[vShow, _ctx.modelValue]]) : createCommentVNode("", true)
		], 32)) : createCommentVNode("", true)
	], 14, _hoisted_1$20)]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		id: _ctx.messageId,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, [
		"id",
		"text",
		"severity"
	])) : createCommentVNode("", true)], 2);
}
var Textbox_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Textbox_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$4], ["__scopeId", "data-v-611bfdfb"]]);
// src/components/InputColor/pickerColor.ts
var defaultPickerColor = "#000000";
var colorContext;
/**
* Values that depend on where they are used, such as var() or currentColor, are rejected like in
* the former Wijmo input, since the picker cannot display them.
*/
function isCssColor(value) {
	return isValidColor(value) || resolveCssColor(value) !== void 0;
}
/**
* The HSB space keeps the hue when the saturation or the brightness goes down to zero
*/
function toPickerColor(value) {
	return convertToHsb(parseColor(toParsableColor(value)));
}
/**
* Same format as the former Wijmo input, so that the stored values stay consistent
*/
function toFieldValue(color) {
	const { r, g, b, alpha } = convertToRgb(color);
	const red = Math.round(r);
	const green = Math.round(g);
	const blue = Math.round(b);
	const percentAlpha = Math.round(alpha * 100);
	if (percentAlpha > 99) return `#${[
		red,
		green,
		blue
	].map((channel) => channel.toString(16).padStart(2, "0")).join("")}`;
	return `rgba(${red},${green},${blue},${percentAlpha / 100})`;
}
function toParsableColor(value) {
	if (!value) return defaultPickerColor;
	if (isValidColor(value)) return value;
	return resolveCssColor(value) ?? defaultPickerColor;
}
function resolveCssColor(value) {
	if (value.toLowerCase() === "currentcolor") return;
	colorContext ??= document.createElement("canvas").getContext("2d") ?? void 0;
	if (!colorContext) return;
	colorContext.fillStyle = "#000000";
	colorContext.fillStyle = value;
	const resolvedColor = colorContext.fillStyle;
	colorContext.fillStyle = "#ffffff";
	colorContext.fillStyle = value;
	return resolvedColor === colorContext.fillStyle && isValidColor(resolvedColor) ? resolvedColor : void 0;
}
// src/components/InputColor/InputColor.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$19 = { class: "input-color-fields" };
// src/components/InputColor/InputColor.vue
var InputColor_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputColor",
	props: {
		...inputProps,
		modelValue: {
			type: String,
			default: null
		}
	},
	emits: [...inputEmits, "togglePopover"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const root = ref();
		const colorPopover = ref();
		const focused = useVModel(props, "focused", emit);
		const textboxValue = ref(props.modelValue);
		const pickerColor = shallowRef(toPickerColor(props.modelValue));
		const displayPicker = computed(() => !props.disabled && !props.readonly);
		const hexColor = computed(() => colorToHex({
			...pickerColor.value,
			alpha: 1
		}));
		const { translate } = useGlobalResourceManager();
		let isPointerPressed = false;
		let hasPendingColor = false;
		useEventListener(window, ["pointerup", "pointercancel"], handlePointerRelease);
		useComponentAutomationProperties(root);
		watch(() => props.modelValue, (value) => {
			textboxValue.value = value;
			synchronizePickerColor();
		});
		watch(displayPicker, (isDisplayed) => {
			if (!isDisplayed) colorPopover.value.hide();
		});
		function handleTextboxValueUpdate(text) {
			const value = normalizeText(text);
			if (value === void 0) {
				displayModelValue(text);
				return;
			}
			emitValue(value);
			if (value === props.modelValue && text !== value) displayModelValue(text);
		}
		function handleColorUpdate(color) {
			pickerColor.value = convertToHsb(color);
			if (isPointerPressed) hasPendingColor = true;
			else emitValue(toFieldValue(pickerColor.value));
		}
		function handlePickerPointerdown() {
			isPointerPressed = true;
		}
		function handlePointerRelease() {
			isPointerPressed = false;
			if (hasPendingColor) {
				hasPendingColor = false;
				emitValue(toFieldValue(pickerColor.value));
			}
		}
		function handleHexUpdate(hex) {
			handleColorUpdate({
				...toPickerColor(hex),
				alpha: pickerColor.value.alpha
			});
		}
		function handleKeyDown(event) {
			if ((event.key === "F4" || event.altKey && (event.key === "ArrowDown" || event.key === "ArrowUp")) && displayPicker.value) {
				event.preventDefault();
				togglePicker();
			}
		}
		function handlePopoverShow() {
			synchronizePickerColor();
			emit("togglePopover", true);
		}
		function handlePopoverHide() {
			emit("togglePopover", false);
		}
		function togglePicker() {
			colorPopover.value.toggle(root.value.$el, getTextboxInput(root.value));
		}
		function synchronizePickerColor() {
			if (props.modelValue !== toFieldValue(pickerColor.value)) pickerColor.value = toPickerColor(props.modelValue);
		}
		function emitValue(value) {
			if (value !== props.modelValue) emit("update:modelValue", value);
		}
		/**
		* Returns null for an empty text and undefined for an invalid one. Like the former Wijmo input,
		* white spaces are dropped, except when the color needs them, such as "rgb(0 0 0)".
		*/
		function normalizeText(text) {
			const trimmedText = text?.trim();
			if (!trimmedText) return null;
			const compactText = trimmedText.replaceAll(/\s+/g, "");
			if (isCssColor(compactText)) return compactText;
			const spacedText = trimmedText.replaceAll(/\s+/g, " ");
			return isCssColor(spacedText) ? spacedText : void 0;
		}
		/**
		* The textbox first receives the typed text, so that setting the model value back on the next tick
		* is seen as a change. Unlike re-creating the textbox, this keeps the focus.
		*/
		function displayModelValue(text) {
			textboxValue.value = text;
			nextTick(() => {
				textboxValue.value = props.modelValue;
			});
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Textbox_default, {
				ref_key: "root",
				ref: root,
				"model-value": textboxValue.value,
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				autofocus: _ctx.autofocus,
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				required: _ctx.required,
				placeholder: _ctx.placeholder,
				"input-display-mode": _ctx.inputDisplayMode,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "input-color",
				onAiApply: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("aiCancel")),
				"onUpdate:modelValue": handleTextboxValueUpdate,
				onKeydown: handleKeyDown
			}, createSlots({
				default: withCtx(() => [displayPicker.value ? (openBlock(), createBlock(Button_default, {
					key: 0,
					focused: unref(focused),
					"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => isRef(focused) ? focused.value = $event : null),
					class: "input-color-open-picker-button",
					size: "small",
					variant: "ghost",
					icon: "chevronDown",
					"aria-label": unref(translate)("InputColor_OpenPicker"),
					tabindex: "-1",
					onClick: togglePicker
				}, null, 8, ["focused", "aria-label"])) : createCommentVNode("", true), createVNode(Popover_default, {
					ref_key: "colorPopover",
					ref: colorPopover,
					class: "input-color-dropdown",
					onShow: handlePopoverShow,
					onHide: handlePopoverHide
				}, {
					default: withCtx(() => [createElementVNode("div", {
						class: "input-color-picker",
						onPointerdown: handlePickerPointerdown
					}, [
						createVNode(unref(ColorAreaRoot), {
							"model-value": pickerColor.value,
							"color-space": "hsb",
							"x-channel": "saturation",
							"y-channel": "brightness",
							"onUpdate:color": handleColorUpdate
						}, {
							default: withCtx(({ style }) => [createVNode(unref(ColorAreaArea), {
								class: "input-color-area",
								style: normalizeStyle(style)
							}, {
								default: withCtx(() => [createVNode(unref(ColorAreaThumb), { class: "input-color-thumb" })]),
								_: 1
							}, 8, ["style"])]),
							_: 1
						}, 8, ["model-value"]),
						createVNode(unref(ColorSliderRoot), {
							"model-value": pickerColor.value,
							channel: "hue",
							"color-space": "hsb",
							class: "input-color-slider",
							"onUpdate:color": handleColorUpdate
						}, {
							default: withCtx(() => [createVNode(unref(ColorSliderTrack), { class: "input-color-slider-track" }), createVNode(unref(ColorSliderThumb), { class: "input-color-thumb" })]),
							_: 1
						}, 8, ["model-value"]),
						createVNode(unref(ColorSliderRoot), {
							"model-value": pickerColor.value,
							channel: "alpha",
							"color-space": "hsb",
							class: "input-color-slider",
							"onUpdate:color": handleColorUpdate
						}, {
							default: withCtx(() => [createVNode(unref(ColorSliderTrack), { class: "input-color-slider-track" }), createVNode(unref(ColorSliderThumb), { class: "input-color-thumb" })]),
							_: 1
						}, 8, ["model-value"]),
						createElementVNode("div", _hoisted_1$19, [createVNode(unref(ColorFieldRoot), {
							"model-value": hexColor.value,
							class: "input-color-hex-field",
							"onUpdate:modelValue": handleHexUpdate
						}, {
							default: withCtx(() => [createVNode(unref(ColorFieldInput), { class: "input-color-field-input" })]),
							_: 1
						}, 8, ["model-value"]), (openBlock(), createElementBlock(Fragment, null, renderList([
							"red",
							"green",
							"blue"
						], (channel) => {
							return createVNode(unref(ColorFieldRoot), {
								key: channel,
								"model-value": pickerColor.value,
								channel,
								"color-space": "rgb",
								class: "input-color-channel-field",
								"onUpdate:color": handleColorUpdate
							}, {
								default: withCtx(() => [createVNode(unref(ColorFieldInput), { class: "input-color-field-input" })]),
								_: 1
							}, 8, ["model-value", "channel"]);
						}), 64))])
					], 32)]),
					_: 1
				}, 512)]),
				_: 2
			}, [__props.modelValue ? {
				name: "before",
				fn: withCtx(() => [createVNode(unref(ColorSwatch), {
					class: "input-color-swatch",
					color: __props.modelValue,
					label: __props.modelValue
				}, null, 8, ["color", "label"])]),
				key: "0"
			} : void 0]), 1032, [
				"model-value",
				"focused",
				"autofocus",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"required",
				"placeholder",
				"input-display-mode",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion"
			]);
		};
	}
}), [["__scopeId", "data-v-710f2e22"]]);
// src/utils/datetime.ts
/**
* Parses and completes a date time value from the specified string value.
* @param value - The value to parse and complete.
* @param dateFormatStrings - The date time format strings.
* @returns A date time value, or null if the value can't be converted.
*/
function parseAndComplete(value, dateFormatStrings) {
	let date = null;
	if (value.includes("/") || !value.startsWith("-") && value.includes("-")) for (const formatString of dateFormatStrings) {
		const parsedDate = Globalize.parseDate(value, formatString);
		if (parsedDate && !Number.isNaN(parsedDate.getDate())) {
			date = parsedDate;
			break;
		}
	}
	else if (value === "0") date = /* @__PURE__ */ new Date();
	else if (value.startsWith("+") || value.startsWith("-")) date = parseRelativeDate(value);
	else {
		const format = getSimplifiedDateFormat(new Intl.DateTimeFormat(navigator.language).resolvedOptions());
		date = parseSimplifiedDate(value, format);
	}
	return date;
}
function parseRelativeDate(value) {
	const amount = Number.parseInt(value, 10);
	return Number.isNaN(amount) ? null : addDays(/* @__PURE__ */ new Date(), amount);
}
// src/composables/useInputDate.ts
var inputDateProps = {
	...inputProps,
	modelValue: {
		type: [Date, null],
		default: null
	},
	invalidValue: {
		type: String,
		default: void 0
	},
	minValue: {
		type: [Date, null],
		default: void 0
	},
	maxValue: {
		type: [Date, null],
		default: void 0
	},
	calendar: {
		type: Boolean,
		default: true
	}
};
var inputDateEmits = [
	...inputEmits,
	"update:invalidValue",
	"togglePopover"
];
function useInputDate(props, emit, formatStrings) {
	const root = ref();
	const focused = useVModel(props, "focused", emit);
	const { translate } = useGlobalResourceManager();
	const messageTextInternal = ref();
	const messageSeverityInternal = ref();
	const displayCalendar = computed(() => props.calendar && !props.disabled && !props.readonly);
	const propsInternal = reactiveComputed(() => ({
		...props,
		messageText: props.messageText ?? messageTextInternal.value,
		messageSeverity: props.messageSeverity ?? messageSeverityInternal.value
	}));
	watch(() => props.modelValue, () => checkMinMax());
	useComponentAutomationProperties(root);
	const calendarPopover = ref();
	const key = ref(0);
	const invalidValue = useInputInvalidValue(propsInternal, emit);
	const textboxValue = computed({
		get() {
			if (invalidValue.value) return invalidValue.value;
			return props.modelValue ? Globalize.format(props.modelValue, props.format) : null;
		},
		set(value) {
			if (!value) {
				emitNewValue(null);
				messageTextInternal.value = void 0;
				messageSeverityInternal.value = void 0;
				return;
			}
			const newValue = getDateFromText(value);
			if (newValue && !Number.isNaN(newValue.getDate())) {
				const oldValue = props.modelValue;
				emitNewValue(newValue);
				checkMinMax(newValue);
				if (shouldUpdateKey(newValue, oldValue)) key.value++;
			} else {
				invalidValue.value = value;
				messageTextInternal.value = translate("ValidationMessage_InvalidFieldValue_ShortText");
				messageSeverityInternal.value = "error";
			}
		}
	});
	const calendarValue = computed({
		get: () => props.modelValue,
		set: (date) => {
			if (date) emitNewValue(props.modelValue ? setTimeOfDay(date, props.modelValue) : date);
			else {
				invalidValue.value = null;
				checkMinMax();
			}
			calendarPopover.value.hide();
			focusInput();
		}
	});
	/**
	* Checks that the value is within the min/max range.
	* When it is not the case, displays an error message.
	* Accepts an explicit value so the successful-parse branch of textboxValue's
	* setter can re-evaluate immediately with newValue, instead of waiting for
	* props.modelValue to change - that prop may never change reference if the
	* corrected value equals what the parent already holds.
	*/
	function checkMinMax(value = props.modelValue) {
		if (value != null && props.minValue != null && value < props.minValue) {
			messageTextInternal.value = translate("ValidationMessage_MinFieldValue_ShortText", Globalize.format(props.minValue, props.format));
			messageSeverityInternal.value = "error";
		} else if (value != null && props.maxValue != null && value > props.maxValue) {
			messageTextInternal.value = translate("ValidationMessage_MaxFieldValue_ShortText", Globalize.format(props.maxValue, props.format));
			messageSeverityInternal.value = "error";
		} else {
			messageTextInternal.value = void 0;
			messageSeverityInternal.value = void 0;
		}
	}
	function getDateFromText(value) {
		let date = Globalize.parseDate(value, props.format);
		date ??= parseAndComplete(value, formatStrings);
		return date;
	}
	function emitNewValue(value) {
		emit("update:modelValue", value);
		invalidValue.value = null;
	}
	function handlePopoverShow() {
		emit("togglePopover", true);
	}
	function handlePopoverHide() {
		emit("togglePopover", false);
	}
	function focusInput() {
		focusExceptOnTouchDevice(getInputElement());
	}
	function getInputElement() {
		return getTextboxInput(root.value);
	}
	function shouldUpdateKey(newValue, oldValue) {
		return props.inputDisplayMode === "form" && oldValue && newValue.getTime() === oldValue.getTime();
	}
	return {
		root,
		focused,
		key,
		displayCalendar,
		calendarPopover,
		calendarValue,
		textboxValue,
		propsInternal,
		handlePopoverShow,
		handlePopoverHide,
		focusInput,
		getInputElement
	};
}
// src/components/InputDate/InputDate.vue
var InputDate_default = /* @__PURE__ */ defineComponent({
	__name: "InputDate",
	props: {
		...inputDateProps,
		format: {
			type: String,
			default: "d"
		},
		calendar: {
			type: Boolean,
			default: true
		}
	},
	emits: [...inputDateEmits],
	setup(__props, { emit: __emit }) {
		const { root, focused, key, displayCalendar, calendarPopover, calendarValue, textboxValue, propsInternal, handlePopoverShow, handlePopoverHide } = useInputDate(__props, __emit, ["d", "yyyy-MM-dd"]);
		const { translate } = useGlobalResourceManager();
		function handleOpenCalendarButton(event) {
			calendarPopover.value.toggle(event, getTextboxInput(root.value));
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Textbox_default, {
				key: unref(key),
				ref_key: "root",
				ref: root,
				modelValue: unref(textboxValue),
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isRef(textboxValue) ? textboxValue.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[3] || (_cache[3] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				required: _ctx.required,
				placeholder: _ctx.placeholder,
				"input-display-mode": _ctx.inputDisplayMode,
				"message-text": unref(propsInternal).messageText,
				"message-severity": unref(propsInternal).messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "input-date",
				onAiApply: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				before: withCtx(() => [renderSlot(_ctx.$slots, "before")]),
				default: withCtx(() => [
					renderSlot(_ctx.$slots, "default"),
					unref(displayCalendar) ? (openBlock(), createBlock(Button_default, {
						key: 0,
						focused: unref(focused),
						"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => isRef(focused) ? focused.value = $event : null),
						class: "input-date-open-calendar-button",
						size: "small",
						variant: "ghost",
						icon: "calendar",
						"aria-label": unref(translate)("InputDate_OpenCalendar"),
						tabindex: "-1",
						onClick: handleOpenCalendarButton
					}, null, 8, ["focused", "aria-label"])) : createCommentVNode("", true),
					renderSlot(_ctx.$slots, "after"),
					createVNode(Popover_default, {
						ref_key: "calendarPopover",
						ref: calendarPopover,
						onShow: unref(handlePopoverShow),
						onHide: unref(handlePopoverHide)
					}, {
						default: withCtx(() => [createVNode(Calendar_default, {
							modelValue: unref(calendarValue),
							"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isRef(calendarValue) ? calendarValue.value = $event : null),
							"min-value": _ctx.minValue,
							"max-value": _ctx.maxValue
						}, null, 8, [
							"modelValue",
							"min-value",
							"max-value"
						])]),
						_: 1
					}, 8, ["onShow", "onHide"])
				]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"required",
				"placeholder",
				"input-display-mode",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion"
			]);
		};
	}
});
// src/components/InputTime/InputTime.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$18 = {
	key: 0,
	class: "input-time-fraction"
};
var _hoisted_2$10 = {
	key: 0,
	class: "input-time-placeholder"
};
var editableSegmentSelector = "[data-reka-time-field-segment]:not([data-reka-time-field-segment=\"literal\"])";
// src/components/InputTime/InputTime.vue
var InputTime_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputTime",
	props: {
		...inputProps,
		...contentProps,
		modelValue: {
			type: Date,
			default: null
		},
		format: {
			type: String,
			default: void 0
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const numberSegmentSelector = [
			"hour",
			"minute",
			"second"
		].map((part) => `[data-reka-time-field-segment="${part}"]`).join(", ");
		const props = __props;
		const contentStyleObject = useContentStyle(props);
		const emit = __emit;
		const { input, id, classes, ariaAttributes, isLabelVisible, isMessageVisible, messageId } = useInput(props, emit, { focusWithin: true });
		const localizator = useLocalizator();
		const segmentAttributes = computed(() => ({
			"aria-invalid": ariaAttributes.value["aria-invalid"],
			"aria-describedby": ariaAttributes.value["aria-describedby"],
			"aria-required": ariaAttributes.value["aria-required"],
			...props.tabStop ? {} : { tabindex: -1 }
		}));
		const granularity = computed(() => props.format === "T" || props.format?.includes("s") ? "second" : "minute");
		const hourCycle = computed(() => {
			if (props.format?.includes("H")) return 24;
			return props.format?.includes("h") ? 12 : void 0;
		});
		const fractionFormat = computed(() => props.format?.match(/([^a-zA-Z]?)(f+)/));
		/**
		* Reka has no segment below the second, so the fraction of second required by the format is
		* displayed as a read-only text after the last displayed number, the seconds or the minutes when
		* the format omits the seconds (e.g. 'HH:mm.fff').
		* Dates are precise to the millisecond, the extra digits of a longer specifier are zeros.
		*/
		const fractionText = computed(() => {
			if (!fractionFormat.value || !props.modelValue) return;
			const [, separator, specifier] = fractionFormat.value;
			return `${separator}${props.modelValue.getMilliseconds().toString().padStart(3, "0").padEnd(specifier.length, "0").slice(0, specifier.length)}`;
		});
		const timeValue = computed({
			get: () => props.modelValue ? new Time(props.modelValue.getHours(), props.modelValue.getMinutes(), props.modelValue.getSeconds(), props.modelValue.getMilliseconds()) : void 0,
			set: (value) => emit("update:modelValue", value ? toDate(value) : null)
		});
		/**
		* Converts the time typed by the user to a date.
		* The date part of the current value is kept so that only the time of day changes,
		* otherwise the time is applied to the current day.
		* Reka carries the milliseconds of the current value over, so they are not lost by an edit.
		*/
		function toDate(value) {
			const date = props.modelValue ? new Date(props.modelValue) : /* @__PURE__ */ new Date();
			date.setHours(value.hour, value.minute, value.second, value.millisecond);
			return date;
		}
		const hasEntry = ref(false);
		const isPlaceholderVisible = computed(() => !!props.placeholder && !props.modelValue && !hasEntry.value);
		function getFieldElement() {
			return input.value.$el;
		}
		function getHiddenInput() {
			return getFieldElement().querySelector("input");
		}
		function updateHiddenInputReadonly() {
			getHiddenInput().toggleAttribute("readonly", props.readonly);
		}
		function handleFieldFocus() {
			getFieldElement().querySelector(editableSegmentSelector).focus();
		}
		function updateHasEntry() {
			hasEntry.value = Array.from(getFieldElement().querySelectorAll(numberSegmentSelector), (segment) => segment.textContent).some((text) => /\p{Nd}/u.test(text));
		}
		watch(() => props.readonly, updateHiddenInputReadonly, { flush: "post" });
		watch(() => props.modelValue, (value) => {
			if (!value && !getFieldElement().contains(document.activeElement)) hasEntry.value = false;
		});
		onMounted(updateHiddenInputReadonly);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["input-time neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(unref(TimeFieldRoot), {
				id: unref(id),
				ref: (el) => input.value = el,
				"aria-label": _ctx.label,
				modelValue: timeValue.value,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => timeValue.value = $event),
				locale: unref(localizator).currentCulture,
				granularity: granularity.value,
				"hour-cycle": hourCycle.value,
				readonly: _ctx.readonly,
				disabled: _ctx.disabled,
				class: normalizeClass(["input-time-content neos-input-content", [{ "input-time-content-placeholder": isPlaceholderVisible.value }, _ctx.contentClass]]),
				style: normalizeStyle(unref(contentStyleObject)),
				tabindex: "-1",
				onFocus: handleFieldFocus,
				onFocusout: updateHasEntry
			}, {
				default: withCtx(({ segments }) => [(openBlock(true), createElementBlock(Fragment, null, renderList(segments, (segment, index) => {
					return openBlock(), createElementBlock(Fragment, { key: index }, [createVNode(unref(TimeFieldInput), mergeProps({
						part: segment.part,
						class: ["input-time-segment", `input-time-segment-${segment.part}`]
					}, { ref_for: true }, segment.part === "literal" ? {} : segmentAttributes.value), {
						default: withCtx(() => [createTextVNode(toDisplayString(segment.value), 1)]),
						_: 2
					}, 1040, ["part", "class"]), segment.part === granularity.value && fractionText.value ? (openBlock(), createElementBlock("span", _hoisted_1$18, toDisplayString(fractionText.value), 1)) : createCommentVNode("", true)], 64);
				}), 128)), isPlaceholderVisible.value ? (openBlock(), createElementBlock("span", _hoisted_2$10, toDisplayString(_ctx.placeholder), 1)) : createCommentVNode("", true)]),
				_: 1
			}, 8, [
				"id",
				"aria-label",
				"modelValue",
				"locale",
				"granularity",
				"hour-cycle",
				"readonly",
				"disabled",
				"class",
				"style"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				id: unref(messageId),
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, [
				"id",
				"text",
				"severity"
			])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-9bb43933"]]);
// src/components/InputDateTime/InputDateTime.vue
var InputDateTime_default = /* @__PURE__ */ defineComponent({
	__name: "InputDateTime",
	props: {
		...inputDateProps,
		format: {
			type: String,
			default: "g"
		},
		time: {
			type: Boolean,
			default: true
		}
	},
	emits: [...inputDateEmits],
	setup(__props, { emit: __emit }) {
		const formatStrings = [
			"d",
			"g",
			"G",
			"s",
			"o",
			"u"
		];
		const standardTimeFormats = {
			g: "t",
			G: "T",
			s: "HH:mm:ss",
			o: "HH:mm:ss",
			u: "HH:mm:ss"
		};
		const props = __props;
		const emit = __emit;
		const { root, focused, key, displayCalendar, calendarPopover, calendarValue, textboxValue, propsInternal, handlePopoverShow, handlePopoverHide, focusInput, getInputElement } = useInputDate(props, emit, formatStrings);
		const { translate } = useGlobalResourceManager();
		const displayTime = computed(() => props.time && !props.disabled && !props.readonly);
		const timeFormat = computed(() => standardTimeFormats[props.format] ?? props.format);
		useComponentAutomationProperties(root);
		const timePopover = ref();
		const invalidValue = useInputInvalidValue(propsInternal, emit);
		const timeDraft = ref(null);
		function emitNewValue(value) {
			emit("update:modelValue", value);
			invalidValue.value = null;
		}
		function handleOpenCalendarButton(event) {
			timePopover.value.hide();
			calendarPopover.value.toggle(event, getInputElement());
		}
		function handleOpenTimeButton(event) {
			calendarPopover.value.hide();
			timeDraft.value = props.modelValue;
			timePopover.value.toggle(event, getInputElement());
		}
		function handleApplyTimeButton() {
			if (timeDraft.value !== props.modelValue) emitNewValue(timeDraft.value);
			timePopover.value.hide();
			focusInput();
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Textbox_default, {
				key: unref(key),
				ref_key: "root",
				ref: root,
				modelValue: unref(textboxValue),
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isRef(textboxValue) ? textboxValue.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[3] || (_cache[3] = ($event) => isRef(focused) ? focused.value = $event : null),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				required: _ctx.required,
				placeholder: _ctx.placeholder,
				"input-display-mode": _ctx.inputDisplayMode,
				"message-text": unref(propsInternal).messageText,
				"message-severity": unref(propsInternal).messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "input-date-time",
				onAiApply: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				before: withCtx(() => [renderSlot(_ctx.$slots, "before")]),
				default: withCtx(() => [
					renderSlot(_ctx.$slots, "default"),
					displayTime.value ? (openBlock(), createBlock(Button_default, {
						key: 0,
						class: "input-date-time-open-time-button",
						size: "small",
						variant: "ghost",
						icon: "clock",
						"aria-label": unref(translate)("InputDateTime_OpenTime"),
						tabindex: "-1",
						onClick: handleOpenTimeButton
					}, null, 8, ["aria-label"])) : createCommentVNode("", true),
					unref(displayCalendar) ? (openBlock(), createBlock(Button_default, {
						key: 1,
						class: "input-date-time-open-calendar-button",
						size: "small",
						variant: "ghost",
						icon: "calendar",
						"aria-label": unref(translate)("InputDate_OpenCalendar"),
						tabindex: "-1",
						onClick: handleOpenCalendarButton
					}, null, 8, ["aria-label"])) : createCommentVNode("", true),
					renderSlot(_ctx.$slots, "after"),
					createVNode(Popover_default, {
						ref_key: "calendarPopover",
						ref: calendarPopover,
						onShow: unref(handlePopoverShow),
						onHide: unref(handlePopoverHide)
					}, {
						default: withCtx(() => [createVNode(Calendar_default, {
							modelValue: unref(calendarValue),
							"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(calendarValue) ? calendarValue.value = $event : null),
							"min-value": _ctx.minValue,
							"max-value": _ctx.maxValue
						}, null, 8, [
							"modelValue",
							"min-value",
							"max-value"
						])]),
						_: 1
					}, 8, ["onShow", "onHide"]),
					createVNode(Popover_default, {
						ref_key: "timePopover",
						ref: timePopover,
						onShow: unref(handlePopoverShow),
						onHide: unref(handlePopoverHide)
					}, {
						default: withCtx(() => [createVNode(HorizontalLayout_default, { "vertical-align": "center" }, {
							default: withCtx(() => [createVNode(InputTime_default, {
								modelValue: timeDraft.value,
								"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => timeDraft.value = $event),
								format: timeFormat.value
							}, null, 8, ["modelValue", "format"]), createVNode(Button_default, {
								class: "input-date-time-apply-time-button",
								variant: "primary",
								size: "small",
								label: unref(translate)("Apply"),
								animated: "",
								onClick: handleApplyTimeButton
							}, null, 8, ["label"])]),
							_: 1
						})]),
						_: 1
					}, 8, ["onShow", "onHide"])
				]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"required",
				"placeholder",
				"input-display-mode",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion"
			]);
		};
	}
});
// src/components/InputLocalizableString/InputLocalizableString.ts?vue&type=script&src=true&lang.ts
var images = {
	en: "flagGB",
	fr: "flagFR",
	es: "flagES",
	de: "flagDE",
	it: "flagIT"
};
function useInputLocalizableStringInput(props, currentValue, defaultLanguage, applicationCurrentLanguage, emitNewValue) {
	const { normalizeWhiteSpaceInput, normalizeWhiteSpaceToEmit } = useStringInput();
	const inputPlaceholder = computed(() => currentValue.value?.[defaultLanguage] ?? props.placeholder);
	const editedLanguage = ref(applicationCurrentLanguage);
	const inputValue = ref("");
	let hasPendingInput = false;
	watch(() => currentValue.value?.[editedLanguage.value], (currentLanguageValue) => inputValue.value = currentLanguageValue ?? "", { immediate: true });
	function commitInputValue(inputText) {
		if (!hasPendingInput) return;
		inputText = normalizeWhiteSpaceToEmit(props.whiteSpaceHandling, inputText);
		emitNewValue({
			...currentValue.value,
			[editedLanguage.value]: inputText
		});
		hasPendingInput = false;
	}
	function handleInputValueInput(event) {
		let inputText = event.target.value;
		inputText = normalizeWhiteSpaceInput(props.whiteSpaceHandling, inputText);
		inputValue.value = inputText;
		hasPendingInput = true;
	}
	function handleInputValueChange(event) {
		commitInputValue(event.target.value);
	}
	function handleInputValueFocusOut() {
		commitInputValue(inputValue.value);
	}
	return {
		editedLanguage,
		handleInputValueChange,
		handleInputValueInput,
		handleInputValueFocusOut,
		inputPlaceholder,
		inputValue
	};
}
function useInputLocalizableStringModal(currentValue, languages, emitToggleModal, emitNewValue) {
	const { isOpen: isModalOpen, open, close } = useModal();
	const modalDraft = ref({});
	function openModal() {
		modalDraft.value = { ...currentValue.value };
		open();
		emitToggleModal(true);
	}
	function closeModal() {
		close();
		emitToggleModal(false);
	}
	function commitModalDraft() {
		const oldValue = currentValue.value ?? {};
		if (languages.some((l) => modalDraft.value[l] !== oldValue[l])) emitNewValue(modalDraft.value);
		closeModal();
	}
	return {
		isModalOpen,
		modalDraft,
		openModal,
		closeModal,
		commitModalDraft
	};
}
function removeUndefinedValues(value) {
	const newValue = {};
	for (const language in value) if (value[language]) newValue[language] = value[language];
	return newValue;
}
var InputLocalizableString_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputLocalizableString",
	components: {
		Button: Button_default,
		Heading: Heading_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		Modal: Modal_default,
		ButtonsLayout: ButtonsLayout_default,
		Text: Text_default,
		Textbox: Textbox_default,
		VerticalLayout: VerticalLayout_default
	},
	props: {
		...inputProps,
		modelValue: {
			type: Object,
			default: void 0
		},
		maxLength: {
			type: Number,
			default: void 0
		},
		multiLines: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Number,
			default: void 0
		},
		whiteSpaceHandling: {
			type: String,
			default: void 0
		},
		smartTranslate: {
			type: Function,
			default: void 0
		}
	},
	emits: [...inputEmits, "toggleModal"],
	setup(props, { emit }) {
		const localizator = useLocalizator();
		const inputLabelPosition = computed(() => props.inputDisplayMode === "form" ? props.labelPosition : "hidden");
		const smartTranslateButtonDisabled = computed(() => {
			const definedValues = Object.values(modalDraft.value).filter(Boolean);
			return definedValues.length === 0 || definedValues.length === localizator.localizableStringLanguages.length;
		});
		const currentValue = toRef(props, "modelValue");
		const root = ref();
		const smartTranslateButtonLoading = ref(false);
		const hasMultipleLanguages = localizator.localizableStringLanguages.length > 1;
		const { editedLanguage, inputValue, inputPlaceholder, handleInputValueFocusOut, handleInputValueInput, handleInputValueChange } = useInputLocalizableStringInput(props, currentValue, localizator.localizableStringDefaultLanguage, localizator.localizableStringCurrentLanguage, emitNewValue);
		const aiSuggestion = computed(() => {
			const suggestion = props.aiSuggestion;
			if (!suggestion) return;
			const languageSuggestedValue = suggestion.suggestedValue?.[editedLanguage.value];
			return {
				text: suggestion.text,
				suggestedValue: languageSuggestedValue
			};
		});
		const { isModalOpen, modalDraft, openModal, closeModal, commitModalDraft } = useInputLocalizableStringModal(currentValue, localizator.localizableStringLanguages, emitToggleModal, emitNewValue);
		const { translate } = useGlobalResourceManager();
		const focused = useVModel(props, "focused", emit);
		useComponentAutomationProperties(root);
		const canDisplayButtonsInColumn = computed(() => inputHeight.value > (localizator.localizableStringLanguages.length + 1) * openModalButtonHeight.value);
		const buttons = ref();
		const input = ref();
		const openModalButton = ref();
		const { width: buttonsWidth } = useElementBounding(buttons);
		const { height: inputHeight } = useElementBounding(input);
		const { height: openModalButtonHeight } = useElementBounding(openModalButton);
		onMounted(() => {
			input.value = root.value?.$el.querySelector(".textbox-content.neos-input-content");
		});
		function emitNewValue(value) {
			value = removeUndefinedValues(value);
			emit("update:modelValue", Object.keys(value).length === 0 ? null : value);
		}
		function emitToggleModal(value) {
			emit("toggleModal", value);
		}
		async function handleSmartTranslateButtonClick() {
			smartTranslateButtonLoading.value = true;
			try {
				const value = removeUndefinedValues(modalDraft.value);
				modalDraft.value = await props.smartTranslate(value);
			} finally {
				smartTranslateButtonLoading.value = false;
			}
		}
		function isRequiredLanguage(language) {
			return language === localizator.localizableStringRequiredLanguage ? props.required : false;
		}
		return {
			aiSuggestion,
			buttons,
			buttonsWidth,
			canDisplayButtonsInColumn,
			closeModal,
			commitModalDraft,
			editedLanguage,
			focused,
			handleInputValueFocusOut,
			handleInputValueChange,
			handleInputValueInput,
			handleSmartTranslateButtonClick,
			hasMultipleLanguages,
			images,
			input,
			inputLabelPosition,
			inputPlaceholder,
			inputValue,
			isModalOpen,
			isRequiredLanguage,
			languages: localizator.localizableStringLanguages,
			modalDraft,
			openModal,
			openModalButton,
			root,
			smartTranslateButtonDisabled,
			smartTranslateButtonLoading,
			translate
		};
	}
});
// src/components/InputLocalizableString/InputLocalizableString.vue
var _hoisted_1$17 = { class: "input-localizable-string-modal-label" };
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_Heading = resolveComponent("Heading");
	const _component_Image = resolveComponent("Image");
	const _component_Textbox = resolveComponent("Textbox");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	const _component_ButtonsLayout = resolveComponent("ButtonsLayout");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_Modal = resolveComponent("Modal");
	return openBlock(), createBlock(_component_Textbox, {
		ref: "root",
		focused: _ctx.focused,
		"onUpdate:focused": _cache[2] || (_cache[2] = ($event) => _ctx.focused = $event),
		"model-value": _ctx.inputValue,
		label: _ctx.label,
		"label-position": _ctx.inputLabelPosition,
		disabled: _ctx.disabled,
		readonly: _ctx.readonly,
		required: _ctx.required,
		tooltip: _ctx.inputValue,
		"input-display-mode": _ctx.inputDisplayMode,
		"message-text": _ctx.messageText,
		"message-severity": _ctx.messageSeverity,
		"message-position": _ctx.messagePosition,
		documentation: _ctx.documentation,
		"tab-stop": _ctx.tabStop,
		"max-length": _ctx.maxLength,
		"multi-lines": _ctx.multiLines,
		rows: _ctx.rows,
		placeholder: _ctx.inputPlaceholder,
		"white-space-handling": _ctx.whiteSpaceHandling,
		"ai-suggestion": _ctx.aiSuggestion,
		class: normalizeClass(["input-localizable-string", { "input-localizable-string-textbox-multiline": _ctx.multiLines }]),
		style: normalizeStyle(`--input-localizable-string-textarea-right-padding: calc(${_ctx.buttonsWidth}px + 0.5rem)`),
		onInput: _ctx.handleInputValueInput,
		onChange: _ctx.handleInputValueChange,
		onFocusout: _ctx.handleInputValueFocusOut,
		onAiApply: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiCancel"))
	}, {
		default: withCtx(() => [_ctx.hasMultipleLanguages ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", {
			ref: "buttons",
			class: normalizeClass(["input-localizable-string-buttons", { "input-localizable-string-buttons-column": _ctx.multiLines && _ctx.canDisplayButtonsInColumn }])
		}, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.languages, (language) => {
			return openBlock(), createBlock(_component_Button, {
				key: language,
				"data-lang": language,
				disabled: _ctx.disabled,
				icon: _ctx.images[language],
				tooltip: language,
				variant: _ctx.editedLanguage == language ? "ghost-primary" : "ghost",
				class: "input-localizable-string-button input-localizable-string-switch-language-button",
				size: "small",
				tabindex: "-1",
				onClick: ($event) => _ctx.editedLanguage = language
			}, null, 8, [
				"data-lang",
				"disabled",
				"icon",
				"tooltip",
				"variant",
				"onClick"
			]);
		}), 128)), createVNode(_component_Button, {
			ref: "openModalButton",
			disabled: _ctx.disabled,
			class: "input-localizable-string-button input-localizable-string-open-modal-button",
			icon: "translate",
			size: "small",
			tabindex: "-1",
			variant: "ghost",
			onClick: _ctx.openModal
		}, null, 8, ["disabled", "onClick"])], 2), createVNode(_component_Modal, {
			"is-open": _ctx.isModalOpen,
			"onUpdate:isOpen": _cache[0] || (_cache[0] = ($event) => _ctx.isModalOpen = $event),
			dismissible: false,
			maximizable: false,
			class: "input-localizable-string-modal",
			onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("toggleModal", false))
		}, {
			header: withCtx(() => [createVNode(_component_Heading, { level: 3 }, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.label), 1)]),
				_: 1
			})]),
			body: withCtx(() => [createVNode(_component_VerticalLayout, { align: "space-between" }, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.languages, (language, i) => {
					return openBlock(), createElementBlock("div", { key: language }, [createElementVNode("div", _hoisted_1$17, [createElementVNode("span", null, toDisplayString(_ctx.translate("InputLocalizableString_TextboxLabel", language)), 1), createVNode(_component_Image, {
						name: _ctx.images[language],
						size: "extrasmall",
						style: { "margin-right": "0.5rem" }
					}, null, 8, ["name"])]), createVNode(_component_Textbox, {
						modelValue: _ctx.modalDraft[language],
						"onUpdate:modelValue": ($event) => _ctx.modalDraft[language] = $event,
						label: _ctx.translate("InputLocalizableString_TextboxLabel", language),
						"label-position": "hidden",
						readonly: _ctx.readonly,
						required: _ctx.isRequiredLanguage(language),
						tooltip: _ctx.modalDraft[language],
						"max-length": _ctx.maxLength,
						"multi-lines": _ctx.multiLines,
						rows: _ctx.rows,
						"data-lang": language,
						focused: i === 0,
						"white-space-handling": _ctx.whiteSpaceHandling,
						class: "input-localizable-string-modal-textbox"
					}, null, 8, [
						"modelValue",
						"onUpdate:modelValue",
						"label",
						"readonly",
						"required",
						"tooltip",
						"max-length",
						"multi-lines",
						"rows",
						"data-lang",
						"focused",
						"white-space-handling"
					])]);
				}), 128))]),
				_: 1
			})]),
			footer: withCtx(() => [createVNode(_component_HorizontalLayout, {
				align: "space-between",
				class: "input-localizable-string-modal-footer"
			}, {
				default: withCtx(() => [_ctx.smartTranslate ? (openBlock(), createBlock(_component_Button, {
					key: 0,
					class: "input-localizable-string-modal-smart-translate-button",
					icon: "translate",
					label: _ctx.translate("Translate"),
					disabled: _ctx.smartTranslateButtonDisabled,
					loading: _ctx.smartTranslateButtonLoading,
					animated: "",
					onClick: _ctx.handleSmartTranslateButtonClick
				}, null, 8, [
					"label",
					"disabled",
					"loading",
					"onClick"
				])) : createCommentVNode("", true), createVNode(_component_ButtonsLayout, { class: "input-localizable-string-modal-buttons" }, {
					default: withCtx(() => [createVNode(_component_Button, {
						class: "input-localizable-string-modal-ok-button",
						variant: "primary",
						icon: "validate",
						label: _ctx.translate("Ok"),
						animated: "",
						onClick: _ctx.commitModalDraft
					}, null, 8, ["label", "onClick"]), createVNode(_component_Button, {
						class: "input-localizable-string-modal-close-button",
						icon: "close",
						label: _ctx.translate("Cancel"),
						animated: "",
						onClick: _ctx.closeModal
					}, null, 8, ["label", "onClick"])]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 8, ["is-open"])], 64)) : createCommentVNode("", true)]),
		_: 1
	}, 8, [
		"focused",
		"model-value",
		"label",
		"label-position",
		"disabled",
		"readonly",
		"required",
		"tooltip",
		"input-display-mode",
		"message-text",
		"message-severity",
		"message-position",
		"documentation",
		"tab-stop",
		"max-length",
		"multi-lines",
		"rows",
		"placeholder",
		"white-space-handling",
		"ai-suggestion",
		"class",
		"style",
		"onInput",
		"onChange",
		"onFocusout"
	]);
}
var InputLocalizableString_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputLocalizableString_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$3], ["__scopeId", "data-v-b0270a8e"]]);
// src/composables/useTextboxInput.ts
/**
* Builds an input on the input of a Textbox, whose template reference is `textbox`: the input
* component handles the edits itself and gives the Textbox the resulting text.
*
* @param initialText - The text before the input is mounted.
* @param alignment - Gets the alignment of the text, which the Textbox does not set.
*/
function useTextboxInput(initialText, alignment) {
	const textbox = useTemplateRef("textbox");
	let input;
	const text = ref(initialText);
	const listeners = [];
	onMounted(() => {
		input = textbox.value.input;
		alignText();
		const root = textbox.value.$el;
		for (const [type, handler] of listeners) root.addEventListener(type, handler, true);
	});
	if (alignment) watch(alignment, alignText);
	function alignText() {
		if (alignment) input.style.textAlign = alignment();
	}
	/**
	* Gets the input, once mounted.
	*/
	function getInput() {
		return input;
	}
	/**
	* Displays a text, in the input as well when it is mounted.
	*/
	function setText(newText) {
		text.value = newText;
		if (input && input.value !== newText) input.value = newText;
	}
	/**
	* Sets a text the input would not get from the key typed, as an input of the user.
	*/
	function applyText(newText, caret) {
		const inputElement = getInput();
		inputElement.value = newText;
		inputElement.setSelectionRange(caret, caret);
		inputElement.dispatchEvent(new Event("input", { bubbles: true }));
	}
	/**
	* Replaces the selected text, as an input of the user.
	*/
	function replaceSelection(newText) {
		const inputElement = getInput();
		const start = inputElement.selectionStart;
		applyText(inputElement.value.slice(0, start) + newText + inputElement.value.slice(inputElement.selectionEnd), start + newText.length);
	}
	/**
	* Listens to an event of the input, before the Textbox. Must be called during the setup.
	*/
	function listen(type, handler) {
		listeners.push([type, (event) => {
			if (event.target === input) handler(event);
		}]);
	}
	return {
		text,
		getInput,
		setText,
		applyText,
		replaceSelection,
		listen
	};
}
// src/components/InputMask/inputMaskUtils.ts
/**
* A pasted text or a text set by a script can be raw or formatted: it is read as typed, or as
* formatted when some of its characters are rejected otherwise.
*/
var untypedTextLiteralMatchings = ["unlessAccepted", "always"];
var caretKeys = /* @__PURE__ */ new Set([
	"ArrowLeft",
	"ArrowRight",
	"ArrowUp",
	"ArrowDown",
	"Home",
	"End",
	"PageUp",
	"PageDown"
]);
var inputSlotPatterns = /* @__PURE__ */ new Map([
	["0", /^\d$/u],
	["9", /^[\d ]$/u],
	["#", /^[\d+\- ]$/u],
	["L", /^\p{L}$/u],
	["l", /^[\p{L} ]$/u],
	["A", /^[\p{L}\p{N}]$/u],
	["a", /^[\p{L}\p{N} ]$/u]
]);
var cultureCurrencies = /* @__PURE__ */ new Map([
	["de", "EUR"],
	["en", "USD"],
	["en-CA", "CAD"],
	["en-GB", "GBP"],
	["es", "EUR"],
	["fr", "EUR"],
	["fr-CA", "CAD"],
	["it", "EUR"],
	["pt", "BRL"]
]);
/**
* Parses a mask into slots of one UTF-16 code unit each, the unit of the selection of the input.
*/
function parseMask(mask, separators) {
	const slots = [];
	const maskChars = mask.split("");
	let casing;
	for (let index = 0; index < maskChars.length; index++) {
		const char = maskChars[index];
		switch (char) {
			case "\\":
				index++;
				pushLiterals(slots, maskChars[index] ?? "");
				break;
			case ">":
				casing = "upper";
				break;
			case "<":
				casing = "lower";
				break;
			case "|":
				casing = void 0;
				break;
			default: {
				const accepts = inputSlotPatterns.get(char);
				if (accepts) slots.push({
					accepts,
					casing
				});
				else pushLiterals(slots, separators.get(char) ?? char);
			}
		}
	}
	return slots;
}
function pushLiterals(slots, text) {
	for (const literal of text.split("")) slots.push({ literal });
}
function getSeparators(localizator) {
	const culture = localizator.currentCulture;
	const numberParts = new Intl.NumberFormat(culture).formatToParts(1000000.1);
	const dateParts = new Intl.DateTimeFormat(culture, {
		day: "2-digit",
		month: "2-digit",
		year: "numeric"
	}).formatToParts();
	const timeParts = new Intl.DateTimeFormat(culture, {
		hour: "2-digit",
		minute: "2-digit"
	}).formatToParts();
	return /* @__PURE__ */ new Map([
		[".", getPart(numberParts, "decimal")],
		[",", getPart(numberParts, "group")],
		["/", getPart(dateParts, "literal")],
		[":", timeParts[timeParts.findIndex((part) => part.type === "hour") + 1].value],
		["$", getCurrencySymbol(localizator)]
	]);
}
/**
* Gets the currency symbol of the first culture with a known currency, written as in that culture.
*/
function getCurrencySymbol(localizator) {
	const currencyCulture = [
		localizator.currentCulture,
		new Intl.Locale(localizator.currentCulture).language,
		localizator.currentLanguage,
		localizator.defaultLanguage
	].find((candidate) => cultureCurrencies.has(candidate)) ?? "en";
	return getPart(new Intl.NumberFormat(currencyCulture, {
		style: "currency",
		currency: cultureCurrencies.get(currencyCulture),
		currencyDisplay: "narrowSymbol"
	}).formatToParts(1), "currency");
}
function getPart(parts, type) {
	return parts.find((part) => part.type === type).value;
}
/**
* Gets the value of a model value, an empty mask having no value.
*/
function toValue(modelValue) {
	return modelValue === "" ? null : modelValue;
}
function isInputSlot(slot) {
	return "accepts" in slot;
}
function applyCasing(char, casing) {
	const converted = convertCase(char, casing);
	return converted.length === 1 ? converted : char;
}
function convertCase(char, casing) {
	switch (casing) {
		case "upper": return char.toUpperCase();
		case "lower": return char.toLowerCase();
		default: return char;
	}
}
// src/components/InputMask/InputMask.vue
var InputMask_default = /* @__PURE__ */ defineComponent({
	__name: "InputMask",
	props: {
		...inputProps,
		...contentProps,
		modelValue: {
			type: String,
			default: null
		},
		updateMode: {
			type: String,
			default: "default"
		},
		mask: {
			type: String,
			required: true
		},
		valueMode: {
			type: String,
			default: "raw"
		},
		tooltip: {
			type: String,
			default: void 0
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const textboxProps = computed(() => {
			const { modelValue, updateMode, mask, valueMode, ...forwardedProps } = props;
			return forwardedProps;
		});
		const localizator = useLocalizator();
		const slots = computed(() => parseMask(props.mask, getSeparators(localizator)));
		let chars = [];
		let committedValue = toValue(props.modelValue);
		let composition;
		let skippedLiterals;
		const { text: displayText, getInput, setText, listen } = useTextboxInput("");
		watch([slots, () => props.valueMode], load, { immediate: true });
		watch(() => props.modelValue, (modelValue) => {
			committedValue = toValue(modelValue);
			if (committedValue !== getValue()) load();
		});
		listen("beforeinput", handleBeforeInput);
		listen("input", handleInput);
		listen("compositionstart", handleCompositionStart);
		listen("compositionend", handleCompositionEnd);
		listen("blur", commit);
		listen("change", commit);
		listen("keydown", handleKeyDown);
		function load() {
			forgetSkippedLiterals();
			chars = slots.value.map(() => null);
			fill(props.modelValue ?? "", 0, props.valueMode === "formatted" ? "always" : "never");
			render();
		}
		function handleBeforeInput(event) {
			const inputEvent = event;
			if (inputEvent.isComposing) return;
			event.preventDefault();
			const input = getInput();
			const start = input.selectionStart;
			const end = input.selectionEnd;
			const lastSkippedLiterals = skippedLiterals;
			skippedLiterals = void 0;
			const caret = edit(inputEvent, start, end, lastSkippedLiterals);
			if (caret !== void 0) {
				render(caret);
				emitValueIfImmediate();
			}
		}
		function edit(event, start, end, lastSkippedLiterals) {
			if (event.inputType.startsWith("insert")) {
				const text = event.data ?? event.dataTransfer?.getData("text/plain") ?? "";
				if (event.inputType !== "insertText") return insert(text, start, end, untypedTextLiteralMatchings)?.caret;
				return typeText(text, start, end, lastSkippedLiterals);
			}
			if (event.inputType.startsWith("delete")) return remove(start, end, event.inputType);
		}
		/**
		* Types a text, or absorbs it when it repeats the literal the caret has just moved past: someone
		* typing a formatted text types the separators too.
		*/
		function typeText(text, start, end, lastSkippedLiterals) {
			if (lastSkippedLiterals && start === end && start === lastSkippedLiterals.end && text === slots.value[lastSkippedLiterals.next].literal) {
				const next = lastSkippedLiterals.next + 1;
				skippedLiterals = next < lastSkippedLiterals.end ? {
					next,
					end: lastSkippedLiterals.end
				} : void 0;
				return start;
			}
			const result = insert(text, start, end, ["unlessAccepted"]);
			if (result && result.caret > result.position) skippedLiterals = {
				next: result.position,
				end: result.caret
			};
			return result?.caret;
		}
		/**
		* Inserts a text at the selection.
		*
		* @returns The position after the last character placed and the caret after the literals that
		* follow it, or undefined when no character was placed.
		*/
		function insert(text, start, end, literalMatchings) {
			const previousChars = [...chars];
			const attempts = literalMatchings.map((literalMatching) => {
				chars = [...previousChars];
				clear(start, end);
				return {
					...fill(text, start, literalMatching),
					chars
				};
			});
			const attempt = attempts.find((candidate) => candidate.isComplete) ?? attempts[0];
			if (attempt.position === start) {
				chars = previousChars;
				return;
			}
			chars = attempt.chars;
			return {
				position: attempt.position,
				caret: skipLiterals(attempt.position)
			};
		}
		function remove(start, end, inputType) {
			if (start !== end) {
				clear(start, end);
				return start;
			}
			const isBackward = inputType.endsWith("Backward");
			const range = getDeletionRange(inputType, start, isBackward);
			if (range) {
				clear(...range);
				return range[0];
			}
			return isBackward ? removeBackward(start) : removeForward(start);
		}
		function removeBackward(start) {
			const position = findPreviousInputSlot(start);
			if (position === void 0) return;
			chars[position] = null;
			return position;
		}
		/**
		* Clears the next input slot and keeps the caret, for the next character typed to fill it, or moves
		* past that slot when it is already empty.
		*/
		function removeForward(start) {
			const position = findNextInputSlot(start);
			if (position === void 0) return;
			if (chars[position] === null) return position + 1;
			chars[position] = null;
			return start;
		}
		/**
		* Gets the slots a word or line deletion clears, a word being a group of input slots.
		*/
		function getDeletionRange(inputType, start, isBackward) {
			if (inputType.includes("Line")) return isBackward ? [0, start] : [start, slots.value.length];
			if (inputType.includes("Word")) return isBackward ? [findGroupStart(start), start] : [start, findGroupEnd(start)];
		}
		/**
		* Applies a text the mask cannot follow edit by edit, set by a script for instance.
		*/
		function handleInput(event) {
			if (event.isComposing) {
				event.stopPropagation();
				return;
			}
			forgetSkippedLiterals();
			const input = getInput();
			const caret = input.selectionStart;
			chars = slots.value.map(() => null);
			insert(input.value, 0, 0, untypedTextLiteralMatchings);
			render(Math.min(caret, slots.value.length));
			emitValueIfImmediate();
		}
		function handleCompositionStart() {
			const input = getInput();
			composition = {
				chars: [...chars],
				start: input.selectionStart,
				end: input.selectionEnd
			};
		}
		/**
		* Applies the composed text as typed text: the events of a composition cannot be canceled.
		*/
		function handleCompositionEnd(event) {
			if (!composition) return;
			forgetSkippedLiterals();
			const { start, end } = composition;
			chars = composition.chars;
			composition = void 0;
			render(insert(event.data, start, end, ["unlessAccepted"])?.caret ?? start);
			emitValueIfImmediate();
		}
		function handleKeyDown(event) {
			if (caretKeys.has(event.key)) forgetSkippedLiterals();
			if (event.key === "Enter") commit();
		}
		function forgetSkippedLiterals() {
			skippedLiterals = void 0;
		}
		function commit() {
			forgetSkippedLiterals();
			emitValue();
		}
		function render(caret) {
			setText(isEmpty() ? "" : getDisplayText());
			if (caret !== void 0) getInput().setSelectionRange(caret, caret);
		}
		function emitValueIfImmediate() {
			if (props.updateMode === "immediate") emitValue();
		}
		function emitValue() {
			const value = getValue();
			if (value !== committedValue) {
				committedValue = value;
				emit("update:modelValue", value);
			}
		}
		function getValue() {
			if (isEmpty()) return null;
			return props.valueMode === "formatted" ? getDisplayText() : chars.join("");
		}
		function isEmpty() {
			return chars.every((char) => char === null);
		}
		function getDisplayText() {
			return slots.value.map((slot, index) => isInputSlot(slot) ? chars[index] ?? "_" : slot.literal).join("");
		}
		/**
		* Fills the slots from a position with the characters of a text. A character matching the next
		* literal can move past it, any other character goes into the next input slot, or is dropped when
		* that slot rejects it. A prompt of a formatted text leaves its slot empty.
		*
		* @returns The position after the last character placed, and whether no character was rejected
		* before the end of the mask.
		*/
		function fill(text, start, literalMatching) {
			let position = start;
			let isComplete = true;
			for (const char of text.split("")) {
				if (position >= slots.value.length) break;
				const nextPosition = fillChar(char, position, literalMatching);
				isComplete &&= nextPosition !== position;
				position = nextPosition;
			}
			return {
				position,
				isComplete
			};
		}
		function fillChar(char, start, literalMatching) {
			for (let position = start; position < slots.value.length; position++) {
				const slot = slots.value[position];
				if (!isInputSlot(slot)) {
					if (slot.literal === char && matchesLiteral(char, position, literalMatching)) return position + 1;
					continue;
				}
				if (char === "_" && literalMatching === "always") {
					chars[position] = null;
					return position + 1;
				}
				const value = applyCasing(char, slot.casing);
				if (slot.accepts.test(value)) {
					chars[position] = value;
					return position + 1;
				}
				return start;
			}
			return start;
		}
		function matchesLiteral(char, position, literalMatching) {
			if (literalMatching !== "unlessAccepted") return literalMatching === "always";
			if (followsFilledSlot(position)) return true;
			const next = findNextInputSlot(position);
			if (next === void 0) return true;
			const slot = slots.value[next];
			return !slot.accepts.test(applyCasing(char, slot.casing));
		}
		function followsFilledSlot(position) {
			const previous = findPreviousInputSlot(position);
			return previous !== void 0 && chars[previous] !== null;
		}
		function clear(start, end) {
			for (let position = start; position < end; position++) chars[position] = null;
		}
		function skipLiterals(start) {
			let position = start;
			while (position < slots.value.length && !isInputSlot(slots.value[position])) position++;
			return position;
		}
		function findPreviousInputSlot(start) {
			for (let position = start - 1; position >= 0; position--) if (isInputSlot(slots.value[position])) return position;
		}
		function findGroupStart(start) {
			let position = start;
			while (position > 0 && !isInputSlot(slots.value[position - 1])) position--;
			while (position > 0 && isInputSlot(slots.value[position - 1])) position--;
			return position;
		}
		function findGroupEnd(start) {
			let position = start;
			while (position < slots.value.length && !isInputSlot(slots.value[position])) position++;
			while (position < slots.value.length && isInputSlot(slots.value[position])) position++;
			return position;
		}
		function findNextInputSlot(start) {
			for (let position = start; position < slots.value.length; position++) if (isInputSlot(slots.value[position])) return position;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Textbox_default, mergeProps({ ref: "textbox" }, textboxProps.value, {
				"model-value": unref(displayText),
				class: "input-mask",
				onPointerdownCapture: forgetSkippedLiterals,
				"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => emit("update:focused", $event)),
				onAiApply: _cache[1] || (_cache[1] = ($event) => emit("aiApply")),
				onAiCancel: _cache[2] || (_cache[2] = ($event) => emit("aiCancel"))
			}), null, 16, ["model-value"]);
		};
	}
});
// src/composables/useNumberRangeMessage.ts
/**
* Gets the error message of a number input whose value is out of its min/max range.
*
* @param props - The props of the number input.
*/
function useNumberRangeMessage(props) {
	const { translate } = useGlobalResourceManager();
	const messageText = computed(() => {
		const value = props.modelValue;
		if (value != null && props.minValue != null && value < props.minValue) return translate("ValidationMessage_MinFieldValue_ShortText", props.minValue);
		if (value != null && props.maxValue != null && value > props.maxValue) return translate("ValidationMessage_MaxFieldValue_ShortText", props.maxValue);
	});
	return {
		messageText,
		messageSeverity: computed(() => messageText.value ? "error" : void 0)
	};
}
var percentSign = "%";
/**
* Reads the symbols and the precision of a format.
*
* @param showPositiveSign - Whether a positive number is displayed with a leading plus sign.
*/
function getNumberFormatInfo(format, showPositiveSign = false) {
	const numberFormat = culture.Globalize.numberFormat;
	const formatInfo = Globalize._parseNumericFormat(format);
	return {
		format,
		decimalSeparator: numberFormat["."],
		groupSeparator: numberFormat[","],
		currencySymbol: formatInfo.curr ?? numberFormat.currency.symbol,
		precision: getPrecision(formatInfo.spec, formatInfo.prec),
		isPercent: formatInfo.spec === "p",
		isHexadecimal: formatInfo.spec === "x",
		isExponential: formatInfo.spec === "e",
		showPositiveSign
	};
}
/**
* Gets the number of decimals a format shows, as Wijmo formats it when the format sets none: the
* currency decimals of the culture for a currency, and all of them for a round-trip format. The
* precision of an integer format pads its digits.
*/
function getPrecision(spec, precision) {
	switch (spec) {
		case "d":
		case "x": return 0;
		case "e": return precision ?? 6;
		case "r": return precision ?? Infinity;
		case "c": return precision ?? culture.Globalize.numberFormat.currency.decimals;
		default: return precision ?? 2;
	}
}
/**
* Formats a number with a format read by getNumberFormatInfo, an empty text standing for no number.
*/
function formatNumber(value, formatInfo) {
	if (value == null || !Number.isFinite(value)) return "";
	const text = Globalize.format(value, formatInfo.format);
	return formatInfo.showPositiveSign && value > 0 && !formatInfo.isHexadecimal && /[1-9]/u.test(text) ? `+${text}` : text;
}
/**
* Parses a text typed or formatted in the culture.
*
* @returns The number, null for an empty text, or undefined for a text that is no number yet.
*/
function parseNumber(text, formatInfo) {
	if (text.trim() === "") return null;
	const percentText = formatInfo.isPercent && !text.includes(percentSign) ? `${text}${percentSign}` : text;
	const value = Globalize.parseFloat(percentText, formatInfo.format);
	return Number.isFinite(value) ? value : void 0;
}
/**
* Rounds a number to what its formatted text shows, the value the input then holds.
*/
function roundNumber(value, formatInfo) {
	return parseNumber(formatNumber(value, formatInfo), formatInfo);
}
/**
* Whether a text can be typed: only the characters of a formatted number, a single decimal
* separator, and no more decimals than the format shows. Only what the typing adds is checked,
* so that a text set otherwise (a currency symbol of several letters for instance) stays editable.
*
* @param typedText - The typed text.
* @param oldText - The text of the input before the typing.
* @param newText - The text of the input with the typed text.
*/
function isTypeable(typedText, oldText, newText, formatInfo) {
	if (!isTypeableText(typedText, formatInfo)) return false;
	const isSeparatorTypeable = newText.split(formatInfo.decimalSeparator).length - 1 === 1 && formatInfo.precision > 0;
	if (typedText.includes(formatInfo.decimalSeparator) && !isSeparatorTypeable) return false;
	const decimalDigits = countDecimalDigits(newText, formatInfo);
	return decimalDigits <= formatInfo.precision || decimalDigits <= countDecimalDigits(oldText, formatInfo);
}
function countDecimalDigits(text, formatInfo) {
	const [, decimals = ""] = text.split(formatInfo.decimalSeparator);
	const [mantissaDecimals] = decimals.split(/e/iu);
	return mantissaDecimals.replaceAll(/\D/gu, "").length;
}
function isTypeableText(text, formatInfo) {
	return [...text].every((char) => isTypeableChar(char, formatInfo));
}
function isTypeableChar(char, formatInfo) {
	const symbols = [
		formatInfo.decimalSeparator,
		formatInfo.groupSeparator,
		formatInfo.currencySymbol,
		"-",
		percentSign
	];
	if (formatInfo.showPositiveSign) symbols.push("+");
	return /[\d()]/u.test(char) || isFormatChar(char, formatInfo) || symbols.includes(char);
}
/**
* Whether a character belongs to the numbers of the format only: a hexadecimal digit, or the
* letter and the sign of an exponent.
*/
function isFormatChar(char, formatInfo) {
	if (formatInfo.isHexadecimal) return /[a-f]/iu.test(char);
	return formatInfo.isExponential && /[e+]/iu.test(char);
}
/**
* Gets the character a typed character stands for: a point or a comma that is not the group
* separator is the decimal separator, whatever the keyboard layout of the numeric keypad, and a
* space is the group separator of a culture that separates groups with a space.
*/
function toTypedChar(char, formatInfo) {
	if ((char === "." || char === ",") && char !== formatInfo.groupSeparator) return formatInfo.decimalSeparator;
	return /\s/u.test(char) && /\s/u.test(formatInfo.groupSeparator) ? formatInfo.groupSeparator : char;
}
/**
* Gets the text a text stands for, its points and commas read as by {@link toTypedChar}, but in
* the currency symbol, which may hold one (kr.).
*/
function toTypedText(text, formatInfo) {
	const { currencySymbol } = formatInfo;
	return text.split(currencySymbol).map((part) => [...part].map((char) => toTypedChar(char, formatInfo)).join("")).join(currencySymbol);
}
/**
* Gets the text a pasted text stands for: trimmed and read as by {@link toTypedChar}. A text
* holding characters that cannot be typed stays as pasted, to be committed as an invalid value
* rather than read as another number.
*/
function toAcceptedText(text, formatInfo) {
	const typedText = toTypedText(text.trim(), formatInfo);
	return isTypeableText(typedText, formatInfo) ? typedText : text;
}
/**
* Whether a character is a digit or the decimal separator, the characters of a number as typed.
*/
function isNumberChar(char, formatInfo) {
	return /\d/u.test(char) || char === formatInfo.decimalSeparator;
}
/**
* Gets the texts a format puts around a number, or undefined for a format whose numbers are not
* typed as digits only (an exponential or a hexadecimal format).
*/
function getMaskInfo(formatInfo) {
	if (formatInfo.isExponential || formatInfo.isHexadecimal) return;
	return {
		positiveAffixes: getAffixes(formatNumber(1, formatInfo)),
		negativeAffixes: getAffixes(formatNumber(-1, formatInfo)),
		isGrouped: formatNumber(1e3, formatInfo).includes(formatInfo.groupSeparator)
	};
}
function getAffixes(formattedText) {
	return [/^\D*/u.exec(formattedText)[0], /\D*$/u.exec(formattedText)[0]];
}
/**
* Gets a number being typed as its format displays it, its decimals kept as typed: the digits
* grouped, and the affixes of the format (a currency or a percent sign) around them. The caret stays
* after the same digit.
*/
function toMaskedText(text, caret, formatInfo, maskInfo) {
	const isNumberPart = (char) => isNumberChar(char, formatInfo);
	const [prefix, suffix] = isNegativeText(text) ? maskInfo.negativeAffixes : maskInfo.positiveAffixes;
	const numberStart = text.startsWith(prefix) ? prefix.length : 0;
	const numberEnd = suffix !== "" && text.endsWith(suffix) ? text.length - suffix.length : text.length;
	const getNumberText = (end) => [...text.slice(numberStart, end)].filter(isNumberPart).join("");
	const [integer, ...decimals] = getNumberText(numberEnd).split(formatInfo.decimalSeparator);
	const maskedText = `${prefix}${[maskInfo.isGrouped ? integer.replaceAll(/\B(?=(?:\d{3})+$)/gu, formatInfo.groupSeparator) : integer, ...decimals].join(formatInfo.decimalSeparator)}${suffix}`;
	let charCount = getNumberText(Math.min(caret, numberEnd)).length;
	let maskedCaret = prefix.length;
	while (charCount > 0) {
		charCount -= isNumberPart(maskedText[maskedCaret]) ? 1 : 0;
		maskedCaret++;
	}
	return {
		text: maskedText,
		caret: maskedCaret
	};
}
/**
* Whether a text is a negative number: led by a minus sign, or in parentheses as a negative
* currency is formatted.
*/
function isNegativeText(text) {
	return text.startsWith("-") || text.startsWith("(") && text.endsWith(")");
}
// src/composables/useRepeatedPress.ts
var repeatDelay = 400;
var repeatInterval = 75;
/**
* Runs an action when a button is pressed, then repeatedly while it is held down, as the spin
* buttons of a native number input do. A click without a press, from a screen reader for instance,
* runs the action once.
*
* @param action - The action to run.
*/
function useRepeatedPress(action) {
	let timer;
	let isClickHandled = false;
	function handlePointerDown(event) {
		if (event.button !== 0) return;
		isClickHandled = true;
		action();
		timer = setTimeout(repeat, repeatDelay);
		window.addEventListener("pointerup", handlePressEnd);
		window.addEventListener("pointercancel", handlePressEnd);
	}
	function repeat() {
		action();
		timer = setTimeout(repeat, repeatInterval);
	}
	function handlePressEnd() {
		stop();
		setTimeout(() => {
			isClickHandled = false;
		});
	}
	function stop() {
		clearTimeout(timer);
		window.removeEventListener("pointerup", handlePressEnd);
		window.removeEventListener("pointercancel", handlePressEnd);
	}
	function handlePointerLeave() {
		clearTimeout(timer);
	}
	function handleClick() {
		if (isClickHandled) {
			isClickHandled = false;
			return;
		}
		action();
	}
	onScopeDispose(stop, true);
	return {
		handlePointerDown,
		handlePointerLeave,
		handleClick
	};
}
// src/components/InputNumber/NumberSpinnerButton.vue
var NumberSpinnerButton_default = /* @__PURE__ */ defineComponent({
	__name: "NumberSpinnerButton",
	props: {
		direction: {},
		disabled: { type: Boolean }
	},
	emits: ["spin"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const press = useRepeatedPress(() => emit("spin"));
		const resourceKeys = {
			decrement: "InputNumber_Decrement",
			increment: "InputNumber_Increment"
		};
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Button_default, {
				class: normalizeClass(`input-number-${props.direction}`),
				size: "small",
				variant: "ghost",
				icon: props.direction,
				tabindex: "-1",
				"aria-label": unref(translate)(resourceKeys[props.direction]),
				disabled: props.disabled,
				onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"])),
				onPointerdown: unref(press).handlePointerDown,
				onPointerleave: unref(press).handlePointerLeave,
				onClick: unref(press).handleClick
			}, null, 8, [
				"class",
				"icon",
				"aria-label",
				"disabled",
				"onPointerdown",
				"onPointerleave",
				"onClick"
			]);
		};
	}
});
// src/components/InputNumber/useCalculableInput.ts
/**
* The calculable mode of an InputNumber: the formula, which a commit evaluates, its preview, and
* the mask that formats the number being typed. Without the calculable prop, the input is left to
* the InputNumber.
*/
function useCalculableInput(props, formatInfo, textboxInput) {
	const { text, getInput, applyText, replaceSelection } = textboxInput;
	const { translate } = useGlobalResourceManager();
	const isFormula = ref(false);
	watch(() => props.calculable, (calculable) => {
		if (!calculable) isFormula.value = false;
	}, { flush: "sync" });
	const modeClasses = computed(() => props.calculable && {
		"calc-mode": isFormula.value,
		"preview-left": props.previewModePosition === "left",
		"preview-top": props.previewModePosition === "top"
	});
	const isPreviewVisible = computed(() => props.previewModePosition === "left" || props.previewModePosition === "top");
	const previewedFormula = refDebounced(computed(() => isFormula.value && isPreviewVisible.value ? text.value : ""), 300);
	const preview = computed(() => {
		if (!isFormula.value) return "";
		const value = evaluateFormula(previewedFormula.value, formatInfo.value);
		return value === void 0 ? translate("InputNumber_InvalidFormula") : formatNumber(value, formatInfo.value);
	});
	const maskInfo = computed(() => getMaskInfo(formatInfo.value));
	/**
	* Gets the value of a text: the result of the formula, or the typed number.
	*
	* @returns The value, null for an empty text, or undefined for a text that has no value.
	*/
	function parse(textToParse) {
		return isFormula.value ? evaluateFormula(textToParse, formatInfo.value) : parseNumber(textToParse, formatInfo.value);
	}
	/**
	* Pastes a text in a formula as is, and replaces the text with the formula of a pasted text led by
	* the formula sign, as typing the sign starts an empty formula.
	*
	* @returns Whether the text is pasted as a formula.
	*/
	function handlePaste(event, pastedText) {
		if (!props.calculable) return false;
		if (isFormula.value) return true;
		const trimmedText = pastedText.trim();
		if (!trimmedText.startsWith(formulaSign)) return false;
		event.preventDefault();
		isFormula.value = true;
		const formula = trimmedText.slice(formulaSign.length);
		applyText(formula, formula.length);
		return true;
	}
	/**
	* Types in a formula the characters it accepts. Out of a formula, the formula sign starts an
	* empty formula, and an operator a formula of the number, or of the operator alone when it
	* replaces the whole text.
	*
	* @returns Whether the text is typed as a formula.
	*/
	function handleTypedText(event, data) {
		if (!props.calculable) return false;
		if (isFormula.value) {
			typeInFormula(event, data);
			return true;
		}
		if (data !== formulaSign && !operators.has(data)) return false;
		event.preventDefault();
		const formula = data === formulaSign ? "" : getTypedFormulaStart(data);
		isFormula.value = true;
		applyText(formula, formula.length);
		return true;
	}
	/**
	* Groups the digits of the number being typed and adds the affixes of its format, with the mask.
	* A deletion that leaves the affixes only empties the input. Another text that is no number is
	* kept as typed.
	*/
	function maskText(isDeletion) {
		if (!props.calculable || !props.enableMask || isFormula.value || !maskInfo.value) return;
		const input = getInput();
		const { positiveAffixes, negativeAffixes } = maskInfo.value;
		const isAffixOnly = [positiveAffixes, negativeAffixes].some((affixes) => input.value === affixes.join(""));
		if (isDeletion && isAffixOnly) {
			input.value = "";
			return;
		}
		if (typeof parseNumber(input.value, formatInfo.value) !== "number") return;
		const masked = toMaskedText(input.value, input.selectionStart, formatInfo.value, maskInfo.value);
		if (masked.text !== input.value) {
			input.value = masked.text;
			input.setSelectionRange(masked.caret, masked.caret);
		}
	}
	function leaveFormula() {
		isFormula.value = false;
	}
	/**
	* Edits as a formula an invalid value a calculable input displays again: a formula that could not
	* be evaluated, or a text that is no number, which a formula evaluates as invalid too.
	*/
	function editInvalidValue() {
		isFormula.value = props.calculable;
	}
	function typeInFormula(event, data) {
		const typedText = toTypedText(data, formatInfo.value);
		if (![...typedText].every((char) => isFormulaChar(char, formatInfo.value))) event.preventDefault();
		else if (typedText !== data) {
			event.preventDefault();
			replaceSelection(typedText);
		}
	}
	function getTypedFormulaStart(operator) {
		const input = getInput();
		return input.selectionStart === 0 && input.selectionEnd === input.value.length && operator !== "(" ? operator : getFormulaStart(operator, input.value, formatInfo.value);
	}
	return {
		isFormula: readonly(isFormula),
		modeClasses,
		isPreviewVisible,
		preview,
		parse,
		handlePaste,
		handleTypedText,
		maskText,
		leaveFormula,
		editInvalidValue
	};
}
var formulaSign = "=";
var operators = /* @__PURE__ */ new Set([
	"+",
	"-",
	"*",
	"/",
	"%",
	"^",
	"(",
	")"
]);
/**
* Whether a character can be typed in a formula: a digit, an operator, a space or a separator of the
* culture.
*/
function isFormulaChar(char, formatInfo) {
	return /[\d\s]/u.test(char) || operators.has(char) || char === formatInfo.decimalSeparator || char === formatInfo.groupSeparator;
}
/**
* Gets the formula an operator typed on a number starts, the number becoming its first operand: an
* opening parenthesis encloses it, any other operator follows it. A negative operand is enclosed: a
* minus sign cannot lead a power.
*/
function getFormulaStart(operator, text, formatInfo) {
	const operand = toFormulaOperand(text, formatInfo);
	if (!operand) return operator;
	const enclosedOperand = `(${operand})`;
	if (operator === "(") return enclosedOperand;
	return `${operand.startsWith("-") ? enclosedOperand : operand}${operator}`;
}
/**
* Gets the operand a number text gives a formula: its digits and its decimal separator, in the unit
* of the typed number (a percentage without its sign). The number of an exponential or a
* hexadecimal format, whose text is not made of decimal digits, is written out from its value.
*/
function toFormulaOperand(text, formatInfo) {
	const value = parseNumber(text, formatInfo);
	if (value == null) return "";
	if (formatInfo.isExponential || formatInfo.isHexadecimal) return String(value).replace(".", formatInfo.decimalSeparator);
	const digits = [...text.replaceAll(formatInfo.currencySymbol, "")].filter((char) => isNumberChar(char, formatInfo)).join("");
	return isNegativeText(text) ? `-${digits}` : digits;
}
/**
* Evaluates a formula typed in the culture. Its result is in the unit of a typed number: a
* percentage without its sign.
*
* @returns The value, null for an empty formula, or undefined for a formula that cannot be evaluated.
*/
function evaluateFormula(formula, formatInfo) {
	const expression = formula.replaceAll(formatInfo.groupSeparator, "").replaceAll(formatInfo.decimalSeparator, ".");
	if (expression.trim() === "") return null;
	const result = evaluate(expression);
	if (result === void 0) return;
	return formatInfo.isPercent ? result / 100 : result;
}
var maxNesting = 100;
var binaryOperations = {
	"+": (left, right) => left + right,
	"-": (left, right) => left - right,
	"*": (left, right) => left * right,
	"/": (left, right) => left / right,
	"%": (left, right) => left % right
};
/**
* Evaluates an arithmetic expression of numbers with a point as decimal separator: the operations
* of {@link binaryOperations}, ^ for a power, parentheses and signs. A sign applies to a power, as
* in -2^2 = -4.
*
* @returns The finite result, or undefined for an expression that cannot be evaluated.
*/
function evaluate(expression) {
	const tokens = expression.match(/[\d.]+(?:e[+-]?\d+)?|\S/gu);
	let position = 0;
	let nesting = 0;
	const parseSum = () => parseOperations(["+", "-"], parseProduct);
	const parseProduct = () => parseOperations([
		"*",
		"/",
		"%"
	], parseSigned);
	function parseOperations(operators, parseOperand) {
		let value = parseOperand();
		while (operators.includes(tokens[position])) {
			const operation = binaryOperations[tokens[position++]];
			value = operation(value, parseOperand());
		}
		return value;
	}
	function parseSigned() {
		if (++nesting > maxNesting) return NaN;
		const value = parseSignedOperand();
		nesting--;
		return value;
	}
	function parseSignedOperand() {
		const sign = tokens[position];
		if (sign === "-" || sign === "+") {
			position++;
			return sign === "-" ? -parseSigned() : parseSigned();
		}
		return parsePower();
	}
	function parsePower() {
		const base = parseOperand();
		if (tokens[position] !== "^") return base;
		position++;
		const exponent = parseSigned();
		return Number.isNaN(base) ? NaN : base ** exponent;
	}
	function parseOperand() {
		const token = tokens[position++];
		if (token !== "(") return Number(token);
		const value = parseSum();
		return tokens[position++] === ")" ? value : NaN;
	}
	const result = parseSum();
	return position === tokens.length && Number.isFinite(result) ? result : void 0;
}
// src/components/InputNumber/InputNumber.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$16 = {
	key: 0,
	class: "calculable-preview",
	"aria-live": "polite"
};
// src/components/InputNumber/InputNumber.vue
var InputNumber_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputNumber",
	props: {
		...inputProps,
		...contentProps,
		modelValue: {
			type: Number,
			default: null
		},
		format: {
			type: String,
			default: void 0
		},
		minValue: {
			type: Number,
			default: void 0
		},
		maxValue: {
			type: Number,
			default: void 0
		},
		alignment: {
			type: String,
			default: "right"
		},
		step: {
			type: Number,
			default: void 0
		},
		updateMode: {
			type: String,
			default: "default"
		},
		invalidValue: {
			type: String,
			default: void 0
		},
		showPositiveSign: {
			type: Boolean,
			default: false
		},
		calculable: {
			type: Boolean,
			default: false
		},
		enableMask: {
			type: Boolean,
			default: true
		},
		previewModePosition: {
			type: String,
			default: "hidden"
		}
	},
	emits: [...inputEmits, "update:invalidValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const textboxProps = computed(() => {
			const { modelValue, format, minValue, maxValue, alignment, step, updateMode, messageText, messageSeverity, aiSuggestion, invalidValue, showPositiveSign, calculable, enableMask, previewModePosition, contentClass, ...forwardedProps } = props;
			return forwardedProps;
		});
		const { translate } = useGlobalResourceManager();
		useComponentAutomationProperties();
		const formatInfo = computed(() => getNumberFormatInfo(props.format ?? "", props.showPositiveSign));
		const committedValue = ref(props.modelValue);
		let focusValue = props.modelValue;
		let isFocusedByPointer = false;
		let isFocused = false;
		const invalidValue = useInputInvalidValue(props, emit);
		const textboxInput = useTextboxInput(invalidValue.value ?? formatNumber(props.modelValue, formatInfo.value), () => props.alignment);
		const { text, getInput, setText, applyText, replaceSelection, listen } = textboxInput;
		const calculableInput = useCalculableInput(props, formatInfo, textboxInput);
		if (invalidValue.value != null) calculableInput.editInvalidValue();
		const { isPreviewVisible, preview } = calculableInput;
		const contentClasses = computed(() => [...[props.contentClass].flat(), calculableInput.modeClasses.value]);
		const { messageText: rangeMessageText, messageSeverity: rangeMessageSeverity } = useNumberRangeMessage(props);
		const displayedMessageText = computed(() => props.messageText ?? (invalidValue.value == null ? rangeMessageText.value : translate("ValidationMessage_InvalidFieldValue_ShortText")));
		const displayedMessageSeverity = computed(() => props.messageSeverity ?? (invalidValue.value == null ? rangeMessageSeverity.value : "error"));
		const displayedAiSuggestion = computed(() => {
			const suggestedValue = props.aiSuggestion?.suggestedValue;
			return typeof suggestedValue === "number" ? {
				...props.aiSuggestion,
				suggestedValue: formatNumber(suggestedValue, formatInfo.value)
			} : props.aiSuggestion;
		});
		const isEditable = computed(() => !props.readonly && !props.disabled);
		const canBeNegative = computed(() => props.minValue == null || props.minValue < 0);
		const hasSpinner = computed(() => !!props.step);
		const isSpinnable = computed(() => hasSpinner.value && isEditable.value);
		const typedValue = computed(() => calculableInput.parse(text.value));
		const currentValue = computed(() => typedValue.value === void 0 ? committedValue.value : typedValue.value);
		const minStepValue = computed(() => toStepBound(props.minValue, 1));
		const maxStepValue = computed(() => toStepBound(props.maxValue, -1));
		const canDecrement = computed(() => isEditable.value && (minStepValue.value == null || currentValue.value == null || currentValue.value > minStepValue.value));
		const canIncrement = computed(() => isEditable.value && (maxStepValue.value == null || currentValue.value == null || currentValue.value < maxStepValue.value));
		/**
		* The attributes of the input the Textbox does not set: the spin button semantics with a step,
		* and the virtual keyboard.
		*/
		const inputAttributes = computed(() => ({
			inputmode: getInputMode(),
			role: hasSpinner.value ? "spinbutton" : void 0,
			"aria-valuemin": hasSpinner.value ? props.minValue : void 0,
			"aria-valuemax": hasSpinner.value ? props.maxValue : void 0,
			"aria-valuenow": hasSpinner.value ? typedValue.value : void 0,
			"aria-valuetext": hasSpinner.value ? text.value || void 0 : void 0
		}));
		const appliedAttributes = /* @__PURE__ */ new Map();
		watch([() => props.modelValue, invalidValue], ([modelValue, newInvalidValue], [oldModelValue, oldInvalidValue]) => {
			const isNewInvalidValue = isInvalidValueSet(newInvalidValue, oldInvalidValue);
			if (modelValue !== oldModelValue) receiveValue(modelValue, isNewInvalidValue);
			if (isNewInvalidValue) {
				calculableInput.editInvalidValue();
				setText(newInvalidValue);
			} else if (newInvalidValue == null && text.value === oldInvalidValue) render(committedValue.value);
		});
		watch(formatInfo, () => {
			if (invalidValue.value == null) render(committedValue.value);
		});
		watch(inputAttributes, applyInputAttributes);
		watch(isSpinnable, listenToWheel);
		listen("beforeinput", handleBeforeInput);
		listen("input", handleInput);
		listen("compositionend", handleInput);
		listen("focus", handleFocus);
		listen("blur", handleBlur);
		listen("change", commit);
		listen("keydown", handleKeyDown);
		onMounted(applyInputAttributes);
		/**
		* Gets the virtual keyboard of a number that cannot be negative, those of phones having no minus
		* key.
		*/
		function getInputMode() {
			if (props.calculable || canBeNegative.value || formatInfo.value.isHexadecimal) return;
			return formatInfo.value.precision > 0 ? "decimal" : "numeric";
		}
		/**
		* Whether the parent sets an invalid value the input does not display, the input setting the one
		* of the text it commits.
		*/
		function isInvalidValueSet(newInvalidValue, oldInvalidValue) {
			return newInvalidValue !== oldInvalidValue && newInvalidValue != null && newInvalidValue !== text.value;
		}
		/**
		* Takes a value of the parent, which Escape restores when it does not come from this input, and
		* displays it unless an invalid value comes with it.
		*/
		function receiveValue(modelValue, hasInvalidValue) {
			if (modelValue !== committedValue.value) focusValue = modelValue;
			committedValue.value = modelValue;
			const isTypedValue = !calculableInput.isFormula.value && parseNumber(text.value, formatInfo.value) === modelValue;
			if (!hasInvalidValue && !isTypedValue) render(modelValue);
		}
		/**
		* Sets the attributes that changed since they were last set: most of them only change with the props,
		* not with the text typed.
		*/
		function applyInputAttributes() {
			for (const [name, value] of Object.entries(inputAttributes.value)) {
				const attributeValue = value == null ? null : String(value);
				if (appliedAttributes.get(name) !== attributeValue) {
					appliedAttributes.set(name, attributeValue);
					if (attributeValue === null) getInput().removeAttribute(name);
					else getInput().setAttribute(name, attributeValue);
				}
			}
		}
		function handleBeforeInput(event) {
			const inputEvent = event;
			if (inputEvent.isComposing) return;
			if (inputEvent.inputType === "insertFromPaste") handlePaste(inputEvent);
			else if (inputEvent.inputType === "insertText" && inputEvent.data) handleTypedText(inputEvent, inputEvent.data);
		}
		function handlePaste(event) {
			const pastedText = event.data ?? event.dataTransfer?.getData("text/plain") ?? "";
			if (calculableInput.handlePaste(event, pastedText)) return;
			const acceptedText = toAcceptedText(pastedText, formatInfo.value);
			if (acceptedText !== pastedText) {
				event.preventDefault();
				replaceSelection(acceptedText);
			}
		}
		function handleTypedText(event, data) {
			if (calculableInput.handleTypedText(event, data)) return;
			const input = getInput();
			const { start, end, isAfterPlusSign } = getTypingRange(input);
			if (isSignKey(data, start)) {
				event.preventDefault();
				changeSign(input.value.slice(0, start) + input.value.slice(end), start, data === "-");
				return;
			}
			const typedText = toTypedText(data, formatInfo.value);
			const newText = input.value.slice(0, start) + typedText + input.value.slice(end);
			if (!isTypeable(typedText, input.value, newText, formatInfo.value)) event.preventDefault();
			else if (isAfterPlusSign) {
				event.preventDefault();
				applyText(newText, start + typedText.length);
			} else if (typedText !== data) {
				event.preventDefault();
				replaceSelection(typedText);
			}
		}
		/**
		* Gets where a typed text goes: the selection, or after the plus sign the number is displayed with
		* when the caret is before it.
		*/
		function getTypingRange(input) {
			const { selectionStart: start, selectionEnd: end } = input;
			const isAfterPlusSign = start === 0 && end === 0 && formatInfo.value.showPositiveSign && input.value.startsWith("+");
			return isAfterPlusSign ? {
				start: 1,
				end: 1,
				isAfterPlusSign
			} : {
				start,
				end,
				isAfterPlusSign
			};
		}
		/**
		* Whether a typed text changes the sign of the number: a minus or a plus sign, unless it is the
		* sign of an exponent, typed right after its letter.
		*/
		function isSignKey(data, caret) {
			const isSign = data === "-" || data === "+";
			const isExponentSign = formatInfo.value.isExponential && /e/iu.test(getInput().value.charAt(caret - 1));
			return isSign && !isExponentSign;
		}
		/**
		* Toggles the sign of the text with minus, removes it with plus: the sign leads the number
		* wherever it is typed. The plus sign a positive number is displayed with is replaced by the minus
		* sign and otherwise left as is.
		*/
		function changeSign(remainingText, caret, isMinus) {
			if (!isNegativeText(remainingText)) {
				if (isMinus && canBeNegative.value) {
					const hasPlusSign = remainingText.startsWith("+");
					const unsignedText = hasPlusSign ? remainingText.slice(1) : remainingText;
					applyText(`-${unsignedText}`, hasPlusSign ? Math.max(caret, 1) : caret + 1);
				}
				return;
			}
			const positiveText = remainingText.startsWith("-") ? remainingText.slice(1) : remainingText.slice(1, -1);
			applyText(positiveText, Math.min(Math.max(caret - 1, 0), positiveText.length));
		}
		function handleInput(event) {
			if (event.isComposing) return;
			const input = getInput();
			const typedText = event.inputType === "insertFromPaste" ? input.value : toTypedText(input.value, formatInfo.value);
			if (typedText !== input.value) {
				const { selectionStart, selectionEnd } = input;
				input.value = typedText;
				input.setSelectionRange(selectionStart, selectionEnd);
			}
			calculableInput.maskText(event.inputType?.startsWith("delete") === true);
			text.value = input.value;
			if (props.updateMode === "immediate" && !calculableInput.isFormula.value) {
				const value = typedValue.value;
				if (value !== void 0) {
					invalidValue.value = null;
					emitValue(value);
				}
			}
		}
		function handleFocus() {
			focusValue = committedValue.value;
			isFocused = true;
			listenToWheel();
		}
		function handleBlur() {
			isFocused = false;
			listenToWheel();
			commit();
		}
		/**
		* Listens to the wheel of a focused spin button only: a wheel listener that can prevent the
		* scrolling of the page makes it wait for the listener.
		*/
		function listenToWheel() {
			if (isFocused && isSpinnable.value) getInput().addEventListener("wheel", handleWheel, { passive: false });
			else getInput().removeEventListener("wheel", handleWheel);
		}
		function handleMouseDown(event) {
			const input = getInput();
			isFocusedByPointer = event.target === input && document.activeElement !== input;
		}
		/**
		* Selects the text of an input focused by a click, whose caret the release of the click places,
		* unless the press selected a part of it.
		*/
		function handleMouseUp(event) {
			const input = getInput();
			if (event.target === input && isFocusedByPointer && input.selectionStart === input.selectionEnd) input.select();
			isFocusedByPointer = false;
		}
		/**
		* Formats the typed text or the result of the formula and emits its value, or keeps a text that is
		* no number or a formula that cannot be evaluated as the invalid value, which displays an error
		* message. An unchanged text emits nothing: its value can have more decimals than the format shows.
		*/
		function commit() {
			const input = getInput();
			if (!calculableInput.isFormula.value && input.value === formatNumber(committedValue.value, formatInfo.value)) {
				invalidValue.value = null;
				keepModelValue(committedValue.value);
				return;
			}
			const value = calculableInput.parse(input.value);
			if (value === void 0) {
				invalidValue.value = input.value;
				return;
			}
			commitValue(value === null ? null : roundNumber(value, formatInfo.value));
		}
		function handleKeyDown(event) {
			if (event.isComposing) return;
			switch (event.key) {
				case "Enter":
					commit();
					break;
				case "Escape":
					if (isEditable.value) commitAndSelect(focusValue);
					break;
				default: handleSpinKey(event);
			}
		}
		/**
		* Handles the keys of a spin button: the arrows step the value, the page keys step it ten times,
		* Home and End go to the minimum and the maximum. Without a step, they are left to the container
		* (the navigation of a datagrid for instance) and to the caret.
		*/
		function handleSpinKey(event) {
			const isShortcut = event.ctrlKey || event.altKey || event.metaKey;
			if (!isSpinnable.value || isShortcut) return;
			const step = props.step;
			const bound = event.shiftKey ? void 0 : {
				Home: minStepValue.value,
				End: maxStepValue.value
			}[event.key];
			const delta = {
				ArrowUp: step,
				ArrowDown: -step,
				PageUp: step * 10,
				PageDown: -step * 10
			}[event.key];
			if (bound != null) {
				event.preventDefault();
				commitAndSelect(bound);
			} else if (delta !== void 0) {
				event.preventDefault();
				increment(delta);
			}
		}
		function handleWheel(event) {
			if (event.ctrlKey || !event.deltaY) return;
			event.preventDefault();
			increment(props.step * Math.sign(-event.deltaY));
		}
		function handleSpinnerClick(direction) {
			increment(props.step * direction);
			focusExceptOnTouchDevice(getInput());
		}
		/**
		* Adds a delta to the typed value, within the min/max range. An empty input starts from zero. A
		* typed value is never clamped: it only displays the range message.
		*/
		function increment(delta) {
			const value = roundNumber((currentValue.value ?? 0) + delta, formatInfo.value);
			commitAndSelect(Math.min(Math.max(value, minStepValue.value ?? Number.NEGATIVE_INFINITY), maxStepValue.value ?? Number.POSITIVE_INFINITY));
		}
		/**
		* Gets the value of the format nearest to a bound, on the side of the range: the format may not
		* show a bound more precise than itself.
		*
		* @param inward - 1 for the minimum, -1 for the maximum.
		*/
		function toStepBound(bound, inward) {
			if (bound == null) return;
			const roundedBound = roundNumber(bound, formatInfo.value);
			if ((roundedBound - bound) * inward >= 0) return roundedBound;
			const { precision, isPercent } = formatInfo.value;
			return roundNumber(roundedBound + 10 ** -precision / (isPercent ? 100 : 1) * inward, formatInfo.value);
		}
		function commitAndSelect(value) {
			commitValue(value);
			const input = getInput();
			if (document.activeElement === input) input.select();
		}
		/**
		* Displays and emits a value, and displays the value of the parent again if it does not take it, so
		* that the input never shows a value its model does not hold.
		*/
		function commitValue(value) {
			render(value);
			emitValue(value);
			keepModelValue(value);
		}
		function render(value) {
			invalidValue.value = null;
			calculableInput.leaveFormula();
			setText(formatNumber(value, formatInfo.value));
		}
		function emitValue(value) {
			if (value !== committedValue.value) {
				committedValue.value = value;
				emit("update:modelValue", value);
			}
		}
		/**
		* Displays the value of the parent again once it has rendered, if it has not taken a value emitted.
		*/
		function keepModelValue(value) {
			nextTick(() => {
				if (committedValue.value === value && props.modelValue !== value) {
					committedValue.value = props.modelValue;
					render(props.modelValue);
				}
			});
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Textbox_default, mergeProps({ ref: "textbox" }, textboxProps.value, {
				"model-value": unref(text),
				"message-text": displayedMessageText.value,
				"message-severity": displayedMessageSeverity.value,
				"ai-suggestion": displayedAiSuggestion.value,
				"content-class": contentClasses.value,
				class: ["input-number", { "input-number-calculable": __props.calculable }],
				onMousedownCapture: handleMouseDown,
				onMouseupCapture: handleMouseUp,
				"onUpdate:focused": _cache[2] || (_cache[2] = ($event) => emit("update:focused", $event)),
				onAiApply: _cache[3] || (_cache[3] = ($event) => emit("aiApply")),
				onAiCancel: _cache[4] || (_cache[4] = ($event) => emit("aiCancel"))
			}), createSlots({ _: 2 }, [_ctx.$slots.before || hasSpinner.value || __props.calculable ? {
				name: "before",
				fn: withCtx(() => [
					renderSlot(_ctx.$slots, "before", {}, void 0, true),
					hasSpinner.value ? (openBlock(), createBlock(NumberSpinnerButton_default, {
						key: 0,
						direction: "decrement",
						disabled: !canDecrement.value,
						onSpin: _cache[0] || (_cache[0] = ($event) => handleSpinnerClick(-1))
					}, null, 8, ["disabled"])) : createCommentVNode("", true),
					__props.calculable ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [createVNode(Image_default, {
						class: "image-calc",
						name: "excel",
						size: "small"
					}), unref(isPreviewVisible) ? (openBlock(), createElementBlock("div", _hoisted_1$16, toDisplayString(unref(preview)), 1)) : createCommentVNode("", true)], 64)) : createCommentVNode("", true)
				]),
				key: "0"
			} : void 0, _ctx.$slots.default || hasSpinner.value ? {
				name: "default",
				fn: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true), hasSpinner.value ? (openBlock(), createBlock(NumberSpinnerButton_default, {
					key: 0,
					direction: "increment",
					disabled: !canIncrement.value,
					onSpin: _cache[1] || (_cache[1] = ($event) => handleSpinnerClick(1))
				}, null, 8, ["disabled"])) : createCommentVNode("", true)]),
				key: "1"
			} : void 0]), 1040, [
				"model-value",
				"message-text",
				"message-severity",
				"ai-suggestion",
				"content-class",
				"class"
			]);
		};
	}
}), [["__scopeId", "data-v-2be9fe2e"]]);
// src/components/InputPassword/InputPassword.vue
var InputPassword_default = /* @__PURE__ */ defineComponent({
	__name: "InputPassword",
	props: {
		...inputProps,
		modelValue: {
			type: String,
			default: null
		},
		updateMode: {
			type: String,
			default: "default"
		},
		revealable: {
			type: Boolean,
			default: true
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const value = useVModel(props, "modelValue", emit);
		const focused = useVModel(props, "focused", emit);
		const revealed = ref(false);
		function handleRevealButtonClick() {
			revealed.value = !revealed.value;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Textbox_default, {
				modelValue: unref(value),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
				focused: unref(focused),
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => isRef(focused) ? focused.value = $event : null),
				type: revealed.value ? "text" : "password",
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				required: _ctx.required,
				placeholder: _ctx.placeholder,
				"input-display-mode": _ctx.inputDisplayMode,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				"update-mode": __props.updateMode,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "input-password",
				onAiApply: _cache[2] || (_cache[2] = ($event) => emit("aiApply")),
				onAiCancel: _cache[3] || (_cache[3] = ($event) => emit("aiCancel"))
			}, {
				default: withCtx(() => [__props.revealable && !_ctx.disabled ? (openBlock(), createBlock(Button_default, {
					key: 0,
					class: "input-password-reveal-button",
					size: "small",
					variant: "ghost",
					icon: revealed.value ? "eyeOff" : "eye",
					"aria-label": unref(translate)(revealed.value ? "HidePassword" : "ShowPassword"),
					tabindex: "-1",
					onClick: handleRevealButtonClick
				}, null, 8, ["icon", "aria-label"])) : createCommentVNode("", true)]),
				_: 1
			}, 8, [
				"modelValue",
				"focused",
				"type",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"required",
				"placeholder",
				"input-display-mode",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"update-mode",
				"ai-suggestion"
			]);
		};
	}
});
// src/components/InputSliderDiscrete/InputSliderDiscrete.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$15 = { class: "slider-discrete-field" };
var _hoisted_2$9 = ["id", "tabindex"];
var _hoisted_3$4 = ["disabled"];
var _hoisted_4$2 = ["tabindex", "disabled"];
var _hoisted_5$1 = ["tabindex", "disabled"];
var _hoisted_6 = {
	key: 2,
	class: "slider-discrete-markers"
};
var _hoisted_7 = ["disabled", "onClick"];
var _hoisted_8 = { class: "slider-discrete-marker-label" };
// src/components/InputSliderDiscrete/InputSliderDiscrete.vue
var InputSliderDiscrete_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputSliderDiscrete",
	props: {
		...inputProps,
		...contentProps,
		isRange: {
			type: Boolean,
			default: false
		},
		showMarkers: {
			type: Boolean,
			default: true
		},
		trackThickness: {
			type: Number,
			default: 4
		},
		trackBorderWidth: {
			type: Number,
			default: 0
		},
		trackBorderColor: {
			type: String,
			default: null
		},
		thumbSize: {
			type: Number,
			default: 18
		},
		thumbBorderWidth: {
			type: Number,
			default: 2
		},
		values: {
			type: Array,
			required: true
		},
		trackColor: {
			type: String,
			default: null
		},
		selectedTrackColor: {
			type: String,
			default: null
		},
		selectedThumbColor: {
			type: String,
			default: null
		},
		selectedTrackBorderColor: {
			type: String,
			default: null
		},
		thumbBackground: {
			type: String,
			default: null
		},
		modelValue: {
			type: [Number, Array],
			default: null
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const contentStyleObject = useContentStyle(props);
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const _messageTextInternal = ref(void 0);
		const _messageSeverityInternal = ref(void 0);
		const propsInternal = reactiveComputed(() => ({
			...props,
			focused: props.isRange ? void 0 : props.focused,
			autofocus: props.isRange ? void 0 : props.autofocus,
			messageText: props.messageText ?? _messageTextInternal.value,
			messageSeverity: props.messageSeverity ?? _messageSeverityInternal.value
		}));
		const { input, id, classes, ariaAttributes, isLabelVisible, isMessageVisible, messageId, tabIndex } = useInput(propsInternal, emit);
		function formatList(values) {
			return values.map(String).join(", ");
		}
		const valuesContractViolation = computed(() => {
			if (props.values.length === 0) return;
			const nonNumeric = props.values.filter((value) => typeof value !== "number");
			if (nonNumeric.length > 0) return {
				key: "InputSliderDiscrete_InvalidValuesNonNumeric",
				args: formatList(nonNumeric)
			};
			const nonFinite = props.values.filter((value) => !Number.isFinite(value));
			if (nonFinite.length > 0) return {
				key: "InputSliderDiscrete_InvalidValuesNonFinite",
				args: formatList(nonFinite)
			};
			const seen = /* @__PURE__ */ new Set();
			const duplicates = /* @__PURE__ */ new Set();
			for (const value of props.values) if (seen.has(value)) duplicates.add(value);
			else seen.add(value);
			if (duplicates.size > 0) return {
				key: "InputSliderDiscrete_InvalidValuesDuplicate",
				args: formatList([...duplicates])
			};
			for (let index = 1; index < props.values.length; index++) if (props.values[index - 1] >= props.values[index]) return {
				key: "InputSliderDiscrete_InvalidValuesNotStrictlyIncreasing",
				args: `${props.values[index - 1]} >= ${props.values[index]}`
			};
		});
		const safeValues = computed(() => valuesContractViolation.value == null ? props.values : []);
		const interactionsDisabled = computed(() => props.readonly || props.disabled || safeValues.value.length === 0);
		const labelFor = computed(() => interactionsDisabled.value ? void 0 : id);
		const containerRef = useTemplateRef("containerRef");
		const trackRef = useTemplateRef("trackRef");
		const startThumbRef = useTemplateRef("startThumbRef");
		const endThumbRef = useTemplateRef("endThumbRef");
		const activeThumb = ref("single");
		const isDragging = ref(false);
		const isRangeFocused = ref(false);
		watch(containerRef, () => {
			if (!props.isRange) {
				input.value = containerRef.value;
				return;
			}
			if (props.focused === true) focusSliderContainer();
		});
		function getPreferredFocusableElement() {
			if (!props.isRange) return containerRef.value;
			return (activeThumb.value === "end" ? endThumbRef.value : startThumbRef.value) ?? startThumbRef.value ?? endThumbRef.value ?? containerRef.value;
		}
		watchEffect(() => {
			input.value = getPreferredFocusableElement();
		});
		watch(() => props.focused, (value) => {
			if (!props.isRange || value === void 0 || interactionsDisabled.value) return;
			if (value) {
				focusSliderContainer();
				return;
			}
			const activeElement = document.activeElement;
			if (activeElement instanceof HTMLElement && containerRef.value?.contains(activeElement)) activeElement.blur();
		}, { immediate: true });
		const allowedValuesText = computed(() => safeValues.value.join(", "));
		const hasSingleShapeMismatch = computed(() => !props.isRange && props.modelValue != null && Array.isArray(props.modelValue));
		const hasRangeShapeMismatch = computed(() => {
			if (!props.isRange || props.modelValue == null) return false;
			return !Array.isArray(props.modelValue) || props.modelValue.length !== 2;
		});
		const hasModelValueShapeMismatch = computed(() => hasSingleShapeMismatch.value || hasRangeShapeMismatch.value);
		function rangeBoundToIndex(value) {
			if (typeof value !== "number" || !Number.isFinite(value)) return null;
			const index = safeValues.value.indexOf(value);
			return index !== -1 ? index : null;
		}
		const validationError = computed(() => {
			if (valuesContractViolation.value) return translate(valuesContractViolation.value.key, valuesContractViolation.value.args);
			if (safeValues.value.length === 0) return;
			if (hasModelValueShapeMismatch.value) return props.isRange ? translate("InputSliderDiscrete_InvalidRangeShape") : translate("InputSliderDiscrete_InvalidValueShape");
			if (!props.isRange) return getRangeModeValidationMessage();
			if (props.modelValue == null) return;
			const [start, end] = props.modelValue;
			const invalidValues = [start, end].filter((value) => rangeBoundToIndex(value) == null);
			if (invalidValues.length > 0) return translate("InputSliderDiscrete_InvalidRangeValue", invalidValues.map(String).join(", "), allowedValuesText.value);
			if (start > end) return translate("InputSliderDiscrete_InvalidRangeOrder", start, end, allowedValuesText.value);
		});
		watchEffect(() => {
			if (validationError.value) {
				_messageTextInternal.value = validationError.value;
				_messageSeverityInternal.value = "error";
				return;
			}
			_messageTextInternal.value = void 0;
			_messageSeverityInternal.value = void 0;
		});
		function getRangeModeValidationMessage() {
			if (props.modelValue == null) return;
			const singleValue = props.modelValue;
			if (!safeValues.value.includes(singleValue)) return translate("InputSliderDiscrete_InvalidValue", singleValue, allowedValuesText.value);
		}
		function clampIndex(index) {
			return Math.min(Math.max(index, 0), Math.max(0, safeValues.value.length - 1));
		}
		function indexToPercent(index) {
			if (safeValues.value.length <= 1) return 0;
			return clampIndex(index) / (safeValues.value.length - 1) * 100;
		}
		function valueToPercent(value) {
			if (safeValues.value.length <= 1) return 0;
			const min = safeValues.value[0];
			const span = safeValues.value[safeValues.value.length - 1] - min;
			if (span === 0) return 0;
			const ratio = (value - min) / span;
			return Math.min(Math.max(ratio, 0), 1) * 100;
		}
		const hasInvalidModelValue = computed(() => validationError.value != null);
		const hasNullSelection = computed(() => props.modelValue == null);
		const showSingleThumb = computed(() => !hasSingleShapeMismatch.value && !hasNullSelection.value);
		const singleIndex = computed(() => {
			if (safeValues.value.length === 0 || Array.isArray(props.modelValue) || props.modelValue == null) return null;
			const exact = safeValues.value.indexOf(props.modelValue);
			return exact !== -1 ? exact : null;
		});
		const rangeIndexes = computed(() => {
			const last = Math.max(0, safeValues.value.length - 1);
			if (!props.isRange || safeValues.value.length === 0) return [0, last];
			if (props.modelValue == null) return [null, null];
			if (!Array.isArray(props.modelValue) || props.modelValue.length !== 2) return [null, null];
			const [first, second] = props.modelValue;
			return [rangeBoundToIndex(first), rangeBoundToIndex(second)];
		});
		const startIndex = computed(() => rangeIndexes.value[0]);
		const endIndex = computed(() => rangeIndexes.value[1]);
		const hasStartThumb = computed(() => props.isRange && startIndex.value !== null);
		const hasEndThumb = computed(() => props.isRange && endIndex.value !== null);
		const hasRangeThumb = computed(() => props.isRange && (hasStartThumb.value || hasEndThumb.value));
		watch(hasRangeThumb, (value) => {
			if (value && document.activeElement === containerRef.value) focusSliderContainer();
		}, { flush: "post" });
		const containerTabIndex = computed(() => {
			if (interactionsDisabled.value) return -1;
			if (!props.isRange) return tabIndex.value ?? 0;
			return hasRangeThumb.value ? -1 : tabIndex.value ?? 0;
		});
		function getCurrentRangeIndexesForInteraction() {
			const last = Math.max(0, safeValues.value.length - 1);
			const [start, end] = rangeIndexes.value;
			if (start == null && end == null) return [0, last];
			if (start == null) return [end, end];
			if (end == null) return [start, start];
			return [start, end];
		}
		const fillSegment = computed(() => {
			if (hasInvalidModelValue.value) {
				if (!props.isRange && props.modelValue != null && !Array.isArray(props.modelValue)) return {
					left: 0,
					width: valueToPercent(props.modelValue)
				};
				return {
					left: 0,
					width: 0
				};
			}
			const [from, to] = computeRangeIndexes();
			const left = indexToPercent(from);
			const right = indexToPercent(to);
			return {
				left,
				width: Math.max(0, right - left)
			};
		});
		const fillStyle = computed(() => ({
			left: `${fillSegment.value.left}%`,
			width: `${fillSegment.value.width}%`
		}));
		const isFillEmpty = computed(() => fillSegment.value.width <= 0);
		const singleThumbStyle = computed(() => {
			if (!props.isRange && props.modelValue != null && !Array.isArray(props.modelValue) && singleIndex.value == null) return { left: `${valueToPercent(props.modelValue)}%` };
			return { left: `${indexToPercent(singleIndex.value ?? 0)}%` };
		});
		const startThumbStyle = computed(() => ({ left: `${indexToPercent(startIndex.value ?? 0)}%` }));
		const endThumbStyle = computed(() => ({ left: `${indexToPercent(endIndex.value ?? 0)}%` }));
		const startThumbTabIndex = computed(() => {
			if (!props.isRange || !props.tabStop || interactionsDisabled.value || !hasStartThumb.value) return -1;
			if (!hasEndThumb.value) return 0;
			return activeThumb.value === "end" ? -1 : 0;
		});
		const endThumbTabIndex = computed(() => {
			if (!props.isRange || !props.tabStop || interactionsDisabled.value || !hasEndThumb.value) return -1;
			if (!hasStartThumb.value) return 0;
			return activeThumb.value === "end" ? 0 : -1;
		});
		const minValue = computed(() => safeValues.value.at(0));
		const maxValue = computed(() => safeValues.value.at(-1));
		const startValue = computed(() => startIndex.value == null ? void 0 : safeValues.value[startIndex.value]);
		const endValue = computed(() => endIndex.value == null ? void 0 : safeValues.value[endIndex.value]);
		const stateAttributes = computed(() => ({
			"aria-invalid": ariaAttributes.value["aria-invalid"],
			"aria-describedby": ariaAttributes.value["aria-describedby"]
		}));
		const automationAttributes = computed(() => ({
			...props.showMarkers ? {} : { "data-values": safeValues.value.join(",") },
			"data-selection-invalid": hasInvalidModelValue.value ? "true" : void 0
		}));
		const containerAttributes = computed(() => {
			if (hasRangeThumb.value) return {
				...automationAttributes.value,
				role: "group",
				"aria-label": props.label
			};
			return {
				...automationAttributes.value,
				...stateAttributes.value,
				role: "slider",
				"aria-label": props.label,
				"aria-valuemin": minValue.value,
				"aria-valuemax": maxValue.value,
				...getSingleValueAttributes(),
				"aria-readonly": props.readonly || void 0,
				"aria-disabled": props.disabled || safeValues.value.length === 0 || void 0
			};
		});
		const isRangeOrdered = computed(() => startValue.value == null || endValue.value == null || startValue.value <= endValue.value);
		const startThumbAttributes = computed(() => ({
			...stateAttributes.value,
			role: "slider",
			"aria-label": translate("InputSliderDiscrete_RangeStart"),
			"aria-valuemin": minValue.value,
			"aria-valuemax": isRangeOrdered.value ? endValue.value ?? maxValue.value : maxValue.value,
			"aria-valuenow": startValue.value
		}));
		const endThumbAttributes = computed(() => ({
			...stateAttributes.value,
			role: "slider",
			"aria-label": translate("InputSliderDiscrete_RangeEnd"),
			"aria-valuemin": isRangeOrdered.value ? startValue.value ?? minValue.value : minValue.value,
			"aria-valuemax": maxValue.value,
			"aria-valuenow": endValue.value
		}));
		function getSingleValueAttributes() {
			if (typeof props.modelValue !== "number") return {
				"aria-valuenow": minValue.value,
				"aria-valuetext": translate("InputSliderDiscrete_NoValue")
			};
			if (safeValues.value.length === 0) return { "aria-valuenow": props.modelValue };
			const min = safeValues.value[0];
			const max = safeValues.value[safeValues.value.length - 1];
			const boundedValue = Math.min(Math.max(props.modelValue, min), max);
			return boundedValue === props.modelValue ? { "aria-valuenow": props.modelValue } : {
				"aria-valuenow": boundedValue,
				"aria-valuetext": String(props.modelValue)
			};
		}
		const sliderStyle = computed(() => ({
			"--slider-discrete-track-color": props.trackColor ? getColorValue(props.trackColor) : void 0,
			"--slider-discrete-selected-track-color": props.selectedTrackColor ? getColorValue(props.selectedTrackColor) : void 0,
			"--slider-discrete-selected-thumb-color": props.selectedThumbColor ? getColorValue(props.selectedThumbColor) : void 0,
			"--slider-discrete-track-thickness": `${Math.max(props.trackThickness, 1)}px`,
			"--slider-discrete-selected-track-border-color": props.selectedTrackBorderColor ? getColorValue(props.selectedTrackBorderColor) : void 0,
			"--slider-discrete-thumb-background": props.thumbBackground ? getColorValue(props.thumbBackground) : void 0,
			"--slider-discrete-track-border-width": `${Math.max(props.trackBorderWidth, 0)}px`,
			"--slider-discrete-track-border-color": props.trackBorderColor ? getColorValue(props.trackBorderColor) : void 0,
			"--slider-discrete-thumb-size": `${Math.max(props.thumbSize, 1)}px`,
			"--slider-discrete-thumb-border-width": `${Math.max(props.thumbBorderWidth, 0)}px`
		}));
		function computeRangeIndexes() {
			return props.isRange ? [Math.min(startIndex.value ?? 0, endIndex.value ?? 0), Math.max(startIndex.value ?? 0, endIndex.value ?? 0)] : [0, singleIndex.value ?? 0];
		}
		function isFirstMarker(index) {
			return index === 0;
		}
		function isLastMarker(index) {
			return safeValues.value.length > 1 && index === safeValues.value.length - 1;
		}
		function markerStyle(index) {
			return { left: `${indexToPercent(index)}%` };
		}
		function emitSingleAt(index) {
			if (safeValues.value.length === 0) return;
			emit("update:modelValue", safeValues.value[clampIndex(index)]);
		}
		function emitRangeAt(firstIndex, secondIndex) {
			if (safeValues.value.length === 0) return;
			const first = clampIndex(firstIndex);
			const second = clampIndex(secondIndex);
			const start = Math.min(first, second);
			const end = Math.max(first, second);
			emit("update:modelValue", [safeValues.value[start], safeValues.value[end]]);
		}
		function updateWithActiveThumb(index) {
			if (!props.isRange) {
				emitSingleAt(index);
				return;
			}
			const [currentStart, currentEnd] = getCurrentRangeIndexesForInteraction();
			if (activeThumb.value === "end") emitRangeAt(currentStart, index);
			else emitRangeAt(index, currentEnd);
		}
		function indexFromClientX(clientX) {
			if (!trackRef.value || safeValues.value.length <= 1) return 0;
			const rect = trackRef.value.getBoundingClientRect();
			if (rect.width <= 0) return 0;
			const ratio = (clientX - rect.left) / rect.width;
			return Math.round(Math.min(Math.max(ratio, 0), 1) * (safeValues.value.length - 1));
		}
		function onPointerMove(event) {
			if (!isDragging.value || interactionsDisabled.value) return;
			updateWithActiveThumb(indexFromClientX(event.clientX));
		}
		function stopDrag() {
			isDragging.value = false;
			globalThis.removeEventListener("pointermove", onPointerMove);
			globalThis.removeEventListener("pointerup", stopDrag);
			globalThis.removeEventListener("pointercancel", stopDrag);
		}
		function startDrag(thumb, event) {
			if (interactionsDisabled.value) return;
			activeThumb.value = thumb;
			isDragging.value = true;
			updateWithActiveThumb(indexFromClientX(event.clientX));
			globalThis.addEventListener("pointermove", onPointerMove);
			globalThis.addEventListener("pointerup", stopDrag);
			globalThis.addEventListener("pointercancel", stopDrag);
		}
		onBeforeUnmount(() => {
			stopDrag();
		});
		function selectValue(value) {
			if (interactionsDisabled.value) return;
			const index = safeValues.value.indexOf(value);
			if (index === -1) return;
			if (!props.isRange) {
				activeThumb.value = "single";
				emitSingleAt(index);
				return;
			}
			const [currentStart, currentEnd] = getCurrentRangeIndexesForInteraction();
			const startGap = Math.abs(index - currentStart);
			if (Math.abs(index - currentEnd) < startGap) {
				activeThumb.value = "end";
				emitRangeAt(currentStart, index);
			} else {
				activeThumb.value = "start";
				emitRangeAt(index, currentEnd);
			}
		}
		function handleKeyDown(event) {
			if (interactionsDisabled.value) return;
			if (props.isRange && isCtrlKey(event) && isArrowKey(event)) {
				event.preventDefault();
				activeThumb.value = event.key === "ArrowLeft" ? "start" : "end";
				focusSliderContainer();
				return;
			}
			const delta = getKeyDelta(event.key);
			if (delta === void 0) return;
			event.preventDefault();
			if (!props.isRange) {
				activeThumb.value = "single";
				emitSingleAt((singleIndex.value ?? 0) + delta);
				return;
			}
			updateSliderValue(delta);
		}
		function getKeyDelta(key) {
			switch (key) {
				case "ArrowRight":
				case "ArrowUp": return 1;
				case "ArrowLeft":
				case "ArrowDown": return -1;
				case "Home": return -safeValues.value.length;
				case "End": return safeValues.value.length;
				default: return;
			}
		}
		function isArrowKey(event) {
			return event.key === "ArrowLeft" || event.key === "ArrowRight";
		}
		function updateSliderValue(delta) {
			const [currentStart, currentEnd] = getCurrentRangeIndexesForInteraction();
			if ((activeThumb.value === "end" ? "end" : "start") === "start") emitRangeAt(Math.min(currentEnd, currentStart + delta), currentEnd);
			else emitRangeAt(currentStart, Math.max(currentStart, currentEnd + delta));
		}
		function isCtrlKey(event) {
			const isNotOtherKey = !event.shiftKey && !event.altKey && !event.metaKey;
			return event.ctrlKey && isNotOtherKey;
		}
		function handleTrackPointerDown(event) {
			if (interactionsDisabled.value) return;
			event.preventDefault();
			if (!props.isRange) {
				startDrag("single", event);
				return;
			}
			const targetIndex = indexFromClientX(event.clientX);
			const [currentStart, currentEnd] = getCurrentRangeIndexesForInteraction();
			const startGap = Math.abs(targetIndex - currentStart);
			startDrag(Math.abs(targetIndex - currentEnd) < startGap ? "end" : "start", event);
		}
		function handleThumbPointerDown(thumb, event) {
			event.stopPropagation();
			event.preventDefault();
			startDrag(thumb, event);
		}
		function markerIsSelected(index) {
			if (hasInvalidModelValue.value) return false;
			if (props.isRange) {
				const start = startIndex.value;
				const end = endIndex.value;
				if (start == null || end == null) return false;
				return index >= Math.min(start, end) && index <= Math.max(start, end);
			}
			return singleIndex.value != null && index === singleIndex.value;
		}
		function focusSliderContainer() {
			if (interactionsDisabled.value) return;
			const focusableElement = getPreferredFocusableElement();
			if (focusableElement != null) focusableElement.focus();
		}
		function handleContainerFocusIn() {
			if (!props.isRange || isRangeFocused.value) return;
			isRangeFocused.value = true;
			if (props.focused !== true) emit("update:focused", true);
		}
		function handleContainerFocusOut(event) {
			if (!props.isRange || !isRangeFocused.value) return;
			const nextTarget = event.relatedTarget;
			if (nextTarget instanceof Node && containerRef.value?.contains(nextTarget)) return;
			isRangeFocused.value = false;
			if (props.focused !== false) emit("update:focused", false);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(["input-slider-discrete neos-input", unref(classes)]),
				style: normalizeStyle(sliderStyle.value)
			}, [createElementVNode("div", _hoisted_1$15, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": labelFor.value,
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel")),
				onClick: focusSliderContainer
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createElementVNode("div", mergeProps({
				id: unref(id),
				ref_key: "containerRef",
				ref: containerRef
			}, containerAttributes.value, {
				class: ["slider-discrete-container", _ctx.contentClass],
				style: unref(contentStyleObject),
				tabindex: containerTabIndex.value,
				onKeydown: handleKeyDown,
				onFocusin: handleContainerFocusIn,
				onFocusout: handleContainerFocusOut
			}), [createElementVNode("div", {
				ref_key: "trackRef",
				ref: trackRef,
				class: "slider-discrete-track",
				onPointerdown: handleTrackPointerDown
			}, [
				_cache[9] || (_cache[9] = createElementVNode("div", { class: "slider-discrete-base-line" }, null, -1)),
				withDirectives(createElementVNode("div", {
					class: "slider-discrete-fill",
					style: normalizeStyle(fillStyle.value)
				}, null, 4), [[vShow, !isFillEmpty.value]]),
				!props.isRange ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [showSingleThumb.value ? (openBlock(), createElementBlock("button", {
					key: 0,
					type: "button",
					class: "slider-discrete-thumb",
					style: normalizeStyle(singleThumbStyle.value),
					tabindex: "-1",
					disabled: interactionsDisabled.value,
					onPointerdown: _cache[2] || (_cache[2] = ($event) => handleThumbPointerDown("single", $event))
				}, null, 44, _hoisted_3$4)) : createCommentVNode("", true)], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [startIndex.value !== null ? (openBlock(), createElementBlock("button", mergeProps({
					key: 0,
					ref_key: "startThumbRef",
					ref: startThumbRef
				}, startThumbAttributes.value, {
					type: "button",
					class: ["slider-discrete-thumb", { "slider-discrete-thumb-active": activeThumb.value === "start" }],
					style: startThumbStyle.value,
					tabindex: startThumbTabIndex.value,
					disabled: interactionsDisabled.value,
					onFocus: _cache[3] || (_cache[3] = ($event) => activeThumb.value = "start"),
					onPointerdown: _cache[4] || (_cache[4] = ($event) => handleThumbPointerDown("start", $event))
				}), null, 16, _hoisted_4$2)) : createCommentVNode("", true), endIndex.value !== null ? (openBlock(), createElementBlock("button", mergeProps({
					key: 1,
					ref_key: "endThumbRef",
					ref: endThumbRef
				}, endThumbAttributes.value, {
					type: "button",
					class: ["slider-discrete-thumb", { "slider-discrete-thumb-active": activeThumb.value === "end" }],
					style: endThumbStyle.value,
					tabindex: endThumbTabIndex.value,
					disabled: interactionsDisabled.value,
					onFocus: _cache[5] || (_cache[5] = ($event) => activeThumb.value = "end"),
					onPointerdown: _cache[6] || (_cache[6] = ($event) => handleThumbPointerDown("end", $event))
				}), null, 16, _hoisted_5$1)) : createCommentVNode("", true)], 64)),
				__props.showMarkers ? (openBlock(), createElementBlock("div", _hoisted_6, [(openBlock(true), createElementBlock(Fragment, null, renderList(safeValues.value, (value, index) => {
					return openBlock(), createElementBlock("button", {
						key: `${index}-${value}`,
						type: "button",
						class: normalizeClass(["slider-discrete-marker", {
							"slider-discrete-marker-selected": markerIsSelected(index),
							"slider-discrete-marker-first": isFirstMarker(index),
							"slider-discrete-marker-last": isLastMarker(index)
						}]),
						style: normalizeStyle(markerStyle(index)),
						tabindex: "-1",
						disabled: interactionsDisabled.value,
						onPointerdown: _cache[7] || (_cache[7] = withModifiers(() => {}, ["stop"])),
						onClick: withModifiers(($event) => selectValue(value), ["stop"])
					}, [_cache[8] || (_cache[8] = createElementVNode("span", { class: "slider-discrete-marker-line" }, null, -1)), createElementVNode("span", _hoisted_8, toDisplayString(value), 1)], 46, _hoisted_7);
				}), 128))])) : createCommentVNode("", true)
			], 544)], 16, _hoisted_2$9)]), unref(isMessageVisible) && unref(propsInternal).messageText ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				id: unref(messageId),
				text: unref(propsInternal).messageText,
				severity: unref(propsInternal).messageSeverity
			}, null, 8, [
				"id",
				"text",
				"severity"
			])) : createCommentVNode("", true)], 6);
		};
	}
}), [["__scopeId", "data-v-9e1d2cab"]]);
// src/components/InputRelativeDate/InputRelativeDate.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$14 = ["data-scale"];
var _hoisted_2$8 = { class: "input-relative-date-scale" };
var _hoisted_3$3 = {
	key: 0,
	class: "input-relative-date-date"
};
/**
* Input of a date relative to today, as a number of days, months or years: 0 is the current period,
* 1 the next one, -1 the previous one. The scale letter comes before the number, and the date it
* stands for is shown below: the first day of the period for a start bound, the last one for an end
* bound, or the whole month or year.
*/
var dayInMilliseconds = 864e5;
// src/components/InputRelativeDate/InputRelativeDate.vue
var InputRelativeDate_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputRelativeDate",
	props: {
		...inputProps,
		modelValue: {
			type: Number,
			default: null
		},
		scale: {
			type: String,
			default: "day"
		},
		bound: {
			type: String,
			default: "start"
		},
		wholePeriod: {
			type: Boolean,
			default: false
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const inputNumberProps = computed(() => {
			const { modelValue, scale, bound, wholePeriod, ...forwardedProps } = props;
			return forwardedProps;
		});
		const { translate } = useGlobalResourceManager();
		const localizator = useLocalizator();
		const scaleResourceKeys = {
			day: "RelativeDateScale_Day",
			month: "RelativeDateScale_Month",
			year: "RelativeDateScale_Year"
		};
		const scaleLetter = computed(() => translate(scaleResourceKeys[props.scale]));
		const offsetLimits = computed(() => getOffsetLimits());
		const date = computed(() => {
			const offset = props.modelValue;
			const { min, max } = getOffsetLimits();
			return offset != null && offset >= min && offset <= max ? getRelativeDate(offset) : void 0;
		});
		const periodFormats = {
			day: { dateStyle: "long" },
			month: {
				month: "long",
				year: "numeric"
			},
			year: { year: "numeric" }
		};
		const dateFormatter = computed(() => new Intl.DateTimeFormat(localizator.currentCulture, props.wholePeriod ? periodFormats[props.scale] : periodFormats.day));
		const dateText = computed(() => date.value ? dateFormatter.value.format(date.value) : void 0);
		function handleUpdateModelValue(value) {
			const { min, max } = getOffsetLimits();
			emit("update:modelValue", value == null ? value : Math.min(Math.max(value, min), max));
		}
		function getOffsetLimits() {
			const reference = /* @__PURE__ */ new Date();
			const year = reference.getFullYear();
			const month = reference.getMonth();
			switch (props.scale) {
				case "month": return {
					min: (100 - year) * 12 - month,
					max: (9999 - year) * 12 + 11 - month
				};
				case "year": return {
					min: 100 - year,
					max: 9999 - year
				};
				default: {
					const day = Date.UTC(year, month, reference.getDate());
					return {
						min: Math.round((Date.UTC(100, 0, 1) - day) / dayInMilliseconds),
						max: Math.round((Date.UTC(9999, 11, 31) - day) / dayInMilliseconds)
					};
				}
			}
		}
		function getRelativeDate(value) {
			const date = addToDate(/* @__PURE__ */ new Date(), `${props.scale}s`, value);
			if (props.scale === "day") return date;
			return props.bound === "end" ? endOf(date, props.scale) : startOf(date, props.scale);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "input-relative-date",
				"data-scale": __props.scale
			}, [createVNode(InputNumber_default, mergeProps(inputNumberProps.value, {
				"model-value": __props.modelValue,
				format: "n0",
				step: 1,
				"min-value": offsetLimits.value.min,
				"max-value": offsetLimits.value.max,
				"update-mode": "immediate",
				alignment: "left",
				"show-positive-sign": "",
				class: "input-relative-date-input",
				"onUpdate:modelValue": handleUpdateModelValue,
				"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => emit("update:focused", $event)),
				onAiApply: _cache[1] || (_cache[1] = ($event) => emit("aiApply")),
				onAiCancel: _cache[2] || (_cache[2] = ($event) => emit("aiCancel"))
			}), {
				before: withCtx(() => [createElementVNode("span", _hoisted_2$8, toDisplayString(scaleLetter.value), 1)]),
				_: 1
			}, 16, [
				"model-value",
				"min-value",
				"max-value"
			]), dateText.value ? (openBlock(), createElementBlock("span", _hoisted_3$3, toDisplayString(dateText.value), 1)) : createCommentVNode("", true)], 8, _hoisted_1$14);
		};
	}
}), [["__scopeId", "data-v-effc2e14"]]);
// src/composables/useParentElement.ts
function useParentElement() {
	const parentElement = ref(null);
	const vm = getCurrentInstance();
	onMounted(() => {
		parentElement.value = vm.proxy.$el.parentElement;
	});
	onUnmounted(() => {
		parentElement.value = null;
	});
	return parentElement;
}
// src/components/LoadDataOnScroll/LoadDataOnScroll.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$13 = {
	key: 0,
	class: "load-data-on-scroll-spinner"
};
// src/components/LoadDataOnScroll/LoadDataOnScroll.vue
var LoadDataOnScroll_default = /* @__PURE__ */ defineComponent({
	__name: "LoadDataOnScroll",
	props: {
		direction: { default: "vertical" },
		onLoad: {
			type: Function,
			default: void 0
		},
		hasMoreData: { type: Boolean },
		spinnerSize: { default: "extralarge" }
	},
	setup(__props) {
		const props = __props;
		const loading = ref(false);
		const enabled = computed(() => props.onLoad && props.hasMoreData && !loading.value);
		const parentElement = useParentElement();
		const containerElement = computed(() => {
			const childElement = parentElement.value?.firstElementChild;
			return childElement?.hasAttribute("data-virtual-repeat") ? childElement : parentElement.value;
		});
		watch([enabled, containerElement], async () => {
			while (enabled.value && containerElement.value && !hasScrollbar(containerElement.value, props.direction)) await load();
		});
		useEventListener(containerElement, "scroll", onScroll);
		async function onScroll(event) {
			if (enabled.value && isAtScrollEnd(event.target, props.direction)) await load();
		}
		function hasScrollbar(element, direction) {
			if (direction === "horizontal") return element.scrollWidth > element.clientWidth;
			return element.scrollHeight > element.clientHeight;
		}
		function isAtScrollEnd(element, direction) {
			if (direction === "horizontal") {
				const threshold = (element.scrollWidth - element.clientWidth) * .1;
				return element.scrollLeft + element.clientWidth >= element.scrollWidth - threshold;
			}
			const threshold = (element.scrollHeight - element.clientHeight) * .1;
			return element.scrollTop + element.clientHeight >= element.scrollHeight - threshold;
		}
		async function load() {
			loading.value = true;
			try {
				await props.onLoad();
			} finally {
				loading.value = false;
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [renderSlot(_ctx.$slots, "default"), loading.value ? (openBlock(), createElementBlock("div", _hoisted_1$13, [createVNode(Spinner_default, { size: __props.spinnerSize }, null, 8, ["size"])])) : createCommentVNode("", true)], 64);
		};
	}
});
// src/components/LottieImage/LottieImage.vue
var LottieImage_default = /* @__PURE__ */ defineComponent({
	__name: "LottieImage",
	props: {
		name: {},
		dataPromise: {},
		loop: {
			type: [Boolean, Number],
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		const images = useImages();
		const image = computed(() => images[props.name]);
		const root = ref();
		let animation = void 0;
		watch(root, async () => {
			if (!animation && root.value) {
				const value = root.value;
				animation = Lottie.loadAnimation({
					container: value,
					animationData: (await props.dataPromise()).default,
					loop: props.loop
				});
				intersectionObserver.observe(value);
			} else intersectionObserver.disconnect();
		});
		onBeforeUnmount(() => {
			animation?.destroy();
			intersectionObserver.disconnect();
		});
		const intersectionObserver = new IntersectionObserver((entries) => {
			if (entries[0].isIntersecting && animation) animation.play();
			else if (animation) animation.pause();
		});
		return (_ctx, _cache) => {
			return image.value ? (openBlock(), createBlock(Image_default, {
				key: 0,
				name: __props.name
			}, null, 8, ["name"])) : (openBlock(), createElementBlock("div", {
				key: 1,
				ref_key: "root",
				ref: root
			}, null, 512));
		};
	}
});
// src/components/Message/Message.ts?vue&type=script&src=true&lang.ts
var Message_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Message",
	components: {
		Button: Button_default,
		Image: Image_default,
		Text: Text_default,
		HorizontalLayout: HorizontalLayout_default
	},
	props: {
		visible: {
			type: Boolean,
			default: void 0
		},
		showIcon: {
			type: Boolean,
			default: true
		},
		severity: {
			type: String,
			default: "info"
		},
		closable: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:visible"],
	setup(props, { emit }) {
		const internalVisible = ref(true);
		const isVisible = computed({
			get() {
				return props.visible ?? internalVisible.value;
			},
			set(value) {
				if (props.visible !== void 0) {
					emit("update:visible", value);
					return;
				}
				internalVisible.value = value;
			}
		});
		const severityClass = computed(() => `message-${props.severity}`);
		function close() {
			isVisible.value = false;
		}
		useComponentAutomationProperties();
		return {
			isVisible,
			severityClass,
			close
		};
	}
});
// src/components/Message/Message.vue
var _hoisted_1$12 = { class: "message-content neos-vertical-content" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_Button = resolveComponent("Button");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	return openBlock(), createBlock(Transition, { name: "message" }, {
		default: withCtx(() => [_ctx.isVisible ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["message", `message-${_ctx.severity}`])
		}, [createVNode(_component_HorizontalLayout, {
			class: "message-wrapper",
			wrap: false
		}, {
			default: withCtx(() => [
				_ctx.showIcon ? (openBlock(), createBlock(_component_Image, {
					key: 0,
					name: _ctx.severity,
					size: "large",
					class: "message-icon"
				}, null, 8, ["name"])) : createCommentVNode("", true),
				createElementVNode("div", _hoisted_1$12, [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_ctx.closable ? (openBlock(), createBlock(_component_Button, {
					key: 1,
					class: "message-close-button",
					variant: "link",
					size: "small",
					onClick: _cache[0] || (_cache[0] = ($event) => _ctx.close())
				}, {
					default: withCtx(() => [createVNode(_component_Image, { name: "close" })]),
					_: 1
				})) : createCommentVNode("", true)
			]),
			_: 3
		})], 2)) : createCommentVNode("", true)]),
		_: 3
	});
}
var Message_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Message_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$2], ["__scopeId", "data-v-211b2adf"]]);
// src/components/MultiSelect/MultiSelect.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$11 = { class: "multi-select-chips" };
var _hoisted_2$7 = ["aria-label", "onClick"];
var _hoisted_3$2 = {
	key: 0,
	class: "multi-select-limit"
};
// src/components/MultiSelect/MultiSelect.vue
var MultiSelect_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "MultiSelect",
	props: {
		...inputProps,
		...contentProps,
		modelValue: {
			type: Array,
			default: null
		},
		values: {
			type: Array,
			default: () => []
		},
		keyProperty: {
			type: String,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		searchable: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		caret: {
			type: Boolean,
			default: true
		},
		maxDisplayedChips: {
			type: Number,
			default: 1
		}
	},
	emits: [
		...inputEmits,
		"show",
		"hide"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const contentStyleObject = useContentStyle(props);
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const { input, id, classes, ariaAttributes, isLabelVisible, isMessageVisible, messageId, tabIndex } = useInput(props, emit);
		const { disabledOrReadonly, keyProperty, displayProperty, getOptionValue } = useSelectProps(props);
		const selectedOptions = computed({
			get() {
				const modelValue = props.modelValue ?? [];
				if (props.valueProperty) {
					const selectedValues = new Set(modelValue);
					return props.values.filter((option) => selectedValues.has(getOptionValue(option)));
				}
				return modelValue;
			},
			set(options) {
				emit("update:modelValue", options.map(getOptionValue));
			}
		});
		const displayedSelectedOptions = computed(() => props.maxDisplayedChips && selectedOptions.value.length > props.maxDisplayedChips ? selectedOptions.value.slice(0, props.maxDisplayedChips) : selectedOptions.value);
		const limitValue = computed(() => selectedOptions.value.length - displayedSelectedOptions.value.length);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["multi-select neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(Select_default, mergeProps({ id: unref(id) }, {
				...unref(ariaAttributes),
				"aria-label": _ctx.label
			}, {
				modelValue: selectedOptions.value,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => selectedOptions.value = $event),
				multiple: "",
				values: __props.values,
				"key-property": unref(keyProperty),
				"display-property": unref(displayProperty),
				required: _ctx.required,
				disabled: unref(disabledOrReadonly),
				loading: __props.loading,
				caret: __props.caret,
				searchable: __props.searchable,
				"invalid-value": null,
				placeholder: _ctx.placeholder,
				"tab-index": unref(tabIndex),
				class: ["neos-input-content", _ctx.contentClass],
				style: unref(contentStyleObject),
				onMounted: _cache[3] || (_cache[3] = ($event) => input.value = $event),
				onShow: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("show")),
				onHide: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("hide"))
			}), {
				before: withCtx(() => [renderSlot(_ctx.$slots, "before", {}, void 0, true)]),
				values: withCtx(({ getOptionKey, getOptionLabel, removeOption }) => [createElementVNode("span", _hoisted_1$11, [(openBlock(true), createElementBlock(Fragment, null, renderList(displayedSelectedOptions.value, (option) => {
					return openBlock(), createElementBlock("span", {
						key: getOptionKey(option),
						class: "multi-select-chip"
					}, [renderSlot(_ctx.$slots, "chip", { option }, () => [createTextVNode(toDisplayString(getOptionLabel(option)), 1)], true), !unref(disabledOrReadonly) ? (openBlock(), createElementBlock("button", {
						key: 0,
						type: "button",
						class: "multi-select-remove",
						"aria-label": `${unref(translate)("Remove")} ${getOptionLabel(option)}`,
						tabindex: "-1",
						onClick: withModifiers(($event) => removeOption(option), ["stop"])
					}, [createVNode(Image_default, {
						name: "erase",
						size: "extrasmall"
					})], 8, _hoisted_2$7)) : createCommentVNode("", true)]);
				}), 128))]), limitValue.value ? (openBlock(), createElementBlock("span", _hoisted_3$2, "+" + toDisplayString(limitValue.value), 1)) : createCommentVNode("", true)]),
				after: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				option: withCtx(({ option, getOptionLabel }) => [renderSlot(_ctx.$slots, "option", { option }, () => [createTextVNode(toDisplayString(getOptionLabel(option)), 1)], true)]),
				_: 3
			}, 16, [
				"id",
				"modelValue",
				"values",
				"key-property",
				"display-property",
				"required",
				"disabled",
				"loading",
				"caret",
				"searchable",
				"placeholder",
				"tab-index",
				"class",
				"style"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				id: unref(messageId),
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, [
				"id",
				"text",
				"severity"
			])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-d7e27bb2"]]);
// src/components/PaginationBar/PaginationBar.ts?vue&type=script&src=true&lang.ts
var PaginationBar_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "PaginationBar",
	components: {
		Button: Button_default,
		Combobox: Combobox_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		Text: Text_default
	},
	props: {
		pageNumber: {
			type: Number,
			required: true
		},
		canMoveToNextPage: {
			type: Boolean,
			required: true
		},
		recordsByPage: {
			type: Number,
			required: true
		},
		recordsByPageList: {
			type: Array,
			default: () => [
				5,
				10,
				20,
				50
			]
		},
		totalRecordCount: {
			type: Number,
			default: void 0
		}
	},
	emits: ["update:pageNumber", "update:recordsByPage"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const internalPageNumber = computed({
			get: () => props.pageNumber,
			set: (value) => emit("update:pageNumber", value)
		});
		const internalRecordsByPage = computed({
			get: () => props.recordsByPage,
			set: (value) => emit("update:recordsByPage", value)
		});
		const internalRecordsByPageList = computed(() => props.recordsByPageList.includes(internalRecordsByPage.value) ? props.recordsByPageList : [...props.recordsByPageList, internalRecordsByPage.value].sort((a, b) => a - b));
		const canMoveToPreviousPage = computed(() => internalPageNumber.value > 1);
		const totalRecordCountCaption = computed(() => {
			if (props.totalRecordCount === void 0) return;
			return `/ ${props.totalRecordCount} ${translate(props.totalRecordCount > 1 ? "Items" : "Item").toLowerCase()}`;
		});
		function moveToFirstPage() {
			if (canMoveToPreviousPage.value) internalPageNumber.value = 1;
		}
		function moveToPreviousPage() {
			if (canMoveToPreviousPage.value) internalPageNumber.value -= 1;
		}
		function moveToNextPage() {
			if (props.canMoveToNextPage) internalPageNumber.value += 1;
		}
		return {
			internalPageNumber,
			internalRecordsByPage,
			internalRecordsByPageList,
			canMoveToPreviousPage,
			moveToFirstPage,
			moveToPreviousPage,
			moveToNextPage,
			totalRecordCountCaption
		};
	}
});
// src/components/PaginationBar/PaginationBar.vue
var _hoisted_1$10 = { class: "pagination-page-number" };
var _hoisted_2$6 = {
	key: 0,
	class: "pagination-total-record-count"
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_Text = resolveComponent("Text");
	const _component_Combobox = resolveComponent("Combobox");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	return openBlock(), createBlock(_component_HorizontalLayout, {
		class: "pagination-bar",
		"vertical-align": "center"
	}, {
		default: withCtx(() => [
			createVNode(_component_Button, {
				variant: "link",
				disabled: !_ctx.canMoveToPreviousPage,
				class: "pagination-button-move-first",
				icon: "doubleChevronLeft",
				onClick: _ctx.moveToFirstPage
			}, null, 8, ["disabled", "onClick"]),
			createVNode(_component_Button, {
				variant: "link",
				disabled: !_ctx.canMoveToPreviousPage,
				class: "pagination-button-move-previous",
				icon: "chevronLeft",
				onClick: _ctx.moveToPreviousPage
			}, null, 8, ["disabled", "onClick"]),
			createElementVNode("div", _hoisted_1$10, [createVNode(_component_Text, null, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.internalPageNumber), 1)]),
				_: 1
			})]),
			createVNode(_component_Button, {
				variant: "link",
				disabled: !_ctx.canMoveToNextPage,
				class: "pagination-button-move-next",
				icon: "chevronRight",
				onClick: _ctx.moveToNextPage
			}, null, 8, ["disabled", "onClick"]),
			createVNode(_component_Combobox, {
				modelValue: _ctx.internalRecordsByPage,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.internalRecordsByPage = $event),
				values: _ctx.internalRecordsByPageList,
				required: "",
				class: "pagination-records-by-page"
			}, null, 8, ["modelValue", "values"]),
			_ctx.totalRecordCountCaption ? (openBlock(), createElementBlock("div", _hoisted_2$6, [createVNode(_component_Text, null, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.totalRecordCountCaption), 1)]),
				_: 1
			})])) : createCommentVNode("", true)
		]),
		_: 1
	});
}
var PaginationBar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(PaginationBar_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$1], ["__scopeId", "data-v-748292b0"]]);
// src/components/ProgressBar/ProgressBar.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$9 = ["aria-valuenow"];
// src/components/ProgressBar/ProgressBar.vue
var ProgressBar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "ProgressBar",
	props: {
		value: { default: void 0 },
		showValue: {
			type: Boolean,
			default: true
		},
		mode: { default: "determinate" },
		valueBackground: { default: void 0 },
		cornerRadius: { default: void 0 },
		labelColor: { default: void 0 },
		labelOutsideColor: { default: void 0 },
		labelSize: { default: "medium" }
	},
	setup(__props) {
		const props = __props;
		const trackEl = ref();
		const labelEl = ref();
		const isDeterminate = computed(() => props.mode === "determinate");
		const clampedValue = computed(() => props.value == null ? 0 : Math.min(100, Math.max(0, props.value)));
		const hasLabel = computed(() => isDeterminate.value && props.showValue && props.value != null);
		const labelOutside = ref(false);
		const labelOutsideInsetPx = ref(0);
		function updateLabelPosition() {
			if (!hasLabel.value || !trackEl.value || !labelEl.value) {
				labelOutside.value = false;
				return;
			}
			const trackWidth = trackEl.value.clientWidth;
			const labelWidth = labelEl.value.scrollWidth;
			const targetFillWidth = trackWidth * clampedValue.value / 100;
			labelOutside.value = labelWidth > targetFillWidth;
			if (labelOutside.value) {
				const maxInsetPx = Math.max(0, trackWidth - labelWidth);
				labelOutsideInsetPx.value = Math.min(targetFillWidth, maxInsetPx);
			}
		}
		const labelPositionTransitionsEnabled = ref(false);
		let resizeObserver;
		let resizePositionUpdateTimer;
		function scheduleLabelPositionUpdate() {
			if (resizePositionUpdateTimer) clearTimeout(resizePositionUpdateTimer);
			resizePositionUpdateTimer = setTimeout(updateLabelPosition, 100);
		}
		onMounted(() => {
			resizeObserver = new ResizeObserver(scheduleLabelPositionUpdate);
			resizeObserver.observe(trackEl.value);
			if (labelEl.value) resizeObserver.observe(labelEl.value);
			updateLabelPosition();
		});
		onBeforeUnmount(() => {
			resizeObserver?.disconnect();
			if (resizePositionUpdateTimer) clearTimeout(resizePositionUpdateTimer);
		});
		watch(labelEl, (newLabelEl, oldLabelEl) => {
			if (oldLabelEl) resizeObserver.unobserve(oldLabelEl);
			if (newLabelEl) resizeObserver.observe(newLabelEl);
		});
		watch([clampedValue, hasLabel], () => {
			labelPositionTransitionsEnabled.value = true;
			updateLabelPosition();
		}, { flush: "post" });
		const radiusStyle = computed(() => props.cornerRadius ? { borderRadius: CornerRadiusValues[props.cornerRadius] } : {});
		const fillStyle = computed(() => ({
			...radiusStyle.value,
			...isDeterminate.value ? { width: `${clampedValue.value}%` } : {},
			...props.valueBackground ? { background: getColorValue(props.valueBackground) } : {}
		}));
		const labelSizeValue = computed(() => normalizeSize(props.labelSize));
		const labelStyle = computed(() => {
			const color = labelOutside.value ? props.labelOutsideColor : props.labelColor;
			return {
				...color ? { color: getColorValue(color) } : {},
				...typeof labelSizeValue.value === "number" ? { fontSize: `calc(${labelSizeValue.value}px * var(--neos-font-scale, 1))` } : {},
				...labelOutside.value ? {
					insetInlineStart: `${labelOutsideInsetPx.value}px`,
					transform: "translateX(0)"
				} : {
					insetInlineStart: `${clampedValue.value / 2}%`,
					transform: "translateX(-50%)"
				}
			};
		});
		const labelSizeClass = computed(() => typeof labelSizeValue.value === "string" ? `progress-bar-label-${labelSizeValue.value}` : void 0);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "trackEl",
				ref: trackEl,
				class: normalizeClass(["progress-bar", {
					"progress-bar-determinate": isDeterminate.value,
					"progress-bar-indeterminate": !isDeterminate.value
				}]),
				role: "progressbar",
				"aria-valuemin": "0",
				"aria-valuemax": "100",
				"aria-valuenow": isDeterminate.value && props.value != null ? clampedValue.value : void 0,
				style: normalizeStyle(radiusStyle.value)
			}, [createElementVNode("div", {
				class: "progress-bar-value",
				style: normalizeStyle(fillStyle.value)
			}, null, 4), hasLabel.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				ref_key: "labelEl",
				ref: labelEl,
				class: normalizeClass(["progress-bar-label", [labelSizeClass.value, { "progress-bar-settling-label": !labelPositionTransitionsEnabled.value }]]),
				style: normalizeStyle(labelStyle.value)
			}, toDisplayString(__props.value) + "% ", 7)) : createCommentVNode("", true)], 14, _hoisted_1$9);
		};
	}
}), [["__scopeId", "data-v-1c42ad60"]]);
// src/components/ProgressIndicator/ProgressIndicator.vue
var ProgressIndicator_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "ProgressIndicator",
	props: { text: {} },
	setup(__props) {
		const props = __props;
		const { translate } = useGlobalResourceManager();
		const displayText = computed(() => props.text ?? translate("Loading"));
		return (_ctx, _cache) => {
			return openBlock(), createBlock(VerticalLayout_default, {
				align: "center",
				class: "progress-indicator"
			}, {
				default: withCtx(() => [createVNode(DotLoader_default, { size: "extralarge" }), createVNode(Text_default, { size: "extralarge" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(displayText.value), 1)]),
					_: 1
				})]),
				_: 1
			});
		};
	}
}), [["__scopeId", "data-v-90d9e393"]]);
// src/components/ResponsiveDatagridWrapper/ResponsiveDatagridWrapper.vue
var ResponsiveDatagridWrapper_default = /* @__PURE__ */ defineComponent({
	__name: "ResponsiveDatagridWrapper",
	props: {
		cardMode: {
			type: Boolean,
			default: void 0
		},
		cardModeScope: { default: "window" },
		cardModeBreakpoint: { default: BreakpointValues.medium }
	},
	setup(__props) {
		const props = __props;
		const containerElement = useTemplateRef("container");
		const datagridMode = useDatagridMode();
		function useDatagridMode() {
			if (props.cardMode !== void 0) return computed(() => !props.cardMode);
			const datagridMode = ref(false);
			const cardModeScopeWidth = props.cardModeScope === "container" ? useElementSize(containerElement).width : useWindowSize().width;
			const cardModeBreakpoint = computed(() => {
				if (typeof props.cardModeBreakpoint === "number") return props.cardModeBreakpoint;
				return BreakpointValues[props.cardModeBreakpoint];
			});
			watch(cardModeScopeWidth, () => {
				datagridMode.value = cardModeScopeWidth.value >= cardModeBreakpoint.value;
			}, { immediate: true });
			return datagridMode;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(VerticalLayout_default, { ref: "container" }, {
				default: withCtx(() => [unref(datagridMode) ? renderSlot(_ctx.$slots, "datagrid", {}, void 0, void 0, 0) : renderSlot(_ctx.$slots, "data-cards", {}, void 0, void 0, 1)]),
				_: 3
			}, 512);
		};
	}
});
// src/components/Shimmer/Shimmer.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$8 = { class: "shimmer-content" };
// src/components/Shimmer/Shimmer.vue
var Shimmer_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Shimmer",
	props: { active: {
		type: Boolean,
		default: true
	} },
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("span", { class: normalizeClass(["shimmer", { "shimmer-active": __props.active }]) }, [createElementVNode("span", _hoisted_1$8, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])], 2);
		};
	}
}), [["__scopeId", "data-v-1c633df9"]]);
// src/components/Splitter/splitterUtils.ts
var splitterContextKey = Symbol("Splitter");
var splitterBarStyles = /* @__PURE__ */ new Set(["line", "handle"]);
function injectSplitterContext() {
	const splitter = inject(splitterContextKey, null);
	if (splitter == null) throw new Error("SplitterPanel must be rendered within a Splitter");
	return splitter;
}
function comparePanelPositions(panelA, panelB) {
	const elementA = panelA.getElement();
	const elementB = panelB.getElement();
	if (elementA == null || elementB == null) return 0;
	return (elementA.compareDocumentPosition(elementB) & Node.DOCUMENT_POSITION_FOLLOWING) === Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
}
/**
* Computes the layout to apply once the panels or their constraints changed. A panel keeps its requested size, or else
* its known size, in proportion of the space the others leave, or else its current size. Returns undefined when no
* size is known nor requested.
*/
function computeRestoredLayout(panels) {
	let knownTotal = 0;
	let fixedTotal = 0;
	let isRestored = false;
	for (const { size, knownSize, requestedSize } of panels) if (requestedSize !== void 0) {
		fixedTotal += requestedSize;
		isRestored = true;
	} else if (knownSize === void 0) fixedTotal += size;
	else {
		knownTotal += knownSize;
		isRestored = true;
	}
	if (!isRestored) return;
	const ratio = knownTotal === 0 ? 0 : (100 - fixedTotal) / knownTotal;
	return panels.map(({ size, knownSize, requestedSize }) => {
		if (requestedSize !== void 0) return requestedSize;
		return knownSize === void 0 ? size : knownSize * ratio;
	});
}
/** Reads a size in percent, a trailing unit such as "60%" being ignored. */
function toOptionalNumber(value) {
	const number = typeof value === "number" ? value : Number.parseFloat(value ?? "");
	return Number.isNaN(number) ? void 0 : number;
}
// src/components/Splitter/Splitter.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$7 = { class: "neos-vertical-content splitter" };
// src/components/Splitter/Splitter.vue
var Splitter_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Splitter",
	props: {
		horizontal: {
			type: Boolean,
			default: false
		},
		barStyle: {
			type: String,
			validator: (value) => splitterBarStyles.has(value),
			default: "line"
		},
		barColor: {
			type: String,
			default: ""
		},
		barHoverColor: {
			type: String,
			default: ""
		},
		barCornerRadius: {
			type: String,
			default: ""
		},
		handleLength: {
			type: Number,
			default: void 0
		},
		handleThickness: {
			type: Number,
			default: void 0
		}
	},
	setup(__props) {
		const props = __props;
		const panels = shallowReactive([]);
		const firstPanel = computed(() => panels[0]);
		const knownSizes = /* @__PURE__ */ new Map();
		const requestedSizes = /* @__PURE__ */ new Map();
		const mountedPanels = /* @__PURE__ */ new Set();
		const isDragging = ref(false);
		let isLayoutOutdated = false;
		let isLayoutUpdateScheduled = false;
		let isRestoringLayout = false;
		const isHandle = computed(() => props.barStyle === "handle");
		const hitAreaMargins = computed(() => {
			const margin = isHandle.value ? 6 : 0;
			return {
				coarse: margin,
				fine: margin
			};
		});
		const style = computed(() => {
			const ret = { "--splitter-bar-corner-radius": getMultiRadiusValue(props.barCornerRadius || (isHandle.value ? "full" : "none")) };
			if (props.barColor) ret["--splitter-bar-color"] = getTokenOnlyColorValue(props.barColor);
			if (props.barHoverColor) ret["--splitter-bar-hover-color"] = getTokenOnlyColorValue(props.barHoverColor);
			if (typeof props.handleLength === "number") ret["--splitter-handle-length"] = `${props.handleLength}px`;
			if (typeof props.handleThickness === "number") ret["--splitter-handle-thickness"] = `${props.handleThickness}px`;
			return ret;
		});
		function registerPanel(panel) {
			panels.push(panel);
			invalidateLayout();
		}
		function unregisterPanel(panel) {
			const index = panels.indexOf(panel);
			if (index !== -1) panels.splice(index, 1);
			knownSizes.delete(panel);
			requestedSizes.delete(panel);
			mountedPanels.delete(panel);
			invalidateLayout();
		}
		function handlePanelMounted(panel) {
			panels.sort(comparePanelPositions);
			if (panels.slice(panels.indexOf(panel) + 1).some((next) => mountedPanels.has(next))) console.warn("A splitter panel shown after the panels following it resizes the wrong panels.");
			mountedPanels.add(panel);
		}
		function maximizePanel(panel) {
			const minSizes = panels.map((other) => other.getMinSize());
			const index = panels.indexOf(panel);
			const othersTotal = minSizes.reduce((total, size) => total + size, 0) - minSizes[index];
			minSizes[index] = Math.min(panel.getMaxSize(), 100 - othersTotal);
			applyLayout(minSizes);
			scheduleLayoutUpdate();
		}
		function invalidateLayout() {
			isLayoutOutdated = true;
			scheduleLayoutUpdate();
		}
		function requestSize(panel, size) {
			if (isLayoutOutdated) requestedSizes.set(panel, size);
			else panel.resize(size);
		}
		function setDragging(dragging) {
			isDragging.value = dragging;
			scheduleLayoutUpdate();
		}
		function handleLayout() {
			if (!isRestoringLayout) scheduleLayoutUpdate();
		}
		function scheduleLayoutUpdate() {
			if (isLayoutUpdateScheduled) return;
			isLayoutUpdateScheduled = true;
			nextTick(() => {
				isLayoutUpdateScheduled = false;
				updateLayout();
			});
		}
		function updateLayout() {
			if (isDragging.value) return;
			if (isLayoutOutdated) {
				const panelSizes = panels.map((panel) => ({
					size: panel.getSize(),
					knownSize: knownSizes.get(panel),
					requestedSize: requestedSizes.get(panel)
				}));
				if (panelSizes.some(({ size }) => size === void 0)) return;
				isLayoutOutdated = false;
				requestedSizes.clear();
				restoreLayout(panelSizes);
			}
			notifySizes();
		}
		function restoreLayout(panelSizes) {
			const layout = computeRestoredLayout(panelSizes);
			if (layout !== void 0) applyLayout(layout);
		}
		function applyLayout(layout) {
			isRestoringLayout = true;
			layout.slice(0, -1).forEach((size, index) => panels[index].resize(size));
			isRestoringLayout = false;
		}
		function notifySizes() {
			for (const panel of panels) {
				const size = panel.getSize();
				const knownSize = knownSizes.get(panel);
				if (size !== void 0 && size !== knownSize) {
					knownSizes.set(panel, size);
					if (knownSize !== void 0) panel.onSizeChanged(size);
				}
			}
		}
		provide(splitterContextKey, {
			firstPanel,
			isHorizontal: toRef(props, "horizontal"),
			hitAreaMargins,
			registerPanel,
			unregisterPanel,
			handlePanelMounted,
			maximizePanel,
			invalidateLayout,
			requestSize,
			setDragging
		});
		useComponentAutomationProperties();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$7, [createVNode(unref(SplitterGroup), {
				class: normalizeClass(["splitter-group", {
					"splitter-horizontal": __props.horizontal,
					"splitter-vertical": !__props.horizontal,
					"splitter-handle": isHandle.value,
					"splitter-dragging": isDragging.value
				}]),
				style: normalizeStyle(style.value),
				direction: __props.horizontal ? "vertical" : "horizontal",
				onLayout: handleLayout
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_: 3
			}, 8, [
				"class",
				"style",
				"direction"
			])]);
		};
	}
}), [["__scopeId", "data-v-4dea7472"]]);
// src/components/SplitterPanel/SplitterPanel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$6 = { class: "splitter-item" };
var _hoisted_2$5 = { class: "splitter-panel-content neos-vertical-content" };
// src/components/SplitterPanel/SplitterPanel.vue
var SplitterPanel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "SplitterPanel",
	props: {
		size: {
			type: [Number, String],
			default: void 0
		},
		minSize: {
			type: [Number, String],
			default: 0
		},
		maxSize: {
			type: [Number, String],
			default: 100
		}
	},
	emits: ["update:size"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const splitter = injectSplitterContext();
		const { translate } = useGlobalResourceManager();
		const panel = useTemplateRef("panel");
		const sizeValue = computed(() => toOptionalNumber(props.size));
		const minSizeValue = computed(() => toOptionalNumber(props.minSize));
		const maxSizeValue = computed(() => toOptionalNumber(props.maxSize));
		let isHandleDragging = false;
		let isLaidOut = false;
		const registration = {
			getElement: () => panel.value?.$el,
			getSize: () => isLaidOut ? panel.value?.getSize() : void 0,
			getMinSize: () => minSizeValue.value ?? 0,
			getMaxSize: () => maxSizeValue.value ?? 100,
			resize: (size) => panel.value?.resize(size),
			onSizeChanged: (size) => emit("update:size", size)
		};
		const hasResizeHandle = computed(() => splitter.firstPanel.value !== registration);
		watch(sizeValue, (size) => {
			if (size != null) splitter.requestSize(registration, size);
		}, { flush: "post" });
		watch([minSizeValue, maxSizeValue], () => splitter.invalidateLayout());
		splitter.registerPanel(registration);
		onMounted(() => {
			splitter.handlePanelMounted(registration);
		});
		onUnmounted(() => {
			splitter.unregisterPanel(registration);
		});
		function handleDragging(isDragging) {
			isHandleDragging = isDragging;
			splitter.setDragging(isDragging);
		}
		function handleRekaPanelResize() {
			isLaidOut = true;
		}
		function handleResizeHandleUnmounted() {
			if (isHandleDragging) handleDragging(false);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$6, [hasResizeHandle.value ? (openBlock(), createBlock(unref(SplitterResizeHandle), {
				key: 0,
				class: "splitter-bar",
				"aria-label": unref(translate)("ResizePanels"),
				"aria-orientation": unref(splitter).isHorizontal.value ? "horizontal" : "vertical",
				"hit-area-margins": unref(splitter).hitAreaMargins.value,
				onDragging: handleDragging,
				onDblclick: _cache[0] || (_cache[0] = ($event) => unref(splitter).maximizePanel(registration)),
				onVnodeUnmounted: handleResizeHandleUnmounted
			}, null, 8, [
				"aria-label",
				"aria-orientation",
				"hit-area-margins"
			])) : createCommentVNode("", true), createVNode(unref(SplitterPanel), mergeProps({
				ref_key: "panel",
				ref: panel
			}, _ctx.$attrs, {
				class: "splitter-panel",
				"default-size": sizeValue.value,
				"min-size": minSizeValue.value,
				"max-size": maxSizeValue.value,
				onResize: handleRekaPanelResize
			}), {
				default: withCtx(() => [createElementVNode("div", _hoisted_2$5, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])]),
				_: 3
			}, 16, [
				"default-size",
				"min-size",
				"max-size"
			])]);
		};
	}
}), [["__scopeId", "data-v-61eb7852"]]);
// src/components/Tabs/tabManager.ts
var tabManagerKey = "tabManager";
// src/components/TabItem/TabItem.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$5 = ["data-tab-index"];
// src/components/TabItem/TabItem.vue
var TabItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "TabItem",
	props: {
		caption: { default: "" },
		visible: {
			type: [
				Boolean,
				Object,
				null
			],
			default: void 0
		},
		icon: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		const tabManager = inject(tabManagerKey);
		const visible = computed(() => {
			if (props.visible === void 0) return true;
			if (typeof props.visible === "boolean") return props.visible;
			return props.visible != null;
		});
		const root = ref();
		const tab = shallowRef(null);
		const isSlotMounted = ref(false);
		useComponentAutomationProperties(root);
		useIntersectionObserver(root, ([{ isIntersecting }], o) => {
			if (isIntersecting) {
				isSlotMounted.value = true;
				o.disconnect();
			}
		});
		onMounted(() => {
			tab.value = tabManager.registerTab(toRef(props, "caption"), visible, toRef(props, "icon"));
			isSlotMounted.value = tab.value.active;
		});
		watch(() => props.visible, () => tabManager.onTabVisibilityChanged(tab.value));
		onUnmounted(() => {
			tabManager.unregisterTab(tab.value);
		});
		return (_ctx, _cache) => {
			return tab.value && (tab.value.active || isSlotMounted.value) ? withDirectives((openBlock(), createElementBlock("div", {
				key: 0,
				ref_key: "root",
				ref: root,
				"data-tab-index": tab.value?.index,
				class: "tab-item neos-vertical-content"
			}, [isSlotMounted.value ? renderSlot(_ctx.$slots, "default", {}, void 0, true, 0) : (openBlock(), createBlock(ProgressIndicator_default, { key: 1 }))], 8, _hoisted_1$5)), [[vShow, tab.value?.active]]) : createCommentVNode("", true);
		};
	}
}), [["__scopeId", "data-v-c6829945"]]);
// src/components/Tabs/Tabs.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$4 = [
	"data-tab-index",
	"data-tab-instance-id",
	"label",
	"onClick"
];
var _hoisted_2$4 = { class: "tab-details" };
// src/components/Tabs/Tabs.vue
var Tabs_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Tabs",
	props: {
		"selectedIndex": {
			required: false,
			default: -1
		},
		"selectedIndexModifiers": {}
	},
	emits: ["update:selectedIndex"],
	setup(__props) {
		const selectedIndex = useModel(__props, "selectedIndex");
		const tabs = ref([]);
		let nextTabInstanceId = 0;
		function registerTab(caption, visible, icon) {
			const tab = reactive({
				instanceId: nextTabInstanceId++,
				caption,
				visible,
				icon,
				get index() {
					return tabs.value.indexOf(tab);
				},
				get active() {
					return selectedIndex.value === this.index;
				}
			});
			tabs.value.push(tab);
			if (selectedIndex.value === -1 && visible.value) selectedIndex.value = tab.index;
			return tab;
		}
		function selectNextVisibleTab(fromIndex) {
			for (let i = fromIndex; i < tabs.value.length; i++) if (tabs.value[i].visible) {
				selectedIndex.value = i;
				return;
			}
			for (let i = fromIndex - 1; i >= 0; i--) if (tabs.value[i].visible) {
				selectedIndex.value = i;
				return;
			}
			selectedIndex.value = -1;
		}
		function unregisterTab(tab) {
			const index = tab.index;
			const wasSelected = selectedIndex.value === index;
			tabs.value.splice(index, 1);
			if (wasSelected) selectNextVisibleTab(index);
			else if (selectedIndex.value > index) selectedIndex.value--;
		}
		function onTabVisibilityChanged(tab) {
			const index = tab.index;
			if (selectedIndex.value === -1 && tab.visible) selectedIndex.value = index;
			else if (index === selectedIndex.value && !tab.visible) selectNextVisibleTab(index + 1);
		}
		function handleTabClick(index) {
			selectedIndex.value = index;
		}
		provide(tabManagerKey, {
			registerTab,
			unregisterTab,
			onTabVisibilityChanged
		});
		useComponentAutomationProperties();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(VerticalLayout_default, { class: "tabs-container" }, {
				default: withCtx(() => [createVNode(HorizontalLayout_default, {
					class: "tabs-headers-container",
					space: "none",
					wrap: false
				}, {
					default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(tabs.value, (tab, index) => {
						return openBlock(), createElementBlock(Fragment, { key: tab.instanceId }, [tab.visible ? (openBlock(), createElementBlock("button", {
							key: 0,
							class: normalizeClass(["tab", { "tab-active": tab.active }]),
							"data-tab-index": index,
							"data-tab-instance-id": tab.instanceId,
							label: tab.caption,
							onClick: ($event) => handleTabClick(index)
						}, [createVNode(Image_default, { name: tab.icon }, null, 8, ["name"]), createVNode(Text_default, {
							class: "tab-text",
							style: normalizeStyle(`--tab-text: '${tab.caption}'`)
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(tab.caption), 1)]),
							_: 2
						}, 1032, ["style"])], 10, _hoisted_1$4)) : createCommentVNode("", true)], 64);
					}), 128))]),
					_: 1
				}), createElementVNode("div", _hoisted_2$4, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])]),
				_: 3
			});
		};
	}
}), [["__scopeId", "data-v-c9501cfc"]]);
// src/components/Timeline/Timeline.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$3 = { class: "timeline-event-opposite" };
var _hoisted_2$3 = { class: "timeline-event-separator" };
var _hoisted_3$1 = {
	key: 0,
	class: "timeline-event-connector"
};
var _hoisted_4$1 = { class: "timeline-event-content" };
// src/components/Timeline/Timeline.vue
var Timeline_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Timeline",
	props: {
		source: { default: () => [] },
		orientation: { default: "vertical" },
		align: { default: "left" }
	},
	setup(__props) {
		useComponentAutomationProperties();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["timeline", [`timeline-${__props.orientation}`, `timeline-${__props.align}`]]) }, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.source, (item, index) => {
				return openBlock(), createElementBlock("div", {
					key: index,
					class: "timeline-event"
				}, [
					createElementVNode("div", _hoisted_1$3, [renderSlot(_ctx.$slots, "opposite", { context: item }, void 0, true)]),
					createElementVNode("div", _hoisted_2$3, [renderSlot(_ctx.$slots, "marker", { context: item }, () => [_cache[0] || (_cache[0] = createElementVNode("div", { class: "timeline-event-marker" }, null, -1))], true), index !== __props.source.length - 1 ? (openBlock(), createElementBlock("div", _hoisted_3$1)) : createCommentVNode("", true)]),
					createElementVNode("div", _hoisted_4$1, [renderSlot(_ctx.$slots, "content", { context: item }, void 0, true)])
				]);
			}), 128))], 2);
		};
	}
}), [["__scopeId", "data-v-57aff193"]]);
// src/composables/useToast.ts
var listeners = /* @__PURE__ */ new Set();
var lastMessageId = 0;
function onToastAdded(listener) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}
function useToast() {
	function add(definition) {
		const message = reactive({
			buttons: definition.buttons,
			closable: definition.dismissible,
			detail: definition.text,
			duration: definition.duration || void 0,
			group: definition.group,
			id: ++lastMessageId,
			open: true,
			severity: definition.severity,
			summary: definition.title
		});
		listeners.forEach((listener) => listener(message));
		return message;
	}
	/**
	* Closes a message returned by `add`: the toast component plays the closing animation, then forgets the message.
	*/
	function remove(message) {
		message.open = false;
	}
	return {
		add,
		remove
	};
}
// src/components/Toast/Toast.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$2 = ["onVnodeUnmounted"];
var _hoisted_2$2 = { class: "toast-content" };
var _hoisted_3 = { class: "toast-header" };
var _hoisted_4 = { class: "toast-buttons" };
var _hoisted_5 = {
	key: 0,
	class: "toast-close-button-container"
};
var stackedFromCount = 3;
// src/components/Toast/Toast.vue
var Toast_default = /* @__PURE__ */ defineComponent({
	__name: "Toast",
	props: {
		position: { default: "bottom-right" },
		group: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		const severityNames = {
			error: "danger",
			info: "info",
			success: "positive",
			warn: "warning"
		};
		const { translate } = useGlobalResourceManager();
		const buttonContainerSpace = useButtonContainerSpace(useThemeManager(false));
		const messages = ref([]);
		const isStacked = computed((wasStacked) => {
			return messages.value.filter((message) => message.open).length >= stackedFromCount || wasStacked === true && messages.value.length > 1;
		});
		const viewport = useTemplateRef("viewport");
		const isPaused = ref(false);
		const isWindowFocused = useWindowFocus();
		let unsubscribe;
		let escapeIgnoredMessage;
		const progresses = /* @__PURE__ */ new Map();
		onMounted(() => {
			unsubscribe = onToastAdded(onAdd);
		});
		onBeforeUnmount(() => {
			unsubscribe();
		});
		async function onAdd(message) {
			if (message.group !== props.group) return;
			const isFirstToast = messages.value.length === 0;
			messages.value.push(message);
			if (!isFirstToast) return;
			await nextTick();
			if (!viewport.value) return;
			if (isWindowFocused.value) viewport.value.$el.dispatchEvent(new Event("pointerleave"));
			else window.dispatchEvent(new Event("blur"));
		}
		useEventListener(document, ["pointerleave", "focusout"], (event) => {
			const viewportElement = viewport.value?.$el;
			const isLeavingToasts = event.type === "pointerleave" ? event.target === viewportElement : viewportElement?.contains(event.target) === true;
			if (!isWindowFocused.value && isLeavingToasts) event.stopPropagation();
		}, { capture: true });
		/**
		* Forgets a message once its toast is unmounted, that is at the end of its closing animation.
		*/
		function onMessageUnmounted(message) {
			messages.value = messages.value.filter((m) => m.id !== message.id);
			progresses.delete(message.id);
		}
		/**
		* Keeps Reka from closing a toast without close button on a swipe.
		*/
		function preventSwipeDismissal(message, event) {
			if (!message.closable) event.preventDefault();
		}
		/**
		* Lets Escape close only the toast holding the focus, as Reka listens to it in the whole page for every toast.
		*/
		function onEscapeKeyDown(message, event) {
			const focusedToast = document.activeElement?.closest(".toast-message");
			const canClose = message.closable && focusedToast?.dataset.messageId === String(message.id);
			if (!event.defaultPrevented && !canClose) escapeIgnoredMessage = message;
		}
		function onOpenChange(message, open) {
			if (escapeIgnoredMessage === message) {
				escapeIgnoredMessage = void 0;
				return;
			}
			message.open = open;
		}
		function getButtonClass(index, severity) {
			return `${index === 0 ? "toast-primary-button" : "toast-secondary-button"}-${severityNames[severity]}`;
		}
		function getIconColor(severity) {
			return `var(--toast-${severityNames[severity]}-icon)`;
		}
		function getProgressWidth(message, remaining, duration) {
			const hasTimerStarted = progresses.has(message.id) || remaining > 0 && remaining < duration;
			if (message.open && hasTimerStarted) progresses.set(message.id, 1 - remaining / duration);
			return `${(progresses.get(message.id) ?? 0) * 100}%`;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(ToastProvider), {
				label: unref(translate)("ToastLabel"),
				"swipe-direction": __props.position.endsWith("left") ? "left" : "right"
			}, {
				default: withCtx(() => [(openBlock(), createBlock(Teleport, { to: "body" }, [createVNode(unref(ToastViewport), {
					ref_key: "viewport",
					ref: viewport,
					class: normalizeClass(["toast", [`toast-${__props.position}`, { "toast-stacked": isStacked.value }]]),
					label: (hotkey) => unref(translate)("ToastViewportLabel", hotkey)
				}, null, 8, ["class", "label"])])), (openBlock(true), createElementBlock(Fragment, null, renderList(messages.value, (message) => {
					return openBlock(), createBlock(unref(ToastRoot), {
						key: message.id,
						class: normalizeClass(["toast-message", `toast-message-${message.severity}`]),
						"data-message-id": message.id,
						open: message.open,
						duration: message.duration ?? Number.POSITIVE_INFINITY,
						onEscapeKeyDown: ($event) => onEscapeKeyDown(message, $event),
						onSwipeStart: ($event) => preventSwipeDismissal(message, $event),
						onSwipeMove: ($event) => preventSwipeDismissal(message, $event),
						onSwipeEnd: ($event) => preventSwipeDismissal(message, $event),
						"onUpdate:open": (open) => onOpenChange(message, open),
						onPause: _cache[0] || (_cache[0] = ($event) => isPaused.value = true),
						onResume: _cache[1] || (_cache[1] = ($event) => isPaused.value = false),
						onPointerdownCapture: unref(ignoreInteractionWhileClosing),
						onClickCapture: unref(ignoreInteractionWhileClosing)
					}, {
						default: withCtx(({ remaining, duration }) => [createElementVNode("div", {
							class: "toast-message-content",
							onVnodeUnmounted: ($event) => onMessageUnmounted(message)
						}, [createElementVNode("div", _hoisted_2$2, [
							createElementVNode("div", _hoisted_3, [createVNode(Image_default, {
								class: "toast-message-icon",
								style: normalizeStyle({ backgroundColor: getIconColor(message.severity) }),
								name: severityNames[message.severity]
							}, null, 8, ["style", "name"]), createVNode(unref(ToastTitle), {
								as: "span",
								class: "toast-summary"
							}, {
								default: withCtx(() => [createTextVNode(toDisplayString(message.summary), 1)]),
								_: 2
							}, 1024)]),
							createVNode(unref(ToastDescription), { class: "toast-detail" }, {
								default: withCtx(() => [renderSlot(_ctx.$slots, "message", { message }, () => [createTextVNode(toDisplayString(message.detail), 1)])]),
								_: 2
							}, 1024),
							message.buttons.length > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(Divider_default, { class: "toast-divider" }), createElementVNode("div", _hoisted_4, [createVNode(HorizontalLayout_default, {
								wrap: false,
								align: "right",
								space: unref(buttonContainerSpace)
							}, {
								default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(message.buttons, (button, index) => {
									return openBlock(), createBlock(Button_default, {
										key: index,
										class: normalizeClass(["toast-button", getButtonClass(index, message.severity)]),
										icon: button.icon,
										label: button.text,
										animated: "",
										onClick: button.action
									}, null, 8, [
										"class",
										"icon",
										"label",
										"onClick"
									]);
								}), 128))]),
								_: 2
							}, 1032, ["space"])])], 64)) : createCommentVNode("", true),
							message.duration ? withDirectives((openBlock(), createElementBlock("div", {
								key: 1,
								class: "toast-progress-bar",
								style: normalizeStyle({ backgroundColor: getIconColor(message.severity) })
							}, [createElementVNode("div", {
								class: "toast-progress-bar-value",
								style: normalizeStyle({ width: getProgressWidth(message, remaining, duration) })
							}, null, 4)], 4)), [[vShow, !isPaused.value]]) : createCommentVNode("", true)
						]), message.closable ? (openBlock(), createElementBlock("div", _hoisted_5, [createVNode(unref(ToastClose), {
							class: "toast-close-button neos-close-button button-extrasmall",
							"aria-label": unref(translate)("Close")
						}, {
							default: withCtx(() => [createVNode(Image_default, {
								name: "close",
								size: "extrasmall"
							})]),
							_: 1
						}, 8, ["aria-label"])])) : createCommentVNode("", true)], 8, _hoisted_1$2)]),
						_: 2
					}, 1032, [
						"class",
						"data-message-id",
						"open",
						"duration",
						"onEscapeKeyDown",
						"onSwipeStart",
						"onSwipeMove",
						"onSwipeEnd",
						"onUpdate:open",
						"onPointerdownCapture",
						"onClickCapture"
					]);
				}), 128))]),
				_: 3
			}, 8, ["label", "swipe-direction"]);
		};
	}
});
// src/components/TreeView/TreeViewConfig.ts
var TreeViewConfigKey = Symbol("TreeViewConfig");
function useTreeViewConfig() {
	const config = inject(TreeViewConfigKey);
	if (!config) throw new Error("Tree view configuration not provided.");
	return config;
}
// src/components/TreeViewNode/TreeViewNode.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$1 = ["draggable"];
var _hoisted_2$1 = {
	key: 0,
	class: "tree-view-child-nodes"
};
// src/components/TreeView/TreeView.ts?vue&type=script&src=true&lang.ts
var TreeView_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "TreeView",
	components: {
		HorizontalLayout: HorizontalLayout_default,
		TreeViewNode: /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
			__name: "TreeViewNode",
			props: {
				level: {},
				node: {},
				nodeClick: {},
				nodeCollapse: {},
				nodeDragover: {},
				nodeDragstart: {},
				nodeDrop: {},
				nodeExpand: {},
				parentNode: { default: void 0 }
			},
			setup(__props) {
				const props = __props;
				const config = useTreeViewConfig();
				const caption = computed(() => getPropertyByPath(props.node, config.captionProperty));
				const childNodesLineStyle = computed(() => ({ left: `${padding.value + 5}px` }));
				const children = computed(() => getPropertyByPath(props.node, config.childrenProperty));
				const dropInstruction = computed(() => config.currentDragContext.value?.dropNode === props.node ? config.currentDragContext.value.instruction : void 0);
				const expanded = computed(() => getPropertyByPath(props.node, config.expandedProperty));
				const draggable = computed(() => getPropertyByPath(props.node, config.draggableProperty));
				const dropIndicatorStyle = computed(() => ({
					left: `${6 * (props.level + 1)}px`,
					top: dropInstruction.value === "before" ? "-1px" : void 0,
					bottom: dropInstruction.value === "after" ? "-1px" : void 0
				}));
				const hasBeenExpanded = ref(expanded.value);
				const icon = computed(() => getPropertyByPath(props.node, config.iconProperty));
				const nodeClass = computed(() => ({
					"tree-view-node-selected": getPropertyByPath(props.node, config.selectedProperty),
					"tree-view-node-drag": config.currentDragContext.value?.draggedNode === props.node,
					"tree-view-node-drop": dropInstruction.value === "make-child",
					"tree-view-node-drop-parent-hint": dropInstruction.value === void 0 && config.currentDragContext.value?.newParentNode === props.node
				}));
				const nodeStyle = computed(() => ({ paddingLeft: `${padding.value}px` }));
				const padding = computed(() => 16 * props.level + (!getPropertyByPath(props.node, config.childrenProperty) ? 18 : 0));
				const showDropIndicator = computed(() => dropInstruction.value === "before" || dropInstruction.value === "after");
				const loading = computed(() => getPropertyByPath(props.node, config.loadingProperty));
				const toggleIcon = computed(() => {
					return getPropertyByPath(props.node, config.expandedProperty) ? "chevronDown" : "chevronRight";
				});
				const visible = computed(() => getPropertyByPath(props.node, config.visibleProperty) !== false);
				watch(expanded, (value) => {
					if (value) hasBeenExpanded.value = true;
				});
				function handleDragend() {
					config.currentDragContext.value = void 0;
				}
				function handleDragover(event) {
					props.nodeDragover(event, props.node, props.parentNode);
				}
				function handleDrop() {
					props.nodeDrop(props.node);
				}
				function handleToggle() {
					if (getPropertyByPath(props.node, config.expandedProperty)) props.nodeCollapse(props.node);
					else props.nodeExpand(props.node);
				}
				return (_ctx, _cache) => {
					const _component_TreeViewNode = resolveComponent("TreeViewNode", true);
					return visible.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("button", {
						class: normalizeClass(["tree-view-node neos-horizontal-content", nodeClass.value]),
						draggable: draggable.value,
						style: normalizeStyle(nodeStyle.value),
						onClick: _cache[1] || (_cache[1] = ($event) => __props.nodeClick(__props.node)),
						onDragstart: _cache[2] || (_cache[2] = ($event) => __props.nodeDragstart(__props.node, __props.parentNode)),
						onDragover: handleDragover,
						onDragend: handleDragend,
						onDrop: handleDrop
					}, [
						children.value ? (openBlock(), createElementBlock("button", {
							key: 0,
							class: "tree-view-node-toggle-button",
							onClick: _cache[0] || (_cache[0] = withModifiers(($event) => handleToggle(), ["stop"]))
						}, [loading.value ? (openBlock(), createBlock(Spinner_default, {
							key: 0,
							size: "extrasmall"
						})) : (openBlock(), createBlock(Image_default, {
							key: 1,
							name: toggleIcon.value,
							size: "extrasmall"
						}, null, 8, ["name"]))])) : createCommentVNode("", true),
						renderSlot(_ctx.$slots, "node", { context: __props.node }, () => [createVNode(HorizontalLayout_default, null, {
							default: withCtx(() => [createVNode(Image_default, {
								name: icon.value,
								class: "tree-view-node-icon"
							}, null, 8, ["name"]), createVNode(Text_default, { class: "tree-view-node-caption" }, {
								default: withCtx(() => [createTextVNode(toDisplayString(caption.value), 1)]),
								_: 1
							})]),
							_: 1
						})], true),
						showDropIndicator.value ? (openBlock(), createElementBlock("div", {
							key: 1,
							class: "tree-view-node-drop-indicator",
							style: normalizeStyle(dropIndicatorStyle.value)
						}, null, 4)) : createCommentVNode("", true)
					], 46, _hoisted_1$1), children.value && hasBeenExpanded.value ? withDirectives((openBlock(), createElementBlock("div", _hoisted_2$1, [createElementVNode("div", {
						class: "tree-view-child-nodes-line",
						style: normalizeStyle(childNodesLineStyle.value)
					}, null, 4), (openBlock(true), createElementBlock(Fragment, null, renderList(children.value, (childNode) => {
						return openBlock(), createBlock(_component_TreeViewNode, {
							level: __props.level + 1,
							node: childNode,
							"parent-node": __props.node,
							"node-expand": __props.nodeExpand,
							"node-collapse": __props.nodeCollapse,
							"node-click": __props.nodeClick,
							"node-dragstart": __props.nodeDragstart,
							"node-dragover": __props.nodeDragover,
							"node-drop": __props.nodeDrop
						}, createSlots({ _: 2 }, [_ctx.$slots.node ? {
							name: "node",
							fn: withCtx(({ context }) => [renderSlot(_ctx.$slots, "node", { context }, void 0, true)]),
							key: "0"
						} : void 0]), 1032, [
							"level",
							"node",
							"parent-node",
							"node-expand",
							"node-collapse",
							"node-click",
							"node-dragstart",
							"node-dragover",
							"node-drop"
						]);
					}), 256))], 512)), [[vShow, expanded.value]]) : createCommentVNode("", true)], 64)) : createCommentVNode("", true);
				};
			}
		}), [["__scopeId", "data-v-562659ce"]])
	},
	props: {
		source: {
			type: Array,
			default: () => []
		},
		captionProperty: {
			type: String,
			default: ""
		},
		iconProperty: {
			type: String,
			default: ""
		},
		childrenProperty: {
			type: String,
			default: ""
		},
		loadingProperty: {
			type: String,
			default: "$loading"
		},
		loadedProperty: {
			type: String,
			default: "$loaded"
		},
		selectedProperty: {
			type: String,
			default: "$selected"
		},
		expandedProperty: {
			type: String,
			default: "$expanded"
		},
		visibleProperty: {
			type: String,
			default: "$visible"
		},
		draggableProperty: {
			type: String,
			default: "$draggable"
		},
		nodeColor: {
			type: String,
			default: void 0
		},
		nodeBackground: {
			type: String,
			default: void 0
		},
		nodeHoverColor: {
			type: String,
			default: void 0
		},
		nodeHoverBackground: {
			type: String,
			default: void 0
		},
		activeNodeColor: {
			type: String,
			default: void 0
		},
		activeNodeHoverColor: {
			type: String,
			default: void 0
		},
		activeNodeBackground: {
			type: String,
			default: void 0
		},
		activeNodeHoverBackground: {
			type: String,
			default: void 0
		},
		nodeLoad: {
			type: Function,
			default: void 0
		},
		nodeExpand: {
			type: Function,
			default: void 0
		},
		nodeCollapse: {
			type: Function,
			default: void 0
		},
		nodeClick: {
			type: Function,
			default: void 0
		},
		nodeDragover: {
			type: Function,
			default: void 0
		},
		nodeDrop: {
			type: Function,
			default: void 0
		}
	},
	setup(props) {
		useComponentAutomationProperties();
		const currentDragContext = ref();
		provide(TreeViewConfigKey, {
			captionProperty: props.captionProperty,
			iconProperty: props.iconProperty,
			childrenProperty: props.childrenProperty,
			loadingProperty: props.loadingProperty,
			loadedProperty: props.loadedProperty,
			selectedProperty: props.selectedProperty,
			expandedProperty: props.expandedProperty,
			visibleProperty: props.visibleProperty,
			draggableProperty: props.draggableProperty,
			currentDragContext
		});
		const setColorStyleValue = (styleObj, key, value) => {
			if (value) styleObj[`--${key}`] = getTokenOnlyColorValue(value);
		};
		const style = computed(() => {
			const styleValue = { "--vertical-space": "var(--0)" };
			setColorStyleValue(styleValue, "tree-view-node-foreground", props.nodeColor);
			setColorStyleValue(styleValue, "tree-view-node-background", props.nodeBackground);
			setColorStyleValue(styleValue, "tree-view-node-hover-foreground", props.nodeHoverColor);
			setColorStyleValue(styleValue, "tree-view-node-hover-background", props.nodeHoverBackground);
			setColorStyleValue(styleValue, "tree-view-node-active-foreground", props.activeNodeColor);
			setColorStyleValue(styleValue, "tree-view-node-active-background", props.activeNodeBackground);
			setColorStyleValue(styleValue, "tree-view-node-active-hover-foreground", props.activeNodeHoverColor);
			setColorStyleValue(styleValue, "tree-view-node-active-hover-background", props.activeNodeHoverBackground);
			return styleValue;
		});
		async function handleNodeExpand(node) {
			unselectAllNodes(props.source);
			setPropertyByPath(node, props.selectedProperty, true);
			if (!getPropertyByPath(node, props.loadedProperty)) {
				if (props.nodeLoad) try {
					setPropertyByPath(node, props.loadingProperty, true);
					await props.nodeLoad(node);
				} finally {
					setPropertyByPath(node, props.loadingProperty, false);
				}
				setPropertyByPath(node, props.loadedProperty, true);
			}
			expandNode(node);
		}
		function handleNodeCollapse(node) {
			unselectAllNodes(props.source);
			setPropertyByPath(node, props.selectedProperty, true);
			collapseNode(node);
		}
		function handleNodeClick(node) {
			unselectAllNodes(props.source);
			setPropertyByPath(node, props.selectedProperty, true);
			props.nodeClick?.(node);
		}
		function handleNodeDragstart(node, parentNode) {
			currentDragContext.value = {
				draggedNode: node,
				parentNode,
				expandedBeforeDrag: !!node[props.expandedProperty]
			};
			if (currentDragContext.value.expandedBeforeDrag) collapseNode(node);
		}
		function handleNodeDragover(event, node, parentNode) {
			if (!currentDragContext.value || node === currentDragContext.value.draggedNode) return;
			const newInstruction = getDropInstruction(event);
			if (currentDragContext.value.dropNode === node && currentDragContext.value.instruction === newInstruction) {
				event.preventDefault();
				return;
			}
			currentDragContext.value.instruction = newInstruction;
			if (currentDragContext.value.instruction === "make-child") {
				currentDragContext.value.newIndex = getChildren(node)?.length ?? 0;
				currentDragContext.value.newParentNode = node;
			} else {
				currentDragContext.value.newParentNode = parentNode;
				currentDragContext.value.newIndex = getDropNewIndex(currentDragContext.value, node);
			}
			if (!props.nodeDragover || props.nodeDragover(currentDragContext.value)) {
				currentDragContext.value.dropNode = node;
				event.preventDefault();
			}
		}
		function handleNodeDrop() {
			if (!currentDragContext.value || !props.nodeDrop) {
				currentDragContext.value = void 0;
				return;
			}
			props.nodeDrop(currentDragContext.value);
			if (currentDragContext.value.newParentNode && !currentDragContext.value.newParentNode[props.expandedProperty]) expandNode(currentDragContext.value.newParentNode);
			if (currentDragContext.value.expandedBeforeDrag) expandNode(currentDragContext.value.draggedNode);
		}
		function collapseNode(node) {
			setPropertyByPath(node, props.expandedProperty, false);
			props.nodeCollapse?.(node);
		}
		function expandNode(node) {
			setPropertyByPath(node, props.expandedProperty, true);
			props.nodeExpand?.(node);
		}
		function getDropInstruction(event) {
			const borderBox = event.currentTarget.getBoundingClientRect();
			const quarterOfHeight = borderBox.height / 4;
			if (event.clientY <= borderBox.top + quarterOfHeight) return "before";
			if (event.clientY >= borderBox.bottom - quarterOfHeight) return "after";
			return "make-child";
		}
		function getDropNewIndex(dragContext, node) {
			const list = dragContext.newParentNode ? getChildren(dragContext.newParentNode) : props.source;
			let newIndex = list.indexOf(node);
			if (dragContext.newParentNode === dragContext.parentNode) {
				const oldIndex = list.indexOf(dragContext.draggedNode);
				if (oldIndex !== -1 && oldIndex < newIndex) newIndex--;
			}
			if (dragContext.instruction === "after") newIndex++;
			return newIndex;
		}
		function getChildren(node) {
			return getPropertyByPath(node, props.childrenProperty);
		}
		function unselectAllNodes(nodes) {
			for (const node of nodes) {
				if (getPropertyByPath(node, props.selectedProperty)) setPropertyByPath(node, props.selectedProperty, false);
				const children = getChildren(node);
				if (children) unselectAllNodes(children);
			}
		}
		return {
			style,
			handleNodeExpand,
			handleNodeCollapse,
			handleNodeClick,
			handleNodeDragstart,
			handleNodeDragover,
			handleNodeDrop
		};
	}
});
// src/components/TreeView/TreeView.vue
var _hoisted_1 = { class: "tree-view-body" };
var _hoisted_2 = { class: "tree-view-nodes" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_TreeViewNode = resolveComponent("TreeViewNode");
	return openBlock(), createElementBlock("div", {
		class: "neos-vertical-content tree-view",
		style: normalizeStyle(_ctx.style)
	}, [_ctx.$slots.header ? (openBlock(), createBlock(_component_HorizontalLayout, {
		key: 0,
		space: "extrasmall",
		class: "tree-view-header"
	}, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "header", {}, void 0, true)]),
		_: 3
	})) : createCommentVNode("", true), createElementVNode("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.source, (node, __, ___, _cached) => {
		const _memo = [node, _ctx.$slots.node];
		if (_cached && _cached.el && isMemoSame(_cached, _memo)) return _cached;
		const _item = (openBlock(), createBlock(_component_TreeViewNode, {
			level: 0,
			node,
			"node-expand": _ctx.handleNodeExpand,
			"node-collapse": _ctx.handleNodeCollapse,
			"node-click": _ctx.handleNodeClick,
			"node-dragstart": _ctx.handleNodeDragstart,
			"node-dragover": _ctx.handleNodeDragover,
			"node-drop": _ctx.handleNodeDrop
		}, createSlots({ _: 2 }, [_ctx.$slots.node ? {
			name: "node",
			fn: withCtx(({ context }) => [renderSlot(_ctx.$slots, "node", { context }, void 0, true)]),
			key: "0"
		} : void 0]), 1032, [
			"node",
			"node-expand",
			"node-collapse",
			"node-click",
			"node-dragstart",
			"node-dragover",
			"node-drop"
		]));
		_item.memo = _memo;
		return _item;
	}, _cache, 0), 256))])])], 4);
}
var TreeView_default = /*#__PURE__*/ _plugin_vue_export_helper_default(TreeView_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render], ["__scopeId", "data-v-11c83c6f"]]);
// src/components/VirtualRepeat/itemSpacing.ts
/**
* Computes the spacing style applied to the wrapper around a virtual repeat
* item, so items are spaced like a non-virtual layout's flexbox `gap`.
*
* The padding must sit on a wrapper INSIDE the virtua item, never on the item
* element itself: virtua measures each item through `ResizeObserver.contentRect`
* (the content-box, which excludes the element's own padding). Padding on an
* inner wrapper is part of the item's content-box and is therefore counted into
* the item offsets, producing real spacing; padding on the item element would
* be ignored and the items would stay glued together.
*
* Returns `undefined` (no wrapper needed) for the last item — matching `gap`,
* which adds no trailing space — and when `space` is `none`.
*/
function getItemSpacingStyle(index, count, space, horizontal) {
	if (space === "none" || index >= count - 1) return;
	return { [horizontal ? "paddingInlineEnd" : "paddingBlockEnd"]: SpaceValues[space] };
}
// src/components/VirtualRepeat/VirtualRepeat.ts
var VirtualRepeat = defineComponent({
	name: "VirtualRepeat",
	inheritAttrs: false,
	props: {
		data: {
			type: Array,
			required: true
		},
		horizontal: {
			type: Boolean,
			default: false
		},
		space: {
			type: String,
			default: "none"
		}
	},
	emits: ["scrollEnd"],
	setup(props, { slots, attrs, expose, emit }) {
		const inner = ref();
		function onScrollEnd() {
			const list = inner.value;
			if (list.scrollOffset + list.viewportSize >= list.scrollSize - 1) emit("scrollEnd");
		}
		expose({
			scrollToIndex(index, opts) {
				inner.value.scrollToIndex(index, opts);
			},
			scrollTo(offset) {
				inner.value.scrollTo(offset);
			},
			scrollBy(offset) {
				inner.value.scrollBy(offset);
			}
		});
		function getSharedKey(content) {
			const keys = content.map((node) => node.key).filter((key) => key != null);
			return keys.length > 0 && keys.every((key) => key === keys[0]) ? keys[0] : void 0;
		}
		function renderItem(item, index) {
			const content = slots.default({
				item,
				index
			});
			if (props.space === "none") return content;
			const style = getItemSpacingStyle(index, props.data.length, props.space, props.horizontal);
			return h("div", {
				key: getSharedKey(content),
				style
			}, content);
		}
		return () => h(VList, {
			...attrs,
			ref: inner,
			data: props.data,
			horizontal: props.horizontal,
			onScrollEnd
		}, { default: ({ item, index }) => renderItem(item, index) });
	}
});
// src/composables/usePressEvents.ts
var LONG_PRESS_DELAY = 500;
function usePressEvents(handlers) {
	let pressTimer = null;
	let longPressTriggered = false;
	function onPressStart() {
		longPressTriggered = false;
		pressTimer = setTimeout(() => {
			longPressTriggered = true;
			handlers.onLongPress?.();
		}, LONG_PRESS_DELAY);
	}
	function onPressEnd() {
		clearPressTimer();
		if (longPressTriggered) return;
		handlers.onPress?.();
	}
	function onPressCancel() {
		clearPressTimer();
		longPressTriggered = false;
	}
	function clearPressTimer() {
		if (pressTimer) {
			clearTimeout(pressTimer);
			pressTimer = null;
		}
	}
	onScopeDispose(clearPressTimer);
	return {
		onPressStart,
		onPressEnd,
		onPressCancel
	};
}
// src/composables/usePreventPopoverHide.ts
function usePreventPopoverHide() {
	const preventPopoverHide = shallowRef(false);
	function setPreventPopoverHide(value) {
		preventPopoverHide.value = value;
	}
	return {
		preventPopoverHide,
		setPreventPopoverHide
	};
}
// src/utils/directiveStyles.ts
/**
* The space tokens of a button surface margin: `none` becomes a variable, because an animated button
* surface grows beyond its bounds on hover and keeps a small margin (see Button.vue).
*/
var buttonMarginValues = {
	...SpaceValues,
	none: "var(--neos-button-none-margin, 0px)"
};
/**
* The `transition:properties` names that differ from the CSS property they animate.
*/
var transitionAliases = new Map([
	...[
		"rotate",
		"rotate-x",
		"rotate-y",
		"scale",
		"translate",
		"hover-scale"
	].map((name) => [name, "transform"]),
	...[
		"shadow-color",
		"shadow-offset-x",
		"shadow-offset-y",
		"shadow-blur",
		"shadow-spread",
		"hover-shadow-offset-x",
		"hover-shadow-offset-y",
		"hover-shadow-blur",
		"hover-shadow-spread"
	].map((name) => [name, "box-shadow"]),
	["corner-radius", "border-radius"],
	["hover-background", "background"],
	["hover-border-color", "border-color"],
	["hover-border-width", "border-width"],
	["hover-color", "color"],
	["hover-font-style", "font-style"],
	["hover-font-weight", "font-weight"],
	["hover-opacity", "opacity"],
	["hover-text-decoration", "text-decoration"]
]);
/**
* The size of a color cache, cleared as a whole when full: an application binds few distinct colors.
*/
var maxCachedColors = 500;
/**
* Converts a directive value to a string without its surrounding spaces, or undefined when absent
* (null, undefined, empty or only spaces).
*/
function normalize(value) {
	if (value == null) return;
	const text = String(value).trim();
	return text === "" ? void 0 : text;
}
/**
* Converts a value, or returns undefined when it is absent.
*/
function convert(value, converter) {
	const text = normalize(value);
	return text === void 0 ? void 0 : converter(text);
}
/**
* Caches the results of a color converter: CSS.supports is costly for a binding evaluated on every render.
*/
function cached(converter) {
	const cache = /* @__PURE__ */ new Map();
	return (text) => {
		const cachedResult = cache.get(text);
		if (cachedResult !== void 0) return cachedResult;
		if (cache.size >= maxCachedColors) cache.clear();
		const result = converter(text);
		cache.set(text, result);
		return result;
	};
}
function withUnit(unit) {
	return (text) => `${text}${unit}`;
}
var getDegrees = withUnit("deg");
var getPixels = withUnit("px");
var getMilliseconds = withUnit("ms");
function toPixelsUnlessPercentage(text) {
	return text.endsWith("%") ? text : `${text}px`;
}
function getSize(text) {
	if (text === "fill") return;
	return text === "auto" ? text : toPixelsUnlessPercentage(text);
}
function getButtonWrapperSize(text) {
	return text === "auto" ? void 0 : getSize(text);
}
function getButtonMargin(text) {
	return getPredefinedSizingValue(text, buttonMarginValues);
}
function getWeight(text) {
	return Object.hasOwn(WeightValues, text) ? WeightValues[text] : text;
}
/**
* Splits a value without surrounding spaces on the spaces outside parentheses, ignoring the empty
* parts between consecutive spaces, so that a CSS function color such as "rgb(255, 0, 0)" stays a
* single value.
*/
function splitOutsideParentheses(value) {
	const groups = [];
	let parenthesesDepth = 0;
	let groupStart = 0;
	for (let i = 0; i < value.length; i++) {
		const currentCharacter = value[i];
		if (currentCharacter === "(") parenthesesDepth++;
		else if (currentCharacter === ")") parenthesesDepth--;
		else if (currentCharacter === " " && parenthesesDepth === 0) {
			if (i > groupStart) groups.push(value.slice(groupStart, i));
			groupStart = i + 1;
		}
	}
	groups.push(value.slice(groupStart));
	return groups;
}
function getMultiColorValue(text) {
	return splitOutsideParentheses(text).map(getColorValue).join(" ");
}
function getMultiNumberValue(text) {
	return splitOnSpaces(text).map(getPixels).join(" ");
}
function getTranslate(text) {
	return splitOnSpaces(text).map(toPixelsUnlessPercentage).join(", ");
}
function getTransitionProperties(text) {
	const properties = text.split(",").map((name) => splitOnSpaces(name).join(" ")).filter((name) => name !== "").map((name) => transitionAliases.get(name) ?? name);
	return [...new Set(properties)].join(", ");
}
var getCachedColorValue = cached(getColorValue);
var getCachedMultiColorValue = cached(getMultiColorValue);
/**
* Formatters of the bound template directive values, called by the `:class` and `:style` bindings of
* the generated templates. Twins of the generator's TemplateDirectiveValues, which converts the literal
* values with the same rules and the same test cases. Each formatter converts the value without
* validating it, and returns undefined for an absent value (null, undefined, empty or only spaces) so
* that Vue omits the property or the class. Exposed to every template as the `directiveStyles` global
* property.
*/
var directiveStyles = Object.freeze({
	/** A value written as is, as a string without its surrounding spaces. */
	text(value) {
		return normalize(value);
	},
	/**
	* Whether one of the values is present (not null, undefined, empty nor only spaces): the condition of
	* a directive class, which tests its values without formatting them.
	*/
	has(...values) {
		return values.some((value) => normalize(value) !== void 0);
	},
	/** `layout:width` / `layout:height`: `auto`, pixels or a percentage (`fill` is a class, see sizeClass). */
	size(value) {
		return convert(value, getSize);
	},
	/**
	* `layout:width` / `layout:height` of an ActionButton or a MenuButton: as `size`, but none for
	* `auto`, so that the wrapper keeps the size of its own CSS (MenuButton.css).
	*/
	buttonWrapperSize(value) {
		return convert(value, getButtonWrapperSize);
	},
	/** `layout:min-*` / `layout:max-*` and `canvas:top|right|bottom|left`: pixels or a percentage. */
	length(value) {
		return convert(value, toPixelsUnlessPercentage);
	},
	/**
	* The size class of `layout:width` / `layout:height`: `neos-fill-parent-<axis>` for `fill`,
	* `neos-fixed-<axis>` for a fixed size, none for `auto`.
	*/
	sizeClass(axis, value) {
		const text = normalize(value);
		if (text === "fill") return `neos-fill-parent-${axis}`;
		return text === void 0 || text === "auto" ? void 0 : `neos-fixed-${axis}`;
	},
	/** The class of `layout:align-self-horizontal` / `layout:align-self-vertical`, named after the alignment. */
	alignSelfClass(axis, value) {
		return convert(value, (text) => `neos-align-self-${axis}-${text}`);
	},
	/** Space tokens, in the CSS shorthand order (`layout:padding`, `layout:margin`). */
	space(value) {
		return convert(value, getMultiSpaceValue);
	},
	/** `layout:margin` of a button surface (see buttonMarginValues). */
	buttonMargin(value) {
		return convert(value, getButtonMargin);
	},
	/** Corner radius tokens, in the CSS shorthand order (`style:corner-radius`). */
	radius(value) {
		return convert(value, getMultiRadiusValue);
	},
	/** A theme token or a CSS color (see getColorValue). */
	color(value) {
		return convert(value, getCachedColorValue);
	},
	/** Colors, in the CSS shorthand order (`style:border-color`). */
	colors(value) {
		return convert(value, getCachedMultiColorValue);
	},
	/** Pixels, in the CSS shorthand order (`style:border-width`). */
	borderWidth(value) {
		return convert(value, getMultiNumberValue);
	},
	/** A font weight token. */
	weight(value) {
		return convert(value, getWeight);
	},
	/** A number of degrees. */
	degrees(value) {
		return convert(value, getDegrees);
	},
	/** A number of pixels. */
	pixels(value) {
		return convert(value, getPixels);
	},
	/** A number of milliseconds (`transition:duration`). */
	milliseconds(value) {
		return convert(value, getMilliseconds);
	},
	/** `style:translate`: two numbers, each in pixels unless suffixed with `%`. */
	translate(value) {
		return convert(value, getTranslate);
	},
	/** `transition:properties`: the comma-separated names, as deduplicated CSS properties. */
	transitionProperties(value) {
		return convert(value, getTransitionProperties);
	},
	/**
	* The class string of a `contentClass` prop (compared by value by the component), from the items
	* of a `:class` binding.
	*/
	classText(...items) {
		return normalizeClass(items);
	},
	/**
	* Whether the usage of a template sets a size, a visibility or an alignment, which then replaces the
	* one of the root of the template: the usage marks it with a `neos-usage-<name>` class, without CSS.
	* No marker is the start of another one, so a search in the class string is enough.
	*
	* @param attrs - The attributes of the usage (`$attrs`).
	* @param name - The name of the directive, without its `layout:` prefix (`width`, `visibility`...).
	*/
	isSetByUsage(attrs, name) {
		const usageClass = attrs.class;
		return (typeof usageClass === "string" ? usageClass : normalizeClass(usageClass)).includes(`neos-usage-${name}`);
	},
	/**
	* The class string of the `contentClass` prop of the root of a template: the items of the template,
	* followed by the `content-class` given by its usage.
	*
	* @param attrs - The attributes of the usage (`$attrs`).
	*/
	contentClassText(attrs, ...items) {
		return normalizeClass([...items, attrs["content-class"] ?? attrs.contentClass]);
	},
	/**
	* The style string of the `contentStyle` prop of the root of a template: the style of the template,
	* followed by the `content-style` given by its usage, which wins property by property.
	*
	* @param attrs - The attributes of the usage (`$attrs`).
	* @param style - The style string of the template.
	*/
	contentStyleText(attrs, style) {
		const usageStyle = normalizeStyle(attrs["content-style"] ?? attrs.contentStyle);
		return [style, typeof usageStyle === "object" ? directiveStyles.styleText(usageStyle) : usageStyle].filter(Boolean).join("; ");
	},
	/**
	* The style string of a `contentStyle` prop (compared by value by the component), from a style
	* object keyed by CSS property names. A null, undefined or empty value omits its property.
	* A value containing a semicolon omits its property too: it would add declarations to the string.
	*/
	styleText(style) {
		let text = "";
		for (const property in style) {
			const value = style[property];
			const valueText = value == null ? "" : String(value);
			if (valueText !== "" && !valueText.includes(";")) text += `${text === "" ? "" : "; "}${property}: ${valueText}`;
		}
		return text;
	}
});
// src/utils/DatagridCollectionChangedEventArgs.ts
var DatagridCollectionChangedEventArgs = class extends NotifyCollectionChangedEventArgs {
	constructor(action, item, index, col, value, isSuggestionChange) {
		super(action, item, index);
		this.col = col;
		this.value = value;
		this.isSuggestionChange = isSuggestionChange;
	}
};
// src/utils/plugin.ts
/* v8 ignore next -- @preserve */
var wijmoCultures = /* #__PURE__ */ Object.assign({
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.de.js": () => import("./wijmo.culture.de-Cz8Ic4gm.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.en-CA.js": () => import("./wijmo.culture.en-CA-Djp6Wxhi.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.en-GB.js": () => import("./wijmo.culture.en-GB-CYQM-F1n.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.en.js": () => import("./wijmo.culture.en-BiAcO-7G.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.es.js": () => import("./wijmo.culture.es-DjvIfaLN.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.fr-CA.js": () => import("./wijmo.culture.fr-CA-2qDFPtVQ.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.fr.js": () => import("./wijmo.culture.fr-1xU58MLx.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.it.js": () => import("./wijmo.culture.it-BB4llHTX.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.pt.js": () => import("./wijmo.culture.pt-C3c0zBNs.js")
});
var plugin = { async install(app) {
	app.config.globalProperties.$neos = {};
	app.config.globalProperties.directiveStyles = directiveStyles;
	installSizeTransitionTracking();
} };
var sizeTransitionProperties = /* @__PURE__ */ new Set([
	"height",
	"width",
	"max-height",
	"max-width"
]);
var sizeTransitionAttribute = "data-neos-transition-size";
/**
* Number of size transitions currently running per element.
*/
var runningSizeTransitionCounts = /* @__PURE__ */ new WeakMap();
/**
* Marks an element with the `data-neos-transition-size` attribute while one of its own size transitions
* runs: the box is then briefly smaller than its content, and the attribute suspends the `overflow: auto`
* safety nets of the sized elements (see global.css) that would flash a scrollbar. An attribute rather
* than a class, which Vue would remove when it rewrites the class of the element. The document listens in
* the capture phase, so that a stopped propagation cannot hide an event, and adding the same listeners
* again for another application has no effect.
*/
function installSizeTransitionTracking() {
	document.addEventListener("transitionrun", onSizeTransitionRun, true);
	document.addEventListener("transitionend", onSizeTransitionSettled, true);
	document.addEventListener("transitioncancel", onSizeTransitionSettled, true);
}
/**
* The element whose own size transition the event reports, if any (a pseudo-element is ignored).
*/
function getSizeTransitionElement(event) {
	const { target, propertyName, pseudoElement } = event;
	return target instanceof Element && sizeTransitionProperties.has(propertyName) && !pseudoElement ? target : void 0;
}
function onSizeTransitionRun(event) {
	const element = getSizeTransitionElement(event);
	if (element === void 0) return;
	runningSizeTransitionCounts.set(element, (runningSizeTransitionCounts.get(element) ?? 0) + 1);
	element.setAttribute(sizeTransitionAttribute, "");
}
function onSizeTransitionSettled(event) {
	const element = getSizeTransitionElement(event);
	if (element === void 0) return;
	const count = (runningSizeTransitionCounts.get(element) ?? 0) - 1;
	if (count > 0) runningSizeTransitionCounts.set(element, count);
	else {
		runningSizeTransitionCounts.delete(element);
		element.removeAttribute(sizeTransitionAttribute);
	}
}
var wijmoConfigured = false;
function configureWijmo(key) {
	if (wijmoConfigured) return;
	setLicenseKey(key);
	overrideDatagridCellTemplate();
	overrideDatagridRowDetailTemplate();
	wijmoConfigured = true;
}
function useUILocale(localizator) {
	async function updateUILocale() {
		await importWijmoLocale(localizator);
	}
	return { updateUILocale };
}
async function importWijmoLocale(localizator) {
	await importLocale(localizator, wijmoCultures, (lang) => `../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.${lang}.js`);
	culture.Globalize.calendar.twoDigitYearMax = twoDigitYearMax;
}
async function importLocale(localizator, obj, getPath) {
	let fn = obj[getPath(localizator.currentCulture)];
	fn ??= obj[getPath(ResourceManager.getTwoLetterLanguage(localizator.currentCulture))];
	fn ??= obj[getPath(localizator.currentLanguage)];
	fn ??= obj[getPath(localizator.defaultLanguage)];
	return fn?.();
}
/**
* The Wijmo template overrides below rely on private integration points and browser layout
* primitives such as `ResizeObserver`, `requestAnimationFrame`, and live DOM measurements.
* Those interactions are not reproduced reliably in our unit test environment, so this block
* is documented and covered through manual verification instead of automated unit tests.
*/
/**
* Overrides the datagrid cell template definition to propagate the application context
* and the objects provided by the parent components.
*
* The following code comes from the Wijmo source code.
*
* The `$forceUpdate` method has been modified to update the component instead of remounting it.
*/
/* v8 ignore next -- @preserve */
function overrideDatagridCellTemplate() {
	class V3CellTemplateCmp {
		constructor(props) {
			this.props = props;
			this._host = document.createElement("div");
		}
		$mount() {
			const { parent, ...props } = this.props;
			const vnode = h({
				parent,
				render: () => h("div", props, this.slotFn?.(this.context)),
				setup: () => propagateComponentContext(parent)
			});
			this.$el.innerHTML = "";
			render(vnode, this.$el);
		}
		get $el() {
			return this._host;
		}
		$destroy() {
			render(null, this.$el);
			this._host = null;
		}
		$forceUpdate() {
			if (this._host) {
				const element = this._host.firstChild;
				if (element && element.__vueParentComponent) element.__vueParentComponent.update();
			}
		}
	}
	WjFlexGridCellTemplateDefinition.methods._instantiateTemplate = function(parent, dataContext) {
		const ret = new V3CellTemplateCmp({ parent: this });
		ret.context = dataContext;
		ret.slotFn = this.$slots.default;
		ret.$mount();
		if (parent) parent.append(ret.$el);
		return ret;
	};
}
/**
* Overrides the datagrid detail template definition to propagate the application context
* and the objects provided by the parent components.
*
* This wraps Wijmo's original detail provider creation, replaces the detail cell factory
* to keep row detail height in sync with dynamic content by observing the rendered detail element.
*/
/* v8 ignore next -- @preserve */
function overrideDatagridRowDetailTemplate() {
	const original = WjFlexGridDetail._wjBehCl.prototype._createControl;
	WjFlexGridDetail._wjBehCl.prototype._createControl = function() {
		const ctrl = original.call(this);
		ctrl.createDetailCell = (row) => {
			const parent = this.parent.component;
			const slotFn = this.component.$slots.default;
			const context = {
				row,
				item: row.dataItem,
				provider: this.control
			};
			const vnode = h({
				parent: this.component,
				render: () => h("div", slotFn?.(context)),
				setup: () => propagateComponentContext(parent)
			});
			const detail = document.createElement("div");
			render(vnode, detail);
			const content = vnode.el;
			const cleanup = watchDynamicDetailHeight(ctrl, row, detail, content ?? detail);
			this._openedComponents.push({
				$el: detail,
				$destroy() {
					cleanup();
					render(null, detail);
				}
			});
			return detail;
		};
		return ctrl;
	};
}
/**
* Observes the rendered detail content and keeps at most one pending height refresh.
*
* The first refresh request is issued immediately, but it only runs once the detail
* element is attached to the DOM. Later content resizes are coalesced through the same path.
*/
/* v8 ignore next -- @preserve */
function watchDynamicDetailHeight(detailProvider, row, detail, content) {
	detail._neosResizeObserver = new ResizeObserver(() => {
		scheduleDetailHeightRefresh(detailProvider, row, detail, content);
	});
	detail._neosResizeObserver.observe(content);
	scheduleDetailHeightRefresh(detailProvider, row, detail, content);
	return () => {
		const refreshFrame = detail._neosRefreshFrame;
		if (refreshFrame) {
			cancelAnimationFrame(refreshFrame);
			detail._neosRefreshFrame = void 0;
		}
		detail._neosResizeObserver?.disconnect();
		detail._neosResizeObserver = void 0;
	};
}
/**
* Recomputes the detail row height on the next animation frame after Vue and Wijmo have
* both had a chance to flush their DOM updates.
*
* The extra retries cover cases where the detail is mounted before layout produces a
* measurable height, such as deferred child rendering.
*/
/* v8 ignore next -- @preserve */
function scheduleDetailHeightRefresh(detailProvider, row, detail, content, retryCount = 0) {
	if (detail._neosRefreshFrame || !detail.isConnected) return;
	detail._neosRefreshFrame = requestAnimationFrame(() => {
		detail._neosRefreshFrame = void 0;
		if (!detail.isConnected) return;
		const detailRow = detailProvider.getDetailRow(row);
		if (!detailRow || detailRow.detail !== detail) return;
		Control.refreshAll(detail);
		const grid = detailProvider.grid;
		const measuredHeight = Math.max(content.scrollHeight, content.getBoundingClientRect().height);
		detailRow.height = measuredHeight + grid._cellPadVert * 2;
		if (measuredHeight === 0 && retryCount < 2) scheduleDetailHeightRefresh(detailProvider, row, detail, content, retryCount + 1);
	});
}
/**
* It is through the following code that the context is propagated.
*/
/* v8 ignore next -- @preserve */
function propagateComponentContext(parent) {
	const currentInstance = getCurrentInstance();
	const parentInstance = parent;
	currentInstance.appContext = parentInstance.$.appContext;
	currentInstance.provides = parentInstance.$.provides;
}
export { Aggregate, AiSuggestionIndicator_default as AiSuggestionIndicator, AlignValues, Avatar_default as Avatar, Badge_default as Badge, BooleanCombobox_default as BooleanCombobox, BreakpointValues, Button_default as Button, ButtonsLayout_default as ButtonsLayout, Calendar_default as Calendar, CalendarRange_default as CalendarRange, CanvasLayout_default as CanvasLayout, Card_default as Card, Carousel_default as Carousel, Chart_default as Chart, Checkbox_default as Checkbox, Chip_default as Chip, CollectionViewGroup, Combobox_default as Combobox, ConfirmPopover_default as ConfirmPopover, ContextMenu_default as ContextMenu, CornerRadiusValues, DataType, Datagrid_default as Datagrid, DatagridCollectionChangedEventArgs, DatagridCollectionView, DatagridInstance, Divider_default as Divider, DocumentationButton_default as DocumentationButton, Dropdown_default as Dropdown, DropdownMenu_default as DropdownMenu, DropdownMenuItem_default as DropdownMenuItem, DynamicCheckbox_default as DynamicCheckbox, DynamicCombobox_default as DynamicCombobox, GridLayout_default as GridLayout, GroupBox_default as GroupBox, GroupDescription, Heading_default as Heading, HorizontalLayout_default as HorizontalLayout, HorizontalLayoutVerticalAlignValues, HtmlViewer_default as HtmlViewer, Image_default as Image, InputColor_default as InputColor, InputDate_default as InputDate, InputDateTime_default as InputDateTime, InputLabel_default as InputLabel, InputLocalizableString_default as InputLocalizableString, InputMask_default as InputMask, InputMessage_default as InputMessage, InputNumber_default as InputNumber, InputPassword_default as InputPassword, InputRelativeDate_default as InputRelativeDate, InputSliderDiscrete_default as InputSliderDiscrete, InputTime_default as InputTime, ListBox_default as ListBox, LoadDataOnScroll_default as LoadDataOnScroll, LoadingOverlay_default as LoadingOverlay, LottieImage_default as LottieImage, MarkdownViewer_default as MarkdownViewer, Message_default as Message, Modal_default as Modal, MultiSelect_default as MultiSelect, neosEvent as NeosEvent, NotifyCollectionChangedAction, ObservableArray, PaginationBar_default as PaginationBar, Popover_default as Popover, PopoverWithTarget_default as PopoverWithTarget, ProgressBar_default as ProgressBar, ProgressIndicator_default as ProgressIndicator, PropertyGroupDescription, RadioGroup_default as RadioGroup, ResponsiveDatagridWrapper_default as ResponsiveDatagridWrapper, SelectableListHeader_default as SelectableListHeader, Shimmer_default as Shimmer, SortDescription, SpaceValues, Spinner_default as Spinner, Splitter_default as Splitter, SplitterPanel_default as SplitterPanel, Switch_default as Switch, TabItem_default as TabItem, Tabs_default as Tabs, Text_default as Text, Textbox_default as Textbox, Timeline_default as Timeline, Toast_default as Toast, TreeView_default as TreeView, VerticalAlignValues, VerticalLayout_default as VerticalLayout, VirtualRepeat, WeightValues, configureWijmo, contentProps, convertTextAlignToAlignItems, datagridCommonProps, directiveStyles, focusExceptOnTouchDevice, focusableElementEmits, focusableElementProps, getMultiSpaceValue, getNavigableTag, handleNavigableClick, importLocale, inputEmits, inputProps, isAutomationMode, isDropdownActive, isInDropdown, isSpeechSupported, modalStateVersion, normalizeSize, plugin, provideGlobalResourceManager, provideImages, provideLocalizator, provideThemeManager, setAutomationMode, smallTextPropsDefaults, textPropsDefaults, triggerChangeOnActiveInput, useButtonContainerSpace, useComponentAutomationProperties, useContentStyle, useFocusableElement, useGlobalResourceManager, useImages, useInput, useLocalizator, useModal, useNavigableClick, usePressEvents, usePreventPopoverHide, useSpeech, useStringInput, useText, useThemeManager, useToast, useUILocale, validationMessageSeverities };

//# sourceMappingURL=design-system.js.map